require.register("local-data/assessments/phd-qafeedback-wcn", function(exports, require, module){
  module.exports = {
   "seed": "2a294251-217c-4ca7-87fe-ef78cac7fa0b",
   "questions":[
       {
          "id":12026,
          "shuffle":false,
          "position":1,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "31690"
          ],
          "created_at":"2022-01-10T23:23:46.340Z",
          "updated_at":"2022-04-21T20:38:19.667Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":1,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"In the previous video, what should Deborah have done differently in response to Martin’s request?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29625,
                "question_id":12026,
                "locale":"en",
                "created_at":"2022-01-10T23:23:46.368Z",
                "updated_at":"2022-04-21T20:37:40.157Z",
                "text":"In the previous video, what should Deborah have done differently in response to Martin’s request?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29640,
                "question_id":12026,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:46.481Z",
                "updated_at":"2022-01-10T23:23:46.481Z",
                "text":"İnsanlar her zaman haksız varsayımlara veya klişelere dayalı kararlar aldıklarını bilirler. ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29639,
                "question_id":12026,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:46.475Z",
                "updated_at":"2022-01-10T23:23:46.475Z",
                "text":"Las personas siempre saben cuándo toman decisiones basadas en suposiciones o estereotipos injustos. ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29638,
                "question_id":12026,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:46.469Z",
                "updated_at":"2022-01-10T23:23:46.469Z",
                "text":"Люди всегда осознают, что принимают решения на основании несправедливых предположений или стереотипов. ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29637,
                "question_id":12026,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:46.459Z",
                "updated_at":"2022-01-10T23:23:46.459Z",
                "text":"Ludzie zawsze wiedzą, kiedy podejmują decyzje oparte na niesprawiedliwych założeniach lub stereotypach. ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29636,
                "question_id":12026,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:46.453Z",
                "updated_at":"2022-01-10T23:23:46.453Z",
                "text":"사람들은 자신이 언제 불공평한 가설이나 고정 관념에 근거해 결정을 내리는지 항상 알고 있다. ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29635,
                "question_id":12026,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:46.446Z",
                "updated_at":"2022-01-10T23:23:46.446Z",
                "text":"人は、不公平な思い込みや固定概念に基づいて意思決定を行う際、常にその事実を把握している。 ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29634,
                "question_id":12026,
                "locale":"it",
                "created_at":"2022-01-10T23:23:46.440Z",
                "updated_at":"2022-01-10T23:23:46.440Z",
                "text":"Le persone sanno sempre quando prendono decisioni basate su supposizioni ingiuste o stereotipi. ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29633,
                "question_id":12026,
                "locale":"de",
                "created_at":"2022-01-10T23:23:46.433Z",
                "updated_at":"2022-01-10T23:23:46.433Z",
                "text":"Wir wissen immer, wenn wir Entscheidungen treffen, die auf unfairen Annahmen oder Stereotypen basieren. ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29632,
                "question_id":12026,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:46.427Z",
                "updated_at":"2022-01-10T23:23:46.427Z",
                "text":"Les gens savent toujours quand ils prennent des décisions fondées sur des hypothèses ou des stéréotypes injustes. ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29631,
                "question_id":12026,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:46.421Z",
                "updated_at":"2022-01-10T23:23:46.421Z",
                "text":"Les gens savent toujours lorsqu’ils prennent des décisions en se basant sur de faux préjugés ou des stéréotypes. ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29630,
                "question_id":12026,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:46.415Z",
                "updated_at":"2022-01-10T23:23:46.415Z",
                "text":"As pessoas sempre sabem quando estão tomando decisões baseadas em suposições ou estereótipos injustos. ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29629,
                "question_id":12026,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:46.408Z",
                "updated_at":"2022-01-10T23:23:46.408Z",
                "text":"Alam ng mga tao kapag gumagawa sila ng desisyon na batay sa hindi patas na mga palagay o stereotype. ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29628,
                "question_id":12026,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:46.402Z",
                "updated_at":"2022-01-10T23:23:46.402Z",
                "text":"人们总是能知道何时基于不公平的看法或定式做出决定。 ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29627,
                "question_id":12026,
                "locale":"es",
                "created_at":"2022-01-10T23:23:46.396Z",
                "updated_at":"2022-01-10T23:23:46.396Z",
                "text":"Las personas siempre saben cuando toman decisiones basadas en suposiciones injustas o estereotipos. ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29626,
                "question_id":12026,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:46.389Z",
                "updated_at":"2022-01-10T23:23:46.389Z",
                "text":"當人們基於不公平的預設立場或刻板印象做決定時，他們其實是知道的。 ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30257,
                "position":1,
                "active":true,
                "question_id":12026,
                "created_at":"2022-01-10T23:23:46.489Z",
                "updated_at":"2022-04-14T22:07:20.174Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Only discussed Martin's health condition and request for accommodation with colleagues who handle workplace accommodations.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71371,
                      "answer_id":30257,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:46.597Z",
                      "updated_at":"2022-01-10T23:23:46.597Z",
                      "text":"Doğru",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71370,
                      "answer_id":30257,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:46.593Z",
                      "updated_at":"2022-01-10T23:23:46.593Z",
                      "text":"Verdadera",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71369,
                      "answer_id":30257,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:46.587Z",
                      "updated_at":"2022-01-10T23:23:46.587Z",
                      "text":"Правда",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71368,
                      "answer_id":30257,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:46.581Z",
                      "updated_at":"2022-01-10T23:23:46.581Z",
                      "text":"Prawda",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71367,
                      "answer_id":30257,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:46.575Z",
                      "updated_at":"2022-01-10T23:23:46.575Z",
                      "text":"맞음",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71366,
                      "answer_id":30257,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:46.569Z",
                      "updated_at":"2022-01-10T23:23:46.569Z",
                      "text":"〇",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71365,
                      "answer_id":30257,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:46.563Z",
                      "updated_at":"2022-01-10T23:23:46.563Z",
                      "text":"Vero",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71364,
                      "answer_id":30257,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:46.557Z",
                      "updated_at":"2022-01-10T23:23:46.557Z",
                      "text":"Richtig",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71363,
                      "answer_id":30257,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:46.552Z",
                      "updated_at":"2022-01-10T23:23:46.552Z",
                      "text":"Vrai",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71362,
                      "answer_id":30257,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:46.547Z",
                      "updated_at":"2022-01-10T23:23:46.547Z",
                      "text":"Verdadeira",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71361,
                      "answer_id":30257,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:46.541Z",
                      "updated_at":"2022-01-10T23:23:46.541Z",
                      "text":"Vrai",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71360,
                      "answer_id":30257,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:46.536Z",
                      "updated_at":"2022-01-10T23:23:46.536Z",
                      "text":"Verdadero",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71359,
                      "answer_id":30257,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:46.530Z",
                      "updated_at":"2022-01-10T23:23:46.530Z",
                      "text":"Tama",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71358,
                      "answer_id":30257,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:46.524Z",
                      "updated_at":"2022-01-10T23:23:46.524Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71357,
                      "answer_id":30257,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:46.518Z",
                      "updated_at":"2022-01-10T23:23:46.518Z",
                      "text":"对",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71356,
                      "answer_id":30257,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:46.509Z",
                      "updated_at":"2022-04-14T22:07:20.185Z",
                      "text":"Only discussed Martin's health condition and request for accommodation with colleagues who handle workplace accommodations.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30258,
                "position":2,
                "active":true,
                "question_id":12026,
                "created_at":"2022-01-10T23:23:46.605Z",
                "updated_at":"2022-04-14T22:07:48.300Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Allowed for an open conversation about Martin’s options instead of simply saying “no” to his request.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71387,
                      "answer_id":30258,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:46.690Z",
                      "updated_at":"2022-01-10T23:23:46.690Z",
                      "text":"Yanlış",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71386,
                      "answer_id":30258,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:46.685Z",
                      "updated_at":"2022-01-10T23:23:46.685Z",
                      "text":"Falsa",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71385,
                      "answer_id":30258,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:46.681Z",
                      "updated_at":"2022-01-10T23:23:46.681Z",
                      "text":"Ложь",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71384,
                      "answer_id":30258,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:46.676Z",
                      "updated_at":"2022-01-10T23:23:46.676Z",
                      "text":"Fałsz",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71383,
                      "answer_id":30258,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:46.671Z",
                      "updated_at":"2022-01-10T23:23:46.671Z",
                      "text":"틀림",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71382,
                      "answer_id":30258,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:46.666Z",
                      "updated_at":"2022-01-10T23:23:46.666Z",
                      "text":"×",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71381,
                      "answer_id":30258,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:46.662Z",
                      "updated_at":"2022-01-10T23:23:46.662Z",
                      "text":"Falso",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71380,
                      "answer_id":30258,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:46.657Z",
                      "updated_at":"2022-01-10T23:23:46.657Z",
                      "text":"Falsch",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71379,
                      "answer_id":30258,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:46.652Z",
                      "updated_at":"2022-01-10T23:23:46.652Z",
                      "text":"Faux",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71378,
                      "answer_id":30258,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:46.647Z",
                      "updated_at":"2022-01-10T23:23:46.647Z",
                      "text":"Fausse",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71377,
                      "answer_id":30258,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:46.643Z",
                      "updated_at":"2022-01-10T23:23:46.643Z",
                      "text":"Falsa",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71376,
                      "answer_id":30258,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:46.638Z",
                      "updated_at":"2022-01-10T23:23:46.638Z",
                      "text":"Falso",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71375,
                      "answer_id":30258,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:46.633Z",
                      "updated_at":"2022-01-10T23:23:46.633Z",
                      "text":"Mali",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71374,
                      "answer_id":30258,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:46.628Z",
                      "updated_at":"2022-01-10T23:23:46.628Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71373,
                      "answer_id":30258,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:46.623Z",
                      "updated_at":"2022-01-10T23:23:46.623Z",
                      "text":"错",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71372,
                      "answer_id":30258,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:46.619Z",
                      "updated_at":"2022-04-14T22:07:48.303Z",
                      "text":"Allowed for an open conversation about Martin’s options instead of simply saying “no” to his request.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31689,
                "position":3,
                "active":true,
                "question_id":12026,
                "created_at":"2022-04-14T22:08:29.431Z",
                "updated_at":"2022-04-14T22:08:29.431Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Gotten human resources involved to assist with handling Martin’s accommodation request.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77194,
                      "answer_id":31689,
                      "locale":"en",
                      "created_at":"2022-04-14T22:08:29.441Z",
                      "updated_at":"2022-04-14T22:08:29.441Z",
                      "text":"Gotten human resources involved to assist with handling Martin’s accommodation request.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31690,
                "position":4,
                "active":true,
                "question_id":12026,
                "created_at":"2022-04-14T22:08:48.132Z",
                "updated_at":"2022-04-14T22:08:48.132Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"All of the above.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77195,
                      "answer_id":31690,
                      "locale":"en",
                      "created_at":"2022-04-14T22:08:48.140Z",
                      "updated_at":"2022-04-14T22:08:48.140Z",
                      "text":"All of the above.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12027,
          "shuffle":false,
          "position":2,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30260"
          ],
          "created_at":"2022-01-10T23:23:46.708Z",
          "updated_at":"2022-01-10T23:23:47.000Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":2,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Not watching cable news or reading social media means your beliefs and biases won’t be shaped by the media. \n",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29656,
                "question_id":12027,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:46.808Z",
                "updated_at":"2022-01-10T23:23:46.808Z",
                "text":"Televizyon izlememeniz veya sosyal medyada gezinmemeniz inançlarınızın ve ön yargılarınızın medya tarafından şekillendirilmediği anlamına gelir. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29655,
                "question_id":12027,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:46.804Z",
                "updated_at":"2022-01-10T23:23:46.804Z",
                "text":"No ver las noticias ni leer las redes sociales significa que sus creencias y prejuicios no se verán influenciados por los medios. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29654,
                "question_id":12027,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:46.799Z",
                "updated_at":"2022-01-10T23:23:46.799Z",
                "text":"Если не смотреть телевизор и не использовать социальные сети, то СМИ не повлияет на формирование ваших воззрений и предрассудков. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29653,
                "question_id":12027,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:46.794Z",
                "updated_at":"2022-01-10T23:23:46.794Z",
                "text":"Nieoglądanie wiadomości telewizyjnych lub nieczytanie mediów społecznościowych oznacza, że Pana/Pani przekonania i uprzedzenia nie będą kształtowane przez media. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29652,
                "question_id":12027,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:46.789Z",
                "updated_at":"2022-01-10T23:23:46.789Z",
                "text":"케이블 뉴스를 보지 않거나 소셜 미디어를 사용하지 않는다면 여러분의 신념과 편견은 미디어의 영향을 받지 않게 된다. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29651,
                "question_id":12027,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:46.784Z",
                "updated_at":"2022-01-10T23:23:46.784Z",
                "text":"ケーブルニュースを視聴しないことや、ソーシャルメディアを見ないようにすることとは、信念や偏見がメディアによって形成されないことを意味する。 \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29650,
                "question_id":12027,
                "locale":"it",
                "created_at":"2022-01-10T23:23:46.779Z",
                "updated_at":"2022-01-10T23:23:46.779Z",
                "text":"Non guardare le notizie via cavo o leggere i social media significa che le tue opinioni e i tuoi pregiudizi non saranno influenzati dai media. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29649,
                "question_id":12027,
                "locale":"de",
                "created_at":"2022-01-10T23:23:46.774Z",
                "updated_at":"2022-01-10T23:23:46.774Z",
                "text":"Wenn wir weder Kabelfernsehen sehen noch Social Media lesen, werden unsere Überzeugungen und Vorurteile nicht von den Medien beeinflusst. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29648,
                "question_id":12027,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:46.769Z",
                "updated_at":"2022-01-10T23:23:46.769Z",
                "text":"Si vous ne regardez pas les chaînes d'information ou ne lisez pas les publications sur les réseaux sociaux, vos croyances et vos préjugés ne seront pas façonnés par les médias. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29647,
                "question_id":12027,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:46.765Z",
                "updated_at":"2022-01-10T23:23:46.765Z",
                "text":"Si vous ne regardez pas les chaînes d’actualité ou que vous ne lisez pas les messages sur les réseaux sociaux, vos convictions et vos préjugés ne seront pas influencés par les médias. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29646,
                "question_id":12027,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:46.760Z",
                "updated_at":"2022-01-10T23:23:46.760Z",
                "text":"Se você não assiste a canais de notícias ou lê postagens em mídias sociais, suas crenças e preconceitos não serão moldados pela mídia. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29645,
                "question_id":12027,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:46.755Z",
                "updated_at":"2022-01-10T23:23:46.755Z",
                "text":"如果你不看新闻频道或阅读社交媒体帖子，您的观点和偏见就不会被媒体左右。 \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29644,
                "question_id":12027,
                "locale":"es",
                "created_at":"2022-01-10T23:23:46.751Z",
                "updated_at":"2022-01-10T23:23:46.751Z",
                "text":"Si no miras los canales de noticias ni lees publicaciones en las redes sociales, tus creencias y sesgos no se verán influencias por los medios. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29643,
                "question_id":12027,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:46.746Z",
                "updated_at":"2022-01-10T23:23:46.746Z",
                "text":"Kung hindi ka nanonood ng mga channel ng balita o nagbabasa ng mga post sa social media, ang paniniwala mo at pagkiling ay hindi mahuhubog ng media. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29642,
                "question_id":12027,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:46.741Z",
                "updated_at":"2022-01-10T23:23:46.741Z",
                "text":"如你不看新聞或社交媒體貼文，你的信仰和偏見就不會受到媒體影響。 \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29641,
                "question_id":12027,
                "locale":"en",
                "created_at":"2022-01-10T23:23:46.727Z",
                "updated_at":"2022-01-10T23:23:46.727Z",
                "text":"Not watching cable news or reading social media means your beliefs and biases won’t be shaped by the media. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30259,
                "position":1,
                "active":true,
                "question_id":12027,
                "created_at":"2022-01-10T23:23:46.815Z",
                "updated_at":"2022-01-10T23:23:46.815Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"True",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71403,
                      "answer_id":30259,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:46.904Z",
                      "updated_at":"2022-01-10T23:23:46.904Z",
                      "text":"Doğru",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71402,
                      "answer_id":30259,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:46.899Z",
                      "updated_at":"2022-01-10T23:23:46.899Z",
                      "text":"Verdadera",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71401,
                      "answer_id":30259,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:46.894Z",
                      "updated_at":"2022-01-10T23:23:46.894Z",
                      "text":"Правда",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71400,
                      "answer_id":30259,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:46.889Z",
                      "updated_at":"2022-01-10T23:23:46.889Z",
                      "text":"Prawda",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71399,
                      "answer_id":30259,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:46.884Z",
                      "updated_at":"2022-01-10T23:23:46.884Z",
                      "text":"맞음",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71398,
                      "answer_id":30259,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:46.875Z",
                      "updated_at":"2022-01-10T23:23:46.875Z",
                      "text":"〇",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71397,
                      "answer_id":30259,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:46.870Z",
                      "updated_at":"2022-01-10T23:23:46.870Z",
                      "text":"Vero",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71396,
                      "answer_id":30259,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:46.865Z",
                      "updated_at":"2022-01-10T23:23:46.865Z",
                      "text":"Richtig",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71395,
                      "answer_id":30259,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:46.860Z",
                      "updated_at":"2022-01-10T23:23:46.860Z",
                      "text":"Vrai",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71394,
                      "answer_id":30259,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:46.856Z",
                      "updated_at":"2022-01-10T23:23:46.856Z",
                      "text":"Verdadeira",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71393,
                      "answer_id":30259,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:46.851Z",
                      "updated_at":"2022-01-10T23:23:46.851Z",
                      "text":"Vrai",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71392,
                      "answer_id":30259,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:46.846Z",
                      "updated_at":"2022-01-10T23:23:46.846Z",
                      "text":"Verdadero",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71391,
                      "answer_id":30259,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:46.842Z",
                      "updated_at":"2022-01-10T23:23:46.842Z",
                      "text":"Tama",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71390,
                      "answer_id":30259,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:46.837Z",
                      "updated_at":"2022-01-10T23:23:46.837Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71389,
                      "answer_id":30259,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:46.832Z",
                      "updated_at":"2022-01-10T23:23:46.832Z",
                      "text":"对",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71388,
                      "answer_id":30259,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:46.829Z",
                      "updated_at":"2022-01-10T23:23:46.829Z",
                      "text":"True",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30260,
                "position":2,
                "active":true,
                "question_id":12027,
                "created_at":"2022-01-10T23:23:46.910Z",
                "updated_at":"2022-01-10T23:23:46.910Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"False",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71419,
                      "answer_id":30260,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:46.995Z",
                      "updated_at":"2022-01-10T23:23:46.995Z",
                      "text":"Yanlış",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71418,
                      "answer_id":30260,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:46.990Z",
                      "updated_at":"2022-01-10T23:23:46.990Z",
                      "text":"Falsa",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71417,
                      "answer_id":30260,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:46.986Z",
                      "updated_at":"2022-01-10T23:23:46.986Z",
                      "text":"Ложь",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71416,
                      "answer_id":30260,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:46.980Z",
                      "updated_at":"2022-01-10T23:23:46.980Z",
                      "text":"Fałsz",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71415,
                      "answer_id":30260,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:46.975Z",
                      "updated_at":"2022-01-10T23:23:46.975Z",
                      "text":"틀림",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71414,
                      "answer_id":30260,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:46.970Z",
                      "updated_at":"2022-01-10T23:23:46.970Z",
                      "text":"×",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71413,
                      "answer_id":30260,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:46.965Z",
                      "updated_at":"2022-01-10T23:23:46.965Z",
                      "text":"Falso",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71412,
                      "answer_id":30260,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:46.961Z",
                      "updated_at":"2022-01-10T23:23:46.961Z",
                      "text":"Falsch",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71411,
                      "answer_id":30260,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:46.956Z",
                      "updated_at":"2022-01-10T23:23:46.956Z",
                      "text":"Faux",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71410,
                      "answer_id":30260,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:46.951Z",
                      "updated_at":"2022-01-10T23:23:46.951Z",
                      "text":"Fausse",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71409,
                      "answer_id":30260,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:46.946Z",
                      "updated_at":"2022-01-10T23:23:46.946Z",
                      "text":"Falsa",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71408,
                      "answer_id":30260,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:46.941Z",
                      "updated_at":"2022-01-10T23:23:46.941Z",
                      "text":"Falso",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71407,
                      "answer_id":30260,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:46.936Z",
                      "updated_at":"2022-01-10T23:23:46.936Z",
                      "text":"Mali",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71406,
                      "answer_id":30260,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:46.932Z",
                      "updated_at":"2022-01-10T23:23:46.932Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71405,
                      "answer_id":30260,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:46.927Z",
                      "updated_at":"2022-01-10T23:23:46.927Z",
                      "text":"错",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71404,
                      "answer_id":30260,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:46.923Z",
                      "updated_at":"2022-01-10T23:23:46.923Z",
                      "text":"False",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12028,
          "shuffle":false,
          "position":3,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30262"
          ],
          "created_at":"2022-01-10T23:23:47.013Z",
          "updated_at":"2022-04-21T21:00:46.660Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":3,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best action for Cesar to take?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29657,
                "question_id":12028,
                "locale":"en",
                "created_at":"2022-01-10T23:23:47.033Z",
                "updated_at":"2022-04-21T21:00:46.664Z",
                "text":"What is the best action for Cesar to take?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29672,
                "question_id":12028,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:47.115Z",
                "updated_at":"2022-01-10T23:23:47.115Z",
                "text":"Fahad ne yapmalıdır?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29671,
                "question_id":12028,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:47.111Z",
                "updated_at":"2022-01-10T23:23:47.111Z",
                "text":"¿Qué debería hacer Fahad?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29670,
                "question_id":12028,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:47.106Z",
                "updated_at":"2022-01-10T23:23:47.106Z",
                "text":"Что делать Фахаду?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29669,
                "question_id":12028,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:47.102Z",
                "updated_at":"2022-01-10T23:23:47.102Z",
                "text":"Co powinien zrobić Fahad?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29668,
                "question_id":12028,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:47.097Z",
                "updated_at":"2022-01-10T23:23:47.097Z",
                "text":"Fahad는 어떻게 해야 할까요?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29667,
                "question_id":12028,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:47.092Z",
                "updated_at":"2022-01-10T23:23:47.092Z",
                "text":"Fahadさんは何をすべきですか？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29666,
                "question_id":12028,
                "locale":"it",
                "created_at":"2022-01-10T23:23:47.087Z",
                "updated_at":"2022-01-10T23:23:47.087Z",
                "text":"Che cosa dovrebbe fare Fahad?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29665,
                "question_id":12028,
                "locale":"de",
                "created_at":"2022-01-10T23:23:47.083Z",
                "updated_at":"2022-01-10T23:23:47.083Z",
                "text":"Was sollte Fahad tun?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29664,
                "question_id":12028,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:47.078Z",
                "updated_at":"2022-01-10T23:23:47.078Z",
                "text":"Que devrait faire Fahad?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29663,
                "question_id":12028,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:47.073Z",
                "updated_at":"2022-01-10T23:23:47.073Z",
                "text":"Que devrait faire Fahad ?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29662,
                "question_id":12028,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:47.068Z",
                "updated_at":"2022-01-10T23:23:47.068Z",
                "text":"O que Fahad deve fazer?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29661,
                "question_id":12028,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:47.063Z",
                "updated_at":"2022-01-10T23:23:47.063Z",
                "text":"Fahad 应该做什么？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29660,
                "question_id":12028,
                "locale":"es",
                "created_at":"2022-01-10T23:23:47.058Z",
                "updated_at":"2022-01-10T23:23:47.058Z",
                "text":"¿Qué debería hacer Fahad?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29659,
                "question_id":12028,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:47.053Z",
                "updated_at":"2022-01-10T23:23:47.053Z",
                "text":"Ano ang dapat gawin ni Fahad?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29658,
                "question_id":12028,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:47.048Z",
                "updated_at":"2022-01-10T23:23:47.048Z",
                "text":"Fahad 應該怎麼做？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30261,
                "position":1,
                "active":true,
                "question_id":12028,
                "created_at":"2022-01-10T23:23:47.122Z",
                "updated_at":"2022-04-14T22:10:30.469Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Say to Noel, “Why can’t you just get your work done on time for once?”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71420,
                      "answer_id":30261,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:47.137Z",
                      "updated_at":"2022-04-14T22:10:30.470Z",
                      "text":"Say to Noel, “Why can’t you just get your work done on time for once?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71435,
                      "answer_id":30261,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:47.209Z",
                      "updated_at":"2022-01-10T23:23:47.209Z",
                      "text":"Debbie'ye şunu söylemelidir: \"Açıkçası, bu durum beni tedirgin ediyor ve biraz da hayal kırıklığına uğratıyor. Son tarih konusunda anlaştığımızı sanıyordum. Yarını en iyi şekilde geçirmek istiyorum. Bu durumu nasıl düzeltebiliriz?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71434,
                      "answer_id":30261,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:47.204Z",
                      "updated_at":"2022-01-10T23:23:47.204Z",
                      "text":"Decirle a Debbie: \"Honestamente, esto me pone nervioso y me frustra un poco. Pensaba que habíamos acordado una fecha límite. Quiero que destaquemos el día de mañana. ¿Cómo podemos avanzar desde aquí?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71433,
                      "answer_id":30261,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:47.199Z",
                      "updated_at":"2022-01-10T23:23:47.199Z",
                      "text":"Ответить Дебби: «Честно говоря, я из-за этого нервничаю и слегка фрустрирован: я думал, мы согласовали крайние сроки. Я хочу, чтобы завтра все прошло успешно. Как нам лучше всего поступить?»",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71432,
                      "answer_id":30261,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:47.195Z",
                      "updated_at":"2022-01-10T23:23:47.195Z",
                      "text":"Powiedzieć Debbie: „Szczerze mówiąc, to mnie denerwuje i trochę frustruje — myślałem, że uzgodniliśmy termin. Naprawdę chciałbym, żebyśmy jutro błyszczeli. Jak możemy ruszyć do przodu?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71431,
                      "answer_id":30261,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:47.190Z",
                      "updated_at":"2022-01-10T23:23:47.190Z",
                      "text":"Debbie에게 다음과 같이 말한다.“솔직히 이 상황이 걱정스럽고 약간 실망스럽네요. 저는 우리가 마감일에 동의했다고 생각했어요. 내일 우리가 잘 해낼 수 있으면 좋겠어요. 어떻게 해결하면 될까요?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71430,
                      "answer_id":30261,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:47.186Z",
                      "updated_at":"2022-01-10T23:23:47.186Z",
                      "text":"Debbieさんに、「正直に言いますと、これは私を不安にさせます。多少苛立ちも覚えます。締め切りに同意したと思っていたのですが。本当に、明日成功させたかったです。ここからどう進めることができますか？」と言う。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71429,
                      "answer_id":30261,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:47.181Z",
                      "updated_at":"2022-01-10T23:23:47.181Z",
                      "text":"Dire a Debbie: “Sinceramente questa situazione mi rende nervoso e un po’ frustrato, pensavo avessimo concordato una scadenza. Desidero davvero che la nostra figura sia eccellente domani. Come possiamo proseguire da qui?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71428,
                      "answer_id":30261,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:47.176Z",
                      "updated_at":"2022-01-10T23:23:47.176Z",
                      "text":"Folgendes zu Debbie sagen: „Ehrlich gesagt macht es mich nervös und frustriert mich ein bisschen. Ich dachte, wir hätten eine Frist vereinbart. Ich will, dass wir morgen wirklich glänzen. Wie können wir nun weitermachen?“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71427,
                      "answer_id":30261,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:47.170Z",
                      "updated_at":"2022-01-10T23:23:47.170Z",
                      "text":"Dites à Debbie: « Honnêtement, cela me rend nerveux et un peu frustré - je pensais que nous nous étions mis d'accord sur une date limite. Je veux vraiment qu'on brille demain. Comment pouvons-nous avancer à partir d'ici? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71426,
                      "answer_id":30261,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:47.166Z",
                      "updated_at":"2022-01-10T23:23:47.166Z",
                      "text":"Dire à Debbie : « Franchement, ça m’énerve et ça me déçoit. Je pensais que nous nous étions mis d’accord sur une date limite. Nous devons vraiment donner le meilleur de nous-mêmes demain. Qu’est-ce qu’on fait maintenant ? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71425,
                      "answer_id":30261,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:47.161Z",
                      "updated_at":"2022-01-10T23:23:47.161Z",
                      "text":"Dizer a Debbie: “Honestamente, isso me deixa nervoso e um pouco frustrado. Achei que tivéssemos combinado um prazo. Eu realmente quero que brilhemos amanhã. Como podemos seguir em frente a partir daqui?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71424,
                      "answer_id":30261,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:47.156Z",
                      "updated_at":"2022-01-10T23:23:47.156Z",
                      "text":"Decir a Debbie: “Honestamente, esto me pone nervioso, y un poco frustrado. Creí que habíamos acordado un plazo. Realmente quiero que nos destaquemos mañana. ¿Cómo podemos avanzar desde aquí?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71423,
                      "answer_id":30261,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:47.151Z",
                      "updated_at":"2022-01-10T23:23:47.151Z",
                      "text":"Sabihin kay Debbie, “Ang totoo, kinakabahan ako dahil dito, at medyo nababahala—Akala ko ay napagkasunduan na namin ang deadline. Gusto kong sumikat kami bukas. Paano kami makakausad mula rito?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71422,
                      "answer_id":30261,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:47.147Z",
                      "updated_at":"2022-01-10T23:23:47.147Z",
                      "text":"跟 Debbie 說：「老實說，這樣會讓我緊張，也會覺得有點挫折—我以為我們對於期限已經有共識。我真心希望明天我們能有傑出的表現。我們現在該怎麼進行呢？",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71421,
                      "answer_id":30261,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:47.141Z",
                      "updated_at":"2022-01-10T23:23:47.141Z",
                      "text":"对 Debbie 说，“说实话，这让我感到紧张，还有一点生气 - 我认为我们已商定了期限。我确实希望我们明天能令人眼前一亮。现在我们该怎么办？”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30262,
                "position":2,
                "active":true,
                "question_id":12028,
                "created_at":"2022-01-10T23:23:47.215Z",
                "updated_at":"2022-04-21T21:01:17.792Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Say to Noel, “I’m feeling stressed about these onboarding materials. We both have a lot on our plates, but I am a little frustrated that we haven’t made more progress. How can we move forward?",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71436,
                      "answer_id":30262,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:47.228Z",
                      "updated_at":"2022-04-21T21:01:17.794Z",
                      "text":"Say to Noel, “I’m feeling stressed about these onboarding materials. We both have a lot on our plates, but I am a little frustrated that we haven’t made more progress. How can we move forward?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71451,
                      "answer_id":30262,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:47.299Z",
                      "updated_at":"2022-01-10T23:23:47.299Z",
                      "text":"Debbie'ye şunu söylemelidir: \"Beni çok kötü bir duruma düşüreceksin! Bu gerçekten sorumsuz ve bencilce bir davranış.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71450,
                      "answer_id":30262,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:47.294Z",
                      "updated_at":"2022-01-10T23:23:47.294Z",
                      "text":"Decirle a Debbie: \"Me vas a hacer quedar muy mal. Esto es muy irresponsable y egoísta\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71449,
                      "answer_id":30262,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:47.290Z",
                      "updated_at":"2022-01-10T23:23:47.290Z",
                      "text":"Ответить Дебби: «Из-за тебя я буду выглядеть ужасно! Это так безответственно и эгоистично».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71448,
                      "answer_id":30262,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:47.285Z",
                      "updated_at":"2022-01-10T23:23:47.285Z",
                      "text":"Powiedzieć Debbie: „Sprawisz, że wypadnę źle! To jest naprawdę nieodpowiedzialne i samolubne”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71447,
                      "answer_id":30262,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:47.280Z",
                      "updated_at":"2022-01-10T23:23:47.280Z",
                      "text":"Debbie에게 “당신 때문에 내가 곤란하게 되었잖아요! 정말 무책임하고 이기적이네요.” 라고 말한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71446,
                      "answer_id":30262,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:47.275Z",
                      "updated_at":"2022-01-10T23:23:47.275Z",
                      "text":"Debbieさんに、「私にひどく恥をかかせるつもりですね！本当に無責任ですし、身勝手です。」と言う。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71445,
                      "answer_id":30262,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:47.270Z",
                      "updated_at":"2022-01-10T23:23:47.270Z",
                      "text":"Dire a Debbie: “Mi farai fare una brutta figura! Questo comportamento è davvero irresponsabile ed egoista”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71444,
                      "answer_id":30262,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:47.266Z",
                      "updated_at":"2022-01-10T23:23:47.266Z",
                      "text":"Folgendes zu Debbie sagen: „Deinetwegen werde ich einen schlechten Eindruck hinterlassen! Wie verantwortungslos und egoistisch das ist.“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71443,
                      "answer_id":30262,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:47.261Z",
                      "updated_at":"2022-01-10T23:23:47.261Z",
                      "text":"Dites à Debbie: « Vous allez me faire paraître très mauvais! C'est vraiment irresponsable et égoïste. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71442,
                      "answer_id":30262,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:47.257Z",
                      "updated_at":"2022-01-10T23:23:47.257Z",
                      "text":"Dire à Debbie : « De quoi vais-je avoir l’air maintenant ? C’est vraiment irresponsable et égoïste de ta part. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71441,
                      "answer_id":30262,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:47.252Z",
                      "updated_at":"2022-01-10T23:23:47.252Z",
                      "text":"Dizer a Debbie: “Você vai me fazer ficar muito mal! Isso é muita irresponsabilidade e egoísmo.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71440,
                      "answer_id":30262,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:47.247Z",
                      "updated_at":"2022-01-10T23:23:47.247Z",
                      "text":"Decir a Debbie: “¡Me harás quedar muy mal! Es realmente irresponsable y egoísta\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71439,
                      "answer_id":30262,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:47.242Z",
                      "updated_at":"2022-01-10T23:23:47.242Z",
                      "text":"Sabihin kay Debbie, “Gagawin mo akong mukhang napakasama! Napaka-iresponsable niyan at makasarili.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71438,
                      "answer_id":30262,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:47.237Z",
                      "updated_at":"2022-01-10T23:23:47.237Z",
                      "text":"跟 Debbie 說：「你會讓我很難看！這非常不負責也很自私。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71437,
                      "answer_id":30262,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:47.232Z",
                      "updated_at":"2022-01-10T23:23:47.232Z",
                      "text":"对 Debbie 说，“你会令我很难堪！这完全是不负责任和自私的行为。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30263,
                "position":3,
                "active":true,
                "question_id":12028,
                "created_at":"2022-01-10T23:23:47.305Z",
                "updated_at":"2022-04-14T22:11:06.784Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Ignore his feelings and offer to do Noel’s work for them. It might be frustrating, but at least he’ll know the work will get done on time.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71452,
                      "answer_id":30263,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:47.318Z",
                      "updated_at":"2022-04-14T22:11:06.788Z",
                      "text":"Ignore his feelings and offer to do Noel’s work for them. It might be frustrating, but at least he’ll know the work will get done on time.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71467,
                      "answer_id":30263,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:47.391Z",
                      "updated_at":"2022-01-10T23:23:47.391Z",
                      "text":"Hayal kırıklığını saklamalı ve Debbie'ye yalnızca şunu sormalıdır: \"Yarına kadar hazır olacak değil mi?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71466,
                      "answer_id":30263,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:47.387Z",
                      "updated_at":"2022-01-10T23:23:47.387Z",
                      "text":"Reprimir su frustración y preguntar a Debbie: \"Estarán listos para mañana, ¿no?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71465,
                      "answer_id":30263,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:47.382Z",
                      "updated_at":"2022-01-10T23:23:47.382Z",
                      "text":"Подавить фрустрацию и просто спросить Дебби: «Завтра все будет готово, да?»",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71464,
                      "answer_id":30263,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:47.377Z",
                      "updated_at":"2022-01-10T23:23:47.377Z",
                      "text":"Powstrzymać frustrację i po prostu zapytać Debbie „Będzie to zrobione do jutra, prawda?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71463,
                      "answer_id":30263,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:47.372Z",
                      "updated_at":"2022-01-10T23:23:47.372Z",
                      "text":"답답함을 억누르고 Debbie에게 \"내일까지 끝낼 수 있죠?\"라고 물어본다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71462,
                      "answer_id":30263,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:47.367Z",
                      "updated_at":"2022-01-10T23:23:47.367Z",
                      "text":"苛立ちを押し殺し、Debbieさんに「明日までに終わりますよね？」とだけ聞く。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71461,
                      "answer_id":30263,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:47.362Z",
                      "updated_at":"2022-01-10T23:23:47.362Z",
                      "text":"Reprimere la sua frustrazione e chiedere semplicemente a Debbie “Il lavoro sarà completato entro domani, giusto?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71460,
                      "answer_id":30263,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:47.358Z",
                      "updated_at":"2022-01-10T23:23:47.358Z",
                      "text":"Seinen Frust unterdrücken und Debbie nur Folgendes fragen: „Bis morgen ist alles fertig, oder?“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71459,
                      "answer_id":30263,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:47.353Z",
                      "updated_at":"2022-01-10T23:23:47.353Z",
                      "text":"Ravaler sa frustration et demandez simplement à Debbie: « Vous en aurez fini avec d'ici demain, non? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71458,
                      "answer_id":30263,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:47.348Z",
                      "updated_at":"2022-01-10T23:23:47.348Z",
                      "text":"Refouler sa frustration et demander à Debbie : « Ce sera prêt demain, pas vrai ? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71457,
                      "answer_id":30263,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:47.344Z",
                      "updated_at":"2022-01-10T23:23:47.344Z",
                      "text":"Engolir sua frustração e simplesmente perguntar a Debbie \"Amanhã estarão prontos, certo?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71456,
                      "answer_id":30263,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:47.339Z",
                      "updated_at":"2022-01-10T23:23:47.339Z",
                      "text":"Reprimir su frustración y simplemente preguntar a Debbie: “Terminarán para mañana, ¿verdad?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71455,
                      "answer_id":30263,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:47.333Z",
                      "updated_at":"2022-01-10T23:23:47.333Z",
                      "text":"Pigilan ang galit niya at tanungin na lang si Debbie ng “Matatapos iyon bukas, hindi ba?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71454,
                      "answer_id":30263,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:47.328Z",
                      "updated_at":"2022-01-10T23:23:47.328Z",
                      "text":"壓抑自己的挫折感，簡單地問 Debbie：「這些東西明天會弄好，對嗎？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71453,
                      "answer_id":30263,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:47.323Z",
                      "updated_at":"2022-01-10T23:23:47.323Z",
                      "text":"克制住他的愤怒，只是问 Debbie“明天可以完成，对吧？”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12029,
          "shuffle":false,
          "position":4,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30266"
          ],
          "created_at":"2022-01-10T23:23:47.408Z",
          "updated_at":"2022-04-21T21:02:11.211Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":4,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Could Michele’s comment be problematic?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29673,
                "question_id":12029,
                "locale":"en",
                "created_at":"2022-01-10T23:23:47.430Z",
                "updated_at":"2022-04-21T21:02:11.213Z",
                "text":"Could Michele’s comment be problematic?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29688,
                "question_id":12029,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:47.519Z",
                "updated_at":"2022-01-10T23:23:47.519Z",
                "text":"Hangisi sorunlu bir davranış değildir?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29687,
                "question_id":12029,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:47.515Z",
                "updated_at":"2022-01-10T23:23:47.515Z",
                "text":"¿Cuál de las siguientes opciones no es un comportamiento problemático?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29686,
                "question_id":12029,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:47.510Z",
                "updated_at":"2022-01-10T23:23:47.510Z",
                "text":"Какое поведение не является проблемным?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29685,
                "question_id":12029,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:47.505Z",
                "updated_at":"2022-01-10T23:23:47.505Z",
                "text":"Które z poniższych zachowań nie jest zachowaniem problematycznym?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29684,
                "question_id":12029,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:47.499Z",
                "updated_at":"2022-01-10T23:23:47.499Z",
                "text":"다음 중 문제가 없는 행동은 무엇일까요?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29683,
                "question_id":12029,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:47.494Z",
                "updated_at":"2022-01-10T23:23:47.494Z",
                "text":"次のうち、問題となるような行動でないものはどれですか？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29682,
                "question_id":12029,
                "locale":"it",
                "created_at":"2022-01-10T23:23:47.489Z",
                "updated_at":"2022-01-10T23:23:47.489Z",
                "text":"Quale dei seguenti non è un comportamento problematico?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29681,
                "question_id":12029,
                "locale":"de",
                "created_at":"2022-01-10T23:23:47.485Z",
                "updated_at":"2022-01-10T23:23:47.485Z",
                "text":"Welche der folgenden Verhaltensweisen sind nicht problematisch?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29680,
                "question_id":12029,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:47.480Z",
                "updated_at":"2022-01-10T23:23:47.480Z",
                "text":"Lequel des éléments suivants n'est pas un comportement problématique?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29679,
                "question_id":12029,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:47.475Z",
                "updated_at":"2022-01-10T23:23:47.475Z",
                "text":"Parmi les comportements suivants, lequel ne pose pas problème ?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29678,
                "question_id":12029,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:47.470Z",
                "updated_at":"2022-01-10T23:23:47.470Z",
                "text":"Qual das alternativas a seguir não é um comportamento problemático?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29677,
                "question_id":12029,
                "locale":"es",
                "created_at":"2022-01-10T23:23:47.465Z",
                "updated_at":"2022-01-10T23:23:47.465Z",
                "text":"¿Cuál de las siguientes opciones no es un comportamiento problemático?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29676,
                "question_id":12029,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:47.460Z",
                "updated_at":"2022-01-10T23:23:47.460Z",
                "text":"Alin sa sumusunod ang hindi problemang pag-uugali?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29675,
                "question_id":12029,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:47.455Z",
                "updated_at":"2022-01-10T23:23:47.455Z",
                "text":"以下哪一项不是问题行为？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29674,
                "question_id":12029,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:47.449Z",
                "updated_at":"2022-01-10T23:23:47.449Z",
                "text":"下列何者是有問題的行為？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30264,
                "position":1,
                "active":true,
                "question_id":12029,
                "created_at":"2022-01-10T23:23:47.526Z",
                "updated_at":"2022-04-21T21:02:57.991Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Yes. Michele seems to be unnecessarily bringing Gabrielle’s tic disorder this decision.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71468,
                      "answer_id":30264,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:47.540Z",
                      "updated_at":"2022-04-21T21:02:57.994Z",
                      "text":"Yes. Michele seems to be unnecessarily bringing Gabrielle’s tic disorder this decision.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71483,
                      "answer_id":30264,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:47.615Z",
                      "updated_at":"2022-01-10T23:23:47.615Z",
                      "text":"Aradaki bağlılığın bir göstergesi olduğundan bağırmak sorunlu bir davranış değildir.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71482,
                      "answer_id":30264,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:47.610Z",
                      "updated_at":"2022-01-10T23:23:47.610Z",
                      "text":"Gritar, porque muestra compromiso.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71481,
                      "answer_id":30264,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:47.602Z",
                      "updated_at":"2022-01-10T23:23:47.602Z",
                      "text":"Переход на крик, так как это говорит об энтузиазме.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71480,
                      "answer_id":30264,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:47.597Z",
                      "updated_at":"2022-01-10T23:23:47.597Z",
                      "text":"Krzyk, bo pokazuje zaangażowanie.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71479,
                      "answer_id":30264,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:47.592Z",
                      "updated_at":"2022-01-10T23:23:47.592Z",
                      "text":"소리지르기 - 몰입감을 보여주기 때문에.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71478,
                      "answer_id":30264,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:47.587Z",
                      "updated_at":"2022-01-10T23:23:47.587Z",
                      "text":"怒鳴ること（エンゲージメントを示すため）。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71477,
                      "answer_id":30264,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:47.583Z",
                      "updated_at":"2022-01-10T23:23:47.583Z",
                      "text":"Gridare, perché mostra impegno.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71476,
                      "answer_id":30264,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:47.578Z",
                      "updated_at":"2022-01-10T23:23:47.578Z",
                      "text":"Schreien, weil es Engagement beweist.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71475,
                      "answer_id":30264,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:47.573Z",
                      "updated_at":"2022-01-10T23:23:47.573Z",
                      "text":"Crier, parce que cela montre l'engagement.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71474,
                      "answer_id":30264,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:47.568Z",
                      "updated_at":"2022-01-10T23:23:47.568Z",
                      "text":"Crier, parce que c’est faire preuve d’engagement.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71473,
                      "answer_id":30264,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:47.564Z",
                      "updated_at":"2022-01-10T23:23:47.564Z",
                      "text":"Gritar, porque mostra engajamento.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71472,
                      "answer_id":30264,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:47.559Z",
                      "updated_at":"2022-01-10T23:23:47.559Z",
                      "text":"Gritar, porque demuestra compromiso.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71471,
                      "answer_id":30264,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:47.554Z",
                      "updated_at":"2022-01-10T23:23:47.554Z",
                      "text":"Pagsigaw, dahil nagpapakita ito ng pakikipag-ugnayan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71470,
                      "answer_id":30264,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:47.549Z",
                      "updated_at":"2022-01-10T23:23:47.549Z",
                      "text":"大喊大叫，因為這樣才顯得出自己的投入。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71469,
                      "answer_id":30264,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:47.544Z",
                      "updated_at":"2022-01-10T23:23:47.544Z",
                      "text":"叫嚷，因为这样可以显示认真负责。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30265,
                "position":2,
                "active":true,
                "question_id":12029,
                "created_at":"2022-01-10T23:23:47.621Z",
                "updated_at":"2022-04-21T21:03:08.829Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Maybe. It depends on how Jaylan reacts.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71499,
                      "answer_id":30265,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:47.708Z",
                      "updated_at":"2022-01-10T23:23:47.708Z",
                      "text":"Dave, yaşı ve geçmişi sayesinde onun bakış açısının herkesten daha önemli olduğunu söylüyor. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71498,
                      "answer_id":30265,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:47.703Z",
                      "updated_at":"2022-01-10T23:23:47.703Z",
                      "text":"Dave explica que su edad y antecedentes hacen que su perspectiva sea lo más importante. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71497,
                      "answer_id":30265,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:47.698Z",
                      "updated_at":"2022-01-10T23:23:47.698Z",
                      "text":"Дэйв объясняет, что в силу возраста и опыта именно его точка зрения самая важная. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71496,
                      "answer_id":30265,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:47.693Z",
                      "updated_at":"2022-01-10T23:23:47.693Z",
                      "text":"Dave wyjaśnia, że z racji wieku i pochodzenia jego perspektywa jest najważniejsza. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71495,
                      "answer_id":30265,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:47.688Z",
                      "updated_at":"2022-01-10T23:23:47.688Z",
                      "text":"Dave는 자신의 나이와 배경때문에 자신의 관점이 가장 중요하다고 말합니다. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71494,
                      "answer_id":30265,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:47.684Z",
                      "updated_at":"2022-01-10T23:23:47.684Z",
                      "text":"Daveさんは、自身の年齢と背景が自身の見方に最も重要な影響を与えていると説明しました。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71493,
                      "answer_id":30265,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:47.678Z",
                      "updated_at":"2022-01-10T23:23:47.678Z",
                      "text":"Dave spiega che la sua età e il suo contesto rendono il suo punto di vista il più importante. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71492,
                      "answer_id":30265,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:47.673Z",
                      "updated_at":"2022-01-10T23:23:47.673Z",
                      "text":"Dave erklärt, dass sein Alter und sein Hintergrund seine Ansicht zur wichtigsten machen. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71491,
                      "answer_id":30265,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:47.668Z",
                      "updated_at":"2022-01-10T23:23:47.668Z",
                      "text":"Dave explique que son âge et ses antécédents donnent plus de valeur à son point de vue. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71490,
                      "answer_id":30265,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:47.663Z",
                      "updated_at":"2022-01-10T23:23:47.663Z",
                      "text":"Dave explique qu’en raison de son âge et de ses antécédents, son point de vue est le plus important. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71489,
                      "answer_id":30265,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:47.658Z",
                      "updated_at":"2022-01-10T23:23:47.658Z",
                      "text":"Dave explica que sua idade e formação tornam sua perspectiva a mais importante. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71488,
                      "answer_id":30265,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:47.653Z",
                      "updated_at":"2022-01-10T23:23:47.653Z",
                      "text":"Dave explica que su edad y antecedentes hacen que su perspectiva sea la más importante. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71487,
                      "answer_id":30265,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:47.648Z",
                      "updated_at":"2022-01-10T23:23:47.648Z",
                      "text":"Ipinaliwanag ni Dave na ang edad niya at pinagmulan ang dahilan kung bakit pinakamahalaga ang kanyang pananaw. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71486,
                      "answer_id":30265,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:47.643Z",
                      "updated_at":"2022-01-10T23:23:47.643Z",
                      "text":"Dave 解釋，因為自己的年紀和背景，他的觀點應該最重要。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71485,
                      "answer_id":30265,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:47.638Z",
                      "updated_at":"2022-01-10T23:23:47.638Z",
                      "text":"Dave 解释说他的年龄和背景让的观点显得极为重要。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71484,
                      "answer_id":30265,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:47.634Z",
                      "updated_at":"2022-04-21T21:03:08.831Z",
                      "text":"Maybe. It depends on how Jaylan reacts.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30266,
                "position":3,
                "active":true,
                "question_id":12029,
                "created_at":"2022-01-10T23:23:47.714Z",
                "updated_at":"2022-04-21T21:03:23.969Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"No. If Michele thinks Gabrielle doesn't present the image she prefers, then Gabrielle shouldn’t be the one to present to the client.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71500,
                      "answer_id":30266,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:47.727Z",
                      "updated_at":"2022-04-21T21:03:23.972Z",
                      "text":"No. If Michele thinks Gabrielle doesn't present the image she prefers, then Gabrielle shouldn’t be the one to present to the client.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71515,
                      "answer_id":30266,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:47.803Z",
                      "updated_at":"2022-01-10T23:23:47.803Z",
                      "text":"Bu konuda kesinlikle aynı fikirde değiller. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71514,
                      "answer_id":30266,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:47.798Z",
                      "updated_at":"2022-01-10T23:23:47.798Z",
                      "text":"El hecho de que estén totalmente en desacuerdo. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71513,
                      "answer_id":30266,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:47.791Z",
                      "updated_at":"2022-01-10T23:23:47.791Z",
                      "text":"Тот факт, что они категорически не согласны. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71512,
                      "answer_id":30266,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:47.786Z",
                      "updated_at":"2022-01-10T23:23:47.786Z",
                      "text":"Fakt, że zdecydowanie nie zgadzają się ze sobą. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71511,
                      "answer_id":30266,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:47.781Z",
                      "updated_at":"2022-01-10T23:23:47.781Z",
                      "text":"그들이 강하게 반대하는 사실. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71510,
                      "answer_id":30266,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:47.776Z",
                      "updated_at":"2022-01-10T23:23:47.776Z",
                      "text":"周りが強く反対しているという事実。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71509,
                      "answer_id":30266,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:47.771Z",
                      "updated_at":"2022-01-10T23:23:47.771Z",
                      "text":"Il fatto che siano fortemente in disaccordo. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71508,
                      "answer_id":30266,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:47.766Z",
                      "updated_at":"2022-01-10T23:23:47.766Z",
                      "text":"Die Tatsache, dass sie überhaupt nicht zustimmen. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71507,
                      "answer_id":30266,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:47.761Z",
                      "updated_at":"2022-01-10T23:23:47.761Z",
                      "text":"Le fait qu'ils ne sont pas du tout d'accord. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71506,
                      "answer_id":30266,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:47.757Z",
                      "updated_at":"2022-01-10T23:23:47.757Z",
                      "text":"Le fait qu’ils ne sont pas du tout d’accord. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71505,
                      "answer_id":30266,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:47.751Z",
                      "updated_at":"2022-01-10T23:23:47.751Z",
                      "text":"O fato de que eles discordam fortemente. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71504,
                      "answer_id":30266,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:47.746Z",
                      "updated_at":"2022-01-10T23:23:47.746Z",
                      "text":"El hecho de que están totalmente en desacuerdo. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71503,
                      "answer_id":30266,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:47.741Z",
                      "updated_at":"2022-01-10T23:23:47.741Z",
                      "text":"Ang katotohanan na lubhang hindi sila nagkakasundo. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71502,
                      "answer_id":30266,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:47.737Z",
                      "updated_at":"2022-01-10T23:23:47.737Z",
                      "text":"事實是他們倆意見完全不同。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71501,
                      "answer_id":30266,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:47.732Z",
                      "updated_at":"2022-01-10T23:23:47.732Z",
                      "text":"他们意见严重不一致的问题。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12030,
          "shuffle":false,
          "position":5,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30268"
          ],
          "created_at":"2022-01-10T23:23:47.820Z",
          "updated_at":"2022-01-10T23:23:48.216Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":5,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What’s Guzman’s best path forward?\n",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29704,
                "question_id":12030,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:47.937Z",
                "updated_at":"2022-01-10T23:23:47.937Z",
                "text":"Guzman'ın yapabileceği en iyi şey nedir?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29703,
                "question_id":12030,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:47.932Z",
                "updated_at":"2022-01-10T23:23:47.932Z",
                "text":"¿Cuál es el mejor camino a seguir de Guzman?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29702,
                "question_id":12030,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:47.928Z",
                "updated_at":"2022-01-10T23:23:47.928Z",
                "text":"Что делать Гузману дальше?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29701,
                "question_id":12030,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:47.923Z",
                "updated_at":"2022-01-10T23:23:47.923Z",
                "text":"Jaki jest najlepszy sposób dla Guzmana?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29700,
                "question_id":12030,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:47.918Z",
                "updated_at":"2022-01-10T23:23:47.918Z",
                "text":"Guzman의 최선책은 무엇일까요?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29699,
                "question_id":12030,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:47.914Z",
                "updated_at":"2022-01-10T23:23:47.914Z",
                "text":"Guzmanさんがこの先進むべき最良の道はどれでしょうか？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29698,
                "question_id":12030,
                "locale":"it",
                "created_at":"2022-01-10T23:23:47.909Z",
                "updated_at":"2022-01-10T23:23:47.909Z",
                "text":"Qual è il miglior modo di procedere per Guzman?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29697,
                "question_id":12030,
                "locale":"de",
                "created_at":"2022-01-10T23:23:47.904Z",
                "updated_at":"2022-01-10T23:23:47.904Z",
                "text":"Welchen Schritt sollte Guzman am besten wählen?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29696,
                "question_id":12030,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:47.899Z",
                "updated_at":"2022-01-10T23:23:47.899Z",
                "text":"Quelle est la meilleure voie à suivre pour Guzman?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29695,
                "question_id":12030,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:47.894Z",
                "updated_at":"2022-01-10T23:23:47.894Z",
                "text":"Quelle est la meilleure chose à faire pour Guzman ?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29694,
                "question_id":12030,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:47.890Z",
                "updated_at":"2022-01-10T23:23:47.890Z",
                "text":"Qual é o melhor caminho a seguir por Guzman?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29693,
                "question_id":12030,
                "locale":"es",
                "created_at":"2022-01-10T23:23:47.884Z",
                "updated_at":"2022-01-10T23:23:47.884Z",
                "text":"¿Cuál es la mejor opción para Guzman?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29692,
                "question_id":12030,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:47.880Z",
                "updated_at":"2022-01-10T23:23:47.880Z",
                "text":"Ano ang pinakamahusay kay Guzman para sumulong?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29691,
                "question_id":12030,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:47.867Z",
                "updated_at":"2022-01-10T23:23:47.867Z",
                "text":"Guzman 接下来最佳的做法是什么？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29690,
                "question_id":12030,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:47.861Z",
                "updated_at":"2022-01-10T23:23:47.861Z",
                "text":"要繼續下去，Guzman 最好的做法是甚麼？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29689,
                "question_id":12030,
                "locale":"en",
                "created_at":"2022-01-10T23:23:47.842Z",
                "updated_at":"2022-01-10T23:23:47.842Z",
                "text":"What’s Guzman’s best path forward?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30267,
                "position":1,
                "active":true,
                "question_id":12030,
                "created_at":"2022-01-10T23:23:47.944Z",
                "updated_at":"2022-01-10T23:23:47.944Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Say “Please stop checking your phone—that’s rude.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71531,
                      "answer_id":30267,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:48.029Z",
                      "updated_at":"2022-01-10T23:23:48.029Z",
                      "text":"Şunu söylemelidir: \"Lütfen telefonuna bakmayı bırak; bu çok kaba bir davranış.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71530,
                      "answer_id":30267,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:48.024Z",
                      "updated_at":"2022-01-10T23:23:48.024Z",
                      "text":"Decir: \"Por favor, deja de mirar el teléfono, es de mala educación\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71529,
                      "answer_id":30267,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:48.019Z",
                      "updated_at":"2022-01-10T23:23:48.019Z",
                      "text":"Сказать: «Пожалуйста, отложите телефон — это невежливо».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71528,
                      "answer_id":30267,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:48.015Z",
                      "updated_at":"2022-01-10T23:23:48.015Z",
                      "text":"Powiedzieć: „Proszę, przestań sprawdzać swój telefon — to niegrzeczne”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71527,
                      "answer_id":30267,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:48.008Z",
                      "updated_at":"2022-01-10T23:23:48.008Z",
                      "text":"“휴대 전화 좀 그만 보세요. 예의가 없으시네요”라고 말한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71526,
                      "answer_id":30267,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:48.004Z",
                      "updated_at":"2022-01-10T23:23:48.004Z",
                      "text":"「携帯を見続けるのはやめてください、失礼に当たります。」と言う。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71525,
                      "answer_id":30267,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:47.999Z",
                      "updated_at":"2022-01-10T23:23:47.999Z",
                      "text":"Dire “Per favore, smetti di controllare il telefono perché è un comportamento scortese”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71524,
                      "answer_id":30267,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:47.994Z",
                      "updated_at":"2022-01-10T23:23:47.994Z",
                      "text":"Sagen: „Bitte hör auf, dein Telefon zu benutzen. Das ist unhöflich.“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71523,
                      "answer_id":30267,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:47.989Z",
                      "updated_at":"2022-01-10T23:23:47.989Z",
                      "text":"Dites « Veuillez arrêter de consulter votre téléphone, c'est impoli. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71522,
                      "answer_id":30267,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:47.984Z",
                      "updated_at":"2022-01-10T23:23:47.984Z",
                      "text":"Dire : « Arrête de regarder ton téléphone, c’est impoli. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71521,
                      "answer_id":30267,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:47.980Z",
                      "updated_at":"2022-01-10T23:23:47.980Z",
                      "text":"Dizer: “Por favor, pare de ficar olhando seu telefone - isso é muito desagradável”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71520,
                      "answer_id":30267,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:47.975Z",
                      "updated_at":"2022-01-10T23:23:47.975Z",
                      "text":"Decir: “Por favor, deja de mirar tu teléfono; es grosero”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71519,
                      "answer_id":30267,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:47.971Z",
                      "updated_at":"2022-01-10T23:23:47.971Z",
                      "text":"Sabihin na “Pwede bang itigil mo na ang pagtingin sa telepono mo—kabastusan yan.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71518,
                      "answer_id":30267,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:47.966Z",
                      "updated_at":"2022-01-10T23:23:47.966Z",
                      "text":"說：「不要在看手機了—那樣很沒禮貌。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71517,
                      "answer_id":30267,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:47.961Z",
                      "updated_at":"2022-01-10T23:23:47.961Z",
                      "text":"说“请停止看手机 - 这样做很没礼貌。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71516,
                      "answer_id":30267,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:47.957Z",
                      "updated_at":"2022-01-10T23:23:47.957Z",
                      "text":"Say “Please stop checking your phone—that’s rude.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30268,
                "position":2,
                "active":true,
                "question_id":12030,
                "created_at":"2022-01-10T23:23:48.035Z",
                "updated_at":"2022-01-10T23:23:48.035Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Ask, “Is everything OK, Sam? Is this still a good time to meet?”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71547,
                      "answer_id":30268,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:48.120Z",
                      "updated_at":"2022-01-10T23:23:48.120Z",
                      "text":"Şunu sormalıdır: \"Sam, her şey yolunda mı? Hala buluşmak için iyi bir zaman olduğunu mu düşünüyorsun?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71546,
                      "answer_id":30268,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:48.115Z",
                      "updated_at":"2022-01-10T23:23:48.115Z",
                      "text":"Preguntar: \"¿Va todo bien, Sam? ¿Sigue siendo un buen momento para reunirse?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71545,
                      "answer_id":30268,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:48.110Z",
                      "updated_at":"2022-01-10T23:23:48.110Z",
                      "text":"Спросить: «Все в порядке, Сэм? Сейчас удобное время для встречи?»",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71544,
                      "answer_id":30268,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:48.105Z",
                      "updated_at":"2022-01-10T23:23:48.105Z",
                      "text":"Zapytać: „Sam, czy wszystko w porządku? Czy to dobry moment na spotkanie?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71543,
                      "answer_id":30268,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:48.101Z",
                      "updated_at":"2022-01-10T23:23:48.101Z",
                      "text":"“별일 없는 건가요, Sam? 지금 만나서 얘기하기에 괜찮은 시간인가요?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71542,
                      "answer_id":30268,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:48.096Z",
                      "updated_at":"2022-01-10T23:23:48.096Z",
                      "text":"「Samさん、なにかありましたか？会議を進めても大丈夫ですか？」と聞く。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71541,
                      "answer_id":30268,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:48.091Z",
                      "updated_at":"2022-01-10T23:23:48.091Z",
                      "text":"Chiedere: “Va tutto bene, Sam? È ancora un buon momento per incontrarci?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71540,
                      "answer_id":30268,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:48.086Z",
                      "updated_at":"2022-01-10T23:23:48.086Z",
                      "text":"Fragen: „Ist alles ok bei dir, Sam? Passt die vereinbarte Uhrzeit noch für dich?“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71539,
                      "answer_id":30268,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:48.081Z",
                      "updated_at":"2022-01-10T23:23:48.081Z",
                      "text":"Demandez: « Est-ce que tout va bien, Sam? Est-ce toujours le bon moment pour se rencontrer? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71538,
                      "answer_id":30268,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:48.077Z",
                      "updated_at":"2022-01-10T23:23:48.077Z",
                      "text":"Demander : « Tout va bien, Sam ? Tu es toujours d’accord pour qu’on se voie ? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71537,
                      "answer_id":30268,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:48.072Z",
                      "updated_at":"2022-01-10T23:23:48.072Z",
                      "text":"Perguntar: “Está tudo bem, Sam? Ainda é um bom momento para nos encontrarmos?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71536,
                      "answer_id":30268,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:48.067Z",
                      "updated_at":"2022-01-10T23:23:48.067Z",
                      "text":"問：「一切還好嗎？Sam。現在見面時間還可以嗎？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71535,
                      "answer_id":30268,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:48.062Z",
                      "updated_at":"2022-01-10T23:23:48.062Z",
                      "text":"Preguntar: “¿Todo está bien, Sam? ¿Aún es un buen momento para reunirnos?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71534,
                      "answer_id":30268,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:48.057Z",
                      "updated_at":"2022-01-10T23:23:48.057Z",
                      "text":"Tanungin, “AYOS ka lang ba, Sam? Magandang pagkakataon pa rin ba ito para makipagkita?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71533,
                      "answer_id":30268,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:48.052Z",
                      "updated_at":"2022-01-10T23:23:48.052Z",
                      "text":"问，“一切还好吧，Sam？还可以在这个时间见面吗？”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71532,
                      "answer_id":30268,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:48.048Z",
                      "updated_at":"2022-01-10T23:23:48.048Z",
                      "text":"Ask, “Is everything OK, Sam? Is this still a good time to meet?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30269,
                "position":3,
                "active":true,
                "question_id":12030,
                "created_at":"2022-01-10T23:23:48.126Z",
                "updated_at":"2022-01-10T23:23:48.126Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Pull out his phone while Sam is talking so Sam understands how it feels. ",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71563,
                      "answer_id":30269,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:48.211Z",
                      "updated_at":"2022-01-10T23:23:48.211Z",
                      "text":"Sam konuşurken telefonunu çıkarabilir ve böylece Sam onun nasıl hissettiğini anlayabilir. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71562,
                      "answer_id":30269,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:48.206Z",
                      "updated_at":"2022-01-10T23:23:48.206Z",
                      "text":"Sacar su teléfono mientras Sam habla para que se ponga en su lugar. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71561,
                      "answer_id":30269,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:48.201Z",
                      "updated_at":"2022-01-10T23:23:48.201Z",
                      "text":"Достать собственный телефон, пока Сэм говорит, чтобы дать ему понять, каково это. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71560,
                      "answer_id":30269,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:48.196Z",
                      "updated_at":"2022-01-10T23:23:48.196Z",
                      "text":"Niech wyciągnie swój telefon podczas rozmowy z Samem, żeby Sam zrozumiał, o co chodzi. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71559,
                      "answer_id":30269,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:48.191Z",
                      "updated_at":"2022-01-10T23:23:48.191Z",
                      "text":"Sam이 말하고 있을 때 전화를 꺼내 들어서 그가 자신의 기분을 이해할 수 있게 한다. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71558,
                      "answer_id":30269,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:48.187Z",
                      "updated_at":"2022-01-10T23:23:48.187Z",
                      "text":"Samさんが話している最中に携帯を取り出し、自身がどのように感じているのかをSamさんにも理解してもらう。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71557,
                      "answer_id":30269,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:48.182Z",
                      "updated_at":"2022-01-10T23:23:48.182Z",
                      "text":"Tirare fuori il suo telefono mentre Sam sta parlando in modo che Sam comprenda i suoi sentimenti. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71556,
                      "answer_id":30269,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:48.177Z",
                      "updated_at":"2022-01-10T23:23:48.177Z",
                      "text":"Sein Telefon herausnehmen, während Sam spricht, damit Sam merkt, wie es sich anfühlt. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71555,
                      "answer_id":30269,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:48.172Z",
                      "updated_at":"2022-01-10T23:23:48.172Z",
                      "text":"Sortir son téléphone pendant que Sam parle pour que Sam comprenne ce qu'il ressent. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71554,
                      "answer_id":30269,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:48.167Z",
                      "updated_at":"2022-01-10T23:23:48.167Z",
                      "text":"Sortir son téléphone pendant que Sam parle, pour que Sam comprenne l’effet que ça fait. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71553,
                      "answer_id":30269,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:48.162Z",
                      "updated_at":"2022-01-10T23:23:48.162Z",
                      "text":"Pegar seu telefone enquanto Sam está falando para que ele entenda como é isso. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71552,
                      "answer_id":30269,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:48.158Z",
                      "updated_at":"2022-01-10T23:23:48.158Z",
                      "text":"在 Sam 电话时躲过他的手机，让他体会一下这种感觉。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71551,
                      "answer_id":30269,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:48.153Z",
                      "updated_at":"2022-01-10T23:23:48.153Z",
                      "text":"Sacar su teléfono mientras Sam está hablando para que comprenda cómo se siente. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71550,
                      "answer_id":30269,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:48.148Z",
                      "updated_at":"2022-01-10T23:23:48.148Z",
                      "text":"Hilahin ang telepono nya habang nagsasalita si Sam para maunawaan ni Sam kung ano ang pakiramdam. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71549,
                      "answer_id":30269,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:48.143Z",
                      "updated_at":"2022-01-10T23:23:48.143Z",
                      "text":"Sam 還在說話的時候把手機拿出來，讓他知道那是甚麼感受。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71548,
                      "answer_id":30269,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:48.139Z",
                      "updated_at":"2022-01-10T23:23:48.139Z",
                      "text":"Pull out his phone while Sam is talking so Sam understands how it feels. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12031,
          "shuffle":false,
          "position":6,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30270"
          ],
          "created_at":"2022-01-10T23:23:48.229Z",
          "updated_at":"2022-01-10T23:23:48.675Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":6,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Is this a warning sign?\n",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29720,
                "question_id":12031,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:48.477Z",
                "updated_at":"2022-01-10T23:23:48.477Z",
                "text":"Bu bir uyarı işareti mi?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29719,
                "question_id":12031,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:48.472Z",
                "updated_at":"2022-01-10T23:23:48.472Z",
                "text":"¿Es esta una señal de advertencia?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29718,
                "question_id":12031,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:48.467Z",
                "updated_at":"2022-01-10T23:23:48.467Z",
                "text":"Это тревожный знак?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29717,
                "question_id":12031,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:48.462Z",
                "updated_at":"2022-01-10T23:23:48.462Z",
                "text":"Czy to jest znak ostrzegawczy?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29716,
                "question_id":12031,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:48.457Z",
                "updated_at":"2022-01-10T23:23:48.457Z",
                "text":"이것은 경고 신호입니까?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29715,
                "question_id":12031,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:48.451Z",
                "updated_at":"2022-01-10T23:23:48.451Z",
                "text":"これは、何かの前兆ですか？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29714,
                "question_id":12031,
                "locale":"it",
                "created_at":"2022-01-10T23:23:48.447Z",
                "updated_at":"2022-01-10T23:23:48.447Z",
                "text":"Si tratta di un segnale di allarme?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29713,
                "question_id":12031,
                "locale":"de",
                "created_at":"2022-01-10T23:23:48.442Z",
                "updated_at":"2022-01-10T23:23:48.442Z",
                "text":"Handelt es sich um ein Warnzeichen?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29712,
                "question_id":12031,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:48.437Z",
                "updated_at":"2022-01-10T23:23:48.437Z",
                "text":"Est-ce un signal d'alarme?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29711,
                "question_id":12031,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:48.432Z",
                "updated_at":"2022-01-10T23:23:48.432Z",
                "text":"Est-ce un avertissement ?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29710,
                "question_id":12031,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:48.426Z",
                "updated_at":"2022-01-10T23:23:48.426Z",
                "text":"Isso é um sinal de alerta?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29709,
                "question_id":12031,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:48.421Z",
                "updated_at":"2022-01-10T23:23:48.421Z",
                "text":"這是警訊嗎？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29708,
                "question_id":12031,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:48.416Z",
                "updated_at":"2022-01-10T23:23:48.416Z",
                "text":"这是否是一个警示迹象？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29707,
                "question_id":12031,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:48.411Z",
                "updated_at":"2022-01-10T23:23:48.411Z",
                "text":"Ito ba ay isang palatandaan ng babala?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29706,
                "question_id":12031,
                "locale":"es",
                "created_at":"2022-01-10T23:23:48.406Z",
                "updated_at":"2022-01-10T23:23:48.406Z",
                "text":"¿Es una señal de advertencia?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29705,
                "question_id":12031,
                "locale":"en",
                "created_at":"2022-01-10T23:23:48.383Z",
                "updated_at":"2022-01-10T23:23:48.383Z",
                "text":"Is this a warning sign?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30270,
                "position":1,
                "active":true,
                "question_id":12031,
                "created_at":"2022-01-10T23:23:48.483Z",
                "updated_at":"2022-01-10T23:23:48.483Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Yes",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71579,
                      "answer_id":30270,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:48.578Z",
                      "updated_at":"2022-01-10T23:23:48.578Z",
                      "text":"Evet",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71578,
                      "answer_id":30270,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:48.573Z",
                      "updated_at":"2022-01-10T23:23:48.573Z",
                      "text":"Sí",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71577,
                      "answer_id":30270,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:48.568Z",
                      "updated_at":"2022-01-10T23:23:48.568Z",
                      "text":"Да",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71576,
                      "answer_id":30270,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:48.563Z",
                      "updated_at":"2022-01-10T23:23:48.563Z",
                      "text":"Tak",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71575,
                      "answer_id":30270,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:48.558Z",
                      "updated_at":"2022-01-10T23:23:48.558Z",
                      "text":"예",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71574,
                      "answer_id":30270,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:48.553Z",
                      "updated_at":"2022-01-10T23:23:48.553Z",
                      "text":"はい",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71573,
                      "answer_id":30270,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:48.548Z",
                      "updated_at":"2022-01-10T23:23:48.548Z",
                      "text":"Sì",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71572,
                      "answer_id":30270,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:48.543Z",
                      "updated_at":"2022-01-10T23:23:48.543Z",
                      "text":"Ja",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71571,
                      "answer_id":30270,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:48.538Z",
                      "updated_at":"2022-01-10T23:23:48.538Z",
                      "text":"Oui",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71570,
                      "answer_id":30270,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:48.533Z",
                      "updated_at":"2022-01-10T23:23:48.533Z",
                      "text":"Sim",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71569,
                      "answer_id":30270,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:48.528Z",
                      "updated_at":"2022-01-10T23:23:48.528Z",
                      "text":"Oui",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71568,
                      "answer_id":30270,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:48.523Z",
                      "updated_at":"2022-01-10T23:23:48.523Z",
                      "text":"Opo",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71567,
                      "answer_id":30270,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:48.518Z",
                      "updated_at":"2022-01-10T23:23:48.518Z",
                      "text":"Sí",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71566,
                      "answer_id":30270,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:48.507Z",
                      "updated_at":"2022-01-10T23:23:48.507Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71565,
                      "answer_id":30270,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:48.501Z",
                      "updated_at":"2022-01-10T23:23:48.501Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71564,
                      "answer_id":30270,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:48.496Z",
                      "updated_at":"2022-01-10T23:23:48.496Z",
                      "text":"Yes",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30271,
                "position":2,
                "active":true,
                "question_id":12031,
                "created_at":"2022-01-10T23:23:48.585Z",
                "updated_at":"2022-01-10T23:23:48.585Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"No",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71595,
                      "answer_id":30271,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:48.670Z",
                      "updated_at":"2022-01-10T23:23:48.670Z",
                      "text":"Hayır",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71594,
                      "answer_id":30271,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:48.665Z",
                      "updated_at":"2022-01-10T23:23:48.665Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71593,
                      "answer_id":30271,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:48.660Z",
                      "updated_at":"2022-01-10T23:23:48.660Z",
                      "text":"Нет",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71592,
                      "answer_id":30271,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:48.655Z",
                      "updated_at":"2022-01-10T23:23:48.655Z",
                      "text":"Nie",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71591,
                      "answer_id":30271,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:48.650Z",
                      "updated_at":"2022-01-10T23:23:48.650Z",
                      "text":"아니요",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71590,
                      "answer_id":30271,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:48.646Z",
                      "updated_at":"2022-01-10T23:23:48.646Z",
                      "text":"いいえ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71589,
                      "answer_id":30271,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:48.641Z",
                      "updated_at":"2022-01-10T23:23:48.641Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71588,
                      "answer_id":30271,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:48.636Z",
                      "updated_at":"2022-01-10T23:23:48.636Z",
                      "text":"Nein",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71587,
                      "answer_id":30271,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:48.631Z",
                      "updated_at":"2022-01-10T23:23:48.631Z",
                      "text":"Non",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71586,
                      "answer_id":30271,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:48.626Z",
                      "updated_at":"2022-01-10T23:23:48.626Z",
                      "text":"Não",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71585,
                      "answer_id":30271,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:48.621Z",
                      "updated_at":"2022-01-10T23:23:48.621Z",
                      "text":"Non",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71584,
                      "answer_id":30271,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:48.616Z",
                      "updated_at":"2022-01-10T23:23:48.616Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71583,
                      "answer_id":30271,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:48.612Z",
                      "updated_at":"2022-01-10T23:23:48.612Z",
                      "text":"Hindi",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71582,
                      "answer_id":30271,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:48.607Z",
                      "updated_at":"2022-01-10T23:23:48.607Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71581,
                      "answer_id":30271,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:48.602Z",
                      "updated_at":"2022-01-10T23:23:48.602Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71580,
                      "answer_id":30271,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:48.598Z",
                      "updated_at":"2022-01-10T23:23:48.598Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12032,
          "shuffle":false,
          "position":7,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30272"
          ],
          "created_at":"2022-01-10T23:23:48.688Z",
          "updated_at":"2022-04-21T21:11:46.086Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":7,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Could Ida’s comment be a warning sign?\n",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29721,
                "question_id":12032,
                "locale":"en",
                "created_at":"2022-01-10T23:23:48.708Z",
                "updated_at":"2022-04-21T21:11:46.089Z",
                "text":"Could Ida’s comment be a warning sign?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29736,
                "question_id":12032,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:48.800Z",
                "updated_at":"2022-01-10T23:23:48.800Z",
                "text":"Bu bir uyarı işareti mi?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29735,
                "question_id":12032,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:48.795Z",
                "updated_at":"2022-01-10T23:23:48.795Z",
                "text":"¿Es esta una señal de advertencia?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29734,
                "question_id":12032,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:48.790Z",
                "updated_at":"2022-01-10T23:23:48.790Z",
                "text":"Это тревожный знак?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29733,
                "question_id":12032,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:48.786Z",
                "updated_at":"2022-01-10T23:23:48.786Z",
                "text":"Czy to jest znak ostrzegawczy?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29732,
                "question_id":12032,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:48.781Z",
                "updated_at":"2022-01-10T23:23:48.781Z",
                "text":"이것은 경고 신호입니까?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29731,
                "question_id":12032,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:48.776Z",
                "updated_at":"2022-01-10T23:23:48.776Z",
                "text":"これは、何かの前兆ですか？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29730,
                "question_id":12032,
                "locale":"it",
                "created_at":"2022-01-10T23:23:48.771Z",
                "updated_at":"2022-01-10T23:23:48.771Z",
                "text":"Si tratta di un segnale di allarme?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29729,
                "question_id":12032,
                "locale":"de",
                "created_at":"2022-01-10T23:23:48.767Z",
                "updated_at":"2022-01-10T23:23:48.767Z",
                "text":"Handelt es sich um ein Warnzeichen?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29728,
                "question_id":12032,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:48.762Z",
                "updated_at":"2022-01-10T23:23:48.762Z",
                "text":"Est-ce un signal d'alarme?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29727,
                "question_id":12032,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:48.757Z",
                "updated_at":"2022-01-10T23:23:48.757Z",
                "text":"Est-ce un avertissement ?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29726,
                "question_id":12032,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:48.752Z",
                "updated_at":"2022-01-10T23:23:48.752Z",
                "text":"Isso é um sinal de alerta?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29725,
                "question_id":12032,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:48.747Z",
                "updated_at":"2022-01-10T23:23:48.747Z",
                "text":"這是警訊嗎？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29724,
                "question_id":12032,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:48.742Z",
                "updated_at":"2022-01-10T23:23:48.742Z",
                "text":"这是否是一个警示迹象？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29723,
                "question_id":12032,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:48.737Z",
                "updated_at":"2022-01-10T23:23:48.737Z",
                "text":"Ito ba ay isang palatandaan ng babala?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29722,
                "question_id":12032,
                "locale":"es",
                "created_at":"2022-01-10T23:23:48.732Z",
                "updated_at":"2022-01-10T23:23:48.732Z",
                "text":"¿Es una señal de advertencia?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30272,
                "position":1,
                "active":true,
                "question_id":12032,
                "created_at":"2022-01-10T23:23:48.807Z",
                "updated_at":"2022-04-21T21:11:53.743Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Yes. Ida’s comment is insensitive.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71596,
                      "answer_id":30272,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:48.821Z",
                      "updated_at":"2022-04-21T21:11:53.746Z",
                      "text":"Yes. Ida’s comment is insensitive.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71611,
                      "answer_id":30272,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:48.896Z",
                      "updated_at":"2022-01-10T23:23:48.896Z",
                      "text":"Evet",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71610,
                      "answer_id":30272,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:48.891Z",
                      "updated_at":"2022-01-10T23:23:48.891Z",
                      "text":"Sí",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71609,
                      "answer_id":30272,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:48.886Z",
                      "updated_at":"2022-01-10T23:23:48.886Z",
                      "text":"Да",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71608,
                      "answer_id":30272,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:48.877Z",
                      "updated_at":"2022-01-10T23:23:48.877Z",
                      "text":"Tak",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71607,
                      "answer_id":30272,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:48.873Z",
                      "updated_at":"2022-01-10T23:23:48.873Z",
                      "text":"예",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71606,
                      "answer_id":30272,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:48.868Z",
                      "updated_at":"2022-01-10T23:23:48.868Z",
                      "text":"はい",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71605,
                      "answer_id":30272,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:48.863Z",
                      "updated_at":"2022-01-10T23:23:48.863Z",
                      "text":"Sì",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71604,
                      "answer_id":30272,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:48.859Z",
                      "updated_at":"2022-01-10T23:23:48.859Z",
                      "text":"Ja",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71603,
                      "answer_id":30272,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:48.854Z",
                      "updated_at":"2022-01-10T23:23:48.854Z",
                      "text":"Oui",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71602,
                      "answer_id":30272,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:48.849Z",
                      "updated_at":"2022-01-10T23:23:48.849Z",
                      "text":"Sim",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71601,
                      "answer_id":30272,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:48.844Z",
                      "updated_at":"2022-01-10T23:23:48.844Z",
                      "text":"Oui",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71600,
                      "answer_id":30272,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:48.840Z",
                      "updated_at":"2022-01-10T23:23:48.840Z",
                      "text":"Opo",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71599,
                      "answer_id":30272,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:48.835Z",
                      "updated_at":"2022-01-10T23:23:48.835Z",
                      "text":"Sí",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71598,
                      "answer_id":30272,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:48.830Z",
                      "updated_at":"2022-01-10T23:23:48.830Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71597,
                      "answer_id":30272,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:48.825Z",
                      "updated_at":"2022-01-10T23:23:48.825Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30273,
                "position":2,
                "active":true,
                "question_id":12032,
                "created_at":"2022-01-10T23:23:48.902Z",
                "updated_at":"2022-04-21T21:12:03.055Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Only if Sumiko is upset by it.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71627,
                      "answer_id":30273,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:48.986Z",
                      "updated_at":"2022-01-10T23:23:48.986Z",
                      "text":"Hayır",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71626,
                      "answer_id":30273,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:48.981Z",
                      "updated_at":"2022-01-10T23:23:48.981Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71625,
                      "answer_id":30273,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:48.977Z",
                      "updated_at":"2022-01-10T23:23:48.977Z",
                      "text":"Нет",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71624,
                      "answer_id":30273,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:48.972Z",
                      "updated_at":"2022-01-10T23:23:48.972Z",
                      "text":"Nie",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71623,
                      "answer_id":30273,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:48.967Z",
                      "updated_at":"2022-01-10T23:23:48.967Z",
                      "text":"아니요",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71622,
                      "answer_id":30273,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:48.962Z",
                      "updated_at":"2022-01-10T23:23:48.962Z",
                      "text":"いいえ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71621,
                      "answer_id":30273,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:48.958Z",
                      "updated_at":"2022-01-10T23:23:48.958Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71620,
                      "answer_id":30273,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:48.953Z",
                      "updated_at":"2022-01-10T23:23:48.953Z",
                      "text":"Nein",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71619,
                      "answer_id":30273,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:48.948Z",
                      "updated_at":"2022-01-10T23:23:48.948Z",
                      "text":"Non",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71618,
                      "answer_id":30273,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:48.944Z",
                      "updated_at":"2022-01-10T23:23:48.944Z",
                      "text":"Não",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71617,
                      "answer_id":30273,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:48.939Z",
                      "updated_at":"2022-01-10T23:23:48.939Z",
                      "text":"Non",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71616,
                      "answer_id":30273,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:48.934Z",
                      "updated_at":"2022-01-10T23:23:48.934Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71615,
                      "answer_id":30273,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:48.929Z",
                      "updated_at":"2022-01-10T23:23:48.929Z",
                      "text":"Hindi",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71614,
                      "answer_id":30273,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:48.924Z",
                      "updated_at":"2022-01-10T23:23:48.924Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71613,
                      "answer_id":30273,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:48.919Z",
                      "updated_at":"2022-01-10T23:23:48.919Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71612,
                      "answer_id":30273,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:48.915Z",
                      "updated_at":"2022-04-21T21:12:03.057Z",
                      "text":"Only if Sumiko is upset by it.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31691,
                "position":3,
                "active":true,
                "question_id":12032,
                "created_at":"2022-04-21T21:12:17.120Z",
                "updated_at":"2022-04-21T21:12:17.120Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"No. Ida is only asking a question.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77361,
                      "answer_id":31691,
                      "locale":"en",
                      "created_at":"2022-04-21T21:12:17.131Z",
                      "updated_at":"2022-04-21T21:12:17.131Z",
                      "text":"No. Ida is only asking a question.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12033,
          "shuffle":false,
          "position":8,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30274"
          ],
          "created_at":"2022-01-10T23:23:49.003Z",
          "updated_at":"2022-04-21T21:13:14.060Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":8,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Is Joey showing warning signs of bias?\n",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29752,
                "question_id":12033,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:49.117Z",
                "updated_at":"2022-01-10T23:23:49.117Z",
                "text":"Bu bir uyarı işareti mi?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29751,
                "question_id":12033,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:49.113Z",
                "updated_at":"2022-01-10T23:23:49.113Z",
                "text":"¿Es esta una señal de advertencia?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29750,
                "question_id":12033,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:49.108Z",
                "updated_at":"2022-01-10T23:23:49.108Z",
                "text":"Это тревожный знак?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29749,
                "question_id":12033,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:49.103Z",
                "updated_at":"2022-01-10T23:23:49.103Z",
                "text":"Czy to jest znak ostrzegawczy?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29748,
                "question_id":12033,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:49.098Z",
                "updated_at":"2022-01-10T23:23:49.098Z",
                "text":"이것은 경고 신호입니까?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29747,
                "question_id":12033,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:49.094Z",
                "updated_at":"2022-01-10T23:23:49.094Z",
                "text":"これは、何かの前兆ですか？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29746,
                "question_id":12033,
                "locale":"it",
                "created_at":"2022-01-10T23:23:49.089Z",
                "updated_at":"2022-01-10T23:23:49.089Z",
                "text":"Si tratta di un segnale di allarme?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29745,
                "question_id":12033,
                "locale":"de",
                "created_at":"2022-01-10T23:23:49.084Z",
                "updated_at":"2022-01-10T23:23:49.084Z",
                "text":"Handelt es sich um ein Warnzeichen?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29744,
                "question_id":12033,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:49.078Z",
                "updated_at":"2022-01-10T23:23:49.078Z",
                "text":"Est-ce un signal d'alarme?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29743,
                "question_id":12033,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:49.074Z",
                "updated_at":"2022-01-10T23:23:49.074Z",
                "text":"Est-ce un avertissement ?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29742,
                "question_id":12033,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:49.069Z",
                "updated_at":"2022-01-10T23:23:49.069Z",
                "text":"Isso é um sinal de alerta?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29741,
                "question_id":12033,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:49.064Z",
                "updated_at":"2022-01-10T23:23:49.064Z",
                "text":"這是警訊嗎？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29740,
                "question_id":12033,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:49.059Z",
                "updated_at":"2022-01-10T23:23:49.059Z",
                "text":"这是否是一个警示迹象？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29739,
                "question_id":12033,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:49.054Z",
                "updated_at":"2022-01-10T23:23:49.054Z",
                "text":"Ito ba ay isang palatandaan ng babala?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29738,
                "question_id":12033,
                "locale":"es",
                "created_at":"2022-01-10T23:23:49.049Z",
                "updated_at":"2022-01-10T23:23:49.049Z",
                "text":"¿Es una señal de advertencia?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29737,
                "question_id":12033,
                "locale":"en",
                "created_at":"2022-01-10T23:23:49.024Z",
                "updated_at":"2022-04-21T21:13:14.065Z",
                "text":"Is Joey showing warning signs of bias?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30274,
                "position":1,
                "active":true,
                "question_id":12033,
                "created_at":"2022-01-10T23:23:49.124Z",
                "updated_at":"2022-04-21T21:13:23.201Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Yes, Joey is demonstrating warning signs of bias based on Jessica’s pregnancy.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71628,
                      "answer_id":30274,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:49.138Z",
                      "updated_at":"2022-04-21T21:13:23.204Z",
                      "text":"Yes, Joey is demonstrating warning signs of bias based on Jessica’s pregnancy.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71643,
                      "answer_id":30274,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:49.211Z",
                      "updated_at":"2022-01-10T23:23:49.211Z",
                      "text":"Evet",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71642,
                      "answer_id":30274,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:49.206Z",
                      "updated_at":"2022-01-10T23:23:49.206Z",
                      "text":"Sí",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71641,
                      "answer_id":30274,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:49.201Z",
                      "updated_at":"2022-01-10T23:23:49.201Z",
                      "text":"Да",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71640,
                      "answer_id":30274,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:49.196Z",
                      "updated_at":"2022-01-10T23:23:49.196Z",
                      "text":"Tak",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71639,
                      "answer_id":30274,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:49.191Z",
                      "updated_at":"2022-01-10T23:23:49.191Z",
                      "text":"예",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71638,
                      "answer_id":30274,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:49.187Z",
                      "updated_at":"2022-01-10T23:23:49.187Z",
                      "text":"はい",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71637,
                      "answer_id":30274,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:49.182Z",
                      "updated_at":"2022-01-10T23:23:49.182Z",
                      "text":"Sì",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71636,
                      "answer_id":30274,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:49.177Z",
                      "updated_at":"2022-01-10T23:23:49.177Z",
                      "text":"Ja",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71635,
                      "answer_id":30274,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:49.171Z",
                      "updated_at":"2022-01-10T23:23:49.171Z",
                      "text":"Oui",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71634,
                      "answer_id":30274,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:49.167Z",
                      "updated_at":"2022-01-10T23:23:49.167Z",
                      "text":"Sim",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71633,
                      "answer_id":30274,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:49.161Z",
                      "updated_at":"2022-01-10T23:23:49.161Z",
                      "text":"Oui",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71632,
                      "answer_id":30274,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:49.156Z",
                      "updated_at":"2022-01-10T23:23:49.156Z",
                      "text":"Opo",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71631,
                      "answer_id":30274,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:49.152Z",
                      "updated_at":"2022-01-10T23:23:49.152Z",
                      "text":"Sí",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71630,
                      "answer_id":30274,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:49.147Z",
                      "updated_at":"2022-01-10T23:23:49.147Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71629,
                      "answer_id":30274,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:49.142Z",
                      "updated_at":"2022-01-10T23:23:49.142Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30275,
                "position":2,
                "active":true,
                "question_id":12033,
                "created_at":"2022-01-10T23:23:49.217Z",
                "updated_at":"2022-04-21T21:13:36.600Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Maybe. It depends on how Jessica interprets his question.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71659,
                      "answer_id":30275,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:49.306Z",
                      "updated_at":"2022-01-10T23:23:49.306Z",
                      "text":"Hayır",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71658,
                      "answer_id":30275,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:49.301Z",
                      "updated_at":"2022-01-10T23:23:49.301Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71657,
                      "answer_id":30275,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:49.295Z",
                      "updated_at":"2022-01-10T23:23:49.295Z",
                      "text":"Нет",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71656,
                      "answer_id":30275,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:49.290Z",
                      "updated_at":"2022-01-10T23:23:49.290Z",
                      "text":"Nie",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71655,
                      "answer_id":30275,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:49.286Z",
                      "updated_at":"2022-01-10T23:23:49.286Z",
                      "text":"아니요",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71654,
                      "answer_id":30275,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:49.280Z",
                      "updated_at":"2022-01-10T23:23:49.280Z",
                      "text":"いいえ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71653,
                      "answer_id":30275,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:49.275Z",
                      "updated_at":"2022-01-10T23:23:49.275Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71652,
                      "answer_id":30275,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:49.270Z",
                      "updated_at":"2022-01-10T23:23:49.270Z",
                      "text":"Nein",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71651,
                      "answer_id":30275,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:49.265Z",
                      "updated_at":"2022-01-10T23:23:49.265Z",
                      "text":"Non",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71650,
                      "answer_id":30275,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:49.260Z",
                      "updated_at":"2022-01-10T23:23:49.260Z",
                      "text":"Não",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71649,
                      "answer_id":30275,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:49.254Z",
                      "updated_at":"2022-01-10T23:23:49.254Z",
                      "text":"Non",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71648,
                      "answer_id":30275,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:49.250Z",
                      "updated_at":"2022-01-10T23:23:49.250Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71647,
                      "answer_id":30275,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:49.245Z",
                      "updated_at":"2022-01-10T23:23:49.245Z",
                      "text":"Hindi",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71646,
                      "answer_id":30275,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:49.240Z",
                      "updated_at":"2022-01-10T23:23:49.240Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71645,
                      "answer_id":30275,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:49.235Z",
                      "updated_at":"2022-01-10T23:23:49.235Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71644,
                      "answer_id":30275,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:49.230Z",
                      "updated_at":"2022-04-21T21:13:36.603Z",
                      "text":"Maybe. It depends on how Jessica interprets his question.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31692,
                "position":3,
                "active":true,
                "question_id":12033,
                "created_at":"2022-04-21T21:13:46.890Z",
                "updated_at":"2022-04-21T21:13:46.890Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"No, he is not showing any warning signs of bias.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77362,
                      "answer_id":31692,
                      "locale":"en",
                      "created_at":"2022-04-21T21:13:46.899Z",
                      "updated_at":"2022-04-21T21:13:46.899Z",
                      "text":"No, he is not showing any warning signs of bias.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12034,
          "shuffle":false,
          "position":9,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30277"
          ],
          "created_at":"2022-01-10T23:23:49.328Z",
          "updated_at":"2022-04-21T22:35:41.228Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":9,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Is this a warning sign of bias?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29768,
                "question_id":12034,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:49.454Z",
                "updated_at":"2022-01-10T23:23:49.454Z",
                "text":"Bu olası bir ayrımcılık mı?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29767,
                "question_id":12034,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:49.449Z",
                "updated_at":"2022-01-10T23:23:49.449Z",
                "text":"¿Es esto una posible discriminación?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29766,
                "question_id":12034,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:49.444Z",
                "updated_at":"2022-01-10T23:23:49.444Z",
                "text":"Это потенциальная дискриминация?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29765,
                "question_id":12034,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:49.439Z",
                "updated_at":"2022-01-10T23:23:49.439Z",
                "text":"Czy jest to możliwa dyskryminacja?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29764,
                "question_id":12034,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:49.434Z",
                "updated_at":"2022-01-10T23:23:49.434Z",
                "text":"이것이 차별이 될 수 있을까요?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29763,
                "question_id":12034,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:49.429Z",
                "updated_at":"2022-01-10T23:23:49.429Z",
                "text":"これは、差別の可能性がありますか？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29762,
                "question_id":12034,
                "locale":"it",
                "created_at":"2022-01-10T23:23:49.423Z",
                "updated_at":"2022-01-10T23:23:49.423Z",
                "text":"Si tratta di una possibile discriminazione?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29761,
                "question_id":12034,
                "locale":"de",
                "created_at":"2022-01-10T23:23:49.418Z",
                "updated_at":"2022-01-10T23:23:49.418Z",
                "text":"Liegt hier mögliche Diskriminierung vor?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29760,
                "question_id":12034,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:49.413Z",
                "updated_at":"2022-01-10T23:23:49.413Z",
                "text":"Est-ce une discrimination possible?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29759,
                "question_id":12034,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:49.408Z",
                "updated_at":"2022-01-10T23:23:49.408Z",
                "text":"Est-ce que ce ne serait pas de la discrimination ?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29758,
                "question_id":12034,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:49.403Z",
                "updated_at":"2022-01-10T23:23:49.403Z",
                "text":"Isto é uma possível discriminação?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29757,
                "question_id":12034,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:49.398Z",
                "updated_at":"2022-01-10T23:23:49.398Z",
                "text":"這可能是歧視嗎？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29756,
                "question_id":12034,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:49.393Z",
                "updated_at":"2022-01-10T23:23:49.393Z",
                "text":"这是否可能是歧视？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29755,
                "question_id":12034,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:49.385Z",
                "updated_at":"2022-01-10T23:23:49.385Z",
                "text":"Posible ba itong diskriminasyon?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29754,
                "question_id":12034,
                "locale":"es",
                "created_at":"2022-01-10T23:23:49.380Z",
                "updated_at":"2022-01-10T23:23:49.380Z",
                "text":"¿Es posible discriminación?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29753,
                "question_id":12034,
                "locale":"en",
                "created_at":"2022-01-10T23:23:49.349Z",
                "updated_at":"2022-04-21T22:35:41.231Z",
                "text":"Is this a warning sign of bias?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30276,
                "position":1,
                "active":true,
                "question_id":12034,
                "created_at":"2022-01-10T23:23:49.461Z",
                "updated_at":"2022-04-21T22:35:48.693Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"No. Heidi meant no harm; she wanted to help. ",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71660,
                      "answer_id":30276,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:49.474Z",
                      "updated_at":"2022-04-21T22:35:48.695Z",
                      "text":"No. Heidi meant no harm; she wanted to help. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71675,
                      "answer_id":30276,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:49.548Z",
                      "updated_at":"2022-01-10T23:23:49.548Z",
                      "text":"Evet",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71674,
                      "answer_id":30276,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:49.544Z",
                      "updated_at":"2022-01-10T23:23:49.544Z",
                      "text":"Sí",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71673,
                      "answer_id":30276,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:49.539Z",
                      "updated_at":"2022-01-10T23:23:49.539Z",
                      "text":"Да",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71672,
                      "answer_id":30276,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:49.534Z",
                      "updated_at":"2022-01-10T23:23:49.534Z",
                      "text":"Tak",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71671,
                      "answer_id":30276,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:49.530Z",
                      "updated_at":"2022-01-10T23:23:49.530Z",
                      "text":"예",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71670,
                      "answer_id":30276,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:49.524Z",
                      "updated_at":"2022-01-10T23:23:49.524Z",
                      "text":"はい",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71669,
                      "answer_id":30276,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:49.519Z",
                      "updated_at":"2022-01-10T23:23:49.519Z",
                      "text":"Sì",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71668,
                      "answer_id":30276,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:49.514Z",
                      "updated_at":"2022-01-10T23:23:49.514Z",
                      "text":"Ja",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71667,
                      "answer_id":30276,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:49.509Z",
                      "updated_at":"2022-01-10T23:23:49.509Z",
                      "text":"Oui",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71666,
                      "answer_id":30276,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:49.503Z",
                      "updated_at":"2022-01-10T23:23:49.503Z",
                      "text":"Sim",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71665,
                      "answer_id":30276,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:49.498Z",
                      "updated_at":"2022-01-10T23:23:49.498Z",
                      "text":"Oui",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71664,
                      "answer_id":30276,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:49.493Z",
                      "updated_at":"2022-01-10T23:23:49.493Z",
                      "text":"Opo",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71663,
                      "answer_id":30276,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:49.488Z",
                      "updated_at":"2022-01-10T23:23:49.488Z",
                      "text":"Sí",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71662,
                      "answer_id":30276,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:49.483Z",
                      "updated_at":"2022-01-10T23:23:49.483Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71661,
                      "answer_id":30276,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:49.478Z",
                      "updated_at":"2022-01-10T23:23:49.478Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30277,
                "position":2,
                "active":true,
                "question_id":12034,
                "created_at":"2022-01-10T23:23:49.554Z",
                "updated_at":"2022-04-21T22:36:00.088Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Yes, this is a warning sign of potential ethnicity, race, or national origin bias.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71691,
                      "answer_id":30277,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:49.641Z",
                      "updated_at":"2022-01-10T23:23:49.641Z",
                      "text":"Hayır",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71690,
                      "answer_id":30277,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:49.636Z",
                      "updated_at":"2022-01-10T23:23:49.636Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71689,
                      "answer_id":30277,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:49.631Z",
                      "updated_at":"2022-01-10T23:23:49.631Z",
                      "text":"Нет",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71688,
                      "answer_id":30277,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:49.626Z",
                      "updated_at":"2022-01-10T23:23:49.626Z",
                      "text":"Nie",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71687,
                      "answer_id":30277,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:49.621Z",
                      "updated_at":"2022-01-10T23:23:49.621Z",
                      "text":"아니요",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71686,
                      "answer_id":30277,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:49.616Z",
                      "updated_at":"2022-01-10T23:23:49.616Z",
                      "text":"いいえ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71685,
                      "answer_id":30277,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:49.611Z",
                      "updated_at":"2022-01-10T23:23:49.611Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71684,
                      "answer_id":30277,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:49.605Z",
                      "updated_at":"2022-01-10T23:23:49.605Z",
                      "text":"Nein",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71683,
                      "answer_id":30277,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:49.601Z",
                      "updated_at":"2022-01-10T23:23:49.601Z",
                      "text":"Non",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71682,
                      "answer_id":30277,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:49.596Z",
                      "updated_at":"2022-01-10T23:23:49.596Z",
                      "text":"Não",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71681,
                      "answer_id":30277,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:49.591Z",
                      "updated_at":"2022-01-10T23:23:49.591Z",
                      "text":"Non",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71680,
                      "answer_id":30277,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:49.587Z",
                      "updated_at":"2022-01-10T23:23:49.587Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71679,
                      "answer_id":30277,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:49.582Z",
                      "updated_at":"2022-01-10T23:23:49.582Z",
                      "text":"Hindi",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71678,
                      "answer_id":30277,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:49.577Z",
                      "updated_at":"2022-01-10T23:23:49.577Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71677,
                      "answer_id":30277,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:49.572Z",
                      "updated_at":"2022-01-10T23:23:49.572Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71676,
                      "answer_id":30277,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:49.567Z",
                      "updated_at":"2022-04-21T22:36:00.090Z",
                      "text":"Yes, this is a warning sign of potential ethnicity, race, or national origin bias.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12035,
          "shuffle":false,
          "position":10,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30278"
          ],
          "created_at":"2022-01-10T23:23:49.658Z",
          "updated_at":"2022-04-21T21:16:53.023Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":10,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Could there be a problem with Maleko’s hiring considerations?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29769,
                "question_id":12035,
                "locale":"en",
                "created_at":"2022-01-10T23:23:49.679Z",
                "updated_at":"2022-04-21T21:16:53.026Z",
                "text":"Could there be a problem with Maleko’s hiring considerations?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29784,
                "question_id":12035,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:49.776Z",
                "updated_at":"2022-01-10T23:23:49.776Z",
                "text":"Farah'nın röportaj stratejisiyle ilgili bir sorun var mı? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29783,
                "question_id":12035,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:49.771Z",
                "updated_at":"2022-01-10T23:23:49.771Z",
                "text":"¿Hay algún problema con la estrategia de entrevistas de Farah? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29782,
                "question_id":12035,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:49.766Z",
                "updated_at":"2022-01-10T23:23:49.766Z",
                "text":"Стратегия проведения собеседований Фары проблематична? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29781,
                "question_id":12035,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:49.762Z",
                "updated_at":"2022-01-10T23:23:49.762Z",
                "text":"Czy jest jakiś problem ze sposobem prowadzenia rozmowy przez Faraha? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29780,
                "question_id":12035,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:49.757Z",
                "updated_at":"2022-01-10T23:23:49.757Z",
                "text":"Farah의 인터뷰 전략에 문제가 있습니까? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29779,
                "question_id":12035,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:49.752Z",
                "updated_at":"2022-01-10T23:23:49.752Z",
                "text":"Farahさんの面接戦略に問題はありますか？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29778,
                "question_id":12035,
                "locale":"it",
                "created_at":"2022-01-10T23:23:49.748Z",
                "updated_at":"2022-01-10T23:23:49.748Z",
                "text":"C’è un problema con la strategia per i colloqui di Farah? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29777,
                "question_id":12035,
                "locale":"de",
                "created_at":"2022-01-10T23:23:49.743Z",
                "updated_at":"2022-01-10T23:23:49.743Z",
                "text":"Gibt es mit Farahs Vorstellungsgesprächstrategie ein Problem? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29776,
                "question_id":12035,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:49.738Z",
                "updated_at":"2022-01-10T23:23:49.738Z",
                "text":"Y a-t-il un problème avec la stratégie d'entretien de Farah? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29775,
                "question_id":12035,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:49.734Z",
                "updated_at":"2022-01-10T23:23:49.734Z",
                "text":"La façon dont Farah mène l’entretien pose-t-elle problème ? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29774,
                "question_id":12035,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:49.729Z",
                "updated_at":"2022-01-10T23:23:49.729Z",
                "text":"Há algum problema com a estratégia de entrevista de Farah? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29773,
                "question_id":12035,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:49.724Z",
                "updated_at":"2022-01-10T23:23:49.724Z",
                "text":"May problema ba sa paraan ng pakikipanayam ni Farah? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29772,
                "question_id":12035,
                "locale":"es",
                "created_at":"2022-01-10T23:23:49.719Z",
                "updated_at":"2022-01-10T23:23:49.719Z",
                "text":"¿Hay algún problema con la estrategia de entrevista de Farah? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29771,
                "question_id":12035,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:49.715Z",
                "updated_at":"2022-01-10T23:23:49.715Z",
                "text":"Farah 的面试策略有问题吗？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29770,
                "question_id":12035,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:49.710Z",
                "updated_at":"2022-01-10T23:23:49.710Z",
                "text":"Farah 的面試策略是否有問題？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30278,
                "position":1,
                "active":true,
                "question_id":12035,
                "created_at":"2022-01-10T23:23:49.785Z",
                "updated_at":"2022-04-21T21:17:00.400Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Yes. He is relying on his gut feeling rather than the job requirements.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71692,
                      "answer_id":30278,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:49.799Z",
                      "updated_at":"2022-04-21T21:17:00.402Z",
                      "text":"Yes. He is relying on his gut feeling rather than the job requirements.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71707,
                      "answer_id":30278,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:49.869Z",
                      "updated_at":"2022-01-10T23:23:49.869Z",
                      "text":"Evet",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71706,
                      "answer_id":30278,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:49.864Z",
                      "updated_at":"2022-01-10T23:23:49.864Z",
                      "text":"Sí",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71705,
                      "answer_id":30278,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:49.859Z",
                      "updated_at":"2022-01-10T23:23:49.859Z",
                      "text":"Да",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71704,
                      "answer_id":30278,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:49.855Z",
                      "updated_at":"2022-01-10T23:23:49.855Z",
                      "text":"Tak",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71703,
                      "answer_id":30278,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:49.850Z",
                      "updated_at":"2022-01-10T23:23:49.850Z",
                      "text":"예",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71702,
                      "answer_id":30278,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:49.845Z",
                      "updated_at":"2022-01-10T23:23:49.845Z",
                      "text":"はい",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71701,
                      "answer_id":30278,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:49.840Z",
                      "updated_at":"2022-01-10T23:23:49.840Z",
                      "text":"Sì",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71700,
                      "answer_id":30278,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:49.836Z",
                      "updated_at":"2022-01-10T23:23:49.836Z",
                      "text":"Ja",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71699,
                      "answer_id":30278,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:49.831Z",
                      "updated_at":"2022-01-10T23:23:49.831Z",
                      "text":"Oui",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71698,
                      "answer_id":30278,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:49.826Z",
                      "updated_at":"2022-01-10T23:23:49.826Z",
                      "text":"Sim",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71697,
                      "answer_id":30278,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:49.821Z",
                      "updated_at":"2022-01-10T23:23:49.821Z",
                      "text":"Oui",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71696,
                      "answer_id":30278,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:49.817Z",
                      "updated_at":"2022-01-10T23:23:49.817Z",
                      "text":"Opo",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71695,
                      "answer_id":30278,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:49.812Z",
                      "updated_at":"2022-01-10T23:23:49.812Z",
                      "text":"Sí",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71694,
                      "answer_id":30278,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:49.808Z",
                      "updated_at":"2022-01-10T23:23:49.808Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71693,
                      "answer_id":30278,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:49.803Z",
                      "updated_at":"2022-01-10T23:23:49.803Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30279,
                "position":2,
                "active":true,
                "question_id":12035,
                "created_at":"2022-01-10T23:23:49.875Z",
                "updated_at":"2022-04-21T21:17:10.945Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Maybe. If Oliver agrees with him, the candidate might not be a good fit for the team.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71708,
                      "answer_id":30279,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:49.888Z",
                      "updated_at":"2022-04-21T21:17:10.947Z",
                      "text":"Maybe. If Oliver agrees with him, the candidate might not be a good fit for the team.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71723,
                      "answer_id":30279,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:49.959Z",
                      "updated_at":"2022-01-10T23:23:49.959Z",
                      "text":"Hayır",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71722,
                      "answer_id":30279,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:49.954Z",
                      "updated_at":"2022-01-10T23:23:49.954Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71721,
                      "answer_id":30279,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:49.949Z",
                      "updated_at":"2022-01-10T23:23:49.949Z",
                      "text":"Нет",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71720,
                      "answer_id":30279,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:49.945Z",
                      "updated_at":"2022-01-10T23:23:49.945Z",
                      "text":"Nie",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71719,
                      "answer_id":30279,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:49.940Z",
                      "updated_at":"2022-01-10T23:23:49.940Z",
                      "text":"아니요",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71718,
                      "answer_id":30279,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:49.935Z",
                      "updated_at":"2022-01-10T23:23:49.935Z",
                      "text":"いいえ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71717,
                      "answer_id":30279,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:49.931Z",
                      "updated_at":"2022-01-10T23:23:49.931Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71716,
                      "answer_id":30279,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:49.926Z",
                      "updated_at":"2022-01-10T23:23:49.926Z",
                      "text":"Nein",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71715,
                      "answer_id":30279,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:49.921Z",
                      "updated_at":"2022-01-10T23:23:49.921Z",
                      "text":"Non",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71714,
                      "answer_id":30279,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:49.916Z",
                      "updated_at":"2022-01-10T23:23:49.916Z",
                      "text":"Não",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71713,
                      "answer_id":30279,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:49.912Z",
                      "updated_at":"2022-01-10T23:23:49.912Z",
                      "text":"Non",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71712,
                      "answer_id":30279,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:49.907Z",
                      "updated_at":"2022-01-10T23:23:49.907Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71711,
                      "answer_id":30279,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:49.902Z",
                      "updated_at":"2022-01-10T23:23:49.902Z",
                      "text":"Hindi",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71710,
                      "answer_id":30279,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:49.896Z",
                      "updated_at":"2022-01-10T23:23:49.896Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71709,
                      "answer_id":30279,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:49.892Z",
                      "updated_at":"2022-01-10T23:23:49.892Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31693,
                "position":3,
                "active":true,
                "question_id":12035,
                "created_at":"2022-04-21T21:17:23.742Z",
                "updated_at":"2022-04-21T21:17:23.742Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"No. He should be allowed to go with his gut.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77363,
                      "answer_id":31693,
                      "locale":"en",
                      "created_at":"2022-04-21T21:17:23.749Z",
                      "updated_at":"2022-04-21T21:17:23.749Z",
                      "text":"No. He should be allowed to go with his gut.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12036,
          "shuffle":false,
          "position":11,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30280"
          ],
          "created_at":"2022-01-10T23:23:49.976Z",
          "updated_at":"2022-04-21T21:18:06.287Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":11,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Should you be concerned about potential bias in Cesar's decision?\n",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29800,
                "question_id":12036,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:50.129Z",
                "updated_at":"2022-01-10T23:23:50.129Z",
                "text":"Bir şey yapmalı mısınız? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29799,
                "question_id":12036,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:50.124Z",
                "updated_at":"2022-01-10T23:23:50.124Z",
                "text":"¿Debería hacer algo? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29798,
                "question_id":12036,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:50.120Z",
                "updated_at":"2022-01-10T23:23:50.120Z",
                "text":"Нужно ли вам что-то делать? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29797,
                "question_id":12036,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:50.115Z",
                "updated_at":"2022-01-10T23:23:50.115Z",
                "text":"Czy należy coś zrobić? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29796,
                "question_id":12036,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:50.110Z",
                "updated_at":"2022-01-10T23:23:50.110Z",
                "text":"당신이 뭔가 조치를 취해야 할까요? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29795,
                "question_id":12036,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:50.105Z",
                "updated_at":"2022-01-10T23:23:50.105Z",
                "text":"あなたは、何かすべきですか？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29794,
                "question_id":12036,
                "locale":"it",
                "created_at":"2022-01-10T23:23:50.101Z",
                "updated_at":"2022-01-10T23:23:50.101Z",
                "text":"Dovresti fare qualcosa? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29793,
                "question_id":12036,
                "locale":"de",
                "created_at":"2022-01-10T23:23:50.096Z",
                "updated_at":"2022-01-10T23:23:50.096Z",
                "text":"Sollten Sie etwas unternehmen. \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29792,
                "question_id":12036,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:50.091Z",
                "updated_at":"2022-01-10T23:23:50.091Z",
                "text":"Devriez-vous faire quelque chose? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29791,
                "question_id":12036,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:50.085Z",
                "updated_at":"2022-01-10T23:23:50.085Z",
                "text":"Devriez-vous faire quelque chose ? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29790,
                "question_id":12036,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:50.081Z",
                "updated_at":"2022-01-10T23:23:50.081Z",
                "text":"Você deve fazer alguma coisa? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29789,
                "question_id":12036,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:50.076Z",
                "updated_at":"2022-01-10T23:23:50.076Z",
                "text":"你應該做點甚麼嗎？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29788,
                "question_id":12036,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:50.070Z",
                "updated_at":"2022-01-10T23:23:50.070Z",
                "text":"你应该做点什么吗？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29787,
                "question_id":12036,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:50.065Z",
                "updated_at":"2022-01-10T23:23:50.065Z",
                "text":"May dapat ka bang gawin? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29786,
                "question_id":12036,
                "locale":"es",
                "created_at":"2022-01-10T23:23:50.056Z",
                "updated_at":"2022-01-10T23:23:50.056Z",
                "text":"¿Debes hacer algo? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29785,
                "question_id":12036,
                "locale":"en",
                "created_at":"2022-01-10T23:23:49.999Z",
                "updated_at":"2022-04-21T21:18:06.292Z",
                "text":"Should you be concerned about potential bias in Cesar's decision?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30280,
                "position":1,
                "active":true,
                "question_id":12036,
                "created_at":"2022-01-10T23:23:50.135Z",
                "updated_at":"2022-04-21T21:18:14.443Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Yes, he is treating Amal differently as the only Muslim employee.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71739,
                      "answer_id":30280,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:50.220Z",
                      "updated_at":"2022-01-10T23:23:50.220Z",
                      "text":"Muhtemelen hayır. Dennis'in davranışı mantıklı görünüyor.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71738,
                      "answer_id":30280,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:50.215Z",
                      "updated_at":"2022-01-10T23:23:50.215Z",
                      "text":"Probablemente no. El comportamiento de Dennis parece razonable.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71737,
                      "answer_id":30280,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:50.211Z",
                      "updated_at":"2022-01-10T23:23:50.211Z",
                      "text":"Вероятно нет. Поведение Дэнниса кажется разумным.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71736,
                      "answer_id":30280,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:50.206Z",
                      "updated_at":"2022-01-10T23:23:50.206Z",
                      "text":"Prawdopodobnie nie. Zachowanie Dennisa wydaje się rozsądne.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71735,
                      "answer_id":30280,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:50.201Z",
                      "updated_at":"2022-01-10T23:23:50.201Z",
                      "text":"아닐 것 같다. Dennis의 행동은 합리적으로 보인다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71734,
                      "answer_id":30280,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:50.197Z",
                      "updated_at":"2022-01-10T23:23:50.197Z",
                      "text":"恐らく、いいえ。Dennisさんの行動は妥当なようである。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71733,
                      "answer_id":30280,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:50.192Z",
                      "updated_at":"2022-01-10T23:23:50.192Z",
                      "text":"Probabilmente no. Il comportamento di Dennis sembra ragionevole.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71732,
                      "answer_id":30280,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:50.187Z",
                      "updated_at":"2022-01-10T23:23:50.187Z",
                      "text":"Vermutlich nicht. Dennis' Verhalten scheint gerechtfertigt zu sein.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71731,
                      "answer_id":30280,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:50.182Z",
                      "updated_at":"2022-01-10T23:23:50.182Z",
                      "text":"Probablement pas. Le comportement de Dennis semble raisonnable.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71730,
                      "answer_id":30280,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:50.177Z",
                      "updated_at":"2022-01-10T23:23:50.177Z",
                      "text":"Sans doute pas. Le comportement de Dennis semble raisonnable.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71729,
                      "answer_id":30280,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:50.172Z",
                      "updated_at":"2022-01-10T23:23:50.172Z",
                      "text":"Provavelmente não. O comportamento do Dennis parece razoável.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71728,
                      "answer_id":30280,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:50.168Z",
                      "updated_at":"2022-01-10T23:23:50.168Z",
                      "text":"可能不是。Dennis 的行為看起來合理。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71727,
                      "answer_id":30280,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:50.163Z",
                      "updated_at":"2022-01-10T23:23:50.163Z",
                      "text":"可能没有。Dennis 的行为似乎是合理的。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71726,
                      "answer_id":30280,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:50.158Z",
                      "updated_at":"2022-01-10T23:23:50.158Z",
                      "text":"Hindi siguro. Waring makatwiran ang pag-uugali ni Dennis.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71725,
                      "answer_id":30280,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:50.153Z",
                      "updated_at":"2022-01-10T23:23:50.153Z",
                      "text":"Quizá no. El comportamiento de Dennis parece razonable.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71724,
                      "answer_id":30280,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:50.149Z",
                      "updated_at":"2022-04-21T21:18:14.448Z",
                      "text":"Yes, he is treating Amal differently as the only Muslim employee.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30281,
                "position":2,
                "active":true,
                "question_id":12036,
                "created_at":"2022-01-10T23:23:50.226Z",
                "updated_at":"2022-04-21T21:18:25.679Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Maybe. It depends on whether Cesar knows about Amal's religion.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71755,
                      "answer_id":30281,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:50.311Z",
                      "updated_at":"2022-01-10T23:23:50.311Z",
                      "text":"Evet. Gruptaki tek erkeğe farklı bir şey olursa, bu her zaman bir soruna işaret eder.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71754,
                      "answer_id":30281,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:50.307Z",
                      "updated_at":"2022-01-10T23:23:50.307Z",
                      "text":"Sí. Si al único hombre del grupo le sucede algo diferente, siempre es un problema.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71753,
                      "answer_id":30281,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:50.302Z",
                      "updated_at":"2022-01-10T23:23:50.302Z",
                      "text":"Да. Если что-то нетипичное случается с единственным мужчиной в группе, это всегда проблема.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71752,
                      "answer_id":30281,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:50.297Z",
                      "updated_at":"2022-01-10T23:23:50.297Z",
                      "text":"Tak. Jeśli coś dzieje się z jedynym mężczyzną w grupie, zawsze jest to problem.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71751,
                      "answer_id":30281,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:50.292Z",
                      "updated_at":"2022-01-10T23:23:50.292Z",
                      "text":"그렇다. 그룹 내 유일한 남자에게 뭔가 다른 일이 일어나면 항상 문제가 된다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71750,
                      "answer_id":30281,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:50.287Z",
                      "updated_at":"2022-01-10T23:23:50.287Z",
                      "text":"はい。グループ内唯一の男性に何か異なることが起きている場合、常に問題である。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71749,
                      "answer_id":30281,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:50.282Z",
                      "updated_at":"2022-01-10T23:23:50.282Z",
                      "text":"Sì. Se sta succedendo qualcosa di diverso all’unico uomo del gruppo, si tratta sempre di un problema.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71748,
                      "answer_id":30281,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:50.277Z",
                      "updated_at":"2022-01-10T23:23:50.277Z",
                      "text":"Ja. Wenn dem einzigen Mann in der Gruppe etwas anderes passiert, ist das immer ein Problem.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71747,
                      "answer_id":30281,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:50.272Z",
                      "updated_at":"2022-01-10T23:23:50.272Z",
                      "text":"Oui. Si quelque chose de différent arrive au seul homme du groupe, c'est toujours un problème.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71746,
                      "answer_id":30281,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:50.268Z",
                      "updated_at":"2022-01-10T23:23:50.268Z",
                      "text":"Oui. Si quelque chose de différent arrive au seul homme du groupe, c’est toujours un problème.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71745,
                      "answer_id":30281,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:50.263Z",
                      "updated_at":"2022-01-10T23:23:50.263Z",
                      "text":"Sim. Se algo diferente está acontecendo com o único homem no grupo, isso é sempre um problema.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71744,
                      "answer_id":30281,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:50.258Z",
                      "updated_at":"2022-01-10T23:23:50.258Z",
                      "text":"是。如團體中唯一的男性受到差別待遇，就總會是個問題。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71743,
                      "answer_id":30281,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:50.253Z",
                      "updated_at":"2022-01-10T23:23:50.253Z",
                      "text":"是。只要该部门中唯一的男性出现点异常，始终是一个问题。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71742,
                      "answer_id":30281,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:50.248Z",
                      "updated_at":"2022-01-10T23:23:50.248Z",
                      "text":"Opo. Kung may kakaibang nangyayari sa nag-iisang lalaki sa pangkat, palaging ito ay isang isyu.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71741,
                      "answer_id":30281,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:50.243Z",
                      "updated_at":"2022-01-10T23:23:50.243Z",
                      "text":"Sí. Si sucede algo diferente al único hombre en el grupo, siempre es un problema.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71740,
                      "answer_id":30281,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:50.239Z",
                      "updated_at":"2022-04-21T21:18:25.685Z",
                      "text":"Maybe. It depends on whether Cesar knows about Amal's religion.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31694,
                "position":3,
                "active":true,
                "question_id":12036,
                "created_at":"2022-04-21T21:18:36.300Z",
                "updated_at":"2022-04-21T21:18:36.300Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Probably not. His decision does not seem to be a result of bias.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77364,
                      "answer_id":31694,
                      "locale":"en",
                      "created_at":"2022-04-21T21:18:36.306Z",
                      "updated_at":"2022-04-21T21:18:36.306Z",
                      "text":"Probably not. His decision does not seem to be a result of bias.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12037,
          "shuffle":false,
          "position":12,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30283"
          ],
          "created_at":"2022-01-10T23:23:50.329Z",
          "updated_at":"2022-01-10T23:23:50.729Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":12,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Which of the following does not seem like a good strategy to use when writing inclusive job descriptions?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29816,
                "question_id":12037,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:50.451Z",
                "updated_at":"2022-01-10T23:23:50.451Z",
                "text":"Aşağıdakilerden hangisi işle ilgili herkesi kapsayacak tanımlar yazarken kullanmak için iyi bir strateji gibi görünmüyor?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29815,
                "question_id":12037,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:50.445Z",
                "updated_at":"2022-01-10T23:23:50.445Z",
                "text":"¿Cuál de las siguientes opciones no parece una buena estrategia para utilizar al redactar descripciones de puestos inclusivos?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29814,
                "question_id":12037,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:50.440Z",
                "updated_at":"2022-01-10T23:23:50.440Z",
                "text":"Какая из стратегий написания инклюзивного описания вакансии неудачна?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29813,
                "question_id":12037,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:50.435Z",
                "updated_at":"2022-01-10T23:23:50.435Z",
                "text":"Które z poniższych stwierdzeń nie wydaje się być dobrą strategią podczas pisania włączających opisów stanowisk pracy?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29812,
                "question_id":12037,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:50.431Z",
                "updated_at":"2022-01-10T23:23:50.431Z",
                "text":"포용적인 직무 설명서를 작성할 때 사용하기에 좋지 않은 전략은 무엇일까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29811,
                "question_id":12037,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:50.425Z",
                "updated_at":"2022-01-10T23:23:50.425Z",
                "text":"次のうち、包括的な職務説明を書いている際に、良い戦略でないように思われるものはどれですか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29810,
                "question_id":12037,
                "locale":"it",
                "created_at":"2022-01-10T23:23:50.421Z",
                "updated_at":"2022-01-10T23:23:50.421Z",
                "text":"Quale delle seguenti non sembra una buona strategia da utilizzare quando si scrivono descrizioni delle mansioni inclusive?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29809,
                "question_id":12037,
                "locale":"de",
                "created_at":"2022-01-10T23:23:50.416Z",
                "updated_at":"2022-01-10T23:23:50.416Z",
                "text":"Welche der folgenden Strategien halten Sie für ungeeignet, wenn es darum geht, integrierende Jobbeschreibungen zu verfassen.",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29808,
                "question_id":12037,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:50.411Z",
                "updated_at":"2022-01-10T23:23:50.411Z",
                "text":"Lequel des éléments suivants ne semble pas être une bonne stratégie à utiliser lors de la rédaction de descriptions de poste inclusives?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29807,
                "question_id":12037,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:50.406Z",
                "updated_at":"2022-01-10T23:23:50.406Z",
                "text":"Parmi les stratégies suivantes, laquelle ne semble pas être bonne pour rédiger des descriptions de poste inclusives ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29806,
                "question_id":12037,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:50.402Z",
                "updated_at":"2022-01-10T23:23:50.402Z",
                "text":"Qual das opções a seguir não parece uma boa estratégia a ser usada para descrições de trabalho inclusivo?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29805,
                "question_id":12037,
                "locale":"es",
                "created_at":"2022-01-10T23:23:50.397Z",
                "updated_at":"2022-01-10T23:23:50.397Z",
                "text":"¿Cuál de las opciones siguientes no parece una buena estrategia para usar al redactar descripciones de empleo inclusivas?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29804,
                "question_id":12037,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:50.392Z",
                "updated_at":"2022-01-10T23:23:50.392Z",
                "text":"Alin sa sumusunod ang waring magandang diskarte para gamitin kapag sumusulat ng inklusibong mga paglalarawan sa trabaho?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29803,
                "question_id":12037,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:50.387Z",
                "updated_at":"2022-01-10T23:23:50.387Z",
                "text":"撰写包容性的职位描述时，以下哪一种做法不是好办法？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29802,
                "question_id":12037,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:50.382Z",
                "updated_at":"2022-01-10T23:23:50.382Z",
                "text":"撰寫包容性工作描述時，下列何項不是好的策略？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29801,
                "question_id":12037,
                "locale":"en",
                "created_at":"2022-01-10T23:23:50.349Z",
                "updated_at":"2022-01-10T23:23:50.349Z",
                "text":"Which of the following does not seem like a good strategy to use when writing inclusive job descriptions?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30282,
                "position":1,
                "active":true,
                "question_id":12037,
                "created_at":"2022-01-10T23:23:50.457Z",
                "updated_at":"2022-01-10T23:23:50.457Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Use software such as a bias decoder to check the description for words that discourage qualified people from certain groups from applying.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71771,
                      "answer_id":30282,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:50.541Z",
                      "updated_at":"2022-01-10T23:23:50.541Z",
                      "text":"Belli gruplardan nitelikli kişileri gibi başvuruda bulunmaktan caydıran sözcüklerin tanımını incelemek için ön yargı kod çözücü gibi bir yazılım kullanın.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71770,
                      "answer_id":30282,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:50.536Z",
                      "updated_at":"2022-01-10T23:23:50.536Z",
                      "text":"Usar software como decodificador de sesgos para verificar la descripción de palabras que desalienten a las personas cualificadas de ciertos grupos a postularse.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71769,
                      "answer_id":30282,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:50.531Z",
                      "updated_at":"2022-01-10T23:23:50.531Z",
                      "text":"Использование такого программного обеспечения, как Bias Decoder, для анализа текста на наличие слов, которые отпугнут квалифицированных кандидатов из определенных групп.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71768,
                      "answer_id":30282,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:50.527Z",
                      "updated_at":"2022-01-10T23:23:50.527Z",
                      "text":"Użyj oprogramowania, takiego jak dekoder uprzedzeń, aby sprawdzić opis pod kątem słów, które zniechęcają do aplikowania wykwalifikowane osoby z pewnych grup.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71767,
                      "answer_id":30282,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:50.522Z",
                      "updated_at":"2022-01-10T23:23:50.522Z",
                      "text":"편견을 판독하기 위한 소프트웨어 같은 것을 사용하여 자격을 갖춘 특정 그룹의 사람들이 지원하지 못하게 하는 단어가 있는지 확인한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71766,
                      "answer_id":30282,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:50.517Z",
                      "updated_at":"2022-01-10T23:23:50.517Z",
                      "text":"偏見デコーダーのようなソフトウェアを利用し、特定のグループ内の応募資格のある人が応募をためらうような用語が説明文内に使用されていないかを確認する。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71765,
                      "answer_id":30282,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:50.513Z",
                      "updated_at":"2022-01-10T23:23:50.513Z",
                      "text":"Utilizzare un software come un decodificatore di pregiudizi per controllare la descrizione di parole che scoraggiano la candidatura di persone qualificate appartenenti a determinati gruppi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71764,
                      "answer_id":30282,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:50.508Z",
                      "updated_at":"2022-01-10T23:23:50.508Z",
                      "text":"Software wie beispielsweise einen Bias Decoder verwenden, um die Beschreibung auf Wörter hin zu prüfen, die qualifizierte Personen aus bestimmten Gruppen davon abhalten, sich zu bewerben.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71763,
                      "answer_id":30282,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:50.503Z",
                      "updated_at":"2022-01-10T23:23:50.503Z",
                      "text":"Utilisez un logiciel tel qu'un décodeur de parti pris pour passer en revue la description des mots qui découragent les personnes qualifiées de certains groupes à postuler.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71762,
                      "answer_id":30282,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:50.498Z",
                      "updated_at":"2022-01-10T23:23:50.498Z",
                      "text":"Utiliser un décodeur de préjugés ou un autre logiciel de ce type pour vérifier le contenu des descriptions à la recherche de mots susceptibles de dissuader certains groupes de personnes qualifiées de postuler.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71761,
                      "answer_id":30282,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:50.493Z",
                      "updated_at":"2022-01-10T23:23:50.493Z",
                      "text":"Usar um software, por exemplo, um decodificador de viés, para verificar a descrição de palavras que desencorajam a inscrição de pessoas qualificadas de determinados grupos.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71760,
                      "answer_id":30282,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:50.489Z",
                      "updated_at":"2022-01-10T23:23:50.489Z",
                      "text":"Usar software tal como un decodificador de sesgo para buscar en la descripción palabras que desalienten a presentarse a personas calificadas de ciertos grupos.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71759,
                      "answer_id":30282,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:50.484Z",
                      "updated_at":"2022-01-10T23:23:50.484Z",
                      "text":"Gumamit ng software tulad ng bias decoder para suriin ang paglalarawan sa mga salita na nakakadismaya sa mga kwalipikadong tao mula sa ilang grupo para mag-apply.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71758,
                      "answer_id":30282,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:50.479Z",
                      "updated_at":"2022-01-10T23:23:50.479Z",
                      "text":"使用如偏見解碼程式的軟體，檢查描述內是否有會造成特定群組符合資格的人選不願申請的字眼。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71757,
                      "answer_id":30282,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:50.474Z",
                      "updated_at":"2022-01-10T23:23:50.474Z",
                      "text":"使用偏见编码器等软件检查描述中是否有让某些群体的有资质的人员放弃申请的措辞。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71756,
                      "answer_id":30282,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:50.470Z",
                      "updated_at":"2022-01-10T23:23:50.470Z",
                      "text":"Use software such as a bias decoder to check the description for words that discourage qualified people from certain groups from applying.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30283,
                "position":2,
                "active":true,
                "question_id":12037,
                "created_at":"2022-01-10T23:23:50.547Z",
                "updated_at":"2022-01-10T23:23:50.547Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"List out plenty of job requirements, even if they’re not all necessary for the listed job. This helps more people feel included by the description.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71787,
                      "answer_id":30283,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:50.635Z",
                      "updated_at":"2022-01-10T23:23:50.635Z",
                      "text":"Belirtilen iş için hepsi gerekli olmasa da işle ilgili pek çok gereksinimi listeleyin. Bu sayede daha fazla insan bu tanıma dahil olduğunu hissedecektir.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71786,
                      "answer_id":30283,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:50.630Z",
                      "updated_at":"2022-01-10T23:23:50.630Z",
                      "text":"Enumerar una amplia gama de requisitos del trabajo, aunque no todos sean necesarios para el trabajo indicado. Esto ayuda a que más personas se sientan incluidas en la descripción.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71785,
                      "answer_id":30283,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:50.626Z",
                      "updated_at":"2022-01-10T23:23:50.626Z",
                      "text":"Указание обширного списка требований к кандидату, даже если они необязательны для данной должности. Это покажет большему количеству людей, что описание вакансии их учитывает.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71784,
                      "answer_id":30283,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:50.620Z",
                      "updated_at":"2022-01-10T23:23:50.620Z",
                      "text":"Wymień wiele wymagań związanych z pracą, nawet jeśli nie wszystkie są niezbędne do wykonywania danej pracy. Dzięki temu więcej osób będzie czuć się uwzględnionych w ramach danego opisu.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71783,
                      "answer_id":30283,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:50.616Z",
                      "updated_at":"2022-01-10T23:23:50.616Z",
                      "text":"충분한 직무 요건들을(해당 직무에 꼭 필요한 것이 아니라도) 모두 나열한다. 그렇게 하면 더 많은 사람들이 직무 설명에 포함된다는 인상을 받을 수 있다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71782,
                      "answer_id":30283,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:50.611Z",
                      "updated_at":"2022-01-10T23:23:50.611Z",
                      "text":"求人している仕事にとって全く必要でない場合でも、応募資格を沢山記載する。これにより、より多くの人が説明内容に自身が該当すると感じることができます。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71781,
                      "answer_id":30283,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:50.606Z",
                      "updated_at":"2022-01-10T23:23:50.606Z",
                      "text":"Elencare molti requisiti del lavoro, anche se non sono tutti necessari per il lavoro elencato. Questa strategia aiuta un maggior numero di persone a sentirsi incluse nella descrizione.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71780,
                      "answer_id":30283,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:50.601Z",
                      "updated_at":"2022-01-10T23:23:50.601Z",
                      "text":"Viele Jobanforderungen auflisten, auch wenn sie nicht alle für den betreffenden Job erforderlich sind. Dadurch fühlen sich mehr Menschen von der Beschreibung angesprochen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71779,
                      "answer_id":30283,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:50.596Z",
                      "updated_at":"2022-01-10T23:23:50.596Z",
                      "text":"Énumérez de nombreuses exigences du poste, même si elles ne sont pas toutes nécessaires pour le poste répertorié. Cela aide plus de gens à se sentir inclus dans la description.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71778,
                      "answer_id":30283,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:50.592Z",
                      "updated_at":"2022-01-10T23:23:50.592Z",
                      "text":"Dresser une longue liste d’exigences, même si elles ne sont pas toutes nécessaires pour le poste en question, afin qu’un plus grand nombre de gens se sente inclus dans la description.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71777,
                      "answer_id":30283,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:50.587Z",
                      "updated_at":"2022-01-10T23:23:50.587Z",
                      "text":"Listar vários requisitos de trabalho, mesmo que nem todos sejam necessários para o trabalho listado. Isso ajuda mais pessoas a se sentirem incluídas na descrição.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71776,
                      "answer_id":30283,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:50.582Z",
                      "updated_at":"2022-01-10T23:23:50.582Z",
                      "text":"Enumerar varios requisitos para el empleo, incluso si no todos son necesarios para el empleo publicado. Esto ayuda a más personas a sentirse incluidas por la descripción.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71775,
                      "answer_id":30283,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:50.577Z",
                      "updated_at":"2022-01-10T23:23:50.577Z",
                      "text":"Ilista ang maraming mga kinakailangan sa trabaho, kahit na hindi lahat kailangan ang mga iyon para sa nakalistang trabaho. Makakatulong ito sa maraming tao na madama na kasama ng paglalarawan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71774,
                      "answer_id":30283,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:50.572Z",
                      "updated_at":"2022-01-10T23:23:50.572Z",
                      "text":"列出很多职位要求，即使它们并不全是所列职位需要的。这样可以扩大招聘对象的覆盖面。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71773,
                      "answer_id":30283,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:50.567Z",
                      "updated_at":"2022-01-10T23:23:50.567Z",
                      "text":"列出許多工作要求，即使並非都是職缺必要的工作要求。這可幫助較多的人覺得自己符合描述的要求。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71772,
                      "answer_id":30283,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:50.562Z",
                      "updated_at":"2022-01-10T23:23:50.562Z",
                      "text":"List out plenty of job requirements, even if they’re not all necessary for the listed job. This helps more people feel included by the description.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30284,
                "position":3,
                "active":true,
                "question_id":12037,
                "created_at":"2022-01-10T23:23:50.641Z",
                "updated_at":"2022-01-10T23:23:50.641Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Include a wide range of employment benefits, such as paid sick days, parental leave, healthcare options, or the process your organization uses for requesting workplace accommodations.\n",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71803,
                      "answer_id":30284,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:50.725Z",
                      "updated_at":"2022-01-10T23:23:50.725Z",
                      "text":"Ücretli hastalık izinleri, ebeveyn izni, sağlık hizmeti seçenekleri veya kuruluşunuzun iş yeri düzenleme talebinde bulunmak için kullandığı süreç gibi çok çeşitli istihdam avantajlarını bu bölüme dahil edin.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71802,
                      "answer_id":30284,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:50.719Z",
                      "updated_at":"2022-01-10T23:23:50.719Z",
                      "text":"Incluir una amplia gama de beneficios laborales, como días de enfermedad pagados, permiso parental, opciones de atención médica o el proceso que utiliza su organización para solicitar adaptaciones en el lugar de trabajo.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71801,
                      "answer_id":30284,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:50.715Z",
                      "updated_at":"2022-01-10T23:23:50.715Z",
                      "text":"Перечисление множества преимуществ, как то: оплачиваемый больничный, отпуск по уходу за ребенком, варианты медицинского обслуживания или процесс, используемый в организации для подачи заявления на предоставление условий на рабочем месте.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71800,
                      "answer_id":30284,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:50.710Z",
                      "updated_at":"2022-01-10T23:23:50.710Z",
                      "text":"Uwzględnij szeroki zakres świadczeń pracowniczych, takich jak płatne zwolnienia chorobowe, urlopy rodzicielskie, opcje opieki zdrowotnej lub proces, jaki stosuje Twoja organizacja w celu wdrożenia na stanowisku pracy.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71799,
                      "answer_id":30284,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:50.705Z",
                      "updated_at":"2022-01-10T23:23:50.705Z",
                      "text":"유급 병가, 육아 휴직, 의료 혜택 또는 편의를 요청하기 위한 절차와 같이 다양한 고용 혜택을 포함시킨다.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71798,
                      "answer_id":30284,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:50.700Z",
                      "updated_at":"2022-01-10T23:23:50.700Z",
                      "text":"有給の病気欠勤日、育児休暇、医療保険オプション、職場における配慮を依頼する際に組織で利用するプロセスなど、広範囲の福利厚生を含める。\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71797,
                      "answer_id":30284,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:50.696Z",
                      "updated_at":"2022-01-10T23:23:50.696Z",
                      "text":"Includere un’ampia gamma di vantaggi per l’occupazione, come giorni di malattia retribuiti, congedo parentale, opzioni sanitarie o la procedura utilizzata dall’organizzazione per richiedere adeguamenti per il posto di lavoro.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71796,
                      "answer_id":30284,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:50.691Z",
                      "updated_at":"2022-01-10T23:23:50.691Z",
                      "text":"Möglichst viele Vergünstigungen und Vorteile aufzählen (bezahlte Krankheitstage, Elternzeit, Gesundheitsleistungen) oder den Prozess nennen, den Ihr Unternehmen nutzt, um Wohnraum für Mitarbeiter anzufragen.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71795,
                      "answer_id":30284,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:50.687Z",
                      "updated_at":"2022-01-10T23:23:50.687Z",
                      "text":"Incluez un large éventail d'avantages sociaux, tels que les congés maladie payés, les congés parentaux, les options de soins de santé ou le processus utilisé par votre organisation pour demander des aménagements en milieu de travail.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71794,
                      "answer_id":30284,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:50.682Z",
                      "updated_at":"2022-01-10T23:23:50.682Z",
                      "text":"Inclure un large éventail d’avantages sociaux : congés de maladie, congé parental, soins de santé, ou encore le processus mis en place par votre entreprise pour les demandes d’aménagement sur le lieu de travail.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71793,
                      "answer_id":30284,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:50.677Z",
                      "updated_at":"2022-01-10T23:23:50.677Z",
                      "text":"Incluir uma ampla gama de benefícios do emprego, como licença médica, licença parental, opções de saúde ou o processo que sua organização usa para solicitar adaptações no local de trabalho.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71792,
                      "answer_id":30284,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:50.673Z",
                      "updated_at":"2022-01-10T23:23:50.673Z",
                      "text":"加入多種員工福利，例如支薪病假、育嬰假、醫療險選項，或你的組織用於請求職場照應的流程。\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71791,
                      "answer_id":30284,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:50.668Z",
                      "updated_at":"2022-01-10T23:23:50.668Z",
                      "text":"Incluir una amplia variedad de beneficios de empleo, como días de licencia por enfermedad, licencia para padres, opciones de atención médica o el proceso que utiliza tu organización para solicitar adaptaciones razonables en el lugar de trabajo.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71790,
                      "answer_id":30284,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:50.663Z",
                      "updated_at":"2022-01-10T23:23:50.663Z",
                      "text":"Isama ang isang malawak na hanay ng mga benepisyo sa pagtatrabaho, tulad ng bayad na mga araw na may sakit, leave ng magulang, mga pagpipilian sa pangangalagang pangkalusugan, o ang proseso na ginagamit ng iyong samahan para sa paghingi ng mga accommodation sa lugar ng trabaho.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71789,
                      "answer_id":30284,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:50.658Z",
                      "updated_at":"2022-01-10T23:23:50.658Z",
                      "text":"包括很多就业福利，例如带薪病假、育婴假、医疗选择或者你的组织采用的申请工作场所照顾的流程。\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71788,
                      "answer_id":30284,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:50.654Z",
                      "updated_at":"2022-01-10T23:23:50.654Z",
                      "text":"Include a wide range of employment benefits, such as paid sick days, parental leave, healthcare options, or the process your organization uses for requesting workplace accommodations.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12038,
          "shuffle":false,
          "position":13,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30288"
          ],
          "created_at":"2022-01-10T23:23:50.741Z",
          "updated_at":"2022-04-21T21:21:31.789Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":13,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What could their supervisor have done better to remove bias from performance reviews?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29817,
                "question_id":12038,
                "locale":"en",
                "created_at":"2022-01-10T23:23:50.762Z",
                "updated_at":"2022-04-21T21:21:31.791Z",
                "text":"What could their supervisor have done better to remove bias from performance reviews?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29832,
                "question_id":12038,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:50.867Z",
                "updated_at":"2022-01-10T23:23:50.867Z",
                "text":"Aşağıdakilerden hangisi performans incelemelerinde ön yargıyı ortadan kaldırmak için iyi bir stratejidir?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29831,
                "question_id":12038,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:50.861Z",
                "updated_at":"2022-01-10T23:23:50.861Z",
                "text":"¿Cuál de las siguientes opciones es una buena estrategia para eliminar el sesgo de las evaluaciones de desempeño?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29830,
                "question_id":12038,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:50.857Z",
                "updated_at":"2022-01-10T23:23:50.857Z",
                "text":"Какая из стратегий исключения предрассудков при оценке качества работы является успешной?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29829,
                "question_id":12038,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:50.852Z",
                "updated_at":"2022-01-10T23:23:50.852Z",
                "text":"Która z poniższych strategii jest odpowiednia do eliminowania stronniczości w ocenach wyników?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29828,
                "question_id":12038,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:50.847Z",
                "updated_at":"2022-01-10T23:23:50.847Z",
                "text":"다음 중 업무 평가에서 편견을 없애기 위한 좋은 전략은 무엇일까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29827,
                "question_id":12038,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:50.841Z",
                "updated_at":"2022-01-10T23:23:50.841Z",
                "text":"次のうち、業績評価の際に偏見をなくすための良い戦略はどれですか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29826,
                "question_id":12038,
                "locale":"it",
                "created_at":"2022-01-10T23:23:50.835Z",
                "updated_at":"2022-01-10T23:23:50.835Z",
                "text":"Quale delle seguenti è una buona strategia per rimuovere i pregiudizi dalle revisioni delle prestazioni?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29825,
                "question_id":12038,
                "locale":"de",
                "created_at":"2022-01-10T23:23:50.830Z",
                "updated_at":"2022-01-10T23:23:50.830Z",
                "text":"Welche der folgenden Strategien eignet sich, um Vorurteile bei Leistungsüberprüfungen zu beseitigen?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29824,
                "question_id":12038,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:50.825Z",
                "updated_at":"2022-01-10T23:23:50.825Z",
                "text":"Laquelle des propositions suivantes est une bonne stratégie pour éliminer les parti pris lors des évaluations de performances?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29823,
                "question_id":12038,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:50.820Z",
                "updated_at":"2022-01-10T23:23:50.820Z",
                "text":"Parmi les propositions suivantes, laquelle constitue une bonne stratégie pour éliminer tout préjugé des évaluations de performance ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29822,
                "question_id":12038,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:50.816Z",
                "updated_at":"2022-01-10T23:23:50.816Z",
                "text":"Qual das alternativas a seguir é uma boa estratégia para eliminar viés das avaliações de desempenho?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29821,
                "question_id":12038,
                "locale":"es",
                "created_at":"2022-01-10T23:23:50.811Z",
                "updated_at":"2022-01-10T23:23:50.811Z",
                "text":"¿Cuál de las opciones siguientes es una buena estrategia para eliminar el sesgo en las evaluaciones del desempeño?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29820,
                "question_id":12038,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:50.806Z",
                "updated_at":"2022-01-10T23:23:50.806Z",
                "text":"Alin sa mga sumusunod ang isang mahusay na diskarte para sa pag-alis ng bias mula sa mga rebyu ng performance?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29819,
                "question_id":12038,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:50.801Z",
                "updated_at":"2022-01-10T23:23:50.801Z",
                "text":"以下哪一种做法在避免绩效评估出现偏见方面较好？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29818,
                "question_id":12038,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:50.796Z",
                "updated_at":"2022-01-10T23:23:50.796Z",
                "text":"下列何項是去除績效考核偏見的良好策略？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30285,
                "position":1,
                "active":true,
                "question_id":12038,
                "created_at":"2022-01-10T23:23:50.873Z",
                "updated_at":"2022-01-10T23:23:50.873Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Evaluate employees using consistent, objective, job-related criteria.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71819,
                      "answer_id":30285,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:50.961Z",
                      "updated_at":"2022-01-10T23:23:50.961Z",
                      "text":"Çalışanları değerlendirirken tutarlı, objektif, işle ilgili ölçütler kullanın.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71818,
                      "answer_id":30285,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:50.957Z",
                      "updated_at":"2022-01-10T23:23:50.957Z",
                      "text":"Evaluar a los empleados utilizando criterios coherentes, objetivos y relacionados con el puesto.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71817,
                      "answer_id":30285,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:50.951Z",
                      "updated_at":"2022-01-10T23:23:50.951Z",
                      "text":"Оценивать сотрудников на основании последовательных, объективных критериев, связанных с профессиональной деятельностью.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71816,
                      "answer_id":30285,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:50.946Z",
                      "updated_at":"2022-01-10T23:23:50.946Z",
                      "text":"Ocenianie pracowników przy użyciu spójnych, obiektywnych i związanych z pracą kryteriów.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71815,
                      "answer_id":30285,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:50.941Z",
                      "updated_at":"2022-01-10T23:23:50.941Z",
                      "text":"일관되고, 객관적이며, 업무와 관련이 있는 기준을 적용하여 직원을 평가한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71814,
                      "answer_id":30285,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:50.937Z",
                      "updated_at":"2022-01-10T23:23:50.937Z",
                      "text":"従業員を、一貫しており、客観的で、仕事に関連した基準を使って評価する。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71813,
                      "answer_id":30285,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:50.932Z",
                      "updated_at":"2022-01-10T23:23:50.932Z",
                      "text":"Valutare i dipendenti utilizzando criteri coerenti, obiettivi e correlati al lavoro.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71812,
                      "answer_id":30285,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:50.927Z",
                      "updated_at":"2022-01-10T23:23:50.927Z",
                      "text":"Mitarbeiter anhand einheitlicher, objektiver, jobbezogener Kriterien beurteilen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71811,
                      "answer_id":30285,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:50.922Z",
                      "updated_at":"2022-01-10T23:23:50.922Z",
                      "text":"Évaluer les employés en utilisant des critères cohérents, objectifs et liés à l'emploi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71810,
                      "answer_id":30285,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:50.917Z",
                      "updated_at":"2022-01-10T23:23:50.917Z",
                      "text":"Évaluer les employés sur la base de critères cohérents, objectifs et liés à l’emploi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71809,
                      "answer_id":30285,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:50.913Z",
                      "updated_at":"2022-01-10T23:23:50.913Z",
                      "text":"Avaliar os funcionários usando critérios consistentes, objetivos e relacionados ao trabalho.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71808,
                      "answer_id":30285,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:50.908Z",
                      "updated_at":"2022-01-10T23:23:50.908Z",
                      "text":"Evaluar a los empleados usando criterios laborales consistentes y objetivos.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71807,
                      "answer_id":30285,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:50.903Z",
                      "updated_at":"2022-01-10T23:23:50.903Z",
                      "text":"Suriin ang mga empleyado gamit ang pare-pareho, layunin, at pamantayan na may kaugnayan sa trabaho.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71806,
                      "answer_id":30285,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:50.897Z",
                      "updated_at":"2022-01-10T23:23:50.897Z",
                      "text":"采用一致、客观、与职位有关的标准评估员工。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71805,
                      "answer_id":30285,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:50.892Z",
                      "updated_at":"2022-01-10T23:23:50.892Z",
                      "text":"使用一致、客觀、工作相關的條件來評估員工。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71804,
                      "answer_id":30285,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:50.888Z",
                      "updated_at":"2022-01-10T23:23:50.888Z",
                      "text":"Evaluate employees using consistent, objective, job-related criteria.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30286,
                "position":2,
                "active":true,
                "question_id":12038,
                "created_at":"2022-01-10T23:23:50.968Z",
                "updated_at":"2022-04-21T21:21:48.275Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Ensure that specific examples are included to support evaluation and feedback in each area.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71820,
                      "answer_id":30286,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:50.982Z",
                      "updated_at":"2022-04-21T21:21:48.277Z",
                      "text":"Ensure that specific examples are included to support evaluation and feedback in each area.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71835,
                      "answer_id":30286,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:51.055Z",
                      "updated_at":"2022-01-10T23:23:51.055Z",
                      "text":"Her bir alandaki değerlendirmenizi/geri bildirimlerinizi destekleyecek nitelikte belirli örneklerin dahil edildiğinden emin olun.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71834,
                      "answer_id":30286,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:51.050Z",
                      "updated_at":"2022-01-10T23:23:51.050Z",
                      "text":"Asegurarse de que se incluyan ejemplos específicos para respaldar su evaluación/comentarios en cada área.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71833,
                      "answer_id":30286,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:51.045Z",
                      "updated_at":"2022-01-10T23:23:51.045Z",
                      "text":"Удостовериться, что в каждой области оценки/обратной связи приводятся конкретные примеры.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71832,
                      "answer_id":30286,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:51.040Z",
                      "updated_at":"2022-01-10T23:23:51.040Z",
                      "text":"Podawanie konkretnych przykładów na poparcie swojej oceny/uwagi w każdym z obszarów.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71831,
                      "answer_id":30286,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:51.035Z",
                      "updated_at":"2022-01-10T23:23:51.035Z",
                      "text":"각 영역에서 평가/피드백을 뒷받침할 수 있는 구체적인 예를 포함시킨다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71830,
                      "answer_id":30286,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:51.030Z",
                      "updated_at":"2022-01-10T23:23:51.030Z",
                      "text":"各分野における評価・フィードバックをサポートするための、具体的な例が含まれていることを確認する。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71829,
                      "answer_id":30286,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:51.026Z",
                      "updated_at":"2022-01-10T23:23:51.026Z",
                      "text":"Assicurarsi che siano compresi esempi specifici per supportare la tua valutazione/il tuo feedback in ciascuna area.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71828,
                      "answer_id":30286,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:51.021Z",
                      "updated_at":"2022-01-10T23:23:51.021Z",
                      "text":"Darauf achten, dass spezifische Beispiele genannt werden, um Antworten/Feedback für jeden Bereich zu untermauern.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71827,
                      "answer_id":30286,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:51.015Z",
                      "updated_at":"2022-01-10T23:23:51.015Z",
                      "text":"Assurez-vous que des exemples spécifiques sont inclus pour soutenir votre évaluation/rétroaction dans chaque domaine.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71826,
                      "answer_id":30286,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:51.010Z",
                      "updated_at":"2022-01-10T23:23:51.010Z",
                      "text":"Faire en sorte d’inclure des exemples spécifiques venant étayer votre évaluation / rétroaction dans chaque domaine.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71825,
                      "answer_id":30286,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:51.006Z",
                      "updated_at":"2022-01-10T23:23:51.006Z",
                      "text":"Certificar-se de que exemplos específicos sejam incluídos para apoiar sua avaliação/feedback em cada área.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71824,
                      "answer_id":30286,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:51.000Z",
                      "updated_at":"2022-01-10T23:23:51.000Z",
                      "text":"確認你在各領域的評核/回饋意見均提供特定的例子。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71823,
                      "answer_id":30286,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:50.995Z",
                      "updated_at":"2022-01-10T23:23:50.995Z",
                      "text":"Verificar que se incluyan ejemplos específicos en respaldo de tu evaluación/comentarios en cada área.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71822,
                      "answer_id":30286,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:50.991Z",
                      "updated_at":"2022-01-10T23:23:50.991Z",
                      "text":"Tiyakin na ang mga tiyak na halimbawa ay kasama upang suportahan ang iyong pagsusuri/puna sa bawat lugar.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71821,
                      "answer_id":30286,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:50.986Z",
                      "updated_at":"2022-01-10T23:23:50.986Z",
                      "text":"确保逐一提供具体的例子来支持你的评估/反馈。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30287,
                "position":3,
                "active":true,
                "question_id":12038,
                "created_at":"2022-01-10T23:23:51.061Z",
                "updated_at":"2022-04-21T21:21:58.932Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Collect performance data and examples throughout the entire evaluation period instead of waiting until the end to reflect.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71851,
                      "answer_id":30287,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:51.176Z",
                      "updated_at":"2022-01-10T23:23:51.176Z",
                      "text":"Yalnızca sonunda belirtmek yerine tüm değerlendirme dönemi için geçerli olan performans verilerini ve örnekleri toplayın.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71850,
                      "answer_id":30287,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:51.170Z",
                      "updated_at":"2022-01-10T23:23:51.170Z",
                      "text":"Recopilar datos y ejemplos de desempeño durante todo el período de evaluación en lugar de solo reflexionar al final.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71849,
                      "answer_id":30287,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:51.166Z",
                      "updated_at":"2022-01-10T23:23:51.166Z",
                      "text":"Собирать данные о качестве работы и примеры на протяжении всего периода оценки, вместо простой рефлексии в конце периода.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71848,
                      "answer_id":30287,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:51.161Z",
                      "updated_at":"2022-01-10T23:23:51.161Z",
                      "text":"Gromadzenie danych i przykładów dotyczących wyników przez cały okres oceny, a nie tylko przy końcowym podsumowaniu.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71847,
                      "answer_id":30287,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:51.156Z",
                      "updated_at":"2022-01-10T23:23:51.156Z",
                      "text":"마지막 기간만이 아니라 전체 평가 기간 내내 업무 데이터와 예를 수집한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71846,
                      "answer_id":30287,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:51.151Z",
                      "updated_at":"2022-01-10T23:23:51.151Z",
                      "text":"最後にのみ業績データや例を反映するのではなく、評価期間全体を通してそれを収集する。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71845,
                      "answer_id":30287,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:51.147Z",
                      "updated_at":"2022-01-10T23:23:51.147Z",
                      "text":"Raccogliere dati ed esempi sulle prestazioni durante l’intero periodo di valutazione invece di limitarsi a riflettere alla fine.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71844,
                      "answer_id":30287,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:51.142Z",
                      "updated_at":"2022-01-10T23:23:51.142Z",
                      "text":"Über den gesamten Bewertungszeitraum hinweg leistungsrelevante Daten und Beispiele erfassen, anstatt erst am Ende darüber nachzudenken.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71843,
                      "answer_id":30287,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:51.137Z",
                      "updated_at":"2022-01-10T23:23:51.137Z",
                      "text":"Collectez des données de performance et des exemples tout au long de la période d'évaluation au lieu de simplement réfléchir à la fin.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71842,
                      "answer_id":30287,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:51.133Z",
                      "updated_at":"2022-01-10T23:23:51.133Z",
                      "text":"Récolter des données et des exemples de performance qui reflètent l’ensemble de la période d’évaluation et non uniquement la fin.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71841,
                      "answer_id":30287,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:51.128Z",
                      "updated_at":"2022-01-10T23:23:51.128Z",
                      "text":"Coletar dados de desempenho e exemplos ao longo de todo o período de avaliação, em vez de avaliar apenas no final.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71840,
                      "answer_id":30287,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:51.123Z",
                      "updated_at":"2022-01-10T23:23:51.123Z",
                      "text":"Recopilar datos y ejemplos de desempeño en todo el período de evaluación, en lugar de solo reflexionar al final.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71839,
                      "answer_id":30287,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:51.118Z",
                      "updated_at":"2022-01-10T23:23:51.118Z",
                      "text":"Kolektahin ang data ng performance at mga halimbawa sa buong panahon ng pagsusuri sa halip na pag-isipan lang sa katapusan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71838,
                      "answer_id":30287,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:51.113Z",
                      "updated_at":"2022-01-10T23:23:51.113Z",
                      "text":"在整个评估期内收集绩效数据和例证，不要等到最后再收集。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71837,
                      "answer_id":30287,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:51.108Z",
                      "updated_at":"2022-01-10T23:23:51.108Z",
                      "text":"在整個評核期間持續收集績效資料和例子，而不是只反映最後的結果。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71836,
                      "answer_id":30287,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:51.104Z",
                      "updated_at":"2022-04-21T21:21:58.934Z",
                      "text":"Collect performance data and examples throughout the entire evaluation period instead of waiting until the end to reflect.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30288,
                "position":4,
                "active":true,
                "question_id":12038,
                "created_at":"2022-01-10T23:23:51.182Z",
                "updated_at":"2022-01-10T23:23:51.182Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"All of the above.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71867,
                      "answer_id":30288,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:51.270Z",
                      "updated_at":"2022-01-10T23:23:51.270Z",
                      "text":"Yukarıdakilerin tümü.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71866,
                      "answer_id":30288,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:51.265Z",
                      "updated_at":"2022-01-10T23:23:51.265Z",
                      "text":"Todas las opciones anteriores",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71865,
                      "answer_id":30288,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:51.259Z",
                      "updated_at":"2022-01-10T23:23:51.259Z",
                      "text":"Все вышеперечисленное.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71864,
                      "answer_id":30288,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:51.255Z",
                      "updated_at":"2022-01-10T23:23:51.255Z",
                      "text":"Wszystkie z powyższych odpowiedzi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71863,
                      "answer_id":30288,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:51.249Z",
                      "updated_at":"2022-01-10T23:23:51.249Z",
                      "text":"모두 해당.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71862,
                      "answer_id":30288,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:51.245Z",
                      "updated_at":"2022-01-10T23:23:51.245Z",
                      "text":"上記すべて。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71861,
                      "answer_id":30288,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:51.239Z",
                      "updated_at":"2022-01-10T23:23:51.239Z",
                      "text":"Tutte le risposte precedenti.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71860,
                      "answer_id":30288,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:51.235Z",
                      "updated_at":"2022-01-10T23:23:51.235Z",
                      "text":"Alle der oben genannten Antworten treffen zu.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71859,
                      "answer_id":30288,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:51.230Z",
                      "updated_at":"2022-01-10T23:23:51.230Z",
                      "text":"Toutes ces réponses.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71858,
                      "answer_id":30288,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:51.225Z",
                      "updated_at":"2022-01-10T23:23:51.225Z",
                      "text":"Toutes les réponses ci-dessus.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71857,
                      "answer_id":30288,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:51.220Z",
                      "updated_at":"2022-01-10T23:23:51.220Z",
                      "text":"Todas as respostas acima.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71856,
                      "answer_id":30288,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:51.215Z",
                      "updated_at":"2022-01-10T23:23:51.215Z",
                      "text":"以上皆是。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71855,
                      "answer_id":30288,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:51.210Z",
                      "updated_at":"2022-01-10T23:23:51.210Z",
                      "text":"Todas las anteriores.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71854,
                      "answer_id":30288,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:51.205Z",
                      "updated_at":"2022-01-10T23:23:51.205Z",
                      "text":"Lahat ng nasa itaas.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71853,
                      "answer_id":30288,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:51.200Z",
                      "updated_at":"2022-01-10T23:23:51.200Z",
                      "text":"上述所有行为。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71852,
                      "answer_id":30288,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:51.195Z",
                      "updated_at":"2022-01-10T23:23:51.195Z",
                      "text":"All of the above.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12039,
          "shuffle":false,
          "position":14,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30291"
          ],
          "created_at":"2022-01-10T23:23:51.289Z",
          "updated_at":"2022-01-10T23:23:51.696Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":14,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What’s the most helpful thing you can say? \n",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29848,
                "question_id":12039,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:51.413Z",
                "updated_at":"2022-01-10T23:23:51.413Z",
                "text":"Söyleyebileceğiniz en faydalı şey nedir? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29847,
                "question_id":12039,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:51.408Z",
                "updated_at":"2022-01-10T23:23:51.408Z",
                "text":"¿Qué es lo más útil que puede decir? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29846,
                "question_id":12039,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:51.403Z",
                "updated_at":"2022-01-10T23:23:51.403Z",
                "text":"Что нужно сказать в поддержку? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29845,
                "question_id":12039,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:51.399Z",
                "updated_at":"2022-01-10T23:23:51.399Z",
                "text":"Jakie jest najbardziej pomocne stwierdzenie, które możesz powiedzieć? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29844,
                "question_id":12039,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:51.394Z",
                "updated_at":"2022-01-10T23:23:51.394Z",
                "text":"어떻게 말하면 가장 도움이 될까요? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29843,
                "question_id":12039,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:51.389Z",
                "updated_at":"2022-01-10T23:23:51.389Z",
                "text":"あなたが言うことのできる、最も役立つ物事は何ですか？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29842,
                "question_id":12039,
                "locale":"it",
                "created_at":"2022-01-10T23:23:51.385Z",
                "updated_at":"2022-01-10T23:23:51.385Z",
                "text":"Qual è l’affermazione più utile che puoi dire? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29841,
                "question_id":12039,
                "locale":"de",
                "created_at":"2022-01-10T23:23:51.380Z",
                "updated_at":"2022-01-10T23:23:51.380Z",
                "text":"Was wäre nun das Hilfreichste, die Sie tun könnten? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29840,
                "question_id":12039,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:51.375Z",
                "updated_at":"2022-01-10T23:23:51.375Z",
                "text":"Quelle est la chose la plus utile que vous puissiez dire? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29839,
                "question_id":12039,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:51.370Z",
                "updated_at":"2022-01-10T23:23:51.370Z",
                "text":"Quelle est la chose la plus utile que vous puissiez dire ? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29838,
                "question_id":12039,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:51.365Z",
                "updated_at":"2022-01-10T23:23:51.365Z",
                "text":"Qual é a coisa mais útil que você pode dizer? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29837,
                "question_id":12039,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:51.360Z",
                "updated_at":"2022-01-10T23:23:51.360Z",
                "text":"你可說最有幫助的話是甚麼？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29836,
                "question_id":12039,
                "locale":"es",
                "created_at":"2022-01-10T23:23:51.355Z",
                "updated_at":"2022-01-10T23:23:51.355Z",
                "text":"¿Qué es lo más útil que puedes decir? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29835,
                "question_id":12039,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:51.351Z",
                "updated_at":"2022-01-10T23:23:51.351Z",
                "text":"Ano ang pinaka-kapaki-pakinabang na bagay na maaari mong sabihin? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29834,
                "question_id":12039,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:51.346Z",
                "updated_at":"2022-01-10T23:23:51.346Z",
                "text":"你的哪一种说法最有帮助？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29833,
                "question_id":12039,
                "locale":"en",
                "created_at":"2022-01-10T23:23:51.308Z",
                "updated_at":"2022-01-10T23:23:51.308Z",
                "text":"What’s the most helpful thing you can say? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30289,
                "position":1,
                "active":true,
                "question_id":12039,
                "created_at":"2022-01-10T23:23:51.419Z",
                "updated_at":"2022-01-10T23:23:51.419Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell her you’re proud of her. Make sure she knows how much you value her skills and that you believe in her. ",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71883,
                      "answer_id":30289,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:51.506Z",
                      "updated_at":"2022-01-10T23:23:51.506Z",
                      "text":"Onunla gurur duyduğunuzu söyleyin. Yeteneklerine ne kadar değer verdiğinizi ve ona inandığınızı bilmesini sağlayın. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71882,
                      "answer_id":30289,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:51.501Z",
                      "updated_at":"2022-01-10T23:23:51.501Z",
                      "text":"Decir que está orgulloso de ella. Asegurarse de que sepa cuánto valora usted sus habilidades y que cree en ella. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71881,
                      "answer_id":30289,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:51.496Z",
                      "updated_at":"2022-01-10T23:23:51.496Z",
                      "text":"Сказать, что вы ей гордитесь. Убедиться, что она знает, насколько вы цените ее умения, и что вы верите в нее. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71880,
                      "answer_id":30289,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:51.491Z",
                      "updated_at":"2022-01-10T23:23:51.491Z",
                      "text":"Powiedzieć jej, że jesteś z niej dumny(-a). Potwierdzić, że bardzo cenisz jej umiejętności i że w nią wierzysz. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71879,
                      "answer_id":30289,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:51.487Z",
                      "updated_at":"2022-01-10T23:23:51.487Z",
                      "text":"그녀가 자랑스럽다고 말한다. 그녀의 능력을 높이 평가하고 있고 그녀를 얼마나 신뢰하고 있는지 분명히 알게 해준다. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71878,
                      "answer_id":30289,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:51.482Z",
                      "updated_at":"2022-01-10T23:23:51.482Z",
                      "text":"彼女を誇りに思っていることを伝える。あなたが彼女のスキルをどれだけ評価しているのか、そして彼女を信頼しているということを彼女自身が知っているようにする。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71877,
                      "answer_id":30289,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:51.477Z",
                      "updated_at":"2022-01-10T23:23:51.477Z",
                      "text":"Dirle che sei orgoglioso di lei. Assicurarsi che sappia quanto apprezzi le sue competenze e che credi in lei. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71876,
                      "answer_id":30289,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:51.473Z",
                      "updated_at":"2022-01-10T23:23:51.473Z",
                      "text":"Ihr sagen, dass Sie stolz auf sie sind. Sicherstellen, dass sie weiß, wie sehr sie ihre Fähigkeiten schätzen, und dass Sie an sie glauben. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71875,
                      "answer_id":30289,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:51.468Z",
                      "updated_at":"2022-01-10T23:23:51.468Z",
                      "text":"Dites-lui que vous êtes fier d'elle. Assurez-vous qu'elle sait à quel point vous appréciez ses compétences et que vous croyez en elle. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71874,
                      "answer_id":30289,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:51.461Z",
                      "updated_at":"2022-01-10T23:23:51.461Z",
                      "text":"Lui dire que vous êtes fier d’elle. Lui faire savoir à quel point vous appréciez ses compétences et que vous croyez en elle. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71873,
                      "answer_id":30289,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:51.456Z",
                      "updated_at":"2022-01-10T23:23:51.456Z",
                      "text":"Dizer que você está orgulhoso dela. Certificar-se de que ela saiba o quanto você valoriza as habilidades dela e que acredita nela. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71872,
                      "answer_id":30289,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:51.452Z",
                      "updated_at":"2022-01-10T23:23:51.452Z",
                      "text":"Decirle que te sientes orgulloso de ella. Asegurarte de que sepa cuánto valoras sus habilidades y que crees en ella. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71871,
                      "answer_id":30289,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:51.447Z",
                      "updated_at":"2022-01-10T23:23:51.447Z",
                      "text":"Sabihin mo sa kanya na ipinagmamalaki mo siya. Tiyaking alam niya kung gaano mo pinahahalagahan ang kanyang mga kasanayan at na naniniwala ka sa kanya. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71870,
                      "answer_id":30289,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:51.442Z",
                      "updated_at":"2022-01-10T23:23:51.442Z",
                      "text":"告诉她你为她感到自豪。确保她了解你如何重视她的技能并且你相信她说的话。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71869,
                      "answer_id":30289,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:51.437Z",
                      "updated_at":"2022-01-10T23:23:51.437Z",
                      "text":"告訴她你以她為傲。確認她知道你有多重視她的技能，以及你對她有信心。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71868,
                      "answer_id":30289,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:51.433Z",
                      "updated_at":"2022-01-10T23:23:51.433Z",
                      "text":"Tell her you’re proud of her. Make sure she knows how much you value her skills and that you believe in her. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30290,
                "position":2,
                "active":true,
                "question_id":12039,
                "created_at":"2022-01-10T23:23:51.512Z",
                "updated_at":"2022-01-10T23:23:51.512Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Check in with her department head and put in a good word about her time as an intern. ",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71899,
                      "answer_id":30290,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:51.598Z",
                      "updated_at":"2022-01-10T23:23:51.598Z",
                      "text":"Bölüm başkanına danışın ve stajyer olarak geçirdiği zaman hakkında iyi şeyler söyleyin. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71898,
                      "answer_id":30290,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:51.593Z",
                      "updated_at":"2022-01-10T23:23:51.593Z",
                      "text":"Consultar a su jefe de su departamento y avalar su tiempo como empleada en prácticas. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71897,
                      "answer_id":30290,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:51.589Z",
                      "updated_at":"2022-01-10T23:23:51.589Z",
                      "text":"Поговорить с начальником ее отдела и хорошо отозваться о ней как о стажере. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71896,
                      "answer_id":30290,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:51.583Z",
                      "updated_at":"2022-01-10T23:23:51.583Z",
                      "text":"Skontaktować się z szefem jej działu i przekazać pozytywną opinię na temat czasu, jaki spędziła jako stażystka. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71895,
                      "answer_id":30290,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:51.578Z",
                      "updated_at":"2022-01-10T23:23:51.578Z",
                      "text":"그녀의 부서장과 만나 인턴으로서 그녀의 업무 능력에 대해 좋게 말해 준다. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71894,
                      "answer_id":30290,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:51.573Z",
                      "updated_at":"2022-01-10T23:23:51.573Z",
                      "text":"彼女の部署の部長と話をし、彼女のインターン時代の功績を称賛する。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71893,
                      "answer_id":30290,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:51.569Z",
                      "updated_at":"2022-01-10T23:23:51.569Z",
                      "text":"Parlare con il suo capo reparto e mettere una buona parola sul suo periodo da stagista. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71892,
                      "answer_id":30290,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:51.563Z",
                      "updated_at":"2022-01-10T23:23:51.563Z",
                      "text":"Ihren Abteilungsleiter kontaktieren und ein gutes Wort für sie und ihre Rolle als Praktikantin einlegen. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71891,
                      "answer_id":30290,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:51.559Z",
                      "updated_at":"2022-01-10T23:23:51.559Z",
                      "text":"Renseignez-vous auprès de son chef de service et dites-lui un mot gentil sur la période de son stage. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71890,
                      "answer_id":30290,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:51.554Z",
                      "updated_at":"2022-01-10T23:23:51.554Z",
                      "text":"Prendre de ses nouvelles auprès de son chef de service et parler en termes élogieux de sa période en temps que stagiaire. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71889,
                      "answer_id":30290,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:51.549Z",
                      "updated_at":"2022-01-10T23:23:51.549Z",
                      "text":"Falar com o chefe do departamento dela e fazer um elogio sobre o tempo em que ela foi estagiária. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71888,
                      "answer_id":30290,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:51.544Z",
                      "updated_at":"2022-01-10T23:23:51.544Z",
                      "text":"Consultar con el jefe del departamento y dar una buena recomendación sobre su período como pasante. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71887,
                      "answer_id":30290,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:51.539Z",
                      "updated_at":"2022-01-10T23:23:51.539Z",
                      "text":"Makipag-usap sa kanyang pinuno ng departamento at magsalita ng maganda tungkol sa kanya bilang isang intern. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71886,
                      "answer_id":30290,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:51.534Z",
                      "updated_at":"2022-01-10T23:23:51.534Z",
                      "text":"询问她的部门领导，说她在实习期间表现不错。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71885,
                      "answer_id":30290,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:51.529Z",
                      "updated_at":"2022-01-10T23:23:51.529Z",
                      "text":"與她的部門主管保持聯繫，說一些關於她實習期間表現的美言。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71884,
                      "answer_id":30290,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:51.525Z",
                      "updated_at":"2022-01-10T23:23:51.525Z",
                      "text":"Check in with her department head and put in a good word about her time as an intern. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30291,
                "position":3,
                "active":true,
                "question_id":12039,
                "created_at":"2022-01-10T23:23:51.605Z",
                "updated_at":"2022-01-10T23:23:51.605Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell her you’d like to continue supporting her as a mentor, if she’d like. If your company has a mentoring program, offer to help her enroll and let her know that she’s welcome to set up a time to chat with you.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71915,
                      "answer_id":30291,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:51.691Z",
                      "updated_at":"2022-01-10T23:23:51.691Z",
                      "text":"Eğer isterse mentoru olarak onu desteklemeye devam edeceğinizi söyleyin. Şirketinizde bir mentorluk programı varsa, bu programa kaydolması için yardım teklif edin ve sizinle konuşmak istediğinde ona zaman ayıracağınızı bilmesini sağlayın.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71914,
                      "answer_id":30291,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:51.687Z",
                      "updated_at":"2022-01-10T23:23:51.687Z",
                      "text":"Decirle que le gustaría seguir apoyándola como mentor si ella está de acuerdo. Si su empresa tiene un programa de mentores, ofrézcase para ayudarla a inscribirse y hágale saber que puede establecer un horario para hablar con usted.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71913,
                      "answer_id":30291,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:51.682Z",
                      "updated_at":"2022-01-10T23:23:51.682Z",
                      "text":"Сказать ей, что хотели бы по-прежнему оставаться ее наставником, если она не против. Если в компании предусмотрена программа наставничества, предложить ей помощь в подаче заявки на участие и сказать, что с радостью обсудите с ней детали.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71912,
                      "answer_id":30291,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:51.677Z",
                      "updated_at":"2022-01-10T23:23:51.677Z",
                      "text":"Powiedzieć jej, że chciał(a)byś nadal wspierać ją jako mentor, jeśli miałaby na to ochotę. Jeśli Twoja firma prowadzi program mentoringu, zaproponuj jej pomoc w zapisaniu się i daj jej znać, że może umówić się z Tobą na rozmowę.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71911,
                      "answer_id":30291,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:51.672Z",
                      "updated_at":"2022-01-10T23:23:51.672Z",
                      "text":"원한다면 멘토로서 계속 지원해주고 싶다고 말한다. 회사에 멘토링 프로그램이 있는 경우 등록을 도와주겠다고 제안하고 대화할 시간을 정해도 좋다고 말한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71910,
                      "answer_id":30291,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:51.668Z",
                      "updated_at":"2022-01-10T23:23:51.668Z",
                      "text":"彼女が希望するのであれば、メンターとして引き続きサポートしていきたい旨を伝える。会社にメンタリングプログラムがある場合、彼女が登録する手助けをすることを申し出、喜んで相談に乗るための時間を設定することを伝える。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71909,
                      "answer_id":30291,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:51.663Z",
                      "updated_at":"2022-01-10T23:23:51.663Z",
                      "text":"Dirle che vorresti continuare a supportarla come mentore, se lo desidera. Se la tua azienda ha un programma di mentoring, offrirti di aiutarla a iscriversi e farle sapere che è la benvenuta per organizzare una chiacchierata con te.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71908,
                      "answer_id":30291,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:51.658Z",
                      "updated_at":"2022-01-10T23:23:51.658Z",
                      "text":"Ihr sagen, dass Sie gerne weiterhin ihr/e Mentor/in wären, wenn sie das wünscht. Falls es in der Firma ein Mentorenprogramm gibt, ihr Hilfe bei der Anmeldung anbieten und sie wissen lassen, dass sie jederzeit gerne einen Gesprächstermin mit Ihnen vereinbaren kann.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71907,
                      "answer_id":30291,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:51.654Z",
                      "updated_at":"2022-01-10T23:23:51.654Z",
                      "text":"Dites-lui que vous aimeriez continuer à la soutenir en tant que mentor, si elle le souhaite. Si votre entreprise a un programme de mentorat, proposez-lui de l'aider à s'inscrire et faites-lui savoir qu'elle est la bienvenue si elle veut s'organiser pour un moment de discution avec vous.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71906,
                      "answer_id":30291,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:51.647Z",
                      "updated_at":"2022-01-10T23:23:51.647Z",
                      "text":"Lui dire que vous aimeriez continuer à la soutenir en tant que mentor, pour autant qu’elle le souhaite. Si votre entreprise a un programme de mentorat, lui proposer de l’aider à s’inscrire et lui faire savoir qu’elle ne doit pas hésiter à prévoir un moment pour discuter avec vous.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71905,
                      "answer_id":30291,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:51.642Z",
                      "updated_at":"2022-01-10T23:23:51.642Z",
                      "text":"Dizer a ela que você gostaria de continuar a apoiá-la como mentora, se ela quiser. Se sua empresa tem um programa de mentoria, oferecer-se para ajudá-la a se inscrever e dizer que ela pode agendar um horário para conversar com você.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71904,
                      "answer_id":30291,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:51.637Z",
                      "updated_at":"2022-01-10T23:23:51.637Z",
                      "text":"告訴她，如果她願意，你希望繼續擔任她的導師。如果你的公司有導師計畫，可以協助她加入，並讓她知道可以安排時間跟你談談。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71903,
                      "answer_id":30291,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:51.632Z",
                      "updated_at":"2022-01-10T23:23:51.632Z",
                      "text":"Decirle que deseas continuar apoyándola como mentor, si lo desea. Si tu compañía tiene un programa de mentoría, ofrece ayudarla a inscribirse y dile que puede reservar un momento para hablar contigo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71902,
                      "answer_id":30291,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:51.627Z",
                      "updated_at":"2022-01-10T23:23:51.627Z",
                      "text":"Sabihin sa kanya na nais mong ipagpatuloy ang pagsuporta sa kanya bilang isang tagapayo, kung gusto niya. Kung ang iyong kumpanya ay may isang programa sa pag-uukol, mag-alok na tulungan siyang mag-enrol at ipaalam sa kanya na malugod siyang magtakda ng isang oras upang makipag-chat sa iyo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71901,
                      "answer_id":30291,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:51.622Z",
                      "updated_at":"2022-01-10T23:23:51.622Z",
                      "text":"告诉她如果她愿意，你愿意继续担任她的导师为她提供支持。如果你的公司有指导计划，主动提出帮助她加入，并让她知道她可以随时安排时间商谈此事。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71900,
                      "answer_id":30291,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:51.618Z",
                      "updated_at":"2022-01-10T23:23:51.618Z",
                      "text":"Tell her you’d like to continue supporting her as a mentor, if she’d like. If your company has a mentoring program, offer to help her enroll and let her know that she’s welcome to set up a time to chat with you.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12040,
          "shuffle":false,
          "position":15,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30293"
          ],
          "created_at":"2022-01-10T23:23:51.709Z",
          "updated_at":"2022-04-21T21:23:04.535Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":15,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best way to respond to Reuben?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29864,
                "question_id":12040,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:51.840Z",
                "updated_at":"2022-01-10T23:23:51.840Z",
                "text":"Nasıl karşılık vermelisiniz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29863,
                "question_id":12040,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:51.835Z",
                "updated_at":"2022-01-10T23:23:51.835Z",
                "text":"¿Cómo debería responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29862,
                "question_id":12040,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:51.830Z",
                "updated_at":"2022-01-10T23:23:51.830Z",
                "text":"Как вам следует ответить?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29861,
                "question_id":12040,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:51.826Z",
                "updated_at":"2022-01-10T23:23:51.826Z",
                "text":"Jak należy zareagować?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29860,
                "question_id":12040,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:51.821Z",
                "updated_at":"2022-01-10T23:23:51.821Z",
                "text":"귀하는 어떻게 대처해야 합니까?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29859,
                "question_id":12040,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:51.816Z",
                "updated_at":"2022-01-10T23:23:51.816Z",
                "text":"どのように返答すべきですか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29858,
                "question_id":12040,
                "locale":"it",
                "created_at":"2022-01-10T23:23:51.811Z",
                "updated_at":"2022-01-10T23:23:51.811Z",
                "text":"Come dovresti rispondere?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29857,
                "question_id":12040,
                "locale":"de",
                "created_at":"2022-01-10T23:23:51.807Z",
                "updated_at":"2022-01-10T23:23:51.807Z",
                "text":"Wie sollten Sie reagieren?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29856,
                "question_id":12040,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:51.802Z",
                "updated_at":"2022-01-10T23:23:51.802Z",
                "text":"Comment réagiriez-vous ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29855,
                "question_id":12040,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:51.797Z",
                "updated_at":"2022-01-10T23:23:51.797Z",
                "text":"Comment devriez-vous réagir ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29854,
                "question_id":12040,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:51.792Z",
                "updated_at":"2022-01-10T23:23:51.792Z",
                "text":"Como você deve responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29853,
                "question_id":12040,
                "locale":"es",
                "created_at":"2022-01-10T23:23:51.787Z",
                "updated_at":"2022-01-10T23:23:51.787Z",
                "text":"¿Cómo debes responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29852,
                "question_id":12040,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:51.783Z",
                "updated_at":"2022-01-10T23:23:51.783Z",
                "text":"Paano ka sasagot?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29851,
                "question_id":12040,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:51.778Z",
                "updated_at":"2022-01-10T23:23:51.778Z",
                "text":"你应如何回应？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29850,
                "question_id":12040,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:51.773Z",
                "updated_at":"2022-01-10T23:23:51.773Z",
                "text":"你該如何回應？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29849,
                "question_id":12040,
                "locale":"en",
                "created_at":"2022-01-10T23:23:51.729Z",
                "updated_at":"2022-04-21T21:23:04.538Z",
                "text":"What is the best way to respond to Reuben?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30292,
                "position":1,
                "active":true,
                "question_id":12040,
                "created_at":"2022-01-10T23:23:51.846Z",
                "updated_at":"2022-04-21T21:23:13.589Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Excuse Reuben and move on.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71916,
                      "answer_id":30292,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:51.859Z",
                      "updated_at":"2022-04-21T21:23:13.591Z",
                      "text":"Excuse Reuben and move on.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71931,
                      "answer_id":30292,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:51.929Z",
                      "updated_at":"2022-01-10T23:23:51.929Z",
                      "text":"Marquis'i affedin ve konuyu kapatın.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71930,
                      "answer_id":30292,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:51.924Z",
                      "updated_at":"2022-01-10T23:23:51.924Z",
                      "text":"Disculpar a Marquis y continuar.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71929,
                      "answer_id":30292,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:51.920Z",
                      "updated_at":"2022-01-10T23:23:51.920Z",
                      "text":"Освободить Маркиза и продолжить работу.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71928,
                      "answer_id":30292,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:51.915Z",
                      "updated_at":"2022-01-10T23:23:51.915Z",
                      "text":"Wybaczyć Marquisowi i przejść dalej.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71927,
                      "answer_id":30292,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:51.911Z",
                      "updated_at":"2022-01-10T23:23:51.911Z",
                      "text":"Marquis를 이해하고 조치를 취한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71926,
                      "answer_id":30292,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:51.906Z",
                      "updated_at":"2022-01-10T23:23:51.906Z",
                      "text":"Marquisさんに謝り、次に進む。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71925,
                      "answer_id":30292,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:51.901Z",
                      "updated_at":"2022-01-10T23:23:51.901Z",
                      "text":"Scusare Marquis e proseguire.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71924,
                      "answer_id":30292,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:51.897Z",
                      "updated_at":"2022-01-10T23:23:51.897Z",
                      "text":"Marquis entschuldigen und weitermachen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71923,
                      "answer_id":30292,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:51.892Z",
                      "updated_at":"2022-01-10T23:23:51.892Z",
                      "text":"Exemptez Marquis et continuez.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71922,
                      "answer_id":30292,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:51.887Z",
                      "updated_at":"2022-01-10T23:23:51.887Z",
                      "text":"Excuser Marquis et passer à autre chose.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71921,
                      "answer_id":30292,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:51.883Z",
                      "updated_at":"2022-01-10T23:23:51.883Z",
                      "text":"Dispensar Marquis e seguir em frente.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71920,
                      "answer_id":30292,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:51.878Z",
                      "updated_at":"2022-01-10T23:23:51.878Z",
                      "text":"Excusar a Marquis y continuar.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71919,
                      "answer_id":30292,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:51.873Z",
                      "updated_at":"2022-01-10T23:23:51.873Z",
                      "text":"Huwag isama si Marquis at mag-move on.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71918,
                      "answer_id":30292,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:51.869Z",
                      "updated_at":"2022-01-10T23:23:51.869Z",
                      "text":"原谅 Marquis，然后继续工作。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71917,
                      "answer_id":30292,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:51.864Z",
                      "updated_at":"2022-01-10T23:23:51.864Z",
                      "text":"讓 Marquis 離開然後繼續。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30293,
                "position":2,
                "active":true,
                "question_id":12040,
                "created_at":"2022-01-10T23:23:51.935Z",
                "updated_at":"2022-04-21T21:23:24.301Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Ask if Reuben wants to discuss some ideas that could help him with his Friday tasks.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71932,
                      "answer_id":30293,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:51.948Z",
                      "updated_at":"2022-04-21T21:23:24.303Z",
                      "text":"Ask if Reuben wants to discuss some ideas that could help him with his Friday tasks.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71947,
                      "answer_id":30293,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:52.020Z",
                      "updated_at":"2022-01-10T23:23:52.020Z",
                      "text":"Marquis'e Ramazan ayında geçici olarak programını değiştirmeye ihtiyaç duyup duymadığını sorun. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71946,
                      "answer_id":30293,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:52.015Z",
                      "updated_at":"2022-01-10T23:23:52.015Z",
                      "text":"Preguntar si Marquis puede necesitar un cambio de horario temporal durante el Ramadán. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71945,
                      "answer_id":30293,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:52.010Z",
                      "updated_at":"2022-01-10T23:23:52.010Z",
                      "text":"Спросить, понадобится ли Маркизу временно изменить график на время Рамадана. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71944,
                      "answer_id":30293,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:52.006Z",
                      "updated_at":"2022-01-10T23:23:52.006Z",
                      "text":"Zapytać, czy Marquis może wymagać tymczasowej zmiany harmonogramu podczas Ramadanu. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71943,
                      "answer_id":30293,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:52.001Z",
                      "updated_at":"2022-01-10T23:23:52.001Z",
                      "text":"Marquis에게 라마단 기간 동안 임시로 스케줄을 변경할 필요가 있는지 물어본다. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71942,
                      "answer_id":30293,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:51.995Z",
                      "updated_at":"2022-01-10T23:23:51.995Z",
                      "text":"ラマダンの最中に、一時的なスケジュールの変更が必要かどうかをMarquisさんに尋ねる。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71941,
                      "answer_id":30293,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:51.991Z",
                      "updated_at":"2022-01-10T23:23:51.991Z",
                      "text":"Chiedere se Marquis potrebbe aver bisogno di una modifica temporanea dell’orario durante il Ramadan. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71940,
                      "answer_id":30293,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:51.986Z",
                      "updated_at":"2022-01-10T23:23:51.986Z",
                      "text":"Fragen, ob Marquis während des Ramadan vorübergehend geänderte Arbeitszeiten benötigt. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71939,
                      "answer_id":30293,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:51.981Z",
                      "updated_at":"2022-01-10T23:23:51.981Z",
                      "text":"Demandez si Marquis pourrait avoir besoin d'un changement d'horaire temporaire pendant le Ramadan. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71938,
                      "answer_id":30293,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:51.976Z",
                      "updated_at":"2022-01-10T23:23:51.976Z",
                      "text":"Demander à Marquis s’il a éventuellement besoin d’un changement d’horaire temporaire pendant le Ramadan. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71937,
                      "answer_id":30293,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:51.971Z",
                      "updated_at":"2022-01-10T23:23:51.971Z",
                      "text":"Perguntar se Marquis precisa de uma mudança temporária de horário durante o Ramadã. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71936,
                      "answer_id":30293,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:51.966Z",
                      "updated_at":"2022-01-10T23:23:51.966Z",
                      "text":"Preguntar a Marquis si necesita un cambio temporal en el horario durante Ramadan. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71935,
                      "answer_id":30293,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:51.962Z",
                      "updated_at":"2022-01-10T23:23:51.962Z",
                      "text":"Tanungin kung kailanganin ni Marquis ng isang pansamantalang pagbabago sa iskedyul sa panahon ng Ramadan. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71934,
                      "answer_id":30293,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:51.957Z",
                      "updated_at":"2022-01-10T23:23:51.957Z",
                      "text":"询问 Marquis 是否需要在斋月期间临时改变作息计划。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71933,
                      "answer_id":30293,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:51.952Z",
                      "updated_at":"2022-01-10T23:23:51.952Z",
                      "text":"問問 Marquis 齋月期間是否需要暫時的時程異動。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30294,
                "position":3,
                "active":true,
                "question_id":12040,
                "created_at":"2022-01-10T23:23:52.026Z",
                "updated_at":"2022-04-21T21:23:39.367Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Remind Reuben that it is his responsibility to complete his tasks on time.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71963,
                      "answer_id":30294,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:52.109Z",
                      "updated_at":"2022-01-10T23:23:52.109Z",
                      "text":"Marquis'e her gün işe zamanında gelmesinin onun sorumluluğunda olduğunu hatırlatın.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71962,
                      "answer_id":30294,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:52.104Z",
                      "updated_at":"2022-01-10T23:23:52.104Z",
                      "text":"Recordarle a Marquis que es su responsabilidad ser puntual en el trabajo todos los días.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71961,
                      "answer_id":30294,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:52.100Z",
                      "updated_at":"2022-01-10T23:23:52.100Z",
                      "text":"Напомнить Маркизу, что ответственность за приход на работу каждый день без опозданий лежит на нем.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71960,
                      "answer_id":30294,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:52.095Z",
                      "updated_at":"2022-01-10T23:23:52.095Z",
                      "text":"Przypomnieć Marquisowi, że jego obowiązkiem jest codzienne punktualne stawianie się w pracy.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71959,
                      "answer_id":30294,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:52.090Z",
                      "updated_at":"2022-01-10T23:23:52.090Z",
                      "text":"매일 정시에 출근하는 것이 그의 책임임을 상기시킨다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71958,
                      "answer_id":30294,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:52.085Z",
                      "updated_at":"2022-01-10T23:23:52.085Z",
                      "text":"毎日時間通りに出勤することはMarquisさんの責任であることを再度伝える。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71957,
                      "answer_id":30294,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:52.081Z",
                      "updated_at":"2022-01-10T23:23:52.081Z",
                      "text":"Ricordare a Marquis che è sua responsabilità presentarsi al lavoro ogni giorno in orario.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71956,
                      "answer_id":30294,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:52.076Z",
                      "updated_at":"2022-01-10T23:23:52.076Z",
                      "text":"Marquis daran erinnern, dass es seine Pflicht ist, jeden Tag pünktlich zur Arbeit zu kommen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71955,
                      "answer_id":30294,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:52.071Z",
                      "updated_at":"2022-01-10T23:23:52.071Z",
                      "text":"Rappelez à Marquis qu'il est de sa responsabilité de se présenter au travail à l'heure tous les jours.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71954,
                      "answer_id":30294,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:52.066Z",
                      "updated_at":"2022-01-10T23:23:52.066Z",
                      "text":"Rappeler à Marquis qu’il a le devoir de se présenter au travail à l’heure tous les jours.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71953,
                      "answer_id":30294,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:52.062Z",
                      "updated_at":"2022-01-10T23:23:52.062Z",
                      "text":"Lembrar a Marquis que é responsabilidade dele chegar ao trabalho pontualmente todos os dias.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71952,
                      "answer_id":30294,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:52.057Z",
                      "updated_at":"2022-01-10T23:23:52.057Z",
                      "text":"Recordar a Marquis que es su responsabilidad presentarse a trabajar puntualmente todos los días.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71951,
                      "answer_id":30294,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:52.052Z",
                      "updated_at":"2022-01-10T23:23:52.052Z",
                      "text":"Paalalahanan si Marquis na responsibilidad niya pumasok sa trabaho sa tamang oras araw-araw.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71950,
                      "answer_id":30294,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:52.048Z",
                      "updated_at":"2022-01-10T23:23:52.048Z",
                      "text":"提醒 Marquis 他有责任每天按时上班。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71949,
                      "answer_id":30294,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:52.043Z",
                      "updated_at":"2022-01-10T23:23:52.043Z",
                      "text":"提醒 Marquis 每天準時上班是他的責任。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71948,
                      "answer_id":30294,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:52.039Z",
                      "updated_at":"2022-04-21T21:23:39.370Z",
                      "text":"Remind Reuben that it is his responsibility to complete his tasks on time.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12041,
          "shuffle":false,
          "position":16,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30297"
          ],
          "created_at":"2022-01-10T23:23:52.126Z",
          "updated_at":"2022-04-21T21:25:12.990Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":16,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best way to respond to Kiara?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29880,
                "question_id":12041,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:52.255Z",
                "updated_at":"2022-01-10T23:23:52.255Z",
                "text":"Geoff'a ne söylemelisiniz?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29879,
                "question_id":12041,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:52.250Z",
                "updated_at":"2022-01-10T23:23:52.250Z",
                "text":"¿Qué debería decirle a Geoff?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29878,
                "question_id":12041,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:52.245Z",
                "updated_at":"2022-01-10T23:23:52.245Z",
                "text":"Что следует сказать Джефу?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29877,
                "question_id":12041,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:52.240Z",
                "updated_at":"2022-01-10T23:23:52.240Z",
                "text":"Co należy powiedzieć Geoffowi?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29876,
                "question_id":12041,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:52.235Z",
                "updated_at":"2022-01-10T23:23:52.235Z",
                "text":"Geoff에게 뭐라고 말해야 할까요?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29875,
                "question_id":12041,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:52.230Z",
                "updated_at":"2022-01-10T23:23:52.230Z",
                "text":"Geoffさんに何と伝えるべきですか？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29874,
                "question_id":12041,
                "locale":"it",
                "created_at":"2022-01-10T23:23:52.225Z",
                "updated_at":"2022-01-10T23:23:52.225Z",
                "text":"Che cosa dovresti dire a Geoff?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29873,
                "question_id":12041,
                "locale":"de",
                "created_at":"2022-01-10T23:23:52.220Z",
                "updated_at":"2022-01-10T23:23:52.220Z",
                "text":"Was sollten Sie zu Geoff sagen?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29872,
                "question_id":12041,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:52.216Z",
                "updated_at":"2022-01-10T23:23:52.216Z",
                "text":"Que devriez-vous dire à Geoff?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29871,
                "question_id":12041,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:52.211Z",
                "updated_at":"2022-01-10T23:23:52.211Z",
                "text":"Que devriez-vous dire à Geoff ?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29870,
                "question_id":12041,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:52.206Z",
                "updated_at":"2022-01-10T23:23:52.206Z",
                "text":"O que você deve dizer a Geoff?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29869,
                "question_id":12041,
                "locale":"es",
                "created_at":"2022-01-10T23:23:52.200Z",
                "updated_at":"2022-01-10T23:23:52.200Z",
                "text":"¿Qué le debes decir a Geoff?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29868,
                "question_id":12041,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:52.195Z",
                "updated_at":"2022-01-10T23:23:52.195Z",
                "text":"Ano ang dapat mong sabihin kay Geoff?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29867,
                "question_id":12041,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:52.190Z",
                "updated_at":"2022-01-10T23:23:52.190Z",
                "text":"你应该对 Geoff 说什么？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29866,
                "question_id":12041,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:52.186Z",
                "updated_at":"2022-01-10T23:23:52.186Z",
                "text":"你應該跟 Geoff 說甚麼？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29865,
                "question_id":12041,
                "locale":"en",
                "created_at":"2022-01-10T23:23:52.145Z",
                "updated_at":"2022-04-21T21:25:12.993Z",
                "text":"What is the best way to respond to Kiara?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30295,
                "position":1,
                "active":true,
                "question_id":12041,
                "created_at":"2022-01-10T23:23:52.262Z",
                "updated_at":"2022-04-21T21:25:23.311Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Ask Kiara for a copy of her medical records. You want to understand the whole situation.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71964,
                      "answer_id":30295,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:52.276Z",
                      "updated_at":"2022-04-21T21:25:23.314Z",
                      "text":"Ask Kiara for a copy of her medical records. You want to understand the whole situation.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71979,
                      "answer_id":30295,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:52.359Z",
                      "updated_at":"2022-01-10T23:23:52.359Z",
                      "text":"Geoff'tan daha ayrıntılı bir tıbbi bilgi talep edin. İlaç kullanıyor mu? İntihara meyilli mi? Kiminle çalıştığınızı bilmek istiyorsunuz.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71978,
                      "answer_id":30295,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:52.354Z",
                      "updated_at":"2022-01-10T23:23:52.354Z",
                      "text":"Pedirle a Geoff información médica detallada. ¿Está tomando medicamentos? ¿Tiene tendencias suicidas? Usted quiere saber con quién está trabajando.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71977,
                      "answer_id":30295,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:52.349Z",
                      "updated_at":"2022-01-10T23:23:52.349Z",
                      "text":"Выяснить у Джефа подробную медицинскую информацию. Принимает ли он лекарства? Присутствуют ли у него суицидальные мысли? Вам нужно понять, с чем вы работаете.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71976,
                      "answer_id":30295,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:52.344Z",
                      "updated_at":"2022-01-10T23:23:52.344Z",
                      "text":"Poprosić Geoffa o szczegółowe dane medyczne. Czy bierze leki? Czy podejmował próby samobójcze? Chcesz dowiedzieć się, z kim pracujesz.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71975,
                      "answer_id":30295,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:52.337Z",
                      "updated_at":"2022-01-10T23:23:52.337Z",
                      "text":"자세한 의료 정보를 Geoff에게 물어본다. 그가 약을 복용하고 있는지 그가 몹시 위험한 상황에 있는지 물어본다. 여러분은 자신이 어떤 문제를 다루고 있는지 명확히 이해하고 싶을 것입니다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71974,
                      "answer_id":30295,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:52.333Z",
                      "updated_at":"2022-01-10T23:23:52.333Z",
                      "text":"Geoffさんに詳細な医療情報を要求する。彼は薬を飲んでいるか？彼には自殺願望があるか？どのような問題を扱っているのか知っておきたいです。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71973,
                      "answer_id":30295,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:52.328Z",
                      "updated_at":"2022-01-10T23:23:52.328Z",
                      "text":"Chiedere a Geoff informazioni mediche dettagliate. Sta assumendo farmaci? Ha tendenze suicide? Desideri comprendere la persona con cui stai lavorando.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71972,
                      "answer_id":30295,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:52.323Z",
                      "updated_at":"2022-01-10T23:23:52.323Z",
                      "text":"Geoff nach genauen medizinischen Informationen fragen. Nimmt er Medikamente? Ist er suizidgefährdet? Sie möchten wissen, mit wem Sie zusammenarbeiten.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71971,
                      "answer_id":30295,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:52.318Z",
                      "updated_at":"2022-01-10T23:23:52.318Z",
                      "text":"Demandez à Geoff des informations médicales détaillées. Prend-il des médicaments? Est-il suicidaire? Vous voulez comprendre avec quoi vous travaillez?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71970,
                      "answer_id":30295,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:52.313Z",
                      "updated_at":"2022-01-10T23:23:52.313Z",
                      "text":"Demander à Geoff des informations médicales détaillées. Est-ce qu’il prend des médicaments ? Est-ce qu’il a des pensées suicidaires ? Vous voulez comprendre de quoi il retourne.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71969,
                      "answer_id":30295,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:52.308Z",
                      "updated_at":"2022-01-10T23:23:52.308Z",
                      "text":"Pedir a Geoff informações médicas detalhadas. Ele está tomando remédios? Ele é suicida? Você quer entender com o que está lidando.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71968,
                      "answer_id":30295,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:52.299Z",
                      "updated_at":"2022-01-10T23:23:52.299Z",
                      "text":"Solicitar a Geoff información médica detallada. ¿Está tomando medicamentos? ¿Tiene tendencias suicidas? Deseas comprender con qué estás trabajando.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71967,
                      "answer_id":30295,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:52.292Z",
                      "updated_at":"2022-01-10T23:23:52.292Z",
                      "text":"Tanungin si Geoff para sa detalyadong impormasyon sa medisina. Naggagamot ba siya? Nagtatangka ba siyang magpakamatay? Nais mong maunawaan kung ano ang iyong pinagtatrabahuhan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71966,
                      "answer_id":30295,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:52.287Z",
                      "updated_at":"2022-01-10T23:23:52.287Z",
                      "text":"询问 Geoff 详细医疗信息。他是否在接受治疗？他会自杀吗？你想要了解你的工作内容。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71965,
                      "answer_id":30295,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:52.280Z",
                      "updated_at":"2022-01-10T23:23:52.280Z",
                      "text":"要求 Geoff 提供詳細的醫療資訊。他目前是否服藥？他是否有自殺傾向？你希望瞭解你面對的是甚麼問題。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30296,
                "position":2,
                "active":true,
                "question_id":12041,
                "created_at":"2022-01-10T23:23:52.366Z",
                "updated_at":"2022-04-21T21:25:33.218Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell her she should talk to human resources herself and emphasize that you are also concerned about how she will continue to get her work done.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71995,
                      "answer_id":30296,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:52.452Z",
                      "updated_at":"2022-01-10T23:23:52.452Z",
                      "text":"Geoff'a, konuyla ilgilenmesi için uzman olan birini bulmanız gerektiğini söyleyin.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71994,
                      "answer_id":30296,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:52.447Z",
                      "updated_at":"2022-01-10T23:23:52.447Z",
                      "text":"Dígale a Geoff que necesitará contratar a alguien con experiencia para gestionar el problema.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71993,
                      "answer_id":30296,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:52.442Z",
                      "updated_at":"2022-01-10T23:23:52.442Z",
                      "text":"Сказать Джефу, что вам необходимо обратиться к опытному сотруднику для решения этого вопроса.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71992,
                      "answer_id":30296,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:52.437Z",
                      "updated_at":"2022-01-10T23:23:52.437Z",
                      "text":"Powiedz Geoffowi, że musisz poprosić kogoś z doświadczeniem, aby zajął się tą sprawą.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71991,
                      "answer_id":30296,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:52.433Z",
                      "updated_at":"2022-01-10T23:23:52.433Z",
                      "text":"Geoff에게 이 문제를 다루려면 전문가의 도움이 필요하다고 말합니다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71990,
                      "answer_id":30296,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:52.428Z",
                      "updated_at":"2022-01-10T23:23:52.428Z",
                      "text":"Geoffさんに、問題を対処するためには、専門家の手を借りる必要があることを伝える。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71989,
                      "answer_id":30296,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:52.423Z",
                      "updated_at":"2022-01-10T23:23:52.423Z",
                      "text":"Dire a Geoff che avrai bisogno di qualcuno con esperienza per affrontare il problema.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71988,
                      "answer_id":30296,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:52.418Z",
                      "updated_at":"2022-01-10T23:23:52.418Z",
                      "text":"Geoff erklären, dass Sie einen Experten zu Rate ziehen werden, um das Problem zu besprechen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71987,
                      "answer_id":30296,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:52.413Z",
                      "updated_at":"2022-01-10T23:23:52.413Z",
                      "text":"Dites à Geoff que vous devrez faire appel à une personne compétente pour régler le problème.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71986,
                      "answer_id":30296,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:52.408Z",
                      "updated_at":"2022-01-10T23:23:52.408Z",
                      "text":"Dire à Geoff que vous allez devoir faire appel à une personne compétente pour régler le problème.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71985,
                      "answer_id":30296,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:52.404Z",
                      "updated_at":"2022-01-10T23:23:52.404Z",
                      "text":"Dizer a Geoff que você precisará de alguém com experiência para lidar com o problema.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71984,
                      "answer_id":30296,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:52.399Z",
                      "updated_at":"2022-01-10T23:23:52.399Z",
                      "text":"Sabihin mo kay Geoff na kakailanganin mo na makakuha ng isang tao na bihasa para harapin ang isyu.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71983,
                      "answer_id":30296,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:52.393Z",
                      "updated_at":"2022-01-10T23:23:52.393Z",
                      "text":"Decirle a Geoff que necesitas una persona con conocimiento para manejar el problema.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71982,
                      "answer_id":30296,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:52.388Z",
                      "updated_at":"2022-01-10T23:23:52.388Z",
                      "text":"告诉 Geoff 你需要找专业人士来处理该问题。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71981,
                      "answer_id":30296,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:52.383Z",
                      "updated_at":"2022-01-10T23:23:52.383Z",
                      "text":"告訴 Geoff 你需要有這方面專業的人協助解決這個問題。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71980,
                      "answer_id":30296,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:52.379Z",
                      "updated_at":"2022-04-21T21:25:33.219Z",
                      "text":"Tell her she should talk to human resources herself and emphasize that you are also concerned about how she will continue to get her work done.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30297,
                "position":3,
                "active":true,
                "question_id":12041,
                "created_at":"2022-01-10T23:23:52.458Z",
                "updated_at":"2022-04-21T21:25:46.535Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Thank Kiara for sharing that information with you. Offer to connect her to human resources for assistance with workplace accommodations.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":71996,
                      "answer_id":30297,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:52.471Z",
                      "updated_at":"2022-04-21T21:25:46.537Z",
                      "text":"Thank Kiara for sharing that information with you. Offer to connect her to human resources for assistance with workplace accommodations.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72011,
                      "answer_id":30297,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:52.549Z",
                      "updated_at":"2022-01-10T23:23:52.549Z",
                      "text":"Geoff'a, son zamanlarda işini yaparken en çok hangi konularda zorlandığını sorun ve düzenlemelerle ilgili yardımcı olacak fikirlerini paylaşmasını isteyin.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72010,
                      "answer_id":30297,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:52.543Z",
                      "updated_at":"2022-01-10T23:23:52.543Z",
                      "text":"Pídale a Geoff que le explique las dificultades que ha tenido para realizar su trabajo recientemente y que comparta cualquier idea que tenga sobre adaptaciones que podrían servir de ayuda",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72009,
                      "answer_id":30297,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:52.537Z",
                      "updated_at":"2022-01-10T23:23:52.537Z",
                      "text":"Попросить Джефа объяснить, в чем состояли сложности с выполнением работы в последнее время, и спросить, какие у него есть предложения по созданию более удобных условий.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72008,
                      "answer_id":30297,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:52.532Z",
                      "updated_at":"2022-01-10T23:23:52.532Z",
                      "text":"Poproś Geoffa, aby wyjaśnił, co ostatnio utrudniało mu wykonywanie pracy i podzielił się pomysłami na udogodnienia, które mogłyby mu pomóc.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72007,
                      "answer_id":30297,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:52.528Z",
                      "updated_at":"2022-01-10T23:23:52.528Z",
                      "text":"Geoff에게 최근에 업무를 수행하는 데 어떤 어려움이 있었는지, 그리고 무엇이 그에게 도움이 될 수 있는지 말해달라고 요청합니다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72006,
                      "answer_id":30297,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:52.523Z",
                      "updated_at":"2022-01-10T23:23:52.523Z",
                      "text":"Geoffさんに最近の仕事を遂行する能力について、何故難しいと感じているのかを説明してもらい、役立つ可能性のある配慮があれば、それを共有するよう促す。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72005,
                      "answer_id":30297,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:52.518Z",
                      "updated_at":"2022-01-10T23:23:52.518Z",
                      "text":"Chiedere a Geoff di spiegare quali sono stati gli aspetti difficili riguardo alla sua capacità di svolgere il lavoro di recente e di condividere le idee relative ad adeguamenti che potrebbero essere utili.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72004,
                      "answer_id":30297,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:52.513Z",
                      "updated_at":"2022-01-10T23:23:52.513Z",
                      "text":"Geoff bitten, zu erklären, womit er bei der Ausführung seiner Arbeit in letzter Zeit Schwierigkeiten hatte, und auf seine Vorschläge bezüglich unterstützender Maßnahmen eingehen, die ihm helfen könnten.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72003,
                      "answer_id":30297,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:52.508Z",
                      "updated_at":"2022-01-10T23:23:52.508Z",
                      "text":"Demandez à Geoff d'expliquer ce qui a été difficile dans sa capacité à effectuer son travail ces derniers temps et de partager toutes ses idées d'aménagements qui pourraient l'aider.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72002,
                      "answer_id":30297,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:52.503Z",
                      "updated_at":"2022-01-10T23:23:52.503Z",
                      "text":"Demander à Geoff d’expliquer en quoi il a eu des difficultés à effectuer son travail dernièrement et de ne pas hésiter à faire savoir quels aménagements pourraient l’aider.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72001,
                      "answer_id":30297,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:52.499Z",
                      "updated_at":"2022-01-10T23:23:52.499Z",
                      "text":"Pedir que Geoff explique a dificuldade que ele tem tido ultimamente com relação à capacidade dele de realizar o trabalho e que compartilhe alguma ideia para adaptações que possam ajudar.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72000,
                      "answer_id":30297,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:52.494Z",
                      "updated_at":"2022-01-10T23:23:52.494Z",
                      "text":"請 Geoff 說明他在最近的工作表現上遇到甚麼問題，以及分享甚麼樣的照應會對他有幫助的想法。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71999,
                      "answer_id":30297,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:52.490Z",
                      "updated_at":"2022-01-10T23:23:52.490Z",
                      "text":"Solicitar a Geoff que explique que le ha resultado difícil para realizar su trabajo últimamente y que comparta sus ideas de adaptaciones razonables que podrían ayudar.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71998,
                      "answer_id":30297,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:52.480Z",
                      "updated_at":"2022-01-10T23:23:52.480Z",
                      "text":"Hilingin kay Geoff na ipaliwanag kung ano ang naging mahirap tungkol sa kanyang kakayahang maisagawa ang kanyang trabaho kamakailan at ibahagi ang anumang mga ideya na mayroon siya para sa mga accommodation na maaaring makatulong.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":71997,
                      "answer_id":30297,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:52.475Z",
                      "updated_at":"2022-01-10T23:23:52.475Z",
                      "text":"让 Geoff 解释最近工作中遇到了什么困难，如果他需要什么照顾，尽管告诉你。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12042,
          "shuffle":false,
          "position":17,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30299"
          ],
          "created_at":"2022-01-10T23:23:52.567Z",
          "updated_at":"2022-04-21T21:26:49.275Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":17,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best action for you to take?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29881,
                "question_id":12042,
                "locale":"en",
                "created_at":"2022-01-10T23:23:52.588Z",
                "updated_at":"2022-04-21T21:26:49.278Z",
                "text":"What is the best action for you to take?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29896,
                "question_id":12042,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:52.701Z",
                "updated_at":"2022-01-10T23:23:52.701Z",
                "text":"Ne yapmalısınız?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29895,
                "question_id":12042,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:52.696Z",
                "updated_at":"2022-01-10T23:23:52.696Z",
                "text":"¿Qué debería hacer?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29894,
                "question_id":12042,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:52.692Z",
                "updated_at":"2022-01-10T23:23:52.692Z",
                "text":"Что вам следует сделать?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29893,
                "question_id":12042,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:52.687Z",
                "updated_at":"2022-01-10T23:23:52.687Z",
                "text":"Co należy zrobić?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29892,
                "question_id":12042,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:52.683Z",
                "updated_at":"2022-01-10T23:23:52.683Z",
                "text":"어떻게 하시겠습니까?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29891,
                "question_id":12042,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:52.678Z",
                "updated_at":"2022-01-10T23:23:52.678Z",
                "text":"あなたは何をすべきでしょうか？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29890,
                "question_id":12042,
                "locale":"it",
                "created_at":"2022-01-10T23:23:52.673Z",
                "updated_at":"2022-01-10T23:23:52.673Z",
                "text":"Che cosa dovresti fare?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29889,
                "question_id":12042,
                "locale":"de",
                "created_at":"2022-01-10T23:23:52.668Z",
                "updated_at":"2022-01-10T23:23:52.668Z",
                "text":"Was sollten Sie tun?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29888,
                "question_id":12042,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:52.664Z",
                "updated_at":"2022-01-10T23:23:52.664Z",
                "text":"Que devriez-vous faire?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29887,
                "question_id":12042,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:52.659Z",
                "updated_at":"2022-01-10T23:23:52.659Z",
                "text":"Que devriez-vous faire ?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29886,
                "question_id":12042,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:52.654Z",
                "updated_at":"2022-01-10T23:23:52.654Z",
                "text":"O que você deve fazer?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29885,
                "question_id":12042,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:52.649Z",
                "updated_at":"2022-01-10T23:23:52.649Z",
                "text":"你應該怎麼做？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29884,
                "question_id":12042,
                "locale":"es",
                "created_at":"2022-01-10T23:23:52.645Z",
                "updated_at":"2022-01-10T23:23:52.645Z",
                "text":"¿Qué debes hacer?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29883,
                "question_id":12042,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:52.640Z",
                "updated_at":"2022-01-10T23:23:52.640Z",
                "text":"Ano ang dapat mong gawin?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29882,
                "question_id":12042,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:52.634Z",
                "updated_at":"2022-01-10T23:23:52.634Z",
                "text":"我们应怎么做？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30298,
                "position":1,
                "active":true,
                "question_id":12042,
                "created_at":"2022-01-10T23:23:52.708Z",
                "updated_at":"2022-04-21T21:27:14.320Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Explain that Lena has an ADA accommodation without sharing the diagnosis. You value Lena’s privacy but don’t want Cam to judge her unfairly.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72027,
                      "answer_id":30298,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:52.791Z",
                      "updated_at":"2022-01-10T23:23:52.791Z",
                      "text":"Ash'in bir ADA düzenlemesine tabi tutulacağını açıklayın ancak ne olduğunu tam olarak paylaşmayın. Ash'in gizlilik hakkına değer veriyorsunuz fakat Natasha'nın onu haksız yere yargılamasını istemiyorsunuz.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72026,
                      "answer_id":30298,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:52.787Z",
                      "updated_at":"2022-01-10T23:23:52.787Z",
                      "text":"Explicar que Ash tiene una adaptación conforme con la ADA, pero no compartir el diagnóstico. Usted valora la privacidad de Ash, pero no quiere que Natasha lo juzgue injustamente.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72025,
                      "answer_id":30298,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:52.782Z",
                      "updated_at":"2022-01-10T23:23:52.782Z",
                      "text":"Объяснить, что для Эша, как для человека с ограниченными возможностями, предусмотрены особые условия, не вдаваясь в подробности диагноза. Вы уважаете конфиденциальность личных данных Эша, но не хотите, чтобы Наташа относилась к нему предвзято.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72024,
                      "answer_id":30298,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:52.778Z",
                      "updated_at":"2022-01-10T23:23:52.778Z",
                      "text":"Wyjaśnić, że Ash ma przyznany stopień niepełnosprawności (ADA), ale nie ujawniać diagnozy. Cenisz prywatność Asha, ale nie chcesz, aby Natasha niesprawiedliwie go oceniała.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72023,
                      "answer_id":30298,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:52.773Z",
                      "updated_at":"2022-01-10T23:23:52.773Z",
                      "text":"Ash가 정당한 편의(미국 장애인법, ADA)를 활용하고 있다고 말하되, 진단 내용은 공유하지 않는다. Ash의 프라이버시를 중요하게 여기지만 Natasha가 그를 부당하게 판단하는 것은 원하지 않는다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72022,
                      "answer_id":30298,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:52.769Z",
                      "updated_at":"2022-01-10T23:23:52.769Z",
                      "text":"AshさんにはADAの合理的配慮が適用される旨を説明するが、診断内容は共有しない。Ashさんのプライバシーを尊重していますが、Natashaさんに彼を不公平に批難してほしくもありません。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72021,
                      "answer_id":30298,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:52.764Z",
                      "updated_at":"2022-01-10T23:23:52.764Z",
                      "text":"Spiegare che Ash ha un adeguamento per l’ADA, ma non condividere la diagnosi. Apprezzare la privacy di Ash, ma non volere che Natasha lo giudichi ingiustamente.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72020,
                      "answer_id":30298,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:52.758Z",
                      "updated_at":"2022-01-10T23:23:52.758Z",
                      "text":"Erklären, dass Ash zu Behindertenförderung nach ADA (Americans with Disabilities Act) berechtigt ist, aber nicht preisgeben, welche Behinderung er hat. Sie achten Ashs Privatsphäre, möchten aber nicht, dass Natasha ihn falsch beurteilt.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72019,
                      "answer_id":30298,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:52.754Z",
                      "updated_at":"2022-01-10T23:23:52.754Z",
                      "text":"Expliquez qu'Ash a un logement ADA, mais ne partagez pas le diagnostic. Vous appréciez la vie privée d'Ash, mais ne voulez pas que Natasha le juge injustement.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72018,
                      "answer_id":30298,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:52.749Z",
                      "updated_at":"2022-01-10T23:23:52.749Z",
                      "text":"Expliquer qu’Ash bénéficie d’un accommodement raisonnable mais ne pas en révéler la raison. Vous respectez la vie privée d’Ash et ne voulez pas que Natasha le juge injustement.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72017,
                      "answer_id":30298,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:52.744Z",
                      "updated_at":"2022-01-10T23:23:52.744Z",
                      "text":"Explicar que Ash tem uma adaptação da Lei para Americanos com Deficiências (ADA), mas não compartilhar o diagnóstico. Você valoriza a privacidade de Ash, mas não quer que Natasha o julgue injustamente.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72016,
                      "answer_id":30298,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:52.740Z",
                      "updated_at":"2022-01-10T23:23:52.740Z",
                      "text":"說明 Ash 需要 ADA 照應，但不分享病情診斷。你重視 Ash 的隱私權，但不希望 Natasha 對他有不公平的論斷。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72015,
                      "answer_id":30298,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:52.735Z",
                      "updated_at":"2022-01-10T23:23:52.735Z",
                      "text":"Explicar que Ash tiene una adaptación razonable conforme a la Ley ADA, pero no mencionar el diagnóstico. Valoras la privacidad de Ash, pero no deseas que Natasha lo juzgue de forma injusta.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72014,
                      "answer_id":30298,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:52.730Z",
                      "updated_at":"2022-01-10T23:23:52.730Z",
                      "text":"Ipaliwanag na ang Ash ay may ADA accommodation, ngunit huwag ibahagi ang diagnosis. Pinahahalagahan mo ang privacy ni Ash, ngunit ayaw mong husgahan siya nang hindi patas.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72013,
                      "answer_id":30298,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:52.726Z",
                      "updated_at":"2022-01-10T23:23:52.726Z",
                      "text":"解释说 Ash 需要 ADA 照顾，但不要说出诊断的事情。你重视 Ash 的隐私，但不希望 Natasha 不公平地评判他。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72012,
                      "answer_id":30298,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:52.721Z",
                      "updated_at":"2022-04-21T21:27:14.322Z",
                      "text":"Explain that Lena has an ADA accommodation without sharing the diagnosis. You value Lena’s privacy but don’t want Cam to judge her unfairly.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30299,
                "position":2,
                "active":true,
                "question_id":12042,
                "created_at":"2022-01-10T23:23:52.797Z",
                "updated_at":"2022-04-21T21:27:26.089Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Explain that Lena is coming in early to make up for her break and ask Cam if there’s anything you can do to support Cam's workload.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72028,
                      "answer_id":30299,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:52.811Z",
                      "updated_at":"2022-04-21T21:27:26.092Z",
                      "text":"Explain that Lena is coming in early to make up for her break and ask Cam if there’s anything you can do to support Cam's workload.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72043,
                      "answer_id":30299,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:52.880Z",
                      "updated_at":"2022-01-10T23:23:52.880Z",
                      "text":"Natasha'ya, Ash'in biraz farklı bir programda eşit çalışma saatlerinde çalıştığını açıklayın ve iş yükünü azaltmak için yapabileceğiniz bir şey olup olmadığını sorun.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72042,
                      "answer_id":30299,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:52.876Z",
                      "updated_at":"2022-01-10T23:23:52.876Z",
                      "text":"Explicar a Natasha que Ash trabaja las mismas horas en un horario un poco diferente y preguntarle si hay algo que pueda hacer para apoyar su carga de trabajo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72041,
                      "answer_id":30299,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:52.871Z",
                      "updated_at":"2022-01-10T23:23:52.871Z",
                      "text":"Объяснить Наташе, что Эш работает то же количество часов, но по слегка скорректированному графику, и спросить, что вы можете сделать, чтобы помочь ей справляться с рабочей нагрузкой.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72040,
                      "answer_id":30299,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:52.866Z",
                      "updated_at":"2022-01-10T23:23:52.866Z",
                      "text":"Wyjaśnij Nataszy, że Ash pracuje w takim samym wymiarze godzin i według nieco innego harmonogramu i zapytaj, czy jest coś, co możesz zrobić, aby wesprzeć ją w pracy.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72039,
                      "answer_id":30299,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:52.862Z",
                      "updated_at":"2022-01-10T23:23:52.862Z",
                      "text":"Ash가 스케줄은 다르지만 동일한 근무 시간을 일하고 있음을 Natasha에게 설명하고, 그녀의 작업량을 지원하기 위해 어떻게 도와줄 수 있을지 물어본다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72038,
                      "answer_id":30299,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:52.857Z",
                      "updated_at":"2022-01-10T23:23:52.857Z",
                      "text":"Natashaさんに、Ashさんは多少異なる勤務スケジュールで、同等の勤務時間勤務している旨を伝え、彼女の仕事量をサポートするためにできることはないか聞く。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72037,
                      "answer_id":30299,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:52.852Z",
                      "updated_at":"2022-01-10T23:23:52.852Z",
                      "text":"Spiegare a Natasha che Ash sta svolgendo le stesse ore lavorative con un orario leggermente diverso e chiedere se c’è qualche azione che puoi intraprendere per sostenere il suo carico di lavoro.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72036,
                      "answer_id":30299,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:52.848Z",
                      "updated_at":"2022-01-10T23:23:52.848Z",
                      "text":"Natasha erklären, dass Ash die gleichen Stunden mit etwas anderen Arbeitszeiten arbeitet, und ihr Unterstützung bei ihrer Arbeit anbieten.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72035,
                      "answer_id":30299,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:52.843Z",
                      "updated_at":"2022-01-10T23:23:52.843Z",
                      "text":"Expliquez à Natasha qu'Ash travaille des heures égales selon un horaire légèrement différent et demandez-lui si vous pouvez faire quelque chose pour l'assister dans sa charge de travail.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72034,
                      "answer_id":30299,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:52.838Z",
                      "updated_at":"2022-01-10T23:23:52.838Z",
                      "text":"Expliquer à Natasha qu’Ash travaille un nombre d’heures égal mais selon un emploi du temps légèrement différent, et lui demander si vous pouvez faire quelque chose pour l’aider dans sa charge de travail.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72033,
                      "answer_id":30299,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:52.834Z",
                      "updated_at":"2022-01-10T23:23:52.834Z",
                      "text":"Explicar a Natasha que Ash está trabalhando as mesmas horas em uma programação ligeiramente diferente e perguntar se há algo que você possa fazer para dar apoio à sua carga de trabalho.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72032,
                      "answer_id":30299,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:52.829Z",
                      "updated_at":"2022-01-10T23:23:52.829Z",
                      "text":"Explicar a Natasha que Ash trabaja la misma cantidad de horas con un horario levemente diferente, y preguntar si puedes hacer algo para ayudarla con su carga de trabajo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72031,
                      "answer_id":30299,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:52.824Z",
                      "updated_at":"2022-01-10T23:23:52.824Z",
                      "text":"Ipaliwanag kay Natasha na si Ash ay nagtatrabaho nang katumbas na oras sa isang medyo magkakaibang iskedyul, at tanungin kung mayroon kang magagawa upang suportahan ang kanyang trabaho.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72030,
                      "answer_id":30299,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:52.820Z",
                      "updated_at":"2022-01-10T23:23:52.820Z",
                      "text":"向 Natasha 解释说，Ash 的工作时间相同，只是时间安排有点不同，并询问你可以做什么来帮助她减轻工作量。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72029,
                      "answer_id":30299,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:52.815Z",
                      "updated_at":"2022-01-10T23:23:52.815Z",
                      "text":"向 Natasha 解釋 Ash 的工作時數相同，只是時間不同，並且問她有哪些地方需要你的支持以減輕她的工作量。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30300,
                "position":3,
                "active":true,
                "question_id":12042,
                "created_at":"2022-01-10T23:23:52.886Z",
                "updated_at":"2022-04-21T21:27:40.584Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Pull Cam aside and explain the details of Lena’s diagnosis in private. You don’t want Cam to judge Lena unfairly, so it’s important that they know why her tasks are different.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72059,
                      "answer_id":30300,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:52.969Z",
                      "updated_at":"2022-01-10T23:23:52.969Z",
                      "text":"Natasha'yı bir kenara çekin ve Ash'in durumuyla ilgili ayrıntıları özel olarak anlatın. Natasha'nın Ash'i haksız yere yargılamasını istemeseniz de programının neden farklı olduğunu bilmesi önem arz ediyor.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72058,
                      "answer_id":30300,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:52.964Z",
                      "updated_at":"2022-01-10T23:23:52.964Z",
                      "text":"Hablar con Natasha en privado para explicarle los detalles del diagnóstico de Ash. Usted no quiere que Natasha juzgue a Ash injustamente, pero es importante que sepa por qué su horario es diferente.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72057,
                      "answer_id":30300,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:52.960Z",
                      "updated_at":"2022-01-10T23:23:52.960Z",
                      "text":"Отвести Наташу в сторону и с глазу на глаз подобно рассказать о диагнозе Эша. Вы не хотите, чтобы Наташа относилась к Эшу предвзято, но важно, чтобы она знала, почему его график отличается.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72056,
                      "answer_id":30300,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:52.955Z",
                      "updated_at":"2022-01-10T23:23:52.955Z",
                      "text":"Poproś Natashę o rozmowę na osobności i wyjaśnij jej szczegóły diagnozy Asha. Nie chcesz, aby Natasha niesprawiedliwie oceniała Asha, ale ważne jest, aby wiedziała, dlaczego jego plan dnia wygląda inaczej.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72055,
                      "answer_id":30300,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:52.951Z",
                      "updated_at":"2022-01-10T23:23:52.951Z",
                      "text":"Ash의 진단 내용을 Natasha에게 비공개로 말한다. Natasha가 Ash를 부당하게 판단하는 것을 원치는 않지만 그의 업무 스케줄이 다른 이유를 그녀가 아는 것이 중요하다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72054,
                      "answer_id":30300,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:52.946Z",
                      "updated_at":"2022-01-10T23:23:52.946Z",
                      "text":"Natashaさんを個別に呼び出し、Ashさんの診断結果の詳細を説明する。NatashaさんにAshさんを不公平に批難してほしくありませんが、彼のスケジュールが何故異なるのかを知ってもらうことも重要です。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72053,
                      "answer_id":30300,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:52.941Z",
                      "updated_at":"2022-01-10T23:23:52.941Z",
                      "text":"Prendere Natasha da parte e spiegarle i dettagli della diagnosi di Ash privatamente. Non volere che Natasha giudichi Ash ingiustamente, ma è importante che lei sappia il motivo per cui il suo orario è diverso.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72052,
                      "answer_id":30300,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:52.937Z",
                      "updated_at":"2022-01-10T23:23:52.937Z",
                      "text":"Natasha beiseite nehmen und ihr unter vier Augen von Ashs Diagnose berichten. Sie möchten nicht, dass Natasha Ash unfair beurteilt, aber es ist wichtig, dass sie weiß, warum er andere Arbeitszeiten hat.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72051,
                      "answer_id":30300,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:52.932Z",
                      "updated_at":"2022-01-10T23:23:52.932Z",
                      "text":"Écartez Natasha et expliquez les détails du diagnostic d'Ash en privé. Vous ne voulez pas que Natasha juge injustement Ash, mais il est important qu'elle sache pourquoi son emploi du temps est différent.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72050,
                      "answer_id":30300,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:52.927Z",
                      "updated_at":"2022-01-10T23:23:52.927Z",
                      "text":"Prendre Natasha à part et lui donner des détails sur le diagnostic d’Ash en privé. Vous ne voulez pas que Natasha juge injustement Ash, mais il faut qu’elle sache pourquoi celui-ci bénéficie d’un emploi du temps différent.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72049,
                      "answer_id":30300,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:52.923Z",
                      "updated_at":"2022-01-10T23:23:52.923Z",
                      "text":"Chamar Natasha no canto e explicar em particular os detalhes do diagnóstico de Ash. Você não quer que Natasha julgue Ash de forma injusta, mas é importante que ela saiba por que o horário dele é diferente.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72048,
                      "answer_id":30300,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:52.918Z",
                      "updated_at":"2022-01-10T23:23:52.918Z",
                      "text":"Llevar a Natasha a un lado y explicar los detalles del diagnóstico de Ash en privado. No deseas que Natasha juzgue injustamente a Ash, pero es importante que sepa por qué su horario es diferente.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72047,
                      "answer_id":30300,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:52.913Z",
                      "updated_at":"2022-01-10T23:23:52.913Z",
                      "text":"Hilahin si Natasha at ipaliwanag nang pribado ang mga detalye sa diagnosis ni Ash. Hindi mo nais na hatulan ni Natasha nang hindi patas si Ash, ngunit mahalaga na alam niya kung bakit pabagu-bago ang kanyang iskedyul.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72046,
                      "answer_id":30300,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:52.908Z",
                      "updated_at":"2022-01-10T23:23:52.908Z",
                      "text":"将 Natasha 拉到一边，私下解释 Ash 的诊断细节。你不希望 Natasha 不公平地评判 Ash，但重要的是她要知道他的上班时间为什么不同。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72045,
                      "answer_id":30300,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:52.904Z",
                      "updated_at":"2022-01-10T23:23:52.904Z",
                      "text":"把 Natasha 拉到旁邊，私下跟她解釋 Ash 的診斷細節。你不希望 Natasha 對 Ash 有不公平的論斷，但讓她知道為何 Ash 的工作時間不同很重要。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72044,
                      "answer_id":30300,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:52.900Z",
                      "updated_at":"2022-04-21T21:27:40.590Z",
                      "text":"Pull Cam aside and explain the details of Lena’s diagnosis in private. You don’t want Cam to judge Lena unfairly, so it’s important that they know why her tasks are different.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12043,
          "shuffle":false,
          "position":18,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30302"
          ],
          "created_at":"2022-01-10T23:23:52.986Z",
          "updated_at":"2022-04-21T21:28:42.879Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":18,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best action for you to take?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29897,
                "question_id":12043,
                "locale":"en",
                "created_at":"2022-01-10T23:23:53.004Z",
                "updated_at":"2022-04-21T21:28:42.881Z",
                "text":"What is the best action for you to take?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29912,
                "question_id":12043,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:53.117Z",
                "updated_at":"2022-01-10T23:23:53.117Z",
                "text":"Ne yapmalısınız? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29911,
                "question_id":12043,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:53.112Z",
                "updated_at":"2022-01-10T23:23:53.112Z",
                "text":"¿Qué debería hacer? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29910,
                "question_id":12043,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:53.107Z",
                "updated_at":"2022-01-10T23:23:53.107Z",
                "text":"Что вам следует сделать? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29909,
                "question_id":12043,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:53.102Z",
                "updated_at":"2022-01-10T23:23:53.102Z",
                "text":"Co należy zrobić? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29908,
                "question_id":12043,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:53.098Z",
                "updated_at":"2022-01-10T23:23:53.098Z",
                "text":"어떻게 하시겠습니까? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29907,
                "question_id":12043,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:53.093Z",
                "updated_at":"2022-01-10T23:23:53.093Z",
                "text":"あなたは何をすべきでしょうか？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29906,
                "question_id":12043,
                "locale":"it",
                "created_at":"2022-01-10T23:23:53.088Z",
                "updated_at":"2022-01-10T23:23:53.088Z",
                "text":"Che cosa dovresti fare? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29905,
                "question_id":12043,
                "locale":"de",
                "created_at":"2022-01-10T23:23:53.083Z",
                "updated_at":"2022-01-10T23:23:53.083Z",
                "text":"Was sollten Sie tun? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29904,
                "question_id":12043,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:53.079Z",
                "updated_at":"2022-01-10T23:23:53.079Z",
                "text":"Que devriez-vous faire? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29903,
                "question_id":12043,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:53.074Z",
                "updated_at":"2022-01-10T23:23:53.074Z",
                "text":"Que devriez-vous faire ? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29902,
                "question_id":12043,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:53.070Z",
                "updated_at":"2022-01-10T23:23:53.070Z",
                "text":"O que você deve fazer? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29901,
                "question_id":12043,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:53.065Z",
                "updated_at":"2022-01-10T23:23:53.065Z",
                "text":"你應該怎麼做？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29900,
                "question_id":12043,
                "locale":"es",
                "created_at":"2022-01-10T23:23:53.060Z",
                "updated_at":"2022-01-10T23:23:53.060Z",
                "text":"¿Qué debes hacer? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29899,
                "question_id":12043,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:53.056Z",
                "updated_at":"2022-01-10T23:23:53.056Z",
                "text":"Ano ang dapat mong gawin? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29898,
                "question_id":12043,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:53.051Z",
                "updated_at":"2022-01-10T23:23:53.051Z",
                "text":"我们应怎么做？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30301,
                "position":1,
                "active":true,
                "question_id":12043,
                "created_at":"2022-01-10T23:23:53.124Z",
                "updated_at":"2022-04-21T21:29:18.025Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Move on. If she hasn’t expressed a need to you, there’s nothing you can do.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72060,
                      "answer_id":30301,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:53.138Z",
                      "updated_at":"2022-04-21T21:29:18.027Z",
                      "text":"Move on. If she hasn’t expressed a need to you, there’s nothing you can do.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72075,
                      "answer_id":30301,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:53.209Z",
                      "updated_at":"2022-01-10T23:23:53.209Z",
                      "text":"Bir şey yapmayın. Size ihtiyacı olmadığını belirttiyse yapacak bir şeyiniz yok demektir.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72074,
                      "answer_id":30301,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:53.204Z",
                      "updated_at":"2022-01-10T23:23:53.204Z",
                      "text":"Continuar. Si no le ha comunicado ninguna necesidad, no hay nada que usted pueda hacer.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72073,
                      "answer_id":30301,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:53.199Z",
                      "updated_at":"2022-01-10T23:23:53.199Z",
                      "text":"Продолжить работу. Если он ничего не сказал о своих потребностях, вы ничего не можете сделать.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72072,
                      "answer_id":30301,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:53.195Z",
                      "updated_at":"2022-01-10T23:23:53.195Z",
                      "text":"Przejść dalej. Jeśli nie wyraził potrzeby, nie możesz nic zrobić.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72071,
                      "answer_id":30301,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:53.190Z",
                      "updated_at":"2022-01-10T23:23:53.190Z",
                      "text":"조치를 취한다. 그가 무엇이 필요한지 말하지 않았기 때문에 해줄 수 있는 것이 없다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72070,
                      "answer_id":30301,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:53.185Z",
                      "updated_at":"2022-01-10T23:23:53.185Z",
                      "text":"次に進む。彼があなたに対して必要性を示さない限り、あなたにできることはない。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72069,
                      "answer_id":30301,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:53.181Z",
                      "updated_at":"2022-01-10T23:23:53.181Z",
                      "text":"Proseguire. Se non ti ha espresso una necessità, non è possibile fare nulla.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72068,
                      "answer_id":30301,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:53.176Z",
                      "updated_at":"2022-01-10T23:23:53.176Z",
                      "text":"Weitermachen. Wenn er nicht um Hilfe gebeten hat, gibt es nichts, das Sie tun können.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72067,
                      "answer_id":30301,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:53.171Z",
                      "updated_at":"2022-01-10T23:23:53.171Z",
                      "text":"Il faut aller de l'avant. S'il ne vous a pas exprimé de besoin, vous ne pouvez rien faire.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72066,
                      "answer_id":30301,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:53.166Z",
                      "updated_at":"2022-01-10T23:23:53.166Z",
                      "text":"Passer à autre chose. S’il n’en a pas exprimé le besoin, vous ne pouvez rien faire.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72065,
                      "answer_id":30301,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:53.161Z",
                      "updated_at":"2022-01-10T23:23:53.161Z",
                      "text":"Seguir em frente. Se ele não expressou uma necessidade a você, não há nada que você possa fazer.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72064,
                      "answer_id":30301,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:53.156Z",
                      "updated_at":"2022-01-10T23:23:53.156Z",
                      "text":"Avanzar. Si no ha expresado una necesidad, no hay nada que puedas hacer.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72063,
                      "answer_id":30301,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:53.152Z",
                      "updated_at":"2022-01-10T23:23:53.152Z",
                      "text":"Magpatuloy. Kung hindi siya nagpahayag ng pangangailangan sa iyo, wala kang magagawa.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72062,
                      "answer_id":30301,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:53.147Z",
                      "updated_at":"2022-01-10T23:23:53.147Z",
                      "text":"继续。如果他没有向你表达需要，那你什么也做不了。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72061,
                      "answer_id":30301,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:53.142Z",
                      "updated_at":"2022-01-10T23:23:53.142Z",
                      "text":"繼續。如果他未向你表達需求，你也幫不上忙。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30302,
                "position":2,
                "active":true,
                "question_id":12043,
                "created_at":"2022-01-10T23:23:53.215Z",
                "updated_at":"2022-04-21T21:29:30.834Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Contact the human resources department on Zehra’s behalf.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72091,
                      "answer_id":30302,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:53.304Z",
                      "updated_at":"2022-01-10T23:23:53.304Z",
                      "text":"Ahanu'ya, eğer ilgilenirse, yazmayı daha rahat hale getirmek için cihaz satın almak gibi bir düzenleme üzerinde birlikte çalışabileceğinizi söyleyin. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72090,
                      "answer_id":30302,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:53.300Z",
                      "updated_at":"2022-01-10T23:23:53.300Z",
                      "text":"Decirle a Ahanu que, si está interesado, usted puede trabajar con él en realizar adaptaciones, como comprar un dispositivo que permita escribir de forma más cómoda. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72089,
                      "answer_id":30302,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:53.293Z",
                      "updated_at":"2022-01-10T23:23:53.293Z",
                      "text":"Сказать Ахану, что, если он хочет, вы можете вместе обсудить любые удобства, например, покупку устройства, которое упростит печать на клавиатуре. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72088,
                      "answer_id":30302,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:53.285Z",
                      "updated_at":"2022-01-10T23:23:53.285Z",
                      "text":"Powiedz Ahanu, że jeśli jest zainteresowany, możesz z nim współpracować nad udogodnieniami, takimi jak zakup urządzenia, które sprawi, że pisanie na klawiaturze będzie wygodniejsze. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72087,
                      "answer_id":30302,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:53.280Z",
                      "updated_at":"2022-01-10T23:23:53.280Z",
                      "text":"Ahanu에게 그가 관심이 있다면 필요한 편의(예를 들어 더 편안하게 타이핑할 수 있는 기기)를 마련할 수 있다고 말한다. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72086,
                      "answer_id":30302,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:53.275Z",
                      "updated_at":"2022-01-10T23:23:53.275Z",
                      "text":"Ahanuさんに、興味があれば、タイピングを行いやすくするための機器の購入など、あらゆる配慮をすべく取り組むことができる旨を伝える。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72085,
                      "answer_id":30302,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:53.270Z",
                      "updated_at":"2022-01-10T23:23:53.270Z",
                      "text":"Dire ad Ahanu che, se è interessato, è possibile lavorare con lui su qualsiasi adeguamento, come l’acquisto di un dispositivo per rendere più comoda la digitazione. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72084,
                      "answer_id":30302,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:53.265Z",
                      "updated_at":"2022-01-10T23:23:53.265Z",
                      "text":"Ahanu anbieten, dass Sie ihm helfen können, entsprechende Hilfsmittel für ihn zu besorgen, falls er daran interessiert, wie beispielsweise die Anschaffung eines Geräts, auf dem ihm das Schreiben leichter fällt. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72083,
                      "answer_id":30302,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:53.261Z",
                      "updated_at":"2022-01-10T23:23:53.261Z",
                      "text":"Dites à Ahanu que s'il est intéressé, vous pouvez travailler avec lui sur n'importe quel accommodation, comme l'achat d'un appareil pour rendre la frappe plus confortable. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72082,
                      "answer_id":30302,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:53.256Z",
                      "updated_at":"2022-01-10T23:23:53.256Z",
                      "text":"Dire à Ahanu que s’il le veut, vous pouvez l’aider à trouver un accommodement, comme par exemple acheter un appareil qui lui permette de taper plus facilement. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72081,
                      "answer_id":30302,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:53.251Z",
                      "updated_at":"2022-01-10T23:23:53.251Z",
                      "text":"Dizer a Ahanu que, se ele estiver interessado, você poderá trabalhar com ele em alguma adaptação, como comprar um dispositivo para tornar a digitação mais confortável. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72080,
                      "answer_id":30302,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:53.247Z",
                      "updated_at":"2022-01-10T23:23:53.247Z",
                      "text":"告訴 Ahanu 如果他有興趣，你可以和他一起處理任何照應需求，例如，購買可以讓打字變得更舒適的裝置。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72079,
                      "answer_id":30302,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:53.241Z",
                      "updated_at":"2022-01-10T23:23:53.241Z",
                      "text":"Decirle a Ahanu que si está interesado, puedes trabajar con él para realizar adaptaciones razonables, como comprar un dispositivo para que escribir en el teclado sea más cómodo. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72078,
                      "answer_id":30302,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:53.237Z",
                      "updated_at":"2022-01-10T23:23:53.237Z",
                      "text":"Sabihin kay Ahanu na kung siya ay interesado, maaari kang makipagtulungan sa kanya sa anumang mga accommodation, tulad ng pagbili ng isang aparato upang maging mas komportable. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72077,
                      "answer_id":30302,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:53.232Z",
                      "updated_at":"2022-01-10T23:23:53.232Z",
                      "text":"告诉 Ahanu 如果他感兴趣，你可以帮助他想办法让他得到照顾，例如购买设备让打字变得更轻松。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72076,
                      "answer_id":30302,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:53.228Z",
                      "updated_at":"2022-04-21T21:29:30.836Z",
                      "text":"Contact the human resources department on Zehra’s behalf.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31695,
                "position":3,
                "active":true,
                "question_id":12043,
                "created_at":"2022-04-21T21:29:43.465Z",
                "updated_at":"2022-04-21T21:29:43.465Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell Zehra that you can work with her on any accommodations, like purchasing a hand magnifier or task light, if she's interested.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77365,
                      "answer_id":31695,
                      "locale":"en",
                      "created_at":"2022-04-21T21:29:43.472Z",
                      "updated_at":"2022-04-21T21:29:43.472Z",
                      "text":"Tell Zehra that you can work with her on any accommodations, like purchasing a hand magnifier or task light, if she's interested.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12044,
          "shuffle":false,
          "position":19,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30305"
          ],
          "created_at":"2022-01-10T23:23:53.321Z",
          "updated_at":"2022-01-10T23:23:53.739Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":19,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What’s the best way to start the discussion?\n",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29928,
                "question_id":12044,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:53.456Z",
                "updated_at":"2022-01-10T23:23:53.456Z",
                "text":"Bir tartışmaya başlamanın en iyi yolu nedir?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29927,
                "question_id":12044,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:53.451Z",
                "updated_at":"2022-01-10T23:23:53.451Z",
                "text":"¿Cuál es la mejor forma de iniciar la conversación?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29926,
                "question_id":12044,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:53.446Z",
                "updated_at":"2022-01-10T23:23:53.446Z",
                "text":"Как лучше всего начать обсуждение?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29925,
                "question_id":12044,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:53.442Z",
                "updated_at":"2022-01-10T23:23:53.442Z",
                "text":"Jaki jest najlepszy sposób na rozpoczęcie dyskusji?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29924,
                "question_id":12044,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:53.437Z",
                "updated_at":"2022-01-10T23:23:53.437Z",
                "text":"이 점에 대해 대화를 시작하는 가장 좋은 방법은 무엇입니까?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29923,
                "question_id":12044,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:53.432Z",
                "updated_at":"2022-01-10T23:23:53.432Z",
                "text":"話し合いを始めるための最善の方法はなんですか？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29922,
                "question_id":12044,
                "locale":"it",
                "created_at":"2022-01-10T23:23:53.428Z",
                "updated_at":"2022-01-10T23:23:53.428Z",
                "text":"Qual è il modo migliore per iniziare la discussione?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29921,
                "question_id":12044,
                "locale":"de",
                "created_at":"2022-01-10T23:23:53.423Z",
                "updated_at":"2022-01-10T23:23:53.423Z",
                "text":"Wie beginnen Sie die Diskussion am besten?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29920,
                "question_id":12044,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:53.418Z",
                "updated_at":"2022-01-10T23:23:53.418Z",
                "text":"Quelle est la meilleure façon de lancer la discussion?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29919,
                "question_id":12044,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:53.414Z",
                "updated_at":"2022-01-10T23:23:53.414Z",
                "text":"Quelle est le meilleur moyen de lancer la discussion ?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29918,
                "question_id":12044,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:53.409Z",
                "updated_at":"2022-01-10T23:23:53.409Z",
                "text":"Qual é a melhor maneira de iniciar a conversa?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29917,
                "question_id":12044,
                "locale":"es",
                "created_at":"2022-01-10T23:23:53.404Z",
                "updated_at":"2022-01-10T23:23:53.404Z",
                "text":"¿Cuál es la mejor forma de comenzar una conversación?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29916,
                "question_id":12044,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:53.400Z",
                "updated_at":"2022-01-10T23:23:53.400Z",
                "text":"Ano ang pinakamahusay na paraan upang simulan ang talakayan?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29915,
                "question_id":12044,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:53.395Z",
                "updated_at":"2022-01-10T23:23:53.395Z",
                "text":"以什么方式开启谈话最好？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29914,
                "question_id":12044,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:53.390Z",
                "updated_at":"2022-01-10T23:23:53.390Z",
                "text":"討論的最佳開場白是甚麼？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29913,
                "question_id":12044,
                "locale":"en",
                "created_at":"2022-01-10T23:23:53.342Z",
                "updated_at":"2022-01-10T23:23:53.342Z",
                "text":"What’s the best way to start the discussion?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30303,
                "position":1,
                "active":true,
                "question_id":12044,
                "created_at":"2022-01-10T23:23:53.463Z",
                "updated_at":"2022-01-10T23:23:53.463Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Krishna, I really need you to try harder. I know you are capable of the work, but your effort on these past few projects has really been below what I know you can do.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72107,
                      "answer_id":30303,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:53.548Z",
                      "updated_at":"2022-01-10T23:23:53.548Z",
                      "text":"Krishna, gerçekten daha fazla çaba göstermene ihtiyacım var. İşinde yetenekli olduğunu biliyorum ancak son birkaç projede gösterdiğin çaba yapabileceklerinin çok altındaydı.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72106,
                      "answer_id":30303,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:53.543Z",
                      "updated_at":"2022-01-10T23:23:53.543Z",
                      "text":"Krishna, necesito que te esfuerces más. Sé que eres capaz de hacer el trabajo, pero la verdad es que tu esfuerzo en estos últimos proyectos ha sido inferior de lo que sé que puedes hacer.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72105,
                      "answer_id":30303,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:53.539Z",
                      "updated_at":"2022-01-10T23:23:53.539Z",
                      "text":"Кришна, я хочу, чтобы вы больше старались. Я знаю, что вы можете выполнять эту работу, но усилия, которые вы прилагали в рамках последних проектов, намного ниже, чем ваш потенциал.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72104,
                      "answer_id":30303,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:53.534Z",
                      "updated_at":"2022-01-10T23:23:53.534Z",
                      "text":"Krishna, naprawdę musisz się bardziej postarać. Wiem, że jesteś zdolny do pracy, ale twój wysiłek w tych ostatnich kilku projektach był naprawdę poniżej Twoich możliwości.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72103,
                      "answer_id":30303,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:53.529Z",
                      "updated_at":"2022-01-10T23:23:53.529Z",
                      "text":"Krishna, 더 열심히 일해 줬으면 좋겠어요. 당신이 훌륭한 업무 능력을 가지고 있다는 걸 알고 있어요. 하지만 지난 몇 가지 프로젝트를 보면 능력에 비해 성과가 낮았죠.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72102,
                      "answer_id":30303,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:53.524Z",
                      "updated_at":"2022-01-10T23:23:53.524Z",
                      "text":"Krishnaさん、もっと頑張ってもらわないと困ります。あなたに仕事をこなす能力があることは知っています。しかし、最近のいくつかのプロジェクトに対するあなたの努力は、私の知るあなたの能力に全く達していません。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72101,
                      "answer_id":30303,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:53.519Z",
                      "updated_at":"2022-01-10T23:23:53.519Z",
                      "text":"Krishna, ho davvero bisogno che tu ti impegni maggiormente. So che sei capace di svolgere il tuo lavoro, ma il tuo impegno in questi ultimi progetti è stato davvero inferiore rispetto a quello che so che sei in grado di fare.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72100,
                      "answer_id":30303,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:53.515Z",
                      "updated_at":"2022-01-10T23:23:53.515Z",
                      "text":"Krishna, du solltest dir wirklich mehr Mühe geben. Ich weiß, dass du es kannst, aber in den letzten paar Projekten hast du viel weniger Einsatz gezeigt als sonst.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72099,
                      "answer_id":30303,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:53.510Z",
                      "updated_at":"2022-01-10T23:23:53.510Z",
                      "text":"Krishna, j'ai vraiment besoin que tu fasses plus d'efforts. Je sais que vous êtes capable de faire le travail, mais vos efforts sur ces derniers projets ont vraiment été inférieurs à ce que je sais que vous pouvez faire.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72098,
                      "answer_id":30303,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:53.505Z",
                      "updated_at":"2022-01-10T23:23:53.505Z",
                      "text":"Krishna, j’ai vraiment besoin que tu fasses plus d’efforts. Je sais que tu es capable de faire ce travail, mais tes efforts sur les derniers projets ont vraiment été en-deçà de ce dont je sais que tu es capable.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72097,
                      "answer_id":30303,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:53.500Z",
                      "updated_at":"2022-01-10T23:23:53.500Z",
                      "text":"Krishna, realmente preciso que você se esforce mais. Sei que você é capaz de fazer o trabalho, mas seu esforço nestes últimos projetos está realmente aquém do que sei que você pode fazer.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72096,
                      "answer_id":30303,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:53.495Z",
                      "updated_at":"2022-01-10T23:23:53.495Z",
                      "text":"Krishna, realmente necesito que te esfuerces más. Sé que puedes hacer el trabajo, pero tu esfuerzo en estos últimos proyectos realmente ha sido inferior a lo que sé que puedes hacer.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72095,
                      "answer_id":30303,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:53.491Z",
                      "updated_at":"2022-01-10T23:23:53.491Z",
                      "text":"Krishna, kailangan ko talagang subukan ka. Alam kong may kakayahan ka sa trabaho, ngunit ang iyong pagsisikap sa mga nakaraang ilang proyekto ay talagang mababa sa alam kong kaya mong gawin.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72094,
                      "answer_id":30303,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:53.486Z",
                      "updated_at":"2022-01-10T23:23:53.486Z",
                      "text":"Krishna，我真的希望你工作更努力一些。我知道你工作能力强，但从你过去做的几个项目来看，你的努力确实与我了解的你的能力不符。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72093,
                      "answer_id":30303,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:53.481Z",
                      "updated_at":"2022-01-10T23:23:53.481Z",
                      "text":"Krishna，我需要你再努力一些。我知道你有能力，但你在最近幾個專案的表現不如我對你的瞭解。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72092,
                      "answer_id":30303,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:53.477Z",
                      "updated_at":"2022-01-10T23:23:53.477Z",
                      "text":"Krishna, I really need you to try harder. I know you are capable of the work, but your effort on these past few projects has really been below what I know you can do.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30304,
                "position":2,
                "active":true,
                "question_id":12044,
                "created_at":"2022-01-10T23:23:53.554Z",
                "updated_at":"2022-01-10T23:23:53.554Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Krishna, I wanted to see if there’s anything you need from me to help you excel at your job. I want to make sure I’m supporting you as well as I can.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72123,
                      "answer_id":30304,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:53.637Z",
                      "updated_at":"2022-01-10T23:23:53.637Z",
                      "text":"Krishna, işini daha iyi yapma konusunda yardım edebileceğim bir şey olup olmadığını görmek istedim. Elimden geldiğince desteklediğimden emin olmak istiyorum.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72122,
                      "answer_id":30304,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:53.632Z",
                      "updated_at":"2022-01-10T23:23:53.632Z",
                      "text":"Krishna, quería ver si hay algo que pueda hacer para ayudarte a sobresalir en tu trabajo. Quiero asegurarme de que te estoy apoyando en todo lo que puedo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72121,
                      "answer_id":30304,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:53.628Z",
                      "updated_at":"2022-01-10T23:23:53.628Z",
                      "text":"Кришна, я хотел бы узнать, что я могу сделать, чтобы помочь вам работать более эффективно? Я хочу быть уверен, что максимально поддерживаю вас.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72120,
                      "answer_id":30304,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:53.623Z",
                      "updated_at":"2022-01-10T23:23:53.623Z",
                      "text":"Krishna, czy jest coś, czego potrzebujesz ode mnie, aby pomóc Ci w doskonaleniu się w swojej pracy? Chcę się upewnić, że wspieram Cię najlepiej jak potrafię.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72119,
                      "answer_id":30304,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:53.618Z",
                      "updated_at":"2022-01-10T23:23:53.618Z",
                      "text":"Krishna, 당신이 일을 더 잘할 수 있도록 제가 도움을 줄 수 있는 게 있을지 알고 싶어요. 내가 충분히 당신을 잘 도와주고 있는지도 알고 싶고요.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72118,
                      "answer_id":30304,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:53.614Z",
                      "updated_at":"2022-01-10T23:23:53.614Z",
                      "text":"Krishnaさん、ご自身の職務を果たすために、何か私にできることはないでしょうか。最大限あなたをサポートできているかどうか確認したいです。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72117,
                      "answer_id":30304,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:53.609Z",
                      "updated_at":"2022-01-10T23:23:53.609Z",
                      "text":"Krishna, volevo sapere se c’è qualcosa di cui hai bisogno in modo che possa aiutarti a eccellere nel tuo lavoro. Desidero assicurarmi di supportarti nel miglior modo possibile.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72116,
                      "answer_id":30304,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:53.604Z",
                      "updated_at":"2022-01-10T23:23:53.604Z",
                      "text":"Krishna, ich wollte fragen, ob es irgendetwas gibt, das ich für dich tun kann, damit du Spitzenarbeit leisten kannst. Ich will sicherstellen, dass ich dich unterstütze, so gut ich kann.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72115,
                      "answer_id":30304,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:53.600Z",
                      "updated_at":"2022-01-10T23:23:53.600Z",
                      "text":"Krishna, je voulais voir si vous aviez besoin de mon aide pour vous aider à exceller dans votre travail. Je veux m'assurer de vous soutenir du mieux que je peux.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72114,
                      "answer_id":30304,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:53.595Z",
                      "updated_at":"2022-01-10T23:23:53.595Z",
                      "text":"Krishna, je voulais voir si je peux faire quoi que ce soit pour t’aider à faire ton travail au mieux. Je veux t’aider du mieux que je peux.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72113,
                      "answer_id":30304,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:53.590Z",
                      "updated_at":"2022-01-10T23:23:53.590Z",
                      "text":"Krishna, queria ver se há algo que eu possa fazer para ajudá-la a se destacar em seu trabalho. Quero ter certeza de que estou apoiando você no melhor que posso.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72112,
                      "answer_id":30304,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:53.586Z",
                      "updated_at":"2022-01-10T23:23:53.586Z",
                      "text":"Krishna, quería preguntarte si hay algo que pueda hacer para ayudarte a destacarte en tu trabajo. Deseo asegurarme de apoyarte lo mejor posible.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72111,
                      "answer_id":30304,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:53.581Z",
                      "updated_at":"2022-01-10T23:23:53.581Z",
                      "text":"Krishna, Nais kong makita kung mayroong anumang kailangan mo sa akin upang matulungan kang maging higit sa iyong trabaho. Gusto kong tiyakin na sinusuportahan kita hangga't kaya ko.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72110,
                      "answer_id":30304,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:53.576Z",
                      "updated_at":"2022-01-10T23:23:53.576Z",
                      "text":"Krishna，我想知道你是否需要我做什么来帮助你做好工作。我希望竭尽我的所能为你提供支持。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72109,
                      "answer_id":30304,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:53.572Z",
                      "updated_at":"2022-01-10T23:23:53.572Z",
                      "text":"Krishna，我想知道是否有可以幫助你在工作上表現更優異的地方。我希望確認我能盡力給予你協助。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72108,
                      "answer_id":30304,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:53.567Z",
                      "updated_at":"2022-01-10T23:23:53.567Z",
                      "text":"Krishna, I wanted to see if there’s anything you need from me to help you excel at your job. I want to make sure I’m supporting you as well as I can.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30305,
                "position":3,
                "active":true,
                "question_id":12044,
                "created_at":"2022-01-10T23:23:53.643Z",
                "updated_at":"2022-01-10T23:23:53.643Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Krishna, you were doing great a few months ago, and I know you’re capable of this job. But lately, your performance has been suffering — what’s going on? ",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72139,
                      "answer_id":30305,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:53.733Z",
                      "updated_at":"2022-01-10T23:23:53.733Z",
                      "text":"Krishna, birkaç ay önce işinde harikaydın ve bunu yapabilecek nitelikte olduğunu biliyorum. Ancak son zamanlarda performansında düşüş gözlemliyorum. Bir sorun mu var? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72138,
                      "answer_id":30305,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:53.727Z",
                      "updated_at":"2022-01-10T23:23:53.727Z",
                      "text":"Krishna, lo estabas haciendo muy bien hace unos meses y sé que eres capaz de hacer este trabajo. No obstante, hace poco tu rendimiento se ha visto afectado, ¿qué ocurre? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72137,
                      "answer_id":30305,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:53.721Z",
                      "updated_at":"2022-01-10T23:23:53.721Z",
                      "text":"Кришна, пару месяцев назад вы работали очень эффективно, и я знаю, что вы можете выполнять эту работу. Но в последнее время качество вашей работы упало — что происходит? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72136,
                      "answer_id":30305,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:53.714Z",
                      "updated_at":"2022-01-10T23:23:53.714Z",
                      "text":"Krishna, jeszcze kilka miesięcy temu świetnie sobie radziłeś i wiem, że możesz wykonać to zadanie. Ostatnio jednak Twoja wydajność spadła — co się dzieje? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72135,
                      "answer_id":30305,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:53.709Z",
                      "updated_at":"2022-01-10T23:23:53.709Z",
                      "text":"Krishna 당신은 몇 달 전에 업무를 잘 수행하고 있었고 그럴 능력도 충분해요. 하지만 최근에는 좀 힘들어 보였어요. 무슨 일이 있나요? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72134,
                      "answer_id":30305,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:53.704Z",
                      "updated_at":"2022-01-10T23:23:53.704Z",
                      "text":"Krishnaさん、数カ月前までは非常に良い成果をあげていらっしゃいました。私はあなたが職務を果たす能力を持っていることを知っています。しかし最近、業績が下がってきているようです。何かありましたか？ ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72133,
                      "answer_id":30305,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:53.699Z",
                      "updated_at":"2022-01-10T23:23:53.699Z",
                      "text":"Krishna, stavi andando benissimo alcuni mesi fa e so che sei capace di svolgere questo lavoro. Ma ultimamente, le tue prestazioni ne stanno risentendo: che cosa sta succedendo? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72132,
                      "answer_id":30305,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:53.694Z",
                      "updated_at":"2022-01-10T23:23:53.694Z",
                      "text":"Krishna, vor ein paar Monaten hast du Spitzenarbeit geleistet, und ich weiß, dass du gut in deinem Job bist. Nur hat deine Leistung in letzter Zeit nachgelassen. Was ist los? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72131,
                      "answer_id":30305,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:53.689Z",
                      "updated_at":"2022-01-10T23:23:53.689Z",
                      "text":"Krishna, vous vous débrouilliez très bien il y a quelques mois, et je sais que vous êtes à la hauteur de ce travail. Mais dernièrement, votre performance en a souffert - que se passe-t-il? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72130,
                      "answer_id":30305,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:53.683Z",
                      "updated_at":"2022-01-10T23:23:53.683Z",
                      "text":"Krishna, tu as vraiment fait du très bon travail il y a quelques mois, et je sais que tu en es capable. Mais dernièrement, tes performances n’ont pas été à la hauteur. Qu’est-ce qui se passe ? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72129,
                      "answer_id":30305,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:53.678Z",
                      "updated_at":"2022-01-10T23:23:53.678Z",
                      "text":"Krishna, você estava indo muito bem há alguns meses e sei que é capaz de fazer esse trabalho. Mas ultimamente seu desempenho tem sido prejudicado. O que está acontecendo? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72128,
                      "answer_id":30305,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:53.674Z",
                      "updated_at":"2022-01-10T23:23:53.674Z",
                      "text":"Krishna, trabajaste muy bien hace unos meses, sé que puedes hacer este trabajo. Pero últimamente tu desempeño se ha reducido. ¿Qué sucede? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72127,
                      "answer_id":30305,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:53.669Z",
                      "updated_at":"2022-01-10T23:23:53.669Z",
                      "text":"Krishna, mahusay ang mga ginawa nitong nakaraang ilang buwan, at alam kong may kakayahan ka sa trabahong ito. Ngunit kamakailan, ang iyong performance ay hindi naging maganda - ano ang nangyayari? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72126,
                      "answer_id":30305,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:53.665Z",
                      "updated_at":"2022-01-10T23:23:53.665Z",
                      "text":"Krishna，你几个月前工作很出色，而且我知道你胜任这项工作。但最近你的表现一直很糟糕，出了什么事情？ ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72125,
                      "answer_id":30305,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:53.660Z",
                      "updated_at":"2022-01-10T23:23:53.660Z",
                      "text":"Krishna，你幾個月前的表現很好，我知道你可以勝任這個工作。但你最近的表現不太好 — 發生甚麼事了嗎？ ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72124,
                      "answer_id":30305,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:53.656Z",
                      "updated_at":"2022-01-10T23:23:53.656Z",
                      "text":"Krishna, you were doing great a few months ago, and I know you’re capable of this job. But lately, your performance has been suffering — what’s going on? ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12045,
          "shuffle":false,
          "position":20,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30307"
          ],
          "created_at":"2022-01-10T23:23:53.752Z",
          "updated_at":"2022-04-21T22:36:54.954Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":20,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best action for you to take?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29944,
                "question_id":12045,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:53.889Z",
                "updated_at":"2022-01-10T23:23:53.889Z",
                "text":"Ne yapmalısınız? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29943,
                "question_id":12045,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:53.885Z",
                "updated_at":"2022-01-10T23:23:53.885Z",
                "text":"¿Qué debería hacer? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29942,
                "question_id":12045,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:53.880Z",
                "updated_at":"2022-01-10T23:23:53.880Z",
                "text":"Что вам следует сделать? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29941,
                "question_id":12045,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:53.875Z",
                "updated_at":"2022-01-10T23:23:53.875Z",
                "text":"Co należy zrobić? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29940,
                "question_id":12045,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:53.870Z",
                "updated_at":"2022-01-10T23:23:53.870Z",
                "text":"어떻게 하시겠습니까? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29939,
                "question_id":12045,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:53.866Z",
                "updated_at":"2022-01-10T23:23:53.866Z",
                "text":"あなたは何をすべきでしょうか？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29938,
                "question_id":12045,
                "locale":"it",
                "created_at":"2022-01-10T23:23:53.861Z",
                "updated_at":"2022-01-10T23:23:53.861Z",
                "text":"Che cosa dovresti fare? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29937,
                "question_id":12045,
                "locale":"de",
                "created_at":"2022-01-10T23:23:53.856Z",
                "updated_at":"2022-01-10T23:23:53.856Z",
                "text":"Was sollten Sie tun? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29936,
                "question_id":12045,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:53.851Z",
                "updated_at":"2022-01-10T23:23:53.851Z",
                "text":"Que devriez-vous faire? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29935,
                "question_id":12045,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:53.846Z",
                "updated_at":"2022-01-10T23:23:53.846Z",
                "text":"Que devriez-vous faire ? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29934,
                "question_id":12045,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:53.842Z",
                "updated_at":"2022-01-10T23:23:53.842Z",
                "text":"O que você deve fazer? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29933,
                "question_id":12045,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:53.837Z",
                "updated_at":"2022-01-10T23:23:53.837Z",
                "text":"你應該怎麼做？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29932,
                "question_id":12045,
                "locale":"es",
                "created_at":"2022-01-10T23:23:53.832Z",
                "updated_at":"2022-01-10T23:23:53.832Z",
                "text":"¿Qué debes hacer? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29931,
                "question_id":12045,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:53.827Z",
                "updated_at":"2022-01-10T23:23:53.827Z",
                "text":"Ano ang dapat mong gawin? \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29930,
                "question_id":12045,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:53.822Z",
                "updated_at":"2022-01-10T23:23:53.822Z",
                "text":"我们应怎么做？ \n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29929,
                "question_id":12045,
                "locale":"en",
                "created_at":"2022-01-10T23:23:53.771Z",
                "updated_at":"2022-04-21T22:36:54.957Z",
                "text":"What is the best action for you to take?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30306,
                "position":1,
                "active":true,
                "question_id":12045,
                "created_at":"2022-01-10T23:23:53.896Z",
                "updated_at":"2022-04-21T22:37:21.295Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Say nothing. No one else is speaking up, so maybe they know something you don’t.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72140,
                      "answer_id":30306,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:53.909Z",
                      "updated_at":"2022-04-21T22:37:21.297Z",
                      "text":"Say nothing. No one else is speaking up, so maybe they know something you don’t.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72155,
                      "answer_id":30306,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:53.982Z",
                      "updated_at":"2022-01-10T23:23:53.982Z",
                      "text":"Weinan ve çevrenizdeki kişilere danışın. Sizin bilmediğiniz bir şeyi bilmelerine rağmen müdahale etmiyor olabilirler. . Belki kendi aralarında yaptıkları bir şakadır.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72154,
                      "answer_id":30306,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:53.978Z",
                      "updated_at":"2022-01-10T23:23:53.978Z",
                      "text":"Seguir el ejemplo de Weinan y las personas de su entorno. Deben saber algo que usted no sabe y, por eso, no intervienen. . . Quizás se trate de una broma implícita que aún no ha escuchado.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72153,
                      "answer_id":30306,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:53.973Z",
                      "updated_at":"2022-01-10T23:23:53.973Z",
                      "text":"Вести себя, как Вейнань и окружающие люди. Они точно знают что-то, чего вы не знаете, и поэтому не вмешиваются. . . Может это шутка «для своих», которую вы пока не слышали.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72152,
                      "answer_id":30306,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:53.968Z",
                      "updated_at":"2022-01-10T23:23:53.968Z",
                      "text":"Wziąć przykład z Weinana i osób wokół Ciebie. Muszą wiedzieć coś, czego Ty nie wiesz i dlatego nie interweniują. . Może to jakiś biurowy dowcip, którego jeszcze nie znasz.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72151,
                      "answer_id":30306,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:53.963Z",
                      "updated_at":"2022-01-10T23:23:53.963Z",
                      "text":"Weinan과 주변 사람들로부터 단서를 얻는다. 그들은 뭔가를 알고 있기 때문에 개입하지 않는 것이다. . 자기들만 아는 농담일 수도 있다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72150,
                      "answer_id":30306,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:53.957Z",
                      "updated_at":"2022-01-10T23:23:53.957Z",
                      "text":"Weinanさんや周りの人からの合図を認識します。あなたの知らない何かを知っているために、介入しないのでしょう。。あなたの耳にはまだ入っていない内輪話かもしれません。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72149,
                      "answer_id":30306,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:53.952Z",
                      "updated_at":"2022-01-10T23:23:53.952Z",
                      "text":"Prendere spunto da Weinan e dalle persone intorno a te. Devono essere a conoscenza di qualche elemento che tu non sai, ed è questo il motivo per cui non stanno intervenendo. . .forse si tratta di una battuta del gruppo che non hai ancora sentito.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72148,
                      "answer_id":30306,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:53.947Z",
                      "updated_at":"2022-01-10T23:23:53.947Z",
                      "text":"Sich ein Vorbild nehmen an Weinan und den anderen Personen um Sie herum. Bestimmt wissen sie etwas, das Sie nicht wissen, und schreiten deswegen nicht ein. . Vielleicht ist es ein Insider-Witz, den Sie noch nicht kennen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72147,
                      "answer_id":30306,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:53.942Z",
                      "updated_at":"2022-01-10T23:23:53.942Z",
                      "text":"Inspirez-vous de Weinan et des gens autour de vous. Ils doivent savoir quelque chose que vous ne connaissez pas, et c'est pourquoi ils n'interviennent pas. . . C'est peut-être une blague d'initiés que vous n'avez pas encore entendue.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72146,
                      "answer_id":30306,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:53.938Z",
                      "updated_at":"2022-01-10T23:23:53.938Z",
                      "text":"Prendre exemple sur Weinan et les gens qui vous entourent. Ils savent sans doute quelque chose que vous ignorez, et c’est pourquoi ils n’interviennent pas. . Il s’agit peut-être d’une blague entre initiés que vous ne connaissez pas.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72145,
                      "answer_id":30306,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:53.933Z",
                      "updated_at":"2022-01-10T23:23:53.933Z",
                      "text":"Seguir a dica de Weinan e das pessoas ao seu redor. Eles devem saber algo que você não sabe, e é por isso que não estão intervindo. . Talvez seja uma piada interna que você não ouviu.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72144,
                      "answer_id":30306,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:53.928Z",
                      "updated_at":"2022-01-10T23:23:53.928Z",
                      "text":"从 Weinan 和你周围人的身上找到启示。他们一定会到你不知道的什么事情，所以他们才不干预。。。或许这是一个圈内玩笑，只是你尚未听说而已。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72143,
                      "answer_id":30306,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:53.923Z",
                      "updated_at":"2022-01-10T23:23:53.923Z",
                      "text":"Observar las señales de Weinan y las personas a tu alrededor. Deben saber algo que tú no sabes, y es por eso que intervienen. . . tal vez es una broma interna que aún no conoces.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72142,
                      "answer_id":30306,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:53.918Z",
                      "updated_at":"2022-01-10T23:23:53.918Z",
                      "text":"Kumuha ng isang cue mula kau Weinan at sa mga tao sa paligid mo. Dapat nilang malaman ang isang bagay na hindi mo dapat malaman, at iyon ang dahilan kung bakit hindi sila nakikialam. . . baka biro iyon sa loob na hindi mo pa naririnig.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72141,
                      "answer_id":30306,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:53.913Z",
                      "updated_at":"2022-01-10T23:23:53.913Z",
                      "text":"接收來自 Weinan 和身邊的人給予的暗示。他們一定知道一些你不知道的事情，那就是他們不介入的原因。.. 或許那是一個你沒聽過流傳在特定群體的笑話。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30307,
                "position":2,
                "active":true,
                "question_id":12045,
                "created_at":"2022-01-10T23:23:53.988Z",
                "updated_at":"2022-04-21T22:37:32.961Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Wait until you get back to the office to tell a colleague what happened.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72171,
                      "answer_id":30307,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:54.082Z",
                      "updated_at":"2022-01-10T23:23:54.082Z",
                      "text":"Bir şey söyleyin. Kişinin aksanıyla alay etmek o kişiye hakaret etmektir. Bunu duyan insanları ve hatta Weinan'ı dahi incitebilir.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72170,
                      "answer_id":30307,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:54.077Z",
                      "updated_at":"2022-01-10T23:23:54.077Z",
                      "text":"Decir algo. Burlarse de un acento es ofensivo. Puede ser hiriente para otras personas alrededor, o incluso para Weinan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72169,
                      "answer_id":30307,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:54.072Z",
                      "updated_at":"2022-01-10T23:23:54.072Z",
                      "text":"Сказать что-нибудь. Имитация акцента — это оскорбительно. Это может унизить тех, кто это услышит, и даже Вейнаня.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72168,
                      "answer_id":30307,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:54.067Z",
                      "updated_at":"2022-01-10T23:23:54.067Z",
                      "text":"Odezwać się. Wyśmiewanie się z akcentu jest obraźliwe. Może to być krzywdzące dla innych osób w pobliżu — nawet dla Weinana.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72167,
                      "answer_id":30307,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:54.062Z",
                      "updated_at":"2022-01-10T23:23:54.062Z",
                      "text":"적절한 말을 한다. 억양을 조롱하는 것은 모욕적인 행동이다. 그것을 들은 사람이나 Weinan에게도 상처를 줄 수 있다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72166,
                      "answer_id":30307,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:54.058Z",
                      "updated_at":"2022-01-10T23:23:54.058Z",
                      "text":"何か言う。訛りをからかうことは侮辱的です。話が聞こえる範囲にいる人や、Weinanさんまでもを傷つける可能性があります。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72165,
                      "answer_id":30307,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:54.053Z",
                      "updated_at":"2022-01-10T23:23:54.053Z",
                      "text":"Dire qualcosa. Deridere un accento è offensivo. Potrebbe essere offensivo per altre persone che possono sentire, o anche per Weinan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72164,
                      "answer_id":30307,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:54.048Z",
                      "updated_at":"2022-01-10T23:23:54.048Z",
                      "text":"Etwas sagen. Über einen Akzent zu spotten, ist beleidigend. Es könnte andere Personen verletzen, die mitgehört haben, oder sogar Weinan selbst.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72163,
                      "answer_id":30307,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:54.043Z",
                      "updated_at":"2022-01-10T23:23:54.043Z",
                      "text":"Dites quelque chose. Se moquer d'un accent est offensant. Cela pourrait être blessant pour d'autres personnes à portée de voix, ou même pour Weinan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72162,
                      "answer_id":30307,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:54.038Z",
                      "updated_at":"2022-01-10T23:23:54.038Z",
                      "text":"Dire quelque chose. Se moquer d’un accent est injurieux. Cela pourrait blesser les autres personnes présentes, ou même Weinan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72161,
                      "answer_id":30307,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:54.033Z",
                      "updated_at":"2022-01-10T23:23:54.033Z",
                      "text":"Diga algo. Zombar de um sotaque é ofensivo. Pode ser ofensivo para outras pessoas que possam ouvir, ou até mesmo para o Weinan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72160,
                      "answer_id":30307,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:54.028Z",
                      "updated_at":"2022-01-10T23:23:54.028Z",
                      "text":"Decir algo. Burlarse de un acento es ofensivo. Podría dañar a las otras personas que lo escuchan, o incluso a Weinan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72159,
                      "answer_id":30307,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:54.022Z",
                      "updated_at":"2022-01-10T23:23:54.022Z",
                      "text":"Magsalita. Nakasasakit ang pangungutya sa punto. Maaaring makasakit ito pandinig ng ibang tao, o kahit kay Weinan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72158,
                      "answer_id":30307,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:54.015Z",
                      "updated_at":"2022-01-10T23:23:54.015Z",
                      "text":"说点什么。模仿别人说话的口音是冒犯行为。别人要是听到了可能受伤害，甚至是 Weinan。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72157,
                      "answer_id":30307,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:54.010Z",
                      "updated_at":"2022-01-10T23:23:54.010Z",
                      "text":"說些甚麼。模仿口音是冒犯人的行為。這麼做可能傷害聽到的人，或甚至 Weinan。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72156,
                      "answer_id":30307,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:54.003Z",
                      "updated_at":"2022-04-21T22:37:32.964Z",
                      "text":"Wait until you get back to the office to tell a colleague what happened.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31708,
                "position":3,
                "active":true,
                "question_id":12045,
                "created_at":"2022-04-21T22:37:42.512Z",
                "updated_at":"2022-04-21T22:37:42.512Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Say something to Ida and Jaylan. Mocking someone’s size and pregnancy is offensive and hurtful.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77378,
                      "answer_id":31708,
                      "locale":"en",
                      "created_at":"2022-04-21T22:37:42.519Z",
                      "updated_at":"2022-04-21T22:37:42.519Z",
                      "text":"Say something to Ida and Jaylan. Mocking someone’s size and pregnancy is offensive and hurtful.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12046,
          "shuffle":false,
          "position":21,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30309"
          ],
          "created_at":"2022-01-10T23:23:54.099Z",
          "updated_at":"2022-04-21T21:31:50.916Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":21,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"How should you respond?\n",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29960,
                "question_id":12046,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:54.240Z",
                "updated_at":"2022-01-10T23:23:54.240Z",
                "text":"Ne yapmalısınız?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29959,
                "question_id":12046,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:54.236Z",
                "updated_at":"2022-01-10T23:23:54.236Z",
                "text":"¿Qué debería hacer?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29958,
                "question_id":12046,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:54.231Z",
                "updated_at":"2022-01-10T23:23:54.231Z",
                "text":"Что вам следует сделать?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29957,
                "question_id":12046,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:54.226Z",
                "updated_at":"2022-01-10T23:23:54.226Z",
                "text":"Co należy zrobić?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29956,
                "question_id":12046,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:54.221Z",
                "updated_at":"2022-01-10T23:23:54.221Z",
                "text":"어떻게 하시겠습니까?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29955,
                "question_id":12046,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:54.216Z",
                "updated_at":"2022-01-10T23:23:54.216Z",
                "text":"あなたは何をすべきでしょうか？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29954,
                "question_id":12046,
                "locale":"it",
                "created_at":"2022-01-10T23:23:54.211Z",
                "updated_at":"2022-01-10T23:23:54.211Z",
                "text":"Che cosa dovresti fare?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29953,
                "question_id":12046,
                "locale":"de",
                "created_at":"2022-01-10T23:23:54.207Z",
                "updated_at":"2022-01-10T23:23:54.207Z",
                "text":"Was sollten Sie tun?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29952,
                "question_id":12046,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:54.201Z",
                "updated_at":"2022-01-10T23:23:54.201Z",
                "text":"Que devriez-vous faire?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29951,
                "question_id":12046,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:54.196Z",
                "updated_at":"2022-01-10T23:23:54.196Z",
                "text":"Que devriez-vous faire ?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29950,
                "question_id":12046,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:54.192Z",
                "updated_at":"2022-01-10T23:23:54.192Z",
                "text":"O que você deve fazer?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29949,
                "question_id":12046,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:54.187Z",
                "updated_at":"2022-01-10T23:23:54.187Z",
                "text":"你應該怎麼做？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29948,
                "question_id":12046,
                "locale":"es",
                "created_at":"2022-01-10T23:23:54.182Z",
                "updated_at":"2022-01-10T23:23:54.182Z",
                "text":"¿Qué debes hacer?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29947,
                "question_id":12046,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:54.176Z",
                "updated_at":"2022-01-10T23:23:54.176Z",
                "text":"Ano ang dapat mong gawin?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29946,
                "question_id":12046,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:54.170Z",
                "updated_at":"2022-01-10T23:23:54.170Z",
                "text":"我们应怎么做？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29945,
                "question_id":12046,
                "locale":"en",
                "created_at":"2022-01-10T23:23:54.119Z",
                "updated_at":"2022-04-21T21:31:50.918Z",
                "text":"How should you respond?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30308,
                "position":1,
                "active":true,
                "question_id":12046,
                "created_at":"2022-01-10T23:23:54.247Z",
                "updated_at":"2022-04-21T21:33:35.200Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Say nothing. After all, you walked in on a private conversation.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72172,
                      "answer_id":30308,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:54.261Z",
                      "updated_at":"2022-04-21T21:33:35.204Z",
                      "text":"Say nothing. After all, you walked in on a private conversation.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72187,
                      "answer_id":30308,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:54.331Z",
                      "updated_at":"2022-01-10T23:23:54.331Z",
                      "text":"Hiçbir şey söylemeyin. Jessica, Kim'e iltifat ediyor ve Kim gülümsüyor.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72186,
                      "answer_id":30308,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:54.326Z",
                      "updated_at":"2022-01-10T23:23:54.326Z",
                      "text":"No decir nada. Jessica le hace un cumplido a Kim y Kim sonrió.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72185,
                      "answer_id":30308,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:54.321Z",
                      "updated_at":"2022-01-10T23:23:54.321Z",
                      "text":"Ничего не говорить. Джессика сделала Ким комплимент, к тому же Ким улыбнулась.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72184,
                      "answer_id":30308,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:54.317Z",
                      "updated_at":"2022-01-10T23:23:54.317Z",
                      "text":"Nie należy nic mówić. Jessica komplementuje Kim, a poza tym Kim się uśmiechnęła.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72183,
                      "answer_id":30308,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:54.312Z",
                      "updated_at":"2022-01-10T23:23:54.312Z",
                      "text":"아무 말도 하지 않는다. Jessica는 칭찬을 하고 있고, Kim도 그 말을 듣고 웃었다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72182,
                      "answer_id":30308,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:54.308Z",
                      "updated_at":"2022-01-10T23:23:54.308Z",
                      "text":"何も言わない。JessicaさんはKimさんを参照しており、Kimさんも笑顔です。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72181,
                      "answer_id":30308,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:54.303Z",
                      "updated_at":"2022-01-10T23:23:54.303Z",
                      "text":"Non dire nulla. Jessica sta esprimendo un complimento a Kim e, inoltre, quest’ultima ha sorriso.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72180,
                      "answer_id":30308,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:54.298Z",
                      "updated_at":"2022-01-10T23:23:54.298Z",
                      "text":"Nichts sagen. Jessica hat Kim ein Kompliment gemacht. Außerdem hat Kim gelächelt.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72179,
                      "answer_id":30308,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:54.294Z",
                      "updated_at":"2022-01-10T23:23:54.294Z",
                      "text":"Ne rien dire. Jessica fait un compliment à Kim, et en plus, Kim a souri.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72178,
                      "answer_id":30308,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:54.289Z",
                      "updated_at":"2022-01-10T23:23:54.289Z",
                      "text":"Não dizer nada. Jessica está fazendo um elogio a Kim e, além disso, Kim sorriu.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72177,
                      "answer_id":30308,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:54.284Z",
                      "updated_at":"2022-01-10T23:23:54.284Z",
                      "text":"Ne rien dire. Jessica fait un compliment à Kim, et en plus, Kim a souri.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72176,
                      "answer_id":30308,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:54.279Z",
                      "updated_at":"2022-01-10T23:23:54.279Z",
                      "text":"No decir nada. Jessica está elogiando a Kim. Además, Kim sonrió.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72175,
                      "answer_id":30308,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:54.274Z",
                      "updated_at":"2022-01-10T23:23:54.274Z",
                      "text":"Hindi umiimik. Binibigyan ni Jessica si Kim ng papuri, at bukod diyan, napangiti si Kim.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72174,
                      "answer_id":30308,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:54.270Z",
                      "updated_at":"2022-01-10T23:23:54.270Z",
                      "text":"一言不发。Jessica 是在赞美 Kim，而且 Kim 是微笑的。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72173,
                      "answer_id":30308,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:54.265Z",
                      "updated_at":"2022-01-10T23:23:54.265Z",
                      "text":"甚麼都不說。Jessica 正在讚美 Kim，Kim 微笑著。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30309,
                "position":2,
                "active":true,
                "question_id":12046,
                "created_at":"2022-01-10T23:23:54.337Z",
                "updated_at":"2022-04-21T21:33:44.076Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell Zehra that Kyle's outburst was inappropriate.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72203,
                      "answer_id":30309,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:54.428Z",
                      "updated_at":"2022-01-10T23:23:54.428Z",
                      "text":"Müdahale edin. Kim, Jessica'nın ırkı, kocasının görünüşü veya çocuk sahibi olma olasılığı hakkında yorum yapması konusunda rahatsız olmuş olabilir. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72202,
                      "answer_id":30309,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:54.423Z",
                      "updated_at":"2022-01-10T23:23:54.423Z",
                      "text":"Intervenir. Es posible que Kim se haya sentido incómoda con los comentarios de Jessica sobre su raza, el aspecto de su marido o la perspectiva de tener hijos. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72201,
                      "answer_id":30309,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:54.418Z",
                      "updated_at":"2022-01-10T23:23:54.418Z",
                      "text":"Вмешаться. Возможно, Ким было некомфортно слышать, как Джессика комментирует ее расу, внешность ее мужа и будущих детей. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72200,
                      "answer_id":30309,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:54.412Z",
                      "updated_at":"2022-01-10T23:23:54.412Z",
                      "text":"Zainterweniować. Kim mogła poczuć się niekomfortowo, gdy Jessica komentowała jej rasę, wygląd jej męża lub perspektywę posiadania dzieci. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72199,
                      "answer_id":30309,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:54.407Z",
                      "updated_at":"2022-01-10T23:23:54.407Z",
                      "text":"개입한다. Kim은 Jessica가 자신의 인종, 남편의 외모 또는 아이를 가질 가능성에 대해 언급하는 것에 불편함을 느꼈을 수 있다. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72198,
                      "answer_id":30309,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:54.402Z",
                      "updated_at":"2022-01-10T23:23:54.402Z",
                      "text":"介入する。Kimさんは、Jessicaさんが彼女の人種、旦那さんの人種、または子供を持つという見通しに関して批評することに対して、不快に思ったかもしれません。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72197,
                      "answer_id":30309,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:54.398Z",
                      "updated_at":"2022-01-10T23:23:54.398Z",
                      "text":"Intervenire. Kim potrebbe essersi sentita a disagio per il fatto che Jessica ha espresso dei commentato sulla sua razza, sull’aspetto di suo marito o sulla prospettiva di avere figli. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72196,
                      "answer_id":30309,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:54.393Z",
                      "updated_at":"2022-01-10T23:23:54.393Z",
                      "text":"Eingreifen. Jessicas Kommentar zu Kims Rasse, dem Aussehen ihres Ehemannes und dem Kinderkriegen hat bei ihr möglicherweise Unbehagen ausgelöst. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72195,
                      "answer_id":30309,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:54.386Z",
                      "updated_at":"2022-01-10T23:23:54.386Z",
                      "text":"Intervenant. Kim s'est peut-être sentie mal à l'aise à l'idée que Jessica fasse des commentaires sur sa race, l'apparence de son mari ou la perspective d'avoir des enfants. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72194,
                      "answer_id":30309,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:54.380Z",
                      "updated_at":"2022-01-10T23:23:54.380Z",
                      "text":"Intervenir. Kim se sentait peut-être mal à l’aise à l’idée que Jessica fasse des commentaires sur sa race, l’apparence de son mari ou la perspective d’avoir des enfants. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72193,
                      "answer_id":30309,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:54.375Z",
                      "updated_at":"2022-01-10T23:23:54.375Z",
                      "text":"Intervir. Kim pode ter se sentido desconfortável com a Jessica fazendo comentários sobre sua raça, a aparência de seu marido ou a perspectiva de ter filhos. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72192,
                      "answer_id":30309,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:54.370Z",
                      "updated_at":"2022-01-10T23:23:54.370Z",
                      "text":"Intervenir. Kim podría haberse sentido incómoda con los comentarios de Jessica sobre su raza, el aspecto de su esposo o la idea de tener hijos. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72191,
                      "answer_id":30309,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:54.366Z",
                      "updated_at":"2022-01-10T23:23:54.366Z",
                      "text":"Makialam. Maaaring hindi komportable si Kim tungkol sa pagkokomento ni Jessica tungkol sa kanyang lahi, hitsura ng kanyang asawa, o pag-asang magkaroon ng mga anak. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72190,
                      "answer_id":30309,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:54.361Z",
                      "updated_at":"2022-01-10T23:23:54.361Z",
                      "text":"干预。对于 Jessica 对其种族、她丈夫外表的评论或生孩子的预期，Kim 可能会感到不自在。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72189,
                      "answer_id":30309,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:54.356Z",
                      "updated_at":"2022-01-10T23:23:54.356Z",
                      "text":"介入。Kim 對於 Jessica 評論她的種族、丈夫的外觀或生小孩可能性的評論感到不自在。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72188,
                      "answer_id":30309,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:54.352Z",
                      "updated_at":"2022-04-21T21:33:44.078Z",
                      "text":"Tell Zehra that Kyle's outburst was inappropriate.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31696,
                "position":3,
                "active":true,
                "question_id":12046,
                "created_at":"2022-04-21T21:33:56.513Z",
                "updated_at":"2022-04-21T21:33:56.513Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Immediately report what you saw to human resources or another appropriate channel  according to our organization's policy.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77366,
                      "answer_id":31696,
                      "locale":"en",
                      "created_at":"2022-04-21T21:33:56.541Z",
                      "updated_at":"2022-04-21T21:33:56.541Z",
                      "text":"Immediately report what you saw to human resources or another appropriate channel  according to our organization's policy.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12047,
          "shuffle":false,
          "position":22,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30311"
          ],
          "created_at":"2022-01-10T23:23:54.449Z",
          "updated_at":"2022-01-10T23:23:54.794Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":22,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What should you do?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29976,
                "question_id":12047,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:54.605Z",
                "updated_at":"2022-01-10T23:23:54.605Z",
                "text":"Ne yapmalısınız?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29975,
                "question_id":12047,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:54.600Z",
                "updated_at":"2022-01-10T23:23:54.600Z",
                "text":"¿Qué debería hacer?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29974,
                "question_id":12047,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:54.595Z",
                "updated_at":"2022-01-10T23:23:54.595Z",
                "text":"Что вам следует сделать?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29973,
                "question_id":12047,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:54.585Z",
                "updated_at":"2022-01-10T23:23:54.585Z",
                "text":"Co należy zrobić?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29972,
                "question_id":12047,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:54.580Z",
                "updated_at":"2022-01-10T23:23:54.580Z",
                "text":"어떻게 하시겠습니까?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29971,
                "question_id":12047,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:54.575Z",
                "updated_at":"2022-01-10T23:23:54.575Z",
                "text":"あなたは何をすべきでしょうか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29970,
                "question_id":12047,
                "locale":"it",
                "created_at":"2022-01-10T23:23:54.570Z",
                "updated_at":"2022-01-10T23:23:54.570Z",
                "text":"Che cosa dovresti fare?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29969,
                "question_id":12047,
                "locale":"de",
                "created_at":"2022-01-10T23:23:54.566Z",
                "updated_at":"2022-01-10T23:23:54.566Z",
                "text":"Was sollten Sie tun?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29968,
                "question_id":12047,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:54.561Z",
                "updated_at":"2022-01-10T23:23:54.561Z",
                "text":"Que devriez-vous faire?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29967,
                "question_id":12047,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:54.556Z",
                "updated_at":"2022-01-10T23:23:54.556Z",
                "text":"Que devriez-vous faire ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29966,
                "question_id":12047,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:54.551Z",
                "updated_at":"2022-01-10T23:23:54.551Z",
                "text":"O que você deve fazer?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29965,
                "question_id":12047,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:54.547Z",
                "updated_at":"2022-01-10T23:23:54.547Z",
                "text":"你應該怎麼做？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29964,
                "question_id":12047,
                "locale":"es",
                "created_at":"2022-01-10T23:23:54.542Z",
                "updated_at":"2022-01-10T23:23:54.542Z",
                "text":"¿Qué debes hacer?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29963,
                "question_id":12047,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:54.537Z",
                "updated_at":"2022-01-10T23:23:54.537Z",
                "text":"Ano ang dapat mong gawin?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29962,
                "question_id":12047,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:54.532Z",
                "updated_at":"2022-01-10T23:23:54.532Z",
                "text":"我们应怎么做？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29961,
                "question_id":12047,
                "locale":"en",
                "created_at":"2022-01-10T23:23:54.474Z",
                "updated_at":"2022-01-10T23:23:54.474Z",
                "text":"What should you do?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30310,
                "position":1,
                "active":true,
                "question_id":12047,
                "created_at":"2022-01-10T23:23:54.612Z",
                "updated_at":"2022-01-10T23:23:54.612Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Leave it be. David is acting in Phil’s best interest, and besides, Phil won’t be hurt if he doesn’t know about the event.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72219,
                      "answer_id":30310,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:54.697Z",
                      "updated_at":"2022-01-10T23:23:54.697Z",
                      "text":"Karışmayın. David, Phil'in çıkarına olacak şekilde davranmaktadır ve olaydan haberi olmazsa Phil incinmeyecektir.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72218,
                      "answer_id":30310,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:54.692Z",
                      "updated_at":"2022-01-10T23:23:54.692Z",
                      "text":"Dejarlo así. David actúa en beneficio de Phil. Phil no se verá afectado si no se entera del evento.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72217,
                      "answer_id":30310,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:54.687Z",
                      "updated_at":"2022-01-10T23:23:54.687Z",
                      "text":"Не вмешиваться. Дэвид действует на благо Фила, к тому же Фил не обидится, если не узнает о происшествии.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72216,
                      "answer_id":30310,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:54.683Z",
                      "updated_at":"2022-01-10T23:23:54.683Z",
                      "text":"Zostawić to. David działa w najlepszym interesie Phila, a poza tym Philowi nic się nie stanie, jeśli nie będzie wiedział o tym wydarzeniu.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72215,
                      "answer_id":30310,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:54.678Z",
                      "updated_at":"2022-01-10T23:23:54.678Z",
                      "text":"그대로 둔다. David는 Phil을 위해 행동하고 있으며, Phil이 그 일에 대해 알지 못하면 상처가 되지는 않을 것이다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72214,
                      "answer_id":30310,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:54.673Z",
                      "updated_at":"2022-01-10T23:23:54.673Z",
                      "text":"そのままにする。DavidさんはPhilさんのためを思って行動しており、イベントについてPhilさんが知らなかったとしても彼が傷付くことはありません。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72213,
                      "answer_id":30310,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:54.669Z",
                      "updated_at":"2022-01-10T23:23:54.669Z",
                      "text":"Lasciar stare. David sta agendo nel migliore interesse di Phil, e inoltre, Phil non sarà ferito se non viene a conoscenza dell’evento.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72212,
                      "answer_id":30310,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:54.664Z",
                      "updated_at":"2022-01-10T23:23:54.664Z",
                      "text":"Nichts unternehmen. David handelt in Phils bestem Interesse. Außerdem wird Phil es nicht verletzen, wenn er nichts von dem Event weiß.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72211,
                      "answer_id":30310,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:54.658Z",
                      "updated_at":"2022-01-10T23:23:54.658Z",
                      "text":"Laissez couler. David agit dans le meilleur intérêt de Phil, et de plus, Phil ne sera pas blessé s'il ne connaît pas l'événement.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72210,
                      "answer_id":30310,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:54.654Z",
                      "updated_at":"2022-01-10T23:23:54.654Z",
                      "text":"Ne rien faire. David agit dans l’intérêt de Phil. Et puis, Phil ne sera pas vexé s’il ignore tout de ce qui s’est passé.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72209,
                      "answer_id":30310,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:54.649Z",
                      "updated_at":"2022-01-10T23:23:54.649Z",
                      "text":"Deixar para lá. David está agindo no melhor interesse de Phil e, além disso, Phil não se ofenderá se ele não souber sobre o evento.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72208,
                      "answer_id":30310,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:54.644Z",
                      "updated_at":"2022-01-10T23:23:54.644Z",
                      "text":"别管它。David 的行为是为了 Phil 好，而且如果 Phil 不知道该活动，它是不会受伤害的。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72207,
                      "answer_id":30310,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:54.640Z",
                      "updated_at":"2022-01-10T23:23:54.640Z",
                      "text":"Olvidarlo. David actúe en el mejor interés de Phil y, además, Phil no se sentirá mal si no sabe sobre el evento.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72206,
                      "answer_id":30310,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:54.634Z",
                      "updated_at":"2022-01-10T23:23:54.634Z",
                      "text":"Hayaan na lang. Kumikilos si David para sa ikabubuti ni Phil, at bukod diyan, hindi masasaktan si Phil kung hindi niya alam ang tungkol sa kaganapan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72205,
                      "answer_id":30310,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:54.630Z",
                      "updated_at":"2022-01-10T23:23:54.630Z",
                      "text":"隨他去。David 是為了 Phil 的利益著想，除此之外，Phil 不知道這個活動就不會受到傷害。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72204,
                      "answer_id":30310,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:54.626Z",
                      "updated_at":"2022-01-10T23:23:54.626Z",
                      "text":"Leave it be. David is acting in Phil’s best interest, and besides, Phil won’t be hurt if he doesn’t know about the event.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30311,
                "position":2,
                "active":true,
                "question_id":12047,
                "created_at":"2022-01-10T23:23:54.703Z",
                "updated_at":"2022-01-10T23:23:54.703Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Intervene. David is making a negative assumption about Phil based on his national origin.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72235,
                      "answer_id":30311,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:54.789Z",
                      "updated_at":"2022-01-10T23:23:54.789Z",
                      "text":"Müdahale edin. David, Phil'in ulusal kökeni hakkında olumsuz bir varsayımda bulunuyor.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72234,
                      "answer_id":30311,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:54.783Z",
                      "updated_at":"2022-01-10T23:23:54.783Z",
                      "text":"Intervenir. David hace una suposición negativa sobre Phil basada en su origen nacional.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72233,
                      "answer_id":30311,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:54.779Z",
                      "updated_at":"2022-01-10T23:23:54.779Z",
                      "text":"Вмешаться. Дэвид озвучивает негативные предположения о Филе, исходя из его национального происхождения.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72232,
                      "answer_id":30311,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:54.774Z",
                      "updated_at":"2022-01-10T23:23:54.774Z",
                      "text":"Zainterweniować. David wysuwa negatywne przypuszczenia na temat Phila na podstawie jego kraju pochodzenia.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72231,
                      "answer_id":30311,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:54.769Z",
                      "updated_at":"2022-01-10T23:23:54.769Z",
                      "text":"개입한다. David는 Phil의 출신국을 근거로 그에 대해 부정적인 추정을 하고 있다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72230,
                      "answer_id":30311,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:54.765Z",
                      "updated_at":"2022-01-10T23:23:54.765Z",
                      "text":"介入する。Davidさんは、Philさんの国籍に基づいて、否定的な思い込みをしています。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72229,
                      "answer_id":30311,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:54.760Z",
                      "updated_at":"2022-01-10T23:23:54.760Z",
                      "text":"Intervenire. David sta esprimendo una supposizione negativa su Phil sulla base della sua origine.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72228,
                      "answer_id":30311,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:54.755Z",
                      "updated_at":"2022-01-10T23:23:54.755Z",
                      "text":"Eingreifen. David äußert eine negative Annahme über Phil, die auf dessen Herkunft basiert.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72227,
                      "answer_id":30311,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:54.750Z",
                      "updated_at":"2022-01-10T23:23:54.750Z",
                      "text":"Intervenant. David énonce une hypothèse négative sur Phil en fonction de son origine nationale.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72226,
                      "answer_id":30311,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:54.745Z",
                      "updated_at":"2022-01-10T23:23:54.745Z",
                      "text":"Intervenir. David fait une supposition négative sur Phil en fonction de son origine nationale.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72225,
                      "answer_id":30311,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:54.741Z",
                      "updated_at":"2022-01-10T23:23:54.741Z",
                      "text":"介入。David 因為 Phil 的國籍對他做了負面的預設立場。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72224,
                      "answer_id":30311,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:54.736Z",
                      "updated_at":"2022-01-10T23:23:54.736Z",
                      "text":"干预。David 是在因为 Phil 的原国籍而进行负面的猜测。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72223,
                      "answer_id":30311,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:54.731Z",
                      "updated_at":"2022-01-10T23:23:54.731Z",
                      "text":"Intervir. David está fazendo uma suposição negativa sobre Phil com base em sua nacionalidade.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72222,
                      "answer_id":30311,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:54.726Z",
                      "updated_at":"2022-01-10T23:23:54.726Z",
                      "text":"Makialam. Gumagawa ng negatibong palagay si David tungkol kay Phil batay sa kanyang bansang pinagmulan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72221,
                      "answer_id":30311,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:54.720Z",
                      "updated_at":"2022-01-10T23:23:54.720Z",
                      "text":"Intervenir. David está realizando una suposición negativa sobre Phil basado en su nacionalidad de origen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72220,
                      "answer_id":30311,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:54.716Z",
                      "updated_at":"2022-01-10T23:23:54.716Z",
                      "text":"Intervene. David is making a negative assumption about Phil based on his national origin.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12048,
          "shuffle":false,
          "position":23,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30313"
          ],
          "created_at":"2022-01-10T23:23:54.806Z",
          "updated_at":"2022-04-21T21:44:38.202Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":23,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best action for Kiara to take?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":29977,
                "question_id":12048,
                "locale":"en",
                "created_at":"2022-01-10T23:23:54.826Z",
                "updated_at":"2022-04-21T21:44:38.204Z",
                "text":"What is the best action for Kiara to take?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29992,
                "question_id":12048,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:54.953Z",
                "updated_at":"2022-01-10T23:23:54.953Z",
                "text":"Ne yapmalıdır? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29991,
                "question_id":12048,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:54.948Z",
                "updated_at":"2022-01-10T23:23:54.948Z",
                "text":"¿Qué debe hacer? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29990,
                "question_id":12048,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:54.943Z",
                "updated_at":"2022-01-10T23:23:54.943Z",
                "text":"Что ей делать? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29989,
                "question_id":12048,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:54.938Z",
                "updated_at":"2022-01-10T23:23:54.938Z",
                "text":"Co powinna zrobić? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29988,
                "question_id":12048,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:54.934Z",
                "updated_at":"2022-01-10T23:23:54.934Z",
                "text":"그녀는 어떤 행동을 취해야 합니까? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29987,
                "question_id":12048,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:54.929Z",
                "updated_at":"2022-01-10T23:23:54.929Z",
                "text":"彼女は何をすべきですか？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29986,
                "question_id":12048,
                "locale":"it",
                "created_at":"2022-01-10T23:23:54.925Z",
                "updated_at":"2022-01-10T23:23:54.925Z",
                "text":"Che cosa dovrebbe fare? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29985,
                "question_id":12048,
                "locale":"de",
                "created_at":"2022-01-10T23:23:54.920Z",
                "updated_at":"2022-01-10T23:23:54.920Z",
                "text":"Was soll sie tun? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29984,
                "question_id":12048,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:54.915Z",
                "updated_at":"2022-01-10T23:23:54.915Z",
                "text":"Que devrait-elle faire? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29983,
                "question_id":12048,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:54.910Z",
                "updated_at":"2022-01-10T23:23:54.910Z",
                "text":"Que devrait-elle faire ? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29982,
                "question_id":12048,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:54.905Z",
                "updated_at":"2022-01-10T23:23:54.905Z",
                "text":"O que ela deve fazer? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29981,
                "question_id":12048,
                "locale":"es",
                "created_at":"2022-01-10T23:23:54.900Z",
                "updated_at":"2022-01-10T23:23:54.900Z",
                "text":"¿Qué debe hacer? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29980,
                "question_id":12048,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:54.896Z",
                "updated_at":"2022-01-10T23:23:54.896Z",
                "text":"Ano ang dapat niyang gawin? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29979,
                "question_id":12048,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:54.891Z",
                "updated_at":"2022-01-10T23:23:54.891Z",
                "text":"她应该怎么做？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29978,
                "question_id":12048,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:54.885Z",
                "updated_at":"2022-01-10T23:23:54.885Z",
                "text":"她應該怎麼做？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30312,
                "position":1,
                "active":true,
                "question_id":12048,
                "created_at":"2022-01-10T23:23:54.972Z",
                "updated_at":"2022-04-21T21:44:45.095Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Speak up. It's the right thing to do and the only good option, no matter how uncomfortable Kiara may feel.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72236,
                      "answer_id":30312,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:54.986Z",
                      "updated_at":"2022-04-21T21:44:45.099Z",
                      "text":"Speak up. It's the right thing to do and the only good option, no matter how uncomfortable Kiara may feel.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72251,
                      "answer_id":30312,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:55.064Z",
                      "updated_at":"2022-01-10T23:23:55.064Z",
                      "text":"Görmezden gelin. Priti, mentorunun müdahalesini nasıl yorumlayacağını bilmiyor. Sorun çıkaran biri olarak mı görünecek yoksa utanç verici bir duruma mı düşecek? En iyi çözüm konuyu uzun süredir birlikte olan diğer insanlara bırakmaktır.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72250,
                      "answer_id":30312,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:55.059Z",
                      "updated_at":"2022-01-10T23:23:55.059Z",
                      "text":"Ignorarlo. Priti no sabe cómo interpretará su mentor su intervención. ¿La verán como una persona alarmista o se avergonzará a sí misma? Es mejor dejarlo en manos de otras personas que llevan más tiempo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72249,
                      "answer_id":30312,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:55.055Z",
                      "updated_at":"2022-01-10T23:23:55.055Z",
                      "text":"Игнорировать. Прити не знает, как наставник истолкует ее вмешательство. Вдруг ее посчитают возмутительницей спокойствия, или она опозорится? Пусть лучше этим занимаются те, кто дольше тут работает.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72248,
                      "answer_id":30312,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:55.050Z",
                      "updated_at":"2022-01-10T23:23:55.050Z",
                      "text":"Zignorować to. Priti nie wie, jak jej mentor zinterpretuje jej interwencję. Czy będzie postrzegana jako wichrzycielka, czy też będzie się wstydzić? Lepiej zostawić to innym osobom, które są tam dłużej.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72247,
                      "answer_id":30312,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:55.045Z",
                      "updated_at":"2022-01-10T23:23:55.045Z",
                      "text":"무시한다. Priti는 멘토가 자신의 개입에 대해 어떻게 생각할지 모른다. 문제를 일으키고 있다고 보여지거나 창피를 당할 수도 있다. 더 오래 직장을 다닌 사람들에게 맡기는 것이 낫다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72246,
                      "answer_id":30312,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:55.040Z",
                      "updated_at":"2022-01-10T23:23:55.040Z",
                      "text":"無視する。Pritiさんは、彼女が介入することに関して、彼女のメンターがどのように解釈するか知りません。トラブルメーカーとしてみられるでしょうか、恥をかいてしまうでしょうか？勤続年数がより長い人に任せた方がいいです。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72245,
                      "answer_id":30312,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:55.035Z",
                      "updated_at":"2022-01-10T23:23:55.035Z",
                      "text":"Ignorarlo. Priti non sa come il suo mentore interpreterà il suo intervento. Verrà considerata una piantagrane o si sentirà in imbarazzo? Meglio lasciare la gestione della questione ad altre persone che sono lì da più tempo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72244,
                      "answer_id":30312,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:55.028Z",
                      "updated_at":"2022-01-10T23:23:55.028Z",
                      "text":"Ignorieren. Priti weiß nicht, wie ihr Mentor ihr Eingreifen interpretieren wird. Wird sie als Unruhestifter angesehen oder sich selbst in Verlegenheit bringen? Besser, man überlässt das anderen, die schon länger hier sind.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72243,
                      "answer_id":30312,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:55.023Z",
                      "updated_at":"2022-01-10T23:23:55.023Z",
                      "text":"Ignorez ça. Priti ne sait pas comment son mentor interprétera son intervention. Sera-t-elle considérée comme un fauteuse de troubles ou s'embarrassera-t-elle? Mieux vaut laisser ça à d'autres personnes qui sont là depuis plus longtemps.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72242,
                      "answer_id":30312,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:55.017Z",
                      "updated_at":"2022-01-10T23:23:55.017Z",
                      "text":"Ne pas y prêter attention. Priti ignore comment son mentor interprétera son intervention. Sera-t-elle considérée comme une fauteuse de troubles ? Se rendra-t-elle ridicule ? Mieux vaut laisser l’initiative aux autres personnes qui sont là depuis plus longtemps.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72241,
                      "answer_id":30312,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:55.012Z",
                      "updated_at":"2022-01-10T23:23:55.012Z",
                      "text":"Ignorar. Priti não sabe como seu mentor interpretará sua intervenção. Ela será vista como uma encrenqueira ou se envergonhará? Melhor deixar isso para outras pessoas que estão lá há mais tempo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72240,
                      "answer_id":30312,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:55.007Z",
                      "updated_at":"2022-01-10T23:23:55.007Z",
                      "text":"Ignorarla. Priti no sabe que cómo su mentor puede interpretar su intervención. ¿Será considerada como una persona que busca problemas o se avergonzará? Es mejor dejarlo a otras personas que hayan trabajado allí por más tiempo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72239,
                      "answer_id":30312,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:55.000Z",
                      "updated_at":"2022-01-10T23:23:55.000Z",
                      "text":"Huwag itong pansinin. Hindi alam ni Priti kung paano bibigyang kahulugan ng kanyang tagapagturo ang kanyang panghihimasok. Makikita ba siya bilang isang nagkakagulo o nakakahiya sa sarili? Mas makabubuting hayaan na sa ibang tao na naroon na nang mas matagal.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72238,
                      "answer_id":30312,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:54.995Z",
                      "updated_at":"2022-01-10T23:23:54.995Z",
                      "text":"视而不见。Priti 不知道她的导师会如何解读她的干预。她会被看做是麻烦制造者或让她自己难堪吗？最好将这件事留给在这里呆的更久的人处理。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72237,
                      "answer_id":30312,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:54.990Z",
                      "updated_at":"2022-01-10T23:23:54.990Z",
                      "text":"忽略。Priti 不知道她的導師如何解讀她的介入。她是否會被視為麻煩製造者或她只是讓自己難堪？最好由其他待得較久的人決定。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30313,
                "position":2,
                "active":true,
                "question_id":12048,
                "created_at":"2022-01-10T23:23:55.070Z",
                "updated_at":"2022-04-21T21:44:56.416Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Speak up in the moment or check in with Phillip later to offer support. Also, Kiara should consider reporting what she witnessed to human resources or another appropriate channel.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72267,
                      "answer_id":30313,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:55.157Z",
                      "updated_at":"2022-01-10T23:23:55.157Z",
                      "text":"Bir şey söyleyin. Belki rahatsız edici olabilir ama yapılacak doğru şey bu. Ayrıca, mantıklı herhangi bir mentor destekleyici olmaz mıydı?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72266,
                      "answer_id":30313,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:55.151Z",
                      "updated_at":"2022-01-10T23:23:55.151Z",
                      "text":"Decir algo. Tal vez sea incómodo, pero es lo correcto, ¿y no ofrecería su apoyo ningún mentor razonable?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72265,
                      "answer_id":30313,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:55.146Z",
                      "updated_at":"2022-01-10T23:23:55.146Z",
                      "text":"Сказать что-нибудь. Возможно, будет неудобно, но это нужно сделать — тем более разве наставник не должен ее поддерживать?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72264,
                      "answer_id":30313,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:55.141Z",
                      "updated_at":"2022-01-10T23:23:55.141Z",
                      "text":"Odezwać się. Może to będzie niewygodne, ale tak należy postąpić. Czy rozsądny mentor nie udzieliłby wsparcia?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72263,
                      "answer_id":30313,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:55.136Z",
                      "updated_at":"2022-01-10T23:23:55.136Z",
                      "text":"적절한 말을 한다. 불편할 수도 있지만 해야 할 일이다. 합리적인 멘토라면 도움을 주는 게 당연하지 않을까?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72262,
                      "answer_id":30313,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:55.132Z",
                      "updated_at":"2022-01-10T23:23:55.132Z",
                      "text":"何か言う。抵抗があるかもしれませんが、これは行うべき正しいことです。それに、合理的なメンターは皆、協力的であるべきではないでしょうか？",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72261,
                      "answer_id":30313,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:55.127Z",
                      "updated_at":"2022-01-10T23:23:55.127Z",
                      "text":"Dire qualcosa. Forse sarà spiacevole, ma è l’azione giusta da compiere e nessun mentore ragionevole sarebbe di supporto?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72260,
                      "answer_id":30313,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:55.122Z",
                      "updated_at":"2022-01-10T23:23:55.122Z",
                      "text":"Etwas sagen. Vielleicht wird es etwas unangenehm, aber es ist die richtige Entscheidung. Jeder anständige Mentor würde sie unterstützen, oder nicht?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72259,
                      "answer_id":30313,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:55.117Z",
                      "updated_at":"2022-01-10T23:23:55.117Z",
                      "text":"Dites quelque chose. Ce sera peut-être inconfortable, mais c'est la bonne chose à faire - et un mentor raisonnable ne serait-il pas favorable?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72258,
                      "answer_id":30313,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:55.112Z",
                      "updated_at":"2022-01-10T23:23:55.112Z",
                      "text":"Dire quelque chose. Ce sera peut-être gênant, mais c’est la bonne façon d’agir. Et puis, tout mentor raisonnable serait d’accord, non ?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72257,
                      "answer_id":30313,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:55.107Z",
                      "updated_at":"2022-01-10T23:23:55.107Z",
                      "text":"Diga algo. Talvez seja desconfortável, mas é a coisa certa a fazer, e qualquer mentor razoável não apoiaria?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72256,
                      "answer_id":30313,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:55.103Z",
                      "updated_at":"2022-01-10T23:23:55.103Z",
                      "text":"說些甚麼。這麼做或許會不自在，但是那是對的事—而且任何理智的導師不就是應該給予扶助嗎？",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72255,
                      "answer_id":30313,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:55.097Z",
                      "updated_at":"2022-01-10T23:23:55.097Z",
                      "text":"Decir algo. Tal vez sea incómodo, pero es lo correcto. ¿Una persona razonable no ofrecería su apoyo?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72254,
                      "answer_id":30313,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:55.093Z",
                      "updated_at":"2022-01-10T23:23:55.093Z",
                      "text":"Magsalita. Marahil ay hindi komportable, pero iyon ang tamang gawin—at walang sinumang makatwirang tagapagturo ang magiging matulungin?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72253,
                      "answer_id":30313,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:55.088Z",
                      "updated_at":"2022-01-10T23:23:55.088Z",
                      "text":"说点什么。或许这样做会让人感到不自在，但这样做是正确的，懂情理的讲师难道不应该提供支持吗？",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72252,
                      "answer_id":30313,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:55.083Z",
                      "updated_at":"2022-04-21T21:44:56.418Z",
                      "text":"Speak up in the moment or check in with Phillip later to offer support. Also, Kiara should consider reporting what she witnessed to human resources or another appropriate channel.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31697,
                "position":3,
                "active":true,
                "question_id":12048,
                "created_at":"2022-04-21T21:45:07.746Z",
                "updated_at":"2022-04-21T21:45:07.746Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Say nothing now, but report it to a manager later.  Insist that they keep it completely confidential and not do anything about it.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77367,
                      "answer_id":31697,
                      "locale":"en",
                      "created_at":"2022-04-21T21:45:07.752Z",
                      "updated_at":"2022-04-21T21:45:07.752Z",
                      "text":"Say nothing now, but report it to a manager later.  Insist that they keep it completely confidential and not do anything about it.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12049,
          "shuffle":false,
          "position":24,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30315"
          ],
          "created_at":"2022-01-10T23:23:55.174Z",
          "updated_at":"2022-04-21T21:46:17.909Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":24,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best way for you to respond?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30008,
                "question_id":12049,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:55.322Z",
                "updated_at":"2022-01-10T23:23:55.322Z",
                "text":"Ne yapmalısınız? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30007,
                "question_id":12049,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:55.317Z",
                "updated_at":"2022-01-10T23:23:55.317Z",
                "text":"¿Qué debería hacer? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30006,
                "question_id":12049,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:55.312Z",
                "updated_at":"2022-01-10T23:23:55.312Z",
                "text":"Что вам следует сделать? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30005,
                "question_id":12049,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:55.308Z",
                "updated_at":"2022-01-10T23:23:55.308Z",
                "text":"Co należy zrobić? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30004,
                "question_id":12049,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:55.303Z",
                "updated_at":"2022-01-10T23:23:55.303Z",
                "text":"어떻게 하시겠습니까? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30003,
                "question_id":12049,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:55.298Z",
                "updated_at":"2022-01-10T23:23:55.298Z",
                "text":"あなたは何をすべきでしょうか？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30002,
                "question_id":12049,
                "locale":"it",
                "created_at":"2022-01-10T23:23:55.293Z",
                "updated_at":"2022-01-10T23:23:55.293Z",
                "text":"Che cosa dovresti fare? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30001,
                "question_id":12049,
                "locale":"de",
                "created_at":"2022-01-10T23:23:55.289Z",
                "updated_at":"2022-01-10T23:23:55.289Z",
                "text":"Was sollten Sie tun? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30000,
                "question_id":12049,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:55.284Z",
                "updated_at":"2022-01-10T23:23:55.284Z",
                "text":"Que devriez-vous faire? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29999,
                "question_id":12049,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:55.279Z",
                "updated_at":"2022-01-10T23:23:55.279Z",
                "text":"Que devriez-vous faire ? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29998,
                "question_id":12049,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:55.274Z",
                "updated_at":"2022-01-10T23:23:55.274Z",
                "text":"O que você deve fazer? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29997,
                "question_id":12049,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:55.269Z",
                "updated_at":"2022-01-10T23:23:55.269Z",
                "text":"你應該怎麼做？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29996,
                "question_id":12049,
                "locale":"es",
                "created_at":"2022-01-10T23:23:55.265Z",
                "updated_at":"2022-01-10T23:23:55.265Z",
                "text":"¿Qué debes hacer? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29995,
                "question_id":12049,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:55.260Z",
                "updated_at":"2022-01-10T23:23:55.260Z",
                "text":"Ano ang dapat mong gawin? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29994,
                "question_id":12049,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:55.255Z",
                "updated_at":"2022-01-10T23:23:55.255Z",
                "text":"我们应怎么做？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":29993,
                "question_id":12049,
                "locale":"en",
                "created_at":"2022-01-10T23:23:55.193Z",
                "updated_at":"2022-04-21T21:46:17.911Z",
                "text":"What is the best way for you to respond?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30314,
                "position":1,
                "active":true,
                "question_id":12049,
                "created_at":"2022-01-10T23:23:55.328Z",
                "updated_at":"2022-04-21T21:46:27.498Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Answer the question honestly. Richard is probably asking to see if Amina is OK, and you don’t want him to start rumors.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72268,
                      "answer_id":30314,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:55.341Z",
                      "updated_at":"2022-04-21T21:46:27.501Z",
                      "text":"Answer the question honestly. Richard is probably asking to see if Amina is OK, and you don’t want him to start rumors.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72283,
                      "answer_id":30314,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:55.412Z",
                      "updated_at":"2022-01-10T23:23:55.412Z",
                      "text":"Lucy'nin karşılık vermesini bekleyin. Siz de merak ediyorsunuz! ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72282,
                      "answer_id":30314,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:55.407Z",
                      "updated_at":"2022-01-10T23:23:55.407Z",
                      "text":"Esperar a que Lucy responda. Usted también se lo estaba preguntando. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72281,
                      "answer_id":30314,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:55.403Z",
                      "updated_at":"2022-01-10T23:23:55.403Z",
                      "text":"Подождать, что ответит Люси. Вам тоже вроде как интересно! ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72280,
                      "answer_id":30314,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:55.398Z",
                      "updated_at":"2022-01-10T23:23:55.398Z",
                      "text":"Poczekać na odpowiedź Lucy. Też się nad tym zastanawiałeś(-aś)! ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72279,
                      "answer_id":30314,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:55.393Z",
                      "updated_at":"2022-01-10T23:23:55.393Z",
                      "text":"Lucy가 대응할 때까지 기다린다. 당신도 궁금해 했군요! ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72278,
                      "answer_id":30314,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:55.388Z",
                      "updated_at":"2022-01-10T23:23:55.388Z",
                      "text":"Lucyさんが返答するのを待つ。あなたもなんとなく気になっていましたね！ ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72277,
                      "answer_id":30314,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:55.384Z",
                      "updated_at":"2022-01-10T23:23:55.384Z",
                      "text":"Aspettare la risposta di Lucy. Te lo stavi chiedendo anche tu! ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72276,
                      "answer_id":30314,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:55.379Z",
                      "updated_at":"2022-01-10T23:23:55.379Z",
                      "text":"Auf Lucys Antwort warten. Auch Sie hatten sich gewundert. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72275,
                      "answer_id":30314,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:55.374Z",
                      "updated_at":"2022-01-10T23:23:55.374Z",
                      "text":"Attendez que Lucy réponde. Vous vous posiez aussi la question! ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72274,
                      "answer_id":30314,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:55.369Z",
                      "updated_at":"2022-01-10T23:23:55.369Z",
                      "text":"Attendre la réponse de Lucy. Vous vous demandiez la même chose ! ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72273,
                      "answer_id":30314,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:55.365Z",
                      "updated_at":"2022-01-10T23:23:55.365Z",
                      "text":"Esperar a resposta de Lucy. Você também estava meio que se perguntando! ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72272,
                      "answer_id":30314,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:55.360Z",
                      "updated_at":"2022-01-10T23:23:55.360Z",
                      "text":"等待 Lycy 的反应。你也有点拿不定主意。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72271,
                      "answer_id":30314,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:55.355Z",
                      "updated_at":"2022-01-10T23:23:55.355Z",
                      "text":"Esperar a que Lucy responda. ¡También te lo preguntabas! ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72270,
                      "answer_id":30314,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:55.350Z",
                      "updated_at":"2022-01-10T23:23:55.350Z",
                      "text":"Hintaying tumugon si Lucy. Medyo nagtataka ka rin! ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72269,
                      "answer_id":30314,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:55.345Z",
                      "updated_at":"2022-01-10T23:23:55.345Z",
                      "text":"等待 Lucy 回應。你也是覺得疑惑！ ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30315,
                "position":2,
                "active":true,
                "question_id":12049,
                "created_at":"2022-01-10T23:23:55.418Z",
                "updated_at":"2022-04-21T21:46:41.889Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell Richard that Amina is not pregnant without disclosing the miscarriage.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72299,
                      "answer_id":30315,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:55.503Z",
                      "updated_at":"2022-01-10T23:23:55.503Z",
                      "text":"Müdahale edin. Bu sorular biraz saldırganca!",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72298,
                      "answer_id":30315,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:55.498Z",
                      "updated_at":"2022-01-10T23:23:55.498Z",
                      "text":"Intervenir. Esas preguntas son un poco invasivas.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72297,
                      "answer_id":30315,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:55.493Z",
                      "updated_at":"2022-01-10T23:23:55.493Z",
                      "text":"Вмешаться. Это слишком личные вопросы!",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72296,
                      "answer_id":30315,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:55.488Z",
                      "updated_at":"2022-01-10T23:23:55.488Z",
                      "text":"Zainterweniować. Te pytania są trochę inwazyjne!",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72295,
                      "answer_id":30315,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:55.483Z",
                      "updated_at":"2022-01-10T23:23:55.483Z",
                      "text":"개입한다. 그러한 질문은 다소 무례할 수 있어요!",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72294,
                      "answer_id":30315,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:55.479Z",
                      "updated_at":"2022-01-10T23:23:55.479Z",
                      "text":"介入する。それらの質問は少し侵襲的です！",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72293,
                      "answer_id":30315,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:55.474Z",
                      "updated_at":"2022-01-10T23:23:55.474Z",
                      "text":"Intervenire. Quelle domande sono un po’ invadenti!",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72292,
                      "answer_id":30315,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:55.469Z",
                      "updated_at":"2022-01-10T23:23:55.469Z",
                      "text":"Eingreifen. Diese Fragen sind ein bisschen zu invasiv!",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72291,
                      "answer_id":30315,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:55.464Z",
                      "updated_at":"2022-01-10T23:23:55.464Z",
                      "text":"Intervenant. Ces questions sont un peu envahissantes!",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72290,
                      "answer_id":30315,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:55.460Z",
                      "updated_at":"2022-01-10T23:23:55.460Z",
                      "text":"Intervenir. Ces questions sont plutôt indiscrètes !",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72289,
                      "answer_id":30315,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:55.454Z",
                      "updated_at":"2022-01-10T23:23:55.454Z",
                      "text":"Intervir. Essas perguntas são um pouco invasivas!",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72288,
                      "answer_id":30315,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:55.449Z",
                      "updated_at":"2022-01-10T23:23:55.449Z",
                      "text":"Intervenir. ¡Esas preguntas son un poco invasivas!",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72287,
                      "answer_id":30315,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:55.445Z",
                      "updated_at":"2022-01-10T23:23:55.445Z",
                      "text":"Makialam. Ang mga tanong na iyon ay medyo mapanghusga!",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72286,
                      "answer_id":30315,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:55.440Z",
                      "updated_at":"2022-01-10T23:23:55.440Z",
                      "text":"干预。这些问题有些侵犯个人隐私！",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72285,
                      "answer_id":30315,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:55.435Z",
                      "updated_at":"2022-01-10T23:23:55.435Z",
                      "text":"介入。那些問題有點攻擊性！",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72284,
                      "answer_id":30315,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:55.431Z",
                      "updated_at":"2022-04-21T21:46:41.891Z",
                      "text":"Tell Richard that Amina is not pregnant without disclosing the miscarriage.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31698,
                "position":3,
                "active":true,
                "question_id":12049,
                "created_at":"2022-04-21T21:46:53.748Z",
                "updated_at":"2022-04-21T21:46:53.748Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell Richard that while it’s nice he’s concerned about Amina, you don’t want to talk about a private situation.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77368,
                      "answer_id":31698,
                      "locale":"en",
                      "created_at":"2022-04-21T21:46:53.755Z",
                      "updated_at":"2022-04-21T21:46:53.755Z",
                      "text":"Tell Richard that while it’s nice he’s concerned about Amina, you don’t want to talk about a private situation.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12050,
          "shuffle":false,
          "position":25,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30316",
             "30317"
          ],
          "created_at":"2022-01-10T23:23:55.564Z",
          "updated_at":"2022-01-10T23:23:55.898Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":25,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Would you say you feel more motivated to intervene when you see a problem unfolding?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleResponse",
          "translations":[
             {
                "id":30024,
                "question_id":12050,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:55.713Z",
                "updated_at":"2022-01-10T23:23:55.713Z",
                "text":"Herhangi bir sorun meydana geldiğinde buna müdahale etme konusunda motive olmuş hissediyor musunuz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30023,
                "question_id":12050,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:55.708Z",
                "updated_at":"2022-01-10T23:23:55.708Z",
                "text":"¿Diría que se siente más motivado para intervenir cuando ve que se plantea un problema?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30022,
                "question_id":12050,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:55.703Z",
                "updated_at":"2022-01-10T23:23:55.703Z",
                "text":"Вы скорее готовы вмешаться, когда видите, как разворачиваются события?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30021,
                "question_id":12050,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:55.698Z",
                "updated_at":"2022-01-10T23:23:55.698Z",
                "text":"Czy powiedział(a)byś, że czujesz się bardziej zmotywowany(-a) do interwencji, gdy widzisz, że problem staje się coraz większy?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30020,
                "question_id":12050,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:55.694Z",
                "updated_at":"2022-01-10T23:23:55.694Z",
                "text":"문제가 진행되는 것을 볼 때 개입할 동기가 더 생긴다고 느낍니까?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30019,
                "question_id":12050,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:55.689Z",
                "updated_at":"2022-01-10T23:23:55.689Z",
                "text":"問題が明らかになっていく様子を見た方が、介入することに対してよりやる気がおきると感じますか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30018,
                "question_id":12050,
                "locale":"it",
                "created_at":"2022-01-10T23:23:55.684Z",
                "updated_at":"2022-01-10T23:23:55.684Z",
                "text":"Diresti che ti senti più motivato a intervenire quando osservi un problema che si manifesta?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30017,
                "question_id":12050,
                "locale":"de",
                "created_at":"2022-01-10T23:23:55.679Z",
                "updated_at":"2022-01-10T23:23:55.679Z",
                "text":"Glauben Sie, eher zum Eingreifen motiviert zu sein, wenn Sie sehen, wie ein Problem entsteht?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30016,
                "question_id":12050,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:55.675Z",
                "updated_at":"2022-01-10T23:23:55.675Z",
                "text":"Diriez-vous que vous vous sentez plus motivé à intervenir lorsque vous voyez un problème se dérouler?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30015,
                "question_id":12050,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:55.670Z",
                "updated_at":"2022-01-10T23:23:55.670Z",
                "text":"Diriez-vous que vous vous sentez plus enclin à intervenir lorsque vous constatez qu’un problème se pose ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30014,
                "question_id":12050,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:55.665Z",
                "updated_at":"2022-01-10T23:23:55.665Z",
                "text":"Você diria que se sente mais motivado a intervir quando vê um problema se desenrolar?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30013,
                "question_id":12050,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:55.660Z",
                "updated_at":"2022-01-10T23:23:55.660Z",
                "text":"當你看見問題發生時，你是否認為自己有動力介入？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30012,
                "question_id":12050,
                "locale":"es",
                "created_at":"2022-01-10T23:23:55.655Z",
                "updated_at":"2022-01-10T23:23:55.655Z",
                "text":"¿Dirías que te sientes más motivado para intervenir si ves que se desarrolla un problema?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30011,
                "question_id":12050,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:55.650Z",
                "updated_at":"2022-01-10T23:23:55.650Z",
                "text":"Sasabihin mo ba na mas gusto mong makialam kapag nakakita ka ng isang problema?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30010,
                "question_id":12050,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:55.645Z",
                "updated_at":"2022-01-10T23:23:55.645Z",
                "text":"当你看到问题发生时，你会说你会主动干预吗？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30009,
                "question_id":12050,
                "locale":"en",
                "created_at":"2022-01-10T23:23:55.584Z",
                "updated_at":"2022-01-10T23:23:55.584Z",
                "text":"Would you say you feel more motivated to intervene when you see a problem unfolding?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30316,
                "position":1,
                "active":true,
                "question_id":12050,
                "created_at":"2022-01-10T23:23:55.720Z",
                "updated_at":"2022-01-10T23:23:55.720Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Yes",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72315,
                      "answer_id":30316,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:55.803Z",
                      "updated_at":"2022-01-10T23:23:55.803Z",
                      "text":"Evet",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72314,
                      "answer_id":30316,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:55.798Z",
                      "updated_at":"2022-01-10T23:23:55.798Z",
                      "text":"Sí",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72313,
                      "answer_id":30316,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:55.793Z",
                      "updated_at":"2022-01-10T23:23:55.793Z",
                      "text":"Да",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72312,
                      "answer_id":30316,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:55.789Z",
                      "updated_at":"2022-01-10T23:23:55.789Z",
                      "text":"Tak",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72311,
                      "answer_id":30316,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:55.785Z",
                      "updated_at":"2022-01-10T23:23:55.785Z",
                      "text":"예",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72310,
                      "answer_id":30316,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:55.780Z",
                      "updated_at":"2022-01-10T23:23:55.780Z",
                      "text":"はい",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72309,
                      "answer_id":30316,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:55.775Z",
                      "updated_at":"2022-01-10T23:23:55.775Z",
                      "text":"Sì",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72308,
                      "answer_id":30316,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:55.770Z",
                      "updated_at":"2022-01-10T23:23:55.770Z",
                      "text":"Ja",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72307,
                      "answer_id":30316,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:55.766Z",
                      "updated_at":"2022-01-10T23:23:55.766Z",
                      "text":"Oui",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72306,
                      "answer_id":30316,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:55.761Z",
                      "updated_at":"2022-01-10T23:23:55.761Z",
                      "text":"Sim",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72305,
                      "answer_id":30316,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:55.756Z",
                      "updated_at":"2022-01-10T23:23:55.756Z",
                      "text":"Oui",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72304,
                      "answer_id":30316,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:55.752Z",
                      "updated_at":"2022-01-10T23:23:55.752Z",
                      "text":"Opo",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72303,
                      "answer_id":30316,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:55.747Z",
                      "updated_at":"2022-01-10T23:23:55.747Z",
                      "text":"Sí",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72302,
                      "answer_id":30316,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:55.742Z",
                      "updated_at":"2022-01-10T23:23:55.742Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72301,
                      "answer_id":30316,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:55.737Z",
                      "updated_at":"2022-01-10T23:23:55.737Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72300,
                      "answer_id":30316,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:55.733Z",
                      "updated_at":"2022-01-10T23:23:55.733Z",
                      "text":"Yes",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30317,
                "position":2,
                "active":true,
                "question_id":12050,
                "created_at":"2022-01-10T23:23:55.809Z",
                "updated_at":"2022-01-10T23:23:55.809Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"No",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72331,
                      "answer_id":30317,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:55.893Z",
                      "updated_at":"2022-01-10T23:23:55.893Z",
                      "text":"Hayır",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72330,
                      "answer_id":30317,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:55.889Z",
                      "updated_at":"2022-01-10T23:23:55.889Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72329,
                      "answer_id":30317,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:55.884Z",
                      "updated_at":"2022-01-10T23:23:55.884Z",
                      "text":"Нет",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72328,
                      "answer_id":30317,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:55.879Z",
                      "updated_at":"2022-01-10T23:23:55.879Z",
                      "text":"Nie",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72327,
                      "answer_id":30317,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:55.875Z",
                      "updated_at":"2022-01-10T23:23:55.875Z",
                      "text":"아니요",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72326,
                      "answer_id":30317,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:55.870Z",
                      "updated_at":"2022-01-10T23:23:55.870Z",
                      "text":"いいえ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72325,
                      "answer_id":30317,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:55.865Z",
                      "updated_at":"2022-01-10T23:23:55.865Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72324,
                      "answer_id":30317,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:55.861Z",
                      "updated_at":"2022-01-10T23:23:55.861Z",
                      "text":"Nein",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72323,
                      "answer_id":30317,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:55.856Z",
                      "updated_at":"2022-01-10T23:23:55.856Z",
                      "text":"Non",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72322,
                      "answer_id":30317,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:55.851Z",
                      "updated_at":"2022-01-10T23:23:55.851Z",
                      "text":"Não",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72321,
                      "answer_id":30317,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:55.846Z",
                      "updated_at":"2022-01-10T23:23:55.846Z",
                      "text":"Non",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72320,
                      "answer_id":30317,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:55.842Z",
                      "updated_at":"2022-01-10T23:23:55.842Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72319,
                      "answer_id":30317,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:55.837Z",
                      "updated_at":"2022-01-10T23:23:55.837Z",
                      "text":"Hindi",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72318,
                      "answer_id":30317,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:55.832Z",
                      "updated_at":"2022-01-10T23:23:55.832Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72317,
                      "answer_id":30317,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:55.827Z",
                      "updated_at":"2022-01-10T23:23:55.827Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72316,
                      "answer_id":30317,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:55.823Z",
                      "updated_at":"2022-01-10T23:23:55.823Z",
                      "text":"No",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12051,
          "shuffle":false,
          "position":26,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30319"
          ],
          "created_at":"2022-01-10T23:23:55.911Z",
          "updated_at":"2022-04-21T21:48:23.434Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":26,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best way for you to respond?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30040,
                "question_id":12051,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:56.068Z",
                "updated_at":"2022-01-10T23:23:56.068Z",
                "text":"İlk olarak ne yapmalısınız?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30039,
                "question_id":12051,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:56.063Z",
                "updated_at":"2022-01-10T23:23:56.063Z",
                "text":"¿Qué debería hacer primero?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30038,
                "question_id":12051,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:56.058Z",
                "updated_at":"2022-01-10T23:23:56.058Z",
                "text":"Что следует сделать сначала?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30037,
                "question_id":12051,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:56.053Z",
                "updated_at":"2022-01-10T23:23:56.053Z",
                "text":"Co należy zrobić najpierw?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30036,
                "question_id":12051,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:56.049Z",
                "updated_at":"2022-01-10T23:23:56.049Z",
                "text":"우선 어떻게 하시겠습니까?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30035,
                "question_id":12051,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:56.044Z",
                "updated_at":"2022-01-10T23:23:56.044Z",
                "text":"まず何をすべきでしょうか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30034,
                "question_id":12051,
                "locale":"it",
                "created_at":"2022-01-10T23:23:56.039Z",
                "updated_at":"2022-01-10T23:23:56.039Z",
                "text":"Che cosa dovresti fare in primo luogo?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30033,
                "question_id":12051,
                "locale":"de",
                "created_at":"2022-01-10T23:23:56.034Z",
                "updated_at":"2022-01-10T23:23:56.034Z",
                "text":"Was sollten Sie zuerst tun?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30032,
                "question_id":12051,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:56.028Z",
                "updated_at":"2022-01-10T23:23:56.028Z",
                "text":"Que devriez-vous faire en premier?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30031,
                "question_id":12051,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:56.023Z",
                "updated_at":"2022-01-10T23:23:56.023Z",
                "text":"Que devriez-vous faire en premier ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30030,
                "question_id":12051,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:56.017Z",
                "updated_at":"2022-01-10T23:23:56.017Z",
                "text":"O que você deve fazer primeiro?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30029,
                "question_id":12051,
                "locale":"es",
                "created_at":"2022-01-10T23:23:56.012Z",
                "updated_at":"2022-01-10T23:23:56.012Z",
                "text":"¿Qué deberías hacer primero?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30028,
                "question_id":12051,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:56.006Z",
                "updated_at":"2022-01-10T23:23:56.006Z",
                "text":"Ano ang una mong gagawin?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30027,
                "question_id":12051,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:55.999Z",
                "updated_at":"2022-01-10T23:23:55.999Z",
                "text":"你应该先做什么？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30026,
                "question_id":12051,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:55.992Z",
                "updated_at":"2022-01-10T23:23:55.992Z",
                "text":"你首先該做的是甚麼？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30025,
                "question_id":12051,
                "locale":"en",
                "created_at":"2022-01-10T23:23:55.929Z",
                "updated_at":"2022-04-21T21:48:23.437Z",
                "text":"What is the best way for you to respond?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30318,
                "position":1,
                "active":true,
                "question_id":12051,
                "created_at":"2022-01-10T23:23:56.074Z",
                "updated_at":"2022-04-21T21:48:32.285Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Explain to Amina that you work closely with Philip and he’s a good person. She probably misinterpreted the situation.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72332,
                      "answer_id":30318,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:56.088Z",
                      "updated_at":"2022-04-21T21:48:32.287Z",
                      "text":"Explain to Amina that you work closely with Philip and he’s a good person. She probably misinterpreted the situation.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72347,
                      "answer_id":30318,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:56.158Z",
                      "updated_at":"2022-01-10T23:23:56.158Z",
                      "text":"Stacy'ye Brent'i iyi tanıdığınızı ve onun zararsız olduğunu açıklayın. Muhtemelen durumu yanlış yorumladığını fark edip rahatlayacaktır.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72346,
                      "answer_id":30318,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:56.153Z",
                      "updated_at":"2022-01-10T23:23:56.153Z",
                      "text":"Explicarle a Stacy que conoce bien a Brent y que es inofensivo. Seguro que se sentirá aliviada al saber que lo estaba malinterpretando.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72345,
                      "answer_id":30318,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:56.148Z",
                      "updated_at":"2022-01-10T23:23:56.148Z",
                      "text":"Объяснить Стейси, что вы хорошо знаете Брента, и он безобиден. Она, вероятно, вздохнет с облегчением, когда поймет, что не так все восприняла.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72344,
                      "answer_id":30318,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:56.143Z",
                      "updated_at":"2022-01-10T23:23:56.143Z",
                      "text":"Wyjaśnić Stacy, że dobrze znasz Brenta i że jest nieszkodliwy. Pewnie odetchnie z ulgą, gdy dowie się, że źle to zinterpretowała.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72343,
                      "answer_id":30318,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:56.139Z",
                      "updated_at":"2022-01-10T23:23:56.139Z",
                      "text":"Stacy에게 Brent를 잘 알고 있으며 그는 누군가를 해를 가할 사람이 아니라고 말한다. 그녀는 상황을 잘못 이해했음을 알고 안심할 것이다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72342,
                      "answer_id":30318,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:56.134Z",
                      "updated_at":"2022-01-10T23:23:56.134Z",
                      "text":"Stacyさんに、あなたがBrentさんをよく知っている旨を伝え、彼が無害であることを伝える。彼女はきっと、勘違いをしていたことを知って、安堵することでしょう。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72341,
                      "answer_id":30318,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:56.129Z",
                      "updated_at":"2022-01-10T23:23:56.129Z",
                      "text":"Spiegare a Stacy che conosci bene Brent e che è innocuo. Probabilmente sarà sollevata di sapere che ha interpretato male la situazione.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72340,
                      "answer_id":30318,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:56.125Z",
                      "updated_at":"2022-01-10T23:23:56.125Z",
                      "text":"Stacy erklären, dass Sie Brent gut kennen und dass er harmlos ist. Sie wird wahrscheinlich erleichtert sein, wenn sie erkennt, dass sie das falsch interpretiert hat.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72339,
                      "answer_id":30318,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:56.120Z",
                      "updated_at":"2022-01-10T23:23:56.120Z",
                      "text":"Expliquez à Stacy que vous connaissez bien Brent et qu'il est inoffensif. Elle sera probablement soulagée de savoir qu'elle l'a mal interprété.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72338,
                      "answer_id":30318,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:56.115Z",
                      "updated_at":"2022-01-10T23:23:56.115Z",
                      "text":"Expliquer à Stacy que vous connaissez bien Brent et qu’il est inoffensif. Elle sera sans doute soulagée de savoir qu’elle a mal interprété la chose.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72337,
                      "answer_id":30318,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:56.111Z",
                      "updated_at":"2022-01-10T23:23:56.111Z",
                      "text":"Explicar a Stacy que você conhece bem o Brent, e ele é inofensivo. Ela provavelmente ficará aliviada em saber que ela estava interpretando mal.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72336,
                      "answer_id":30318,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:56.106Z",
                      "updated_at":"2022-01-10T23:23:56.106Z",
                      "text":"Explicar a Stacy que conoces bien a Brent, y es inofensivo. Probablemente se sentirá aliviada al saber que lo interpretaba mal.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72335,
                      "answer_id":30318,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:56.101Z",
                      "updated_at":"2022-01-10T23:23:56.101Z",
                      "text":"Ipaliwanag kay Stacy na kilalang-kilala mo si Brent, at hindi siya nakakapinsala. Marahil ay hihinahon siya na malaman niya na maling-ideya niya ito.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72334,
                      "answer_id":30318,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:56.097Z",
                      "updated_at":"2022-01-10T23:23:56.097Z",
                      "text":"向 Stacy 解释你非常了解 Brent，他不会伤害人的。如果她知道自己误会了，她可能会感到释怀。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72333,
                      "answer_id":30318,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:56.092Z",
                      "updated_at":"2022-01-10T23:23:56.092Z",
                      "text":"向 Stacy 解釋你跟 Brent 很熟，他沒有惡意。她或許會鬆一口氣，因為自己可能只是誤解了。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30319,
                "position":2,
                "active":true,
                "question_id":12051,
                "created_at":"2022-01-10T23:23:56.165Z",
                "updated_at":"2022-04-21T21:48:42.811Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell Amina that she should talk to Philip herself if she feels unsettled.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72363,
                      "answer_id":30319,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:56.249Z",
                      "updated_at":"2022-01-10T23:23:56.249Z",
                      "text":"Stacy'ye size söylediklerinin oldukça endişe verici olduğunu ve göz süzmenin iş yerinde uygunsuz olduğunu söyleyin. Ardından, bundan sonra ne yapılacağıyla ilgili seçeneklerini tartışın.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72362,
                      "answer_id":30319,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:56.244Z",
                      "updated_at":"2022-01-10T23:23:56.244Z",
                      "text":"Decirle a Stacy que lo que acaba de decirle es muy preocupante: mirar de forma obscena es totalmente inapropiado en el trabajo. A continuación, consulte las opciones en los próximos pasos.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72361,
                      "answer_id":30319,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:56.239Z",
                      "updated_at":"2022-01-10T23:23:56.239Z",
                      "text":"Сказать Стейси, что все, о чем она только что рассказала, вызывает серьезные опасения, похотливые взгляды на рабочем месте абсолютно неприемлемы. Затем обсудить, как она может поступить дальше.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72360,
                      "answer_id":30319,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:56.234Z",
                      "updated_at":"2022-01-10T23:23:56.234Z",
                      "text":"Powiedz Stacy, że to, co właśnie Ci powiedziała, jest bardzo niepokojące, a pożądliwe spojrzenia są całkowicie niestosowne w pracy. Następnie omów jej możliwości dotyczące kolejnych kroków.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72359,
                      "answer_id":30319,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:56.229Z",
                      "updated_at":"2022-01-10T23:23:56.229Z",
                      "text":"Stacy에게 방금 말한 내용이 매우 걱정스럽다고 말한다. 직장에서 누군가에게 추파를 던지는 것은 매우 부적절하다. 그리고 다음에 할 수 있는 조치들에 대해 논의한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72358,
                      "answer_id":30319,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:56.225Z",
                      "updated_at":"2022-01-10T23:23:56.225Z",
                      "text":"Stacyさんに、たった今聞いた話に対して非常に懸念を抱いたこと、職場でいやらしい目で誰かを見ることは不適切であることを伝える。その後、今後彼女が取ることのできる手順の選択肢について話し合う。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72357,
                      "answer_id":30319,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:56.220Z",
                      "updated_at":"2022-01-10T23:23:56.220Z",
                      "text":"Dire a Stacy che quello che ha appena affermato è molto preoccupante: lo sguardo lascivo è del tutto inappropriato a lavoro. Quindi discutere le sue opzioni per i passaggi successivi da intraprendere.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72356,
                      "answer_id":30319,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:56.215Z",
                      "updated_at":"2022-01-10T23:23:56.215Z",
                      "text":"Stacy erklären, dass das, was sie Ihnen gesagt hat, besorgniserregend ist. Es gehört sich nicht, mit jemandem am Arbeitsplatz zu liebäugeln. Besprechen Sie dann mit ihr die möglichen nächsten Schritte.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72355,
                      "answer_id":30319,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:56.211Z",
                      "updated_at":"2022-01-10T23:23:56.211Z",
                      "text":"Dites à Stacy que ce qu'elle vient de vous dire est très inquiétant - reluquer est totalement inapproprié au travail. Ensuite, discutez de ses options pour les prochaines étapes.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72354,
                      "answer_id":30319,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:56.206Z",
                      "updated_at":"2022-01-10T23:23:56.206Z",
                      "text":"Dire à Stacy que ce qu’elle vient de vous dire est très inquiétant. Les regards lubriques sont totalement inappropriés au travail. Discuter ensuite des choix qui s’offrent à elle par la suite.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72353,
                      "answer_id":30319,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:56.201Z",
                      "updated_at":"2022-01-10T23:23:56.201Z",
                      "text":"Dizer a Stacy que o que ela acabou de dizer é muito preocupante. Avanços sexuais indesejáveis ​​são totalmente inadequados no trabalho. Em seguida, discutir as opções dela para as próximas etapas.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72352,
                      "answer_id":30319,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:56.196Z",
                      "updated_at":"2022-01-10T23:23:56.196Z",
                      "text":"Decir a Stacy que lo que acaba de mencionar es muy inquietante, las miradas lujuriosas son totalmente inapropiadas en el trabajo. Luego analizar sus opciones para los próximos pasos.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72351,
                      "answer_id":30319,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:56.192Z",
                      "updated_at":"2022-01-10T23:23:56.192Z",
                      "text":"Sabihin mo kay Stacy na ang sinabi niya sa iyo ay talagang nakakabahala — ang pagtingin nang may pagnanasa ay talagang hindi naaangkop sa trabaho. Pagkatapos ay talakayin sa kanya ang mga opsyon para sa susunod na mga hakbang.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72350,
                      "answer_id":30319,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:56.187Z",
                      "updated_at":"2022-01-10T23:23:56.187Z",
                      "text":"告诉 Stacy 她刚才告诉你的事情非常令人担心，工作中抛媚眼是完全不恰当的行为。然后讨论她接下来的选择。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72349,
                      "answer_id":30319,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:56.182Z",
                      "updated_at":"2022-01-10T23:23:56.182Z",
                      "text":"告訴 Stacy 她告訴你的事情讓你非常擔心—在工作上拋媚眼是非常不得體的事。接著跟她討論接下來她可以選擇怎麼做。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72348,
                      "answer_id":30319,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:56.178Z",
                      "updated_at":"2022-04-21T21:48:42.813Z",
                      "text":"Tell Amina that she should talk to Philip herself if she feels unsettled.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31699,
                "position":3,
                "active":true,
                "question_id":12051,
                "created_at":"2022-04-21T21:48:53.886Z",
                "updated_at":"2022-04-21T21:48:53.886Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell Amina that what she told you is very concerning. Then, discuss her options for next steps.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77369,
                      "answer_id":31699,
                      "locale":"en",
                      "created_at":"2022-04-21T21:48:53.894Z",
                      "updated_at":"2022-04-21T21:48:53.894Z",
                      "text":"Tell Amina that what she told you is very concerning. Then, discuss her options for next steps.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12052,
          "shuffle":false,
          "position":27,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30321"
          ],
          "created_at":"2022-01-10T23:23:56.268Z",
          "updated_at":"2022-01-10T23:23:56.608Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":27,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What should you do? ",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30056,
                "question_id":12052,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:56.422Z",
                "updated_at":"2022-01-10T23:23:56.422Z",
                "text":"Ne yapmalısınız? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30055,
                "question_id":12052,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:56.417Z",
                "updated_at":"2022-01-10T23:23:56.417Z",
                "text":"¿Qué debería hacer? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30054,
                "question_id":12052,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:56.413Z",
                "updated_at":"2022-01-10T23:23:56.413Z",
                "text":"Что вам следует сделать? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30053,
                "question_id":12052,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:56.408Z",
                "updated_at":"2022-01-10T23:23:56.408Z",
                "text":"Co należy zrobić? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30052,
                "question_id":12052,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:56.403Z",
                "updated_at":"2022-01-10T23:23:56.403Z",
                "text":"어떻게 하시겠습니까? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30051,
                "question_id":12052,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:56.398Z",
                "updated_at":"2022-01-10T23:23:56.398Z",
                "text":"あなたは何をすべきでしょうか？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30050,
                "question_id":12052,
                "locale":"it",
                "created_at":"2022-01-10T23:23:56.393Z",
                "updated_at":"2022-01-10T23:23:56.393Z",
                "text":"Che cosa dovresti fare? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30049,
                "question_id":12052,
                "locale":"de",
                "created_at":"2022-01-10T23:23:56.388Z",
                "updated_at":"2022-01-10T23:23:56.388Z",
                "text":"Was sollten Sie tun? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30048,
                "question_id":12052,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:56.383Z",
                "updated_at":"2022-01-10T23:23:56.383Z",
                "text":"Que devriez-vous faire? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30047,
                "question_id":12052,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:56.379Z",
                "updated_at":"2022-01-10T23:23:56.379Z",
                "text":"Que devriez-vous faire ? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30046,
                "question_id":12052,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:56.374Z",
                "updated_at":"2022-01-10T23:23:56.374Z",
                "text":"O que você deve fazer? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30045,
                "question_id":12052,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:56.369Z",
                "updated_at":"2022-01-10T23:23:56.369Z",
                "text":"你應該怎麼做？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30044,
                "question_id":12052,
                "locale":"es",
                "created_at":"2022-01-10T23:23:56.364Z",
                "updated_at":"2022-01-10T23:23:56.364Z",
                "text":"¿Qué debes hacer? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30043,
                "question_id":12052,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:56.359Z",
                "updated_at":"2022-01-10T23:23:56.359Z",
                "text":"Ano ang dapat mong gawin? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30042,
                "question_id":12052,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:56.354Z",
                "updated_at":"2022-01-10T23:23:56.354Z",
                "text":"我们应怎么做？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30041,
                "question_id":12052,
                "locale":"en",
                "created_at":"2022-01-10T23:23:56.288Z",
                "updated_at":"2022-01-10T23:23:56.288Z",
                "text":"What should you do? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30320,
                "position":1,
                "active":true,
                "question_id":12052,
                "created_at":"2022-01-10T23:23:56.429Z",
                "updated_at":"2022-04-21T21:49:49.266Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell Reuben you’re confused and ask him to re-tell what happened in a clear timeline of events. You can’t tell if you need to take action if you don’t know what happened.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72364,
                      "answer_id":30320,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:56.442Z",
                      "updated_at":"2022-04-21T21:49:49.269Z",
                      "text":"Tell Reuben you’re confused and ask him to re-tell what happened in a clear timeline of events. You can’t tell if you need to take action if you don’t know what happened.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72379,
                      "answer_id":30320,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:56.511Z",
                      "updated_at":"2022-01-10T23:23:56.511Z",
                      "text":"Lee'ye kafanızın karıştığını söyleyin ve ondan olanları daha yavaş ve sırayla yeniden anlatmasını isteyin. Harekete geçip geçmemesini söylemek için öncelikle ne olduğunu bilmelisiniz.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72378,
                      "answer_id":30320,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:56.507Z",
                      "updated_at":"2022-01-10T23:23:56.507Z",
                      "text":"Hacerle saber a Lee que usted está confundido y pedirle que vuelva a contar lo que sucedió de forma más pausada y en orden. Usted no puede saber si debe actuar si no sabe lo que sucedió.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72377,
                      "answer_id":30320,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:56.502Z",
                      "updated_at":"2022-01-10T23:23:56.502Z",
                      "text":"Дать Ли понять, что вы в смятении, и попросить еще раз рассказать, что случилось, но более медленно и по порядку. Вы не можете понять, нужно ли принимать меры, если не знаете, что произошло.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72376,
                      "answer_id":30320,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:56.497Z",
                      "updated_at":"2022-01-10T23:23:56.497Z",
                      "text":"Daj Lee znać, że jesteś zdezorientowany(-a) i poproś go, aby powoli i po kolei opowiedział, co się wydarzyło. Nie możesz stwierdzić, czy musisz podjąć działania, jeśli nie wiesz, co się stało.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72375,
                      "answer_id":30320,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:56.492Z",
                      "updated_at":"2022-01-10T23:23:56.492Z",
                      "text":"Lee에게 당황스럽다고 말하고, 어떤 일이 일어났는지 좀 더 천천히 순서대로 다시 얘기해 달라고 요청한다. 무슨 일이 있었는지 모르면 조치를 취해야 할지 판단할 수 없다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72374,
                      "answer_id":30320,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:56.488Z",
                      "updated_at":"2022-01-10T23:23:56.488Z",
                      "text":"Leeさんに混乱していることを伝え、もう一度何が起こったのかをゆっくり順を追って説明してもらうようお願いする。何が起こったのかを理解していないと、行動を取るべきかどうかも分かりません。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72373,
                      "answer_id":30320,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:56.483Z",
                      "updated_at":"2022-01-10T23:23:56.483Z",
                      "text":"Far sapere a Lee che sei confuso e chiedergli di raccontare nuovamente la situazione che si è verificata più lentamente e in ordine. Non puoi dire se devi agire se non sai esattamente che cosa è successo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72372,
                      "answer_id":30320,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:56.478Z",
                      "updated_at":"2022-01-10T23:23:56.478Z",
                      "text":"Lee wissen lassen, dass Sie verwirrt sind, und ihn bitten, das Geschehene noch einmal langsam und in richtiger Reihenfolge zu erzählen. Wenn Sie nicht wissen, was geschehen ist, wissen Sie nicht, ob Sie etwas unternehmen müssen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72371,
                      "answer_id":30320,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:56.474Z",
                      "updated_at":"2022-01-10T23:23:56.474Z",
                      "text":"Faites savoir à Lee que vous êtes confus et demandez-lui de raconter ce qui s'est passé plus lentement et dans l'ordre. Vous ne pouvez pas dire si vous devez agir si vous ne savez pas ce qui s'est passé.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72370,
                      "answer_id":30320,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:56.469Z",
                      "updated_at":"2022-01-10T23:23:56.469Z",
                      "text":"Dire à Lee que vous n’avez pas bien compris et lui demander de raconter ce qui s’est passé plus lentement et dans l’ordre. Difficile pour vous de savoir si vous devez agir si vous ne savez pas ce qui s’est passé.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72369,
                      "answer_id":30320,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:56.465Z",
                      "updated_at":"2022-01-10T23:23:56.465Z",
                      "text":"Dizer a Lee que você está confuso e pedir que ele conte novamente mais devagar o que aconteceu e na ordem. Você não pode dizer se precisa tomar uma atitude se não sabe o que aconteceu.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72368,
                      "answer_id":30320,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:56.460Z",
                      "updated_at":"2022-01-10T23:23:56.460Z",
                      "text":"Informar a Lee que estás confundido, y pedirle que vuelva a contar lo que sucedió en detalle y en orden. No puedes determinar si es necesario actuar si no sabes qué sucedió.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72367,
                      "answer_id":30320,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:56.456Z",
                      "updated_at":"2022-01-10T23:23:56.456Z",
                      "text":"Ipaalam kay Lee na nalilito ka, at hilingin sa kanya na sabihin muli ang nangyari nang mas mabagal at maayos. Hindi mo masasabi kung kailangan mong gumawa ng aksyon kung hindi mo alam ang nangyari.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72366,
                      "answer_id":30320,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:56.451Z",
                      "updated_at":"2022-01-10T23:23:56.451Z",
                      "text":"告诉 Lee 你感到困惑，让他放慢速度并有条理的重新讲述发生的事情。如果你不知道发生了什么事情，就无法确定是否需要采取行动。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72365,
                      "answer_id":30320,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:56.446Z",
                      "updated_at":"2022-01-10T23:23:56.446Z",
                      "text":"讓 Lee 知道你覺得困惑，請他再重新慢慢地、照順序的重新說一次發生的事。如果你不清楚發生了甚麼，就無法判斷是否需要採取行動。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30321,
                "position":2,
                "active":true,
                "question_id":12052,
                "created_at":"2022-01-10T23:23:56.518Z",
                "updated_at":"2022-04-21T21:49:59.125Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell Rueben to take a couple of days to calm down and then set up a time to discuss it with you.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72395,
                      "answer_id":30321,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:56.603Z",
                      "updated_at":"2022-01-10T23:23:56.603Z",
                      "text":"Lee'ye bu anlattıklarının sizi endişelendirdiğini ve oturmak isteyip istemediğini sorun.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72394,
                      "answer_id":30321,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:56.598Z",
                      "updated_at":"2022-01-10T23:23:56.598Z",
                      "text":"Decirle a Lee que le preocupa lo que le está diciendo y preguntarle si le gustaría sentarse.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72393,
                      "answer_id":30321,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:56.593Z",
                      "updated_at":"2022-01-10T23:23:56.593Z",
                      "text":"Скажите Ли, что обеспокоены тем, что он вам рассказал, и спросите, не хотел бы он сесть.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72392,
                      "answer_id":30321,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:56.589Z",
                      "updated_at":"2022-01-10T23:23:56.589Z",
                      "text":"Powiedz Lee, że jesteś zaniepokojony(-a) tym, co Ci mówi i zapytaj, czy chciałby usiąść.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72391,
                      "answer_id":30321,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:56.583Z",
                      "updated_at":"2022-01-10T23:23:56.583Z",
                      "text":"Lee에게 걱정이 된다고 말하고 자리에 앉아서 얘기할 수 있는지 물어본다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72390,
                      "answer_id":30321,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:56.579Z",
                      "updated_at":"2022-01-10T23:23:56.579Z",
                      "text":"Leeさんに、聞いた話に対して懸念を抱いたことを伝え、話し合いの席を設けたいかどうかを聞く。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72389,
                      "answer_id":30321,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:56.574Z",
                      "updated_at":"2022-01-10T23:23:56.574Z",
                      "text":"Dire a Lee che sei preoccupato per quello che ti sta dicendo e chiedergli se gli piacerebbe sedersi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72388,
                      "answer_id":30321,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:56.569Z",
                      "updated_at":"2022-01-10T23:23:56.569Z",
                      "text":"Lee sagen, dass es Ihnen Sorgen bereitet, was er Ihnen erzählt, und ihm anbieten, sich zu setzen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72387,
                      "answer_id":30321,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:56.564Z",
                      "updated_at":"2022-01-10T23:23:56.564Z",
                      "text":"Dites à Lee que vous vous inquiétez de ce qu'il vous dit et demandez-lui s'il aimerait prendre place.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72386,
                      "answer_id":30321,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:56.560Z",
                      "updated_at":"2022-01-10T23:23:56.560Z",
                      "text":"Dire à Lee que ce qu’il vous dit vous préoccupe et lui demander s’il veut s’asseoir.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72385,
                      "answer_id":30321,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:56.555Z",
                      "updated_at":"2022-01-10T23:23:56.555Z",
                      "text":"Dizer a Lee que você está preocupado com o que ele está lhe dizendo e perguntar se ele gostaria de se sentar.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72384,
                      "answer_id":30321,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:56.550Z",
                      "updated_at":"2022-01-10T23:23:56.550Z",
                      "text":"Decir a Lee que te preocupa lo que te está diciendo, y ofrecerle que tome asiento.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72383,
                      "answer_id":30321,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:56.545Z",
                      "updated_at":"2022-01-10T23:23:56.545Z",
                      "text":"Sabihin kay Lee na nag-aalala ka tungkol sa kung ano ang sinasabi niya sa iyo, at tanungin kung gusto niyang umupo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72382,
                      "answer_id":30321,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:56.540Z",
                      "updated_at":"2022-01-10T23:23:56.540Z",
                      "text":"告诉 Lee 你对他告诉你的事情感到担心，并询问他是否要坐下。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72381,
                      "answer_id":30321,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:56.536Z",
                      "updated_at":"2022-01-10T23:23:56.536Z",
                      "text":"告訴 Lee 你對於他告訴你的事情有疑慮，然後請他是否要坐下來。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72380,
                      "answer_id":30321,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:56.531Z",
                      "updated_at":"2022-04-21T21:49:59.127Z",
                      "text":"Tell Rueben to take a couple of days to calm down and then set up a time to discuss it with you.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31700,
                "position":3,
                "active":true,
                "question_id":12052,
                "created_at":"2022-04-21T21:50:12.415Z",
                "updated_at":"2022-04-21T21:50:12.415Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell Reuben you’re concerned about what he’s telling you and ask if he’d like to meet privately after the call to discuss it further.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77370,
                      "answer_id":31700,
                      "locale":"en",
                      "created_at":"2022-04-21T21:50:12.420Z",
                      "updated_at":"2022-04-21T21:50:12.420Z",
                      "text":"Tell Reuben you’re concerned about what he’s telling you and ask if he’d like to meet privately after the call to discuss it further.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12053,
          "shuffle":false,
          "position":28,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30323"
          ],
          "created_at":"2022-01-10T23:23:56.620Z",
          "updated_at":"2022-04-21T21:50:58.917Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":28,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best action for you to take?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30057,
                "question_id":12053,
                "locale":"en",
                "created_at":"2022-01-10T23:23:56.640Z",
                "updated_at":"2022-04-21T21:50:58.920Z",
                "text":"What is the best action for you to take?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30072,
                "question_id":12053,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:56.775Z",
                "updated_at":"2022-01-10T23:23:56.775Z",
                "text":"Ne yapmalısınız? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30071,
                "question_id":12053,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:56.771Z",
                "updated_at":"2022-01-10T23:23:56.771Z",
                "text":"¿Qué debería hacer? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30070,
                "question_id":12053,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:56.766Z",
                "updated_at":"2022-01-10T23:23:56.766Z",
                "text":"Что вам следует сделать? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30069,
                "question_id":12053,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:56.761Z",
                "updated_at":"2022-01-10T23:23:56.761Z",
                "text":"Co należy zrobić? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30068,
                "question_id":12053,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:56.756Z",
                "updated_at":"2022-01-10T23:23:56.756Z",
                "text":"어떻게 하시겠습니까? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30067,
                "question_id":12053,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:56.752Z",
                "updated_at":"2022-01-10T23:23:56.752Z",
                "text":"あなたは何をすべきでしょうか？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30066,
                "question_id":12053,
                "locale":"it",
                "created_at":"2022-01-10T23:23:56.747Z",
                "updated_at":"2022-01-10T23:23:56.747Z",
                "text":"Che cosa dovresti fare? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30065,
                "question_id":12053,
                "locale":"de",
                "created_at":"2022-01-10T23:23:56.742Z",
                "updated_at":"2022-01-10T23:23:56.742Z",
                "text":"Was sollten Sie tun? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30064,
                "question_id":12053,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:56.737Z",
                "updated_at":"2022-01-10T23:23:56.737Z",
                "text":"Que devriez-vous faire? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30063,
                "question_id":12053,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:56.732Z",
                "updated_at":"2022-01-10T23:23:56.732Z",
                "text":"Que devriez-vous faire ? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30062,
                "question_id":12053,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:56.728Z",
                "updated_at":"2022-01-10T23:23:56.728Z",
                "text":"O que você deve fazer? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30061,
                "question_id":12053,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:56.723Z",
                "updated_at":"2022-01-10T23:23:56.723Z",
                "text":"你應該怎麼做？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30060,
                "question_id":12053,
                "locale":"es",
                "created_at":"2022-01-10T23:23:56.718Z",
                "updated_at":"2022-01-10T23:23:56.718Z",
                "text":"¿Qué debes hacer? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30059,
                "question_id":12053,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:56.713Z",
                "updated_at":"2022-01-10T23:23:56.713Z",
                "text":"Ano ang dapat mong gawin? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30058,
                "question_id":12053,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:56.708Z",
                "updated_at":"2022-01-10T23:23:56.708Z",
                "text":"我们应怎么做？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30322,
                "position":1,
                "active":true,
                "question_id":12053,
                "created_at":"2022-01-10T23:23:56.782Z",
                "updated_at":"2022-04-21T21:51:11.641Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Nod along. You’ve never met Miranda, and you also think Orla is a great employee.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72411,
                      "answer_id":30322,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:56.867Z",
                      "updated_at":"2022-01-10T23:23:56.867Z",
                      "text":"Başınızı sallayın. Bu çalışanla daha önce tanışmamanıza rağmen onun kötü ve Mike'ın iyi biri olduğunu düşünüyorsunuz.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72410,
                      "answer_id":30322,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:56.862Z",
                      "updated_at":"2022-01-10T23:23:56.862Z",
                      "text":"Asentir. Usted no conocía a esta nueva empleada, pero parece desagradable. Mike es agradable.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72409,
                      "answer_id":30322,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:56.857Z",
                      "updated_at":"2022-01-10T23:23:56.857Z",
                      "text":"Согласиться. Вы раньше не встречали эту новую сотрудницу, но она выглядит неприятной, а Майк хороший человек.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72408,
                      "answer_id":30322,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:56.853Z",
                      "updated_at":"2022-01-10T23:23:56.853Z",
                      "text":"Przytakiwać. Nigdy nie poznałeś(-aś) tej nowej pracownicy, ale ona brzmi okropnie, a Mike jest miły.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72407,
                      "answer_id":30322,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:56.848Z",
                      "updated_at":"2022-01-10T23:23:56.848Z",
                      "text":"함께 고개를 끄덕인다. 이 신입 사원을 만난 적이 없지만 그녀는 몹시 기분이 나빠 있고, Mike는 친절한 사람이다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72406,
                      "answer_id":30322,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:56.843Z",
                      "updated_at":"2022-01-10T23:23:56.843Z",
                      "text":"うなずく。この新入社員にあったことはありませんが、聞いた限り感じが悪く、Mikeさんはいい人です。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72405,
                      "answer_id":30322,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:56.838Z",
                      "updated_at":"2022-01-10T23:23:56.838Z",
                      "text":"Annuire. Non hai mai incontrato questa nuova dipendente, ma sembra insopportabile e Mike è gentile.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72404,
                      "answer_id":30322,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:56.834Z",
                      "updated_at":"2022-01-10T23:23:56.834Z",
                      "text":"Nicken. Sie kennen diese neue Mitarbeiterin nicht persönlich, aber sie scheint unausstehlich zu sein, während Mike echt nett ist.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72403,
                      "answer_id":30322,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:56.829Z",
                      "updated_at":"2022-01-10T23:23:56.829Z",
                      "text":"Faites un signe de la tête. Vous n'avez jamais rencontré cette nouvelle employée, mais elle a l'air désagréable et Mike est gentil.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72402,
                      "answer_id":30322,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:56.824Z",
                      "updated_at":"2022-01-10T23:23:56.824Z",
                      "text":"Acquiescer. Vous n’avez encore jamais vu cette nouvelle employée, mais elle semble désagréable et Mike est quelqu’un de sympa.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72401,
                      "answer_id":30322,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:56.819Z",
                      "updated_at":"2022-01-10T23:23:56.819Z",
                      "text":"Acenar com a cabeça. Você nunca esteve com essa nova funcionária, mas ela parece desagradável, e Mike é legal.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72400,
                      "answer_id":30322,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:56.814Z",
                      "updated_at":"2022-01-10T23:23:56.814Z",
                      "text":"Asentir. No conoces a esta nueva empleada, pero parece ofensiva, y Mike es agradable.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72399,
                      "answer_id":30322,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:56.810Z",
                      "updated_at":"2022-01-10T23:23:56.810Z",
                      "text":"Tumungo. Hindi mo pa nakikilala ang bagong empleyado na ito, ngunit para siyang hindi kanais-nais, at mabit si Mike.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72398,
                      "answer_id":30322,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:56.804Z",
                      "updated_at":"2022-01-10T23:23:56.804Z",
                      "text":"一直点头同意。你从未见过这名新员工，但她听起来挺让人讨厌，Mike 不错。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72397,
                      "answer_id":30322,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:56.799Z",
                      "updated_at":"2022-01-10T23:23:56.799Z",
                      "text":"邊聽邊點頭。你未曾見過這個新員工，但她聽起來令人討厭，而且 Mike 人很好。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72396,
                      "answer_id":30322,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:56.795Z",
                      "updated_at":"2022-04-21T21:51:11.644Z",
                      "text":"Nod along. You’ve never met Miranda, and you also think Orla is a great employee.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30323,
                "position":2,
                "active":true,
                "question_id":12053,
                "created_at":"2022-01-10T23:23:56.873Z",
                "updated_at":"2022-04-21T21:51:25.679Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell Jaylan, “I think Orla is great, too, but we need to take reports of harassment seriously. I know you care about being a leader whom people can come to with concerns.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72412,
                      "answer_id":30323,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:56.886Z",
                      "updated_at":"2022-04-21T21:51:25.682Z",
                      "text":"Tell Jaylan, “I think Orla is great, too, but we need to take reports of harassment seriously. I know you care about being a leader whom people can come to with concerns.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72427,
                      "answer_id":30323,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:56.956Z",
                      "updated_at":"2022-01-10T23:23:56.956Z",
                      "text":"Wei'ye şunu söyleyin: \"Biliyorsun, Mike'la hiç sorun yaşamadım, ama tacizle ilgili bir bildiri olduğunda bunu ciddiye almalıyız. İnsanların zorlukları veya endişelerini paylaşmak isteyen bir lider olmayı çok önemsediğini biliyorum. \"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72426,
                      "answer_id":30323,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:56.952Z",
                      "updated_at":"2022-01-10T23:23:56.952Z",
                      "text":"Decirle a Wei: \"Yo tampoco he tenido problemas con Mike, pero debemos tomarnos en serio las denuncias de acoso. Sé que te preocupas mucho por ser un líder al que la gente pueda acudir con desafíos o preocupaciones\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72425,
                      "answer_id":30323,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:56.947Z",
                      "updated_at":"2022-01-10T23:23:56.947Z",
                      "text":"Сказать Вэй: «Знаете, у меня никогда не было проблем с Майком, но мы должны серьезно относиться к жалобам на притеснения. Я знаю, что для вас очень важно быть руководителем, к которому люди будут обращаться с проблемами и вопросами».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72424,
                      "answer_id":30323,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:56.943Z",
                      "updated_at":"2022-01-10T23:23:56.943Z",
                      "text":"Powiedz Wei: „Wiesz, ja też nigdy nie miałem(-am) problemu z Mike'em, ale musimy poważnie traktować zgłoszenia o nękaniu. Wiem, że bardzo zależy Ci na tym, aby być liderem, do którego ludzie mogą przyjść z wyzwaniami lub problemami”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72423,
                      "answer_id":30323,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:56.938Z",
                      "updated_at":"2022-01-10T23:23:56.938Z",
                      "text":"Wei에게 “저 또한 Mike와 한 번도 문제가 없었지만 괴롭힘 신고를 심각하게 받아 들여야 해요. Wei 씨는 직원들이 어려움이나 고민을 상담할 수 있는 리더가 되길 원하니까요”라고 말한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72422,
                      "answer_id":30323,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:56.933Z",
                      "updated_at":"2022-01-10T23:23:56.933Z",
                      "text":"Weiさんに、「私もMikeさんと問題になったことはありませんが、ハラスメントの報告は真摯に捉える必要があります。あなたが、皆が課題や懸念について相談できるようなリーダーになるということを大切に思っていることは知っています。」と伝える。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72421,
                      "answer_id":30323,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:56.929Z",
                      "updated_at":"2022-01-10T23:23:56.929Z",
                      "text":"Dire a Wei: “Non ho mai avuto problemi con Mike, ma dobbiamo prendere seriamente in considerazioni le segnalazioni di molestie. So che tieni molto al tuo ruolo di leader che le persone possono consultare in caso di sfide o dubbi”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72420,
                      "answer_id":30323,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:56.924Z",
                      "updated_at":"2022-01-10T23:23:56.924Z",
                      "text":"Wei sagen, dass es mit Mike zwar noch nie Probleme gab, aber dass Beschwerden zu Belästigung ernst genommen werden müssen. Dass Sie außerdem wissen, dass er viel Wert darauf legt, ein Leader zu sein, zu dem jeder mit seinen Problemen und Sorgen kommen kann.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72419,
                      "answer_id":30323,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:56.919Z",
                      "updated_at":"2022-01-10T23:23:56.919Z",
                      "text":"Dites à Wei: « Vous savez, je n'ai jamais eu de problème avec Mike non plus, mais nous devons prendre au sérieux les signalements de harcèlement. Je sais que vous vous souciez beaucoup d'être un leader vers qui les gens peuvent venir avec des défis ou des préoccupations. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72418,
                      "answer_id":30323,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:56.914Z",
                      "updated_at":"2022-01-10T23:23:56.914Z",
                      "text":"Dire à Wei : « Tu sais, je n’ai jamais eu de problème avec Mike non plus, mais tout signalement de harcèlement doit être pris au sérieux. Je sais que tu veux être un responsable auquel les gens peuvent s’adresser lorsqu’ils ont des problèmes ou des préoccupations.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72417,
                      "answer_id":30323,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:56.910Z",
                      "updated_at":"2022-01-10T23:23:56.910Z",
                      "text":"Dizer a Wei: “Sabe, eu também nunca tive problemas com o Mike, mas precisamos levar as denúncias de assédio a sério. Eu sei que você se preocupa muito em ser um líder a quem as pessoas possam chegar com desafios ou preocupações.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72416,
                      "answer_id":30323,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:56.905Z",
                      "updated_at":"2022-01-10T23:23:56.905Z",
                      "text":"告訴 Wei：「你知道的，我不曾跟 Mike 有過任何問題，但我們必須嚴肅對待騷擾的通報。我知道你很在乎自己是個大家能夠向你傾訴困難或疑慮的主管。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72415,
                      "answer_id":30323,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:56.900Z",
                      "updated_at":"2022-01-10T23:23:56.900Z",
                      "text":"Sabihin kay Wei, “Alam mo, hindi ako nagkaroon ng problema kay Mike, ngunit kailangan nating seryosohin ang mga ulat ng panliligalig. Alam kong mahalaga sa iyo ang tungkol sa pagiging isang pinuno na maaaring makaranas ng mga tao ng mga hamon o alalahanin. ”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72414,
                      "answer_id":30323,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:56.895Z",
                      "updated_at":"2022-01-10T23:23:56.895Z",
                      "text":"Decir a Wei: “Sabes, nunca tuve un problema con Mike, pero debemos tomar seriamente las denuncias de acoso. Sé que te interesa ser un líder al que las personas puedan recurrir con desafíos o inquietudes”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72413,
                      "answer_id":30323,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:56.890Z",
                      "updated_at":"2022-01-10T23:23:56.890Z",
                      "text":"告诉 Wei，“你知道，我与 Mike 之间也从未发生过问题，但我们确实需要严肃对待骚扰举报。我知道作为一名领导你很在意，因为人们遇到挑战或问题都会来找你。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31701,
                "position":3,
                "active":true,
                "question_id":12053,
                "created_at":"2022-04-21T21:51:41.847Z",
                "updated_at":"2022-04-21T21:51:41.847Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Do your own investigation into the situation to see if Miranda is as bad as Jaylan says.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77371,
                      "answer_id":31701,
                      "locale":"en",
                      "created_at":"2022-04-21T21:51:41.854Z",
                      "updated_at":"2022-04-21T21:51:41.854Z",
                      "text":"Do your own investigation into the situation to see if Miranda is as bad as Jaylan says.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12054,
          "shuffle":false,
          "position":29,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30325"
          ],
          "created_at":"2022-01-10T23:23:56.974Z",
          "updated_at":"2022-04-21T21:52:11.842Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":29,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best action for you to take?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30088,
                "question_id":12054,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:57.131Z",
                "updated_at":"2022-01-10T23:23:57.131Z",
                "text":"Ne yapmalısınız?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30087,
                "question_id":12054,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:57.126Z",
                "updated_at":"2022-01-10T23:23:57.126Z",
                "text":"¿Qué debería hacer?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30086,
                "question_id":12054,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:57.122Z",
                "updated_at":"2022-01-10T23:23:57.122Z",
                "text":"Что вам следует сделать?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30085,
                "question_id":12054,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:57.117Z",
                "updated_at":"2022-01-10T23:23:57.117Z",
                "text":"Co należy zrobić?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30084,
                "question_id":12054,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:57.112Z",
                "updated_at":"2022-01-10T23:23:57.112Z",
                "text":"어떻게 하시겠습니까?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30083,
                "question_id":12054,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:57.107Z",
                "updated_at":"2022-01-10T23:23:57.107Z",
                "text":"あなたは何をすべきでしょうか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30082,
                "question_id":12054,
                "locale":"it",
                "created_at":"2022-01-10T23:23:57.101Z",
                "updated_at":"2022-01-10T23:23:57.101Z",
                "text":"Che cosa dovresti fare?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30081,
                "question_id":12054,
                "locale":"de",
                "created_at":"2022-01-10T23:23:57.097Z",
                "updated_at":"2022-01-10T23:23:57.097Z",
                "text":"Was sollten Sie tun?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30080,
                "question_id":12054,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:57.091Z",
                "updated_at":"2022-01-10T23:23:57.091Z",
                "text":"Que devriez-vous faire?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30079,
                "question_id":12054,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:57.087Z",
                "updated_at":"2022-01-10T23:23:57.087Z",
                "text":"Que devriez-vous faire ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30078,
                "question_id":12054,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:57.082Z",
                "updated_at":"2022-01-10T23:23:57.082Z",
                "text":"O que você deve fazer?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30077,
                "question_id":12054,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:57.077Z",
                "updated_at":"2022-01-10T23:23:57.077Z",
                "text":"你應該怎麼做？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30076,
                "question_id":12054,
                "locale":"es",
                "created_at":"2022-01-10T23:23:57.072Z",
                "updated_at":"2022-01-10T23:23:57.072Z",
                "text":"¿Qué debes hacer?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30075,
                "question_id":12054,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:57.067Z",
                "updated_at":"2022-01-10T23:23:57.067Z",
                "text":"Ano ang dapat mong gawin?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30074,
                "question_id":12054,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:57.062Z",
                "updated_at":"2022-01-10T23:23:57.062Z",
                "text":"我们应怎么做？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30073,
                "question_id":12054,
                "locale":"en",
                "created_at":"2022-01-10T23:23:56.993Z",
                "updated_at":"2022-04-21T21:52:11.844Z",
                "text":"What is the best action for you to take?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30324,
                "position":1,
                "active":true,
                "question_id":12054,
                "created_at":"2022-01-10T23:23:57.137Z",
                "updated_at":"2022-04-21T21:52:25.511Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Say to Mustafa, “Just ignore Darryl. He’s only joking with you.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72428,
                      "answer_id":30324,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:57.150Z",
                      "updated_at":"2022-04-21T21:52:25.514Z",
                      "text":"Say to Mustafa, “Just ignore Darryl. He’s only joking with you.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72443,
                      "answer_id":30324,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:57.221Z",
                      "updated_at":"2022-01-10T23:23:57.221Z",
                      "text":"Şöyle yanıtlayın: \"Evet, Sean her zaman kötü şakalar yapmaya çalışıyor. Yapılacak en iyi şey onu görmezden gelmektir.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72442,
                      "answer_id":30324,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:57.216Z",
                      "updated_at":"2022-01-10T23:23:57.216Z",
                      "text":"Responder: \"Sí, Sean siempre intenta hacer bromas fáciles. Quizás sea mejor ignorarlo\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72441,
                      "answer_id":30324,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:57.211Z",
                      "updated_at":"2022-01-10T23:23:57.211Z",
                      "text":"Ответить: «Да, Шон постоянно отпускает пошлые шуточки. По-моему, лучше всего не обращать на него внимания».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72440,
                      "answer_id":30324,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:57.207Z",
                      "updated_at":"2022-01-10T23:23:57.207Z",
                      "text":"Odpowiedzieć: „Tak, Sean zawsze próbuje wszystko obracać w tani żart. Ignorowanie go jest chyba najlepszym rozwiązaniem”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72439,
                      "answer_id":30324,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:57.202Z",
                      "updated_at":"2022-01-10T23:23:57.202Z",
                      "text":"다음과 같이 대응한다: “알아요, Sean은 항상 천박한 농담을 즐겨해요. 그를 무시하는 게 아마 가장 좋을 거예요.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72438,
                      "answer_id":30324,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:57.197Z",
                      "updated_at":"2022-01-10T23:23:57.197Z",
                      "text":"以下のように返答する。「Seanさんは、いつもくだらない冗談を言おうとしています。無視することが最善の策でしょう。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72437,
                      "answer_id":30324,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:57.192Z",
                      "updated_at":"2022-01-10T23:23:57.192Z",
                      "text":"Rispondere: “Sì, Sean cerca sempre di fare una battuta da quattro soldi. Probabilmente la soluzione migliore è ignorarlo”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72436,
                      "answer_id":30324,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:57.188Z",
                      "updated_at":"2022-01-10T23:23:57.188Z",
                      "text":"Antworten: „Ja, Sean macht immer so billige Witze. Wahrscheinlich ignorieren wir ihn am besten.“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72435,
                      "answer_id":30324,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:57.183Z",
                      "updated_at":"2022-01-10T23:23:57.183Z",
                      "text":"Répondre: « Ouais, Sean essaie toujours de faire une blague bon marché. L'ignorer est probablement meilleur.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72434,
                      "answer_id":30324,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:57.178Z",
                      "updated_at":"2022-01-10T23:23:57.178Z",
                      "text":"Répondre : « Ouais, Sean essaie toujours de faire des blagues faciles. Le mieux à faire, c’est de l’ignorer. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72433,
                      "answer_id":30324,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:57.173Z",
                      "updated_at":"2022-01-10T23:23:57.173Z",
                      "text":"Responder: “Sean está sempre tentando fazer uma piada de mau gosto. Ignorá-lo provavelmente é o melhor. ”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72432,
                      "answer_id":30324,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:57.169Z",
                      "updated_at":"2022-01-10T23:23:57.169Z",
                      "text":"Responder: “Sí, Sean siempre trata de hacer una broma tonta. Ignorarlo probablemente sea lo mejor”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72431,
                      "answer_id":30324,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:57.164Z",
                      "updated_at":"2022-01-10T23:23:57.164Z",
                      "text":"Tugon: “Oo, palaging sinusubukan ni Sean na gumawa ng korning biro. Marahil ay pinakamabuti na hindi na lang siya pansinin.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72430,
                      "answer_id":30324,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:57.159Z",
                      "updated_at":"2022-01-10T23:23:57.159Z",
                      "text":"响应：“是的，Sean 总是在试着讲低俗的玩笑。不理他或许最好。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72429,
                      "answer_id":30324,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:57.154Z",
                      "updated_at":"2022-01-10T23:23:57.154Z",
                      "text":"回應：「是，Sean 總愛說些不入流的笑話。最好的方法就是忽略他。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30325,
                "position":2,
                "active":true,
                "question_id":12054,
                "created_at":"2022-01-10T23:23:57.227Z",
                "updated_at":"2022-04-21T21:52:37.681Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Find Darryl and confront him about the inappropriate jokes.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72459,
                      "answer_id":30325,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:57.323Z",
                      "updated_at":"2022-01-10T23:23:57.323Z",
                      "text":"Şöyle yanıtlayın: \"Bu duyduğuma çok üzüldüm. Seni üzdüğüm çok açık.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72458,
                      "answer_id":30325,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:57.318Z",
                      "updated_at":"2022-01-10T23:23:57.318Z",
                      "text":"Responder: \"Siento mucho oír eso. Está claro que te está molestando\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72457,
                      "answer_id":30325,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:57.313Z",
                      "updated_at":"2022-01-10T23:23:57.313Z",
                      "text":"Ответить: «Мне очень жаль, что так произошло. Вас это явно расстраивает».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72456,
                      "answer_id":30325,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:57.309Z",
                      "updated_at":"2022-01-10T23:23:57.309Z",
                      "text":"Odpowiedzieć: „Bardzo przykro mi to słyszeć. Widać, że Cię to denerwuje”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72455,
                      "answer_id":30325,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:57.304Z",
                      "updated_at":"2022-01-10T23:23:57.304Z",
                      "text":"다음과 같이 대응한다: “그런 일이 있었다니 매우 유감이에요. 당신이 분명 걱정할 만 하네요.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72454,
                      "answer_id":30325,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:57.299Z",
                      "updated_at":"2022-01-10T23:23:57.299Z",
                      "text":"以下のように返答する。「とても残念な話です。明らかに、あなたを動揺させるような内容です。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72453,
                      "answer_id":30325,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:57.290Z",
                      "updated_at":"2022-01-10T23:23:57.290Z",
                      "text":"Rispondere: “Mi dispiace molto sentire di questa situazione. Ti sta chiaramente turbando”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72452,
                      "answer_id":30325,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:57.282Z",
                      "updated_at":"2022-01-10T23:23:57.282Z",
                      "text":"Antworten: „Es tut mir wirklich leid, das zu hören. Klar, dass es dich aus der Fassung bringt.“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72451,
                      "answer_id":30325,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:57.274Z",
                      "updated_at":"2022-01-10T23:23:57.274Z",
                      "text":"Répondre: « Je suis vraiment désolé d'apprendre cela. Cela vous dérange clairement.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72450,
                      "answer_id":30325,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:57.269Z",
                      "updated_at":"2022-01-10T23:23:57.269Z",
                      "text":"Répondre : « Je suis vraiment désolé de l’apprendre. Manifestement, cela te contrarie. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72449,
                      "answer_id":30325,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:57.264Z",
                      "updated_at":"2022-01-10T23:23:57.264Z",
                      "text":"Responder: “Sinto muito por isso. Isso está claramente chateando você.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72448,
                      "answer_id":30325,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:57.260Z",
                      "updated_at":"2022-01-10T23:23:57.260Z",
                      "text":"Responder: “Realmente lamento escuchar esto. Claramente te está afectando”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72447,
                      "answer_id":30325,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:57.255Z",
                      "updated_at":"2022-01-10T23:23:57.255Z",
                      "text":"Tugon: “Lubhang ikinalulungkot kong marinig ang tungkol dito. Talagang nakakainis ito para sa iyo.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72446,
                      "answer_id":30325,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:57.250Z",
                      "updated_at":"2022-01-10T23:23:57.250Z",
                      "text":"响应：“听到这件事情我确实很难过。很明显它让你伤心了。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72445,
                      "answer_id":30325,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:57.244Z",
                      "updated_at":"2022-01-10T23:23:57.244Z",
                      "text":"回應：「我很遺憾聽到這件事情。這件事很顯然讓你覺得不舒服。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72444,
                      "answer_id":30325,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:57.240Z",
                      "updated_at":"2022-04-21T21:52:37.683Z",
                      "text":"Find Darryl and confront him about the inappropriate jokes.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31702,
                "position":3,
                "active":true,
                "question_id":12054,
                "created_at":"2022-04-21T21:52:49.106Z",
                "updated_at":"2022-04-21T21:52:49.106Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Say to Mustafa, “I’m really sorry you’re having to deal with this. It’s clearly upsetting you.” Then, discuss his options.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77372,
                      "answer_id":31702,
                      "locale":"en",
                      "created_at":"2022-04-21T21:52:49.113Z",
                      "updated_at":"2022-04-21T21:52:49.113Z",
                      "text":"Say to Mustafa, “I’m really sorry you’re having to deal with this. It’s clearly upsetting you.” Then, discuss his options.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12055,
          "shuffle":false,
          "position":30,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30327"
          ],
          "created_at":"2022-01-10T23:23:57.341Z",
          "updated_at":"2022-04-21T21:54:02.679Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":30,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best action for you to take?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30104,
                "question_id":12055,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:57.500Z",
                "updated_at":"2022-01-10T23:23:57.500Z",
                "text":"Bu sonuç doğru mu yanlış mı?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30103,
                "question_id":12055,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:57.495Z",
                "updated_at":"2022-01-10T23:23:57.495Z",
                "text":"¿Esta conclusión es verdadera o falsa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30102,
                "question_id":12055,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:57.490Z",
                "updated_at":"2022-01-10T23:23:57.490Z",
                "text":"Этот вывод правда или ложь?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30101,
                "question_id":12055,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:57.485Z",
                "updated_at":"2022-01-10T23:23:57.485Z",
                "text":"Czy ten wniosek jest prawdziwy czy fałszywy?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30100,
                "question_id":12055,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:57.480Z",
                "updated_at":"2022-01-10T23:23:57.480Z",
                "text":"이 결론이 맞을까요 틀릴까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30099,
                "question_id":12055,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:57.475Z",
                "updated_at":"2022-01-10T23:23:57.475Z",
                "text":"この結論は正しいですか、間違っていますか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30098,
                "question_id":12055,
                "locale":"it",
                "created_at":"2022-01-10T23:23:57.471Z",
                "updated_at":"2022-01-10T23:23:57.471Z",
                "text":"Questa conclusione è vera o falsa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30097,
                "question_id":12055,
                "locale":"de",
                "created_at":"2022-01-10T23:23:57.466Z",
                "updated_at":"2022-01-10T23:23:57.466Z",
                "text":"Ist diese Folgerung richtig oder falsch?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30096,
                "question_id":12055,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:57.461Z",
                "updated_at":"2022-01-10T23:23:57.461Z",
                "text":"Cette conclusion est-elle vraie ou fausse?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30095,
                "question_id":12055,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:57.456Z",
                "updated_at":"2022-01-10T23:23:57.456Z",
                "text":"Cette conclusion est-elle vraie ou fausse ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30094,
                "question_id":12055,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:57.451Z",
                "updated_at":"2022-01-10T23:23:57.451Z",
                "text":"Essa conclusão é verdadeira ou falsa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30093,
                "question_id":12055,
                "locale":"es",
                "created_at":"2022-01-10T23:23:57.446Z",
                "updated_at":"2022-01-10T23:23:57.446Z",
                "text":"¿Esta conclusión es verdadera o falsa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30092,
                "question_id":12055,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:57.442Z",
                "updated_at":"2022-01-10T23:23:57.442Z",
                "text":"Tama o mali ba ang konklusyong ito?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30091,
                "question_id":12055,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:57.436Z",
                "updated_at":"2022-01-10T23:23:57.436Z",
                "text":"该结论对还是错？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30090,
                "question_id":12055,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:57.431Z",
                "updated_at":"2022-01-10T23:23:57.431Z",
                "text":"這個結論是對的或錯的？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30089,
                "question_id":12055,
                "locale":"en",
                "created_at":"2022-01-10T23:23:57.360Z",
                "updated_at":"2022-04-21T21:54:02.682Z",
                "text":"What is the best action for you to take?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30326,
                "position":1,
                "active":true,
                "question_id":12055,
                "created_at":"2022-01-10T23:23:57.506Z",
                "updated_at":"2022-04-21T21:54:10.506Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Do nothing. It’s none of your business.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72475,
                      "answer_id":30326,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:57.590Z",
                      "updated_at":"2022-01-10T23:23:57.590Z",
                      "text":"Doğru",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72474,
                      "answer_id":30326,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:57.586Z",
                      "updated_at":"2022-01-10T23:23:57.586Z",
                      "text":"Verdadera",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72473,
                      "answer_id":30326,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:57.581Z",
                      "updated_at":"2022-01-10T23:23:57.581Z",
                      "text":"Правда",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72472,
                      "answer_id":30326,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:57.576Z",
                      "updated_at":"2022-01-10T23:23:57.576Z",
                      "text":"Prawda",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72471,
                      "answer_id":30326,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:57.571Z",
                      "updated_at":"2022-01-10T23:23:57.571Z",
                      "text":"맞음",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72470,
                      "answer_id":30326,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:57.566Z",
                      "updated_at":"2022-01-10T23:23:57.566Z",
                      "text":"〇",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72469,
                      "answer_id":30326,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:57.561Z",
                      "updated_at":"2022-01-10T23:23:57.561Z",
                      "text":"Vero",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72468,
                      "answer_id":30326,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:57.557Z",
                      "updated_at":"2022-01-10T23:23:57.557Z",
                      "text":"Richtig",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72467,
                      "answer_id":30326,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:57.552Z",
                      "updated_at":"2022-01-10T23:23:57.552Z",
                      "text":"Vrai",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72466,
                      "answer_id":30326,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:57.547Z",
                      "updated_at":"2022-01-10T23:23:57.547Z",
                      "text":"Verdadeira",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72465,
                      "answer_id":30326,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:57.543Z",
                      "updated_at":"2022-01-10T23:23:57.543Z",
                      "text":"Vrai",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72464,
                      "answer_id":30326,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:57.538Z",
                      "updated_at":"2022-01-10T23:23:57.538Z",
                      "text":"Verdadero",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72463,
                      "answer_id":30326,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:57.533Z",
                      "updated_at":"2022-01-10T23:23:57.533Z",
                      "text":"Tama",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72462,
                      "answer_id":30326,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:57.528Z",
                      "updated_at":"2022-01-10T23:23:57.528Z",
                      "text":"对",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72461,
                      "answer_id":30326,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:57.524Z",
                      "updated_at":"2022-01-10T23:23:57.524Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72460,
                      "answer_id":30326,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:57.520Z",
                      "updated_at":"2022-04-21T21:54:10.509Z",
                      "text":"Do nothing. It’s none of your business.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30327,
                "position":2,
                "active":true,
                "question_id":12055,
                "created_at":"2022-01-10T23:23:57.596Z",
                "updated_at":"2022-04-21T21:54:19.105Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Disclose the potential harassment to your friend so they and their colleagues can protect themselves.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72476,
                      "answer_id":30327,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:57.610Z",
                      "updated_at":"2022-04-21T21:54:19.107Z",
                      "text":"Disclose the potential harassment to your friend so they and their colleagues can protect themselves.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72491,
                      "answer_id":30327,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:57.682Z",
                      "updated_at":"2022-01-10T23:23:57.682Z",
                      "text":"Yanlış",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72490,
                      "answer_id":30327,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:57.678Z",
                      "updated_at":"2022-01-10T23:23:57.678Z",
                      "text":"Falsa",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72489,
                      "answer_id":30327,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:57.673Z",
                      "updated_at":"2022-01-10T23:23:57.673Z",
                      "text":"Ложь",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72488,
                      "answer_id":30327,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:57.668Z",
                      "updated_at":"2022-01-10T23:23:57.668Z",
                      "text":"Fałsz",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72487,
                      "answer_id":30327,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:57.663Z",
                      "updated_at":"2022-01-10T23:23:57.663Z",
                      "text":"틀림",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72486,
                      "answer_id":30327,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:57.658Z",
                      "updated_at":"2022-01-10T23:23:57.658Z",
                      "text":"×",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72485,
                      "answer_id":30327,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:57.653Z",
                      "updated_at":"2022-01-10T23:23:57.653Z",
                      "text":"Falso",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72484,
                      "answer_id":30327,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:57.648Z",
                      "updated_at":"2022-01-10T23:23:57.648Z",
                      "text":"Falsch",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72483,
                      "answer_id":30327,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:57.643Z",
                      "updated_at":"2022-01-10T23:23:57.643Z",
                      "text":"Faux",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72482,
                      "answer_id":30327,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:57.638Z",
                      "updated_at":"2022-01-10T23:23:57.638Z",
                      "text":"Fausse",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72481,
                      "answer_id":30327,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:57.633Z",
                      "updated_at":"2022-01-10T23:23:57.633Z",
                      "text":"Falsa",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72480,
                      "answer_id":30327,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:57.628Z",
                      "updated_at":"2022-01-10T23:23:57.628Z",
                      "text":"Falso",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72479,
                      "answer_id":30327,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:57.623Z",
                      "updated_at":"2022-01-10T23:23:57.623Z",
                      "text":"Mali",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72478,
                      "answer_id":30327,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:57.618Z",
                      "updated_at":"2022-01-10T23:23:57.618Z",
                      "text":"错",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72477,
                      "answer_id":30327,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:57.614Z",
                      "updated_at":"2022-01-10T23:23:57.614Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31703,
                "position":3,
                "active":true,
                "question_id":12055,
                "created_at":"2022-04-21T21:54:32.210Z",
                "updated_at":"2022-04-21T21:54:32.210Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Report the rumor directly to human resources or another appropriate channel under our policy.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77373,
                      "answer_id":31703,
                      "locale":"en",
                      "created_at":"2022-04-21T21:54:32.214Z",
                      "updated_at":"2022-04-21T21:54:32.214Z",
                      "text":"Report the rumor directly to human resources or another appropriate channel under our policy.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12056,
          "shuffle":false,
          "position":31,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30328"
          ],
          "created_at":"2022-01-10T23:23:57.699Z",
          "updated_at":"2022-04-21T21:55:31.654Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":31,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best action for you to take?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30120,
                "question_id":12056,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:57.872Z",
                "updated_at":"2022-01-10T23:23:57.872Z",
                "text":"Bu sonuç doğru mu yanlış mı?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30119,
                "question_id":12056,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:57.867Z",
                "updated_at":"2022-01-10T23:23:57.867Z",
                "text":"¿Esta conclusión es verdadera o falsa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30118,
                "question_id":12056,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:57.863Z",
                "updated_at":"2022-01-10T23:23:57.863Z",
                "text":"Этот вывод правда или ложь?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30117,
                "question_id":12056,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:57.858Z",
                "updated_at":"2022-01-10T23:23:57.858Z",
                "text":"Czy ten wniosek jest prawdziwy czy fałszywy?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30116,
                "question_id":12056,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:57.853Z",
                "updated_at":"2022-01-10T23:23:57.853Z",
                "text":"이 결론이 맞을까요 틀릴까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30115,
                "question_id":12056,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:57.847Z",
                "updated_at":"2022-01-10T23:23:57.847Z",
                "text":"この結論は正しいですか、間違っていますか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30114,
                "question_id":12056,
                "locale":"it",
                "created_at":"2022-01-10T23:23:57.842Z",
                "updated_at":"2022-01-10T23:23:57.842Z",
                "text":"Questa conclusione è vera o falsa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30113,
                "question_id":12056,
                "locale":"de",
                "created_at":"2022-01-10T23:23:57.838Z",
                "updated_at":"2022-01-10T23:23:57.838Z",
                "text":"Ist diese Folgerung richtig oder falsch?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30112,
                "question_id":12056,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:57.833Z",
                "updated_at":"2022-01-10T23:23:57.833Z",
                "text":"Cette conclusion est-elle vraie ou fausse?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30111,
                "question_id":12056,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:57.826Z",
                "updated_at":"2022-01-10T23:23:57.826Z",
                "text":"Cette conclusion est-elle vraie ou fausse ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30110,
                "question_id":12056,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:57.821Z",
                "updated_at":"2022-01-10T23:23:57.821Z",
                "text":"Essa conclusão é verdadeira ou falsa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30109,
                "question_id":12056,
                "locale":"es",
                "created_at":"2022-01-10T23:23:57.816Z",
                "updated_at":"2022-01-10T23:23:57.816Z",
                "text":"¿Esta conclusión es verdadera o falsa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30108,
                "question_id":12056,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:57.811Z",
                "updated_at":"2022-01-10T23:23:57.811Z",
                "text":"Tama o mali ba ang konklusyong ito?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30107,
                "question_id":12056,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:57.807Z",
                "updated_at":"2022-01-10T23:23:57.807Z",
                "text":"這個結論是對的或錯的？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30106,
                "question_id":12056,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:57.802Z",
                "updated_at":"2022-01-10T23:23:57.802Z",
                "text":"该结论对还是错？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30105,
                "question_id":12056,
                "locale":"en",
                "created_at":"2022-01-10T23:23:57.718Z",
                "updated_at":"2022-04-21T21:55:31.657Z",
                "text":"What is the best action for you to take?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30328,
                "position":1,
                "active":true,
                "question_id":12056,
                "created_at":"2022-01-10T23:23:57.879Z",
                "updated_at":"2022-04-21T21:55:43.657Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"None. This can wait until you come back from vacation.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72507,
                      "answer_id":30328,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:57.965Z",
                      "updated_at":"2022-01-10T23:23:57.965Z",
                      "text":"Doğru",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72506,
                      "answer_id":30328,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:57.959Z",
                      "updated_at":"2022-01-10T23:23:57.959Z",
                      "text":"Verdadera",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72505,
                      "answer_id":30328,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:57.954Z",
                      "updated_at":"2022-01-10T23:23:57.954Z",
                      "text":"Правда",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72504,
                      "answer_id":30328,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:57.949Z",
                      "updated_at":"2022-01-10T23:23:57.949Z",
                      "text":"Prawda",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72503,
                      "answer_id":30328,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:57.945Z",
                      "updated_at":"2022-01-10T23:23:57.945Z",
                      "text":"맞음",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72502,
                      "answer_id":30328,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:57.940Z",
                      "updated_at":"2022-01-10T23:23:57.940Z",
                      "text":"〇",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72501,
                      "answer_id":30328,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:57.935Z",
                      "updated_at":"2022-01-10T23:23:57.935Z",
                      "text":"Vero",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72500,
                      "answer_id":30328,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:57.931Z",
                      "updated_at":"2022-01-10T23:23:57.931Z",
                      "text":"Richtig",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72499,
                      "answer_id":30328,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:57.926Z",
                      "updated_at":"2022-01-10T23:23:57.926Z",
                      "text":"Vrai",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72498,
                      "answer_id":30328,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:57.921Z",
                      "updated_at":"2022-01-10T23:23:57.921Z",
                      "text":"Verdadeira",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72497,
                      "answer_id":30328,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:57.916Z",
                      "updated_at":"2022-01-10T23:23:57.916Z",
                      "text":"Vrai",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72496,
                      "answer_id":30328,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:57.911Z",
                      "updated_at":"2022-01-10T23:23:57.911Z",
                      "text":"Verdadero",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72495,
                      "answer_id":30328,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:57.906Z",
                      "updated_at":"2022-01-10T23:23:57.906Z",
                      "text":"Tama",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72494,
                      "answer_id":30328,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:57.901Z",
                      "updated_at":"2022-01-10T23:23:57.901Z",
                      "text":"对",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72493,
                      "answer_id":30328,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:57.896Z",
                      "updated_at":"2022-01-10T23:23:57.896Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72492,
                      "answer_id":30328,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:57.892Z",
                      "updated_at":"2022-04-21T21:55:43.659Z",
                      "text":"None. This can wait until you come back from vacation.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30329,
                "position":2,
                "active":true,
                "question_id":12056,
                "created_at":"2022-01-10T23:23:57.971Z",
                "updated_at":"2022-04-21T21:55:55.916Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell your employee to report the incident to human resources since you are about to leave.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72508,
                      "answer_id":30329,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:57.984Z",
                      "updated_at":"2022-04-21T21:55:55.918Z",
                      "text":"Tell your employee to report the incident to human resources since you are about to leave.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72523,
                      "answer_id":30329,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:58.058Z",
                      "updated_at":"2022-01-10T23:23:58.058Z",
                      "text":"Yanlış",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72522,
                      "answer_id":30329,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:58.053Z",
                      "updated_at":"2022-01-10T23:23:58.053Z",
                      "text":"Falsa",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72521,
                      "answer_id":30329,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:58.048Z",
                      "updated_at":"2022-01-10T23:23:58.048Z",
                      "text":"Ложь",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72520,
                      "answer_id":30329,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:58.044Z",
                      "updated_at":"2022-01-10T23:23:58.044Z",
                      "text":"Fałsz",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72519,
                      "answer_id":30329,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:58.039Z",
                      "updated_at":"2022-01-10T23:23:58.039Z",
                      "text":"틀림",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72518,
                      "answer_id":30329,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:58.034Z",
                      "updated_at":"2022-01-10T23:23:58.034Z",
                      "text":"×",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72517,
                      "answer_id":30329,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:58.029Z",
                      "updated_at":"2022-01-10T23:23:58.029Z",
                      "text":"Falso",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72516,
                      "answer_id":30329,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:58.024Z",
                      "updated_at":"2022-01-10T23:23:58.024Z",
                      "text":"Falsch",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72515,
                      "answer_id":30329,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:58.018Z",
                      "updated_at":"2022-01-10T23:23:58.018Z",
                      "text":"Faux",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72514,
                      "answer_id":30329,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:58.013Z",
                      "updated_at":"2022-01-10T23:23:58.013Z",
                      "text":"Fausse",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72513,
                      "answer_id":30329,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:58.007Z",
                      "updated_at":"2022-01-10T23:23:58.007Z",
                      "text":"Falsa",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72512,
                      "answer_id":30329,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:58.003Z",
                      "updated_at":"2022-01-10T23:23:58.003Z",
                      "text":"Falso",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72511,
                      "answer_id":30329,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:57.998Z",
                      "updated_at":"2022-01-10T23:23:57.998Z",
                      "text":"Mali",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72510,
                      "answer_id":30329,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:57.993Z",
                      "updated_at":"2022-01-10T23:23:57.993Z",
                      "text":"错",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72509,
                      "answer_id":30329,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:57.988Z",
                      "updated_at":"2022-01-10T23:23:57.988Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31704,
                "position":3,
                "active":true,
                "question_id":12056,
                "created_at":"2022-04-21T21:56:05.205Z",
                "updated_at":"2022-04-21T21:56:05.205Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Immediately report the harassment to the appropriate channel. This can’t wait.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77374,
                      "answer_id":31704,
                      "locale":"en",
                      "created_at":"2022-04-21T21:56:05.213Z",
                      "updated_at":"2022-04-21T21:56:05.213Z",
                      "text":"Immediately report the harassment to the appropriate channel. This can’t wait.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12057,
          "shuffle":false,
          "position":32,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30331"
          ],
          "created_at":"2022-01-10T23:23:58.075Z",
          "updated_at":"2022-04-21T21:57:14.838Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":32,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best action for you to take?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30121,
                "question_id":12057,
                "locale":"en",
                "created_at":"2022-01-10T23:23:58.094Z",
                "updated_at":"2022-04-21T21:57:14.841Z",
                "text":"What is the best action for you to take?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30136,
                "question_id":12057,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:58.242Z",
                "updated_at":"2022-01-10T23:23:58.242Z",
                "text":"Bu sonuç doğru mu yanlış mı?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30135,
                "question_id":12057,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:58.237Z",
                "updated_at":"2022-01-10T23:23:58.237Z",
                "text":"¿Esta conclusión es verdadera o falsa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30134,
                "question_id":12057,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:58.232Z",
                "updated_at":"2022-01-10T23:23:58.232Z",
                "text":"Этот вывод правда или ложь?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30133,
                "question_id":12057,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:58.228Z",
                "updated_at":"2022-01-10T23:23:58.228Z",
                "text":"Czy ten wniosek jest prawdziwy czy fałszywy?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30132,
                "question_id":12057,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:58.223Z",
                "updated_at":"2022-01-10T23:23:58.223Z",
                "text":"이 결론이 맞을까요 틀릴까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30131,
                "question_id":12057,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:58.218Z",
                "updated_at":"2022-01-10T23:23:58.218Z",
                "text":"この結論は正しいですか、間違っていますか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30130,
                "question_id":12057,
                "locale":"it",
                "created_at":"2022-01-10T23:23:58.213Z",
                "updated_at":"2022-01-10T23:23:58.213Z",
                "text":"Questa conclusione è vera o falsa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30129,
                "question_id":12057,
                "locale":"de",
                "created_at":"2022-01-10T23:23:58.208Z",
                "updated_at":"2022-01-10T23:23:58.208Z",
                "text":"Ist diese Folgerung richtig oder falsch?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30128,
                "question_id":12057,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:58.203Z",
                "updated_at":"2022-01-10T23:23:58.203Z",
                "text":"Cette conclusion est-elle vraie ou fausse?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30127,
                "question_id":12057,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:58.198Z",
                "updated_at":"2022-01-10T23:23:58.198Z",
                "text":"Cette conclusion est-elle vraie ou fausse ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30126,
                "question_id":12057,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:58.194Z",
                "updated_at":"2022-01-10T23:23:58.194Z",
                "text":"Essa conclusão é verdadeira ou falsa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30125,
                "question_id":12057,
                "locale":"es",
                "created_at":"2022-01-10T23:23:58.188Z",
                "updated_at":"2022-01-10T23:23:58.188Z",
                "text":"¿Esta conclusión es verdadera o falsa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30124,
                "question_id":12057,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:58.184Z",
                "updated_at":"2022-01-10T23:23:58.184Z",
                "text":"Tama o mali ba ang konklusyong ito?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30123,
                "question_id":12057,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:58.178Z",
                "updated_at":"2022-01-10T23:23:58.178Z",
                "text":"這個結論是對的或錯的？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30122,
                "question_id":12057,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:58.173Z",
                "updated_at":"2022-01-10T23:23:58.173Z",
                "text":"该结论对还是错？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30330,
                "position":1,
                "active":true,
                "question_id":12057,
                "created_at":"2022-01-10T23:23:58.249Z",
                "updated_at":"2022-04-21T21:57:21.849Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Ignore the rumor. You don’t want to upset Kyle, and it’s only a rumor, anyway.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72524,
                      "answer_id":30330,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:58.263Z",
                      "updated_at":"2022-04-21T21:57:21.851Z",
                      "text":"Ignore the rumor. You don’t want to upset Kyle, and it’s only a rumor, anyway.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72539,
                      "answer_id":30330,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:58.333Z",
                      "updated_at":"2022-01-10T23:23:58.333Z",
                      "text":"Doğru",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72538,
                      "answer_id":30330,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:58.329Z",
                      "updated_at":"2022-01-10T23:23:58.329Z",
                      "text":"Verdadera",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72537,
                      "answer_id":30330,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:58.324Z",
                      "updated_at":"2022-01-10T23:23:58.324Z",
                      "text":"Правда",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72536,
                      "answer_id":30330,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:58.319Z",
                      "updated_at":"2022-01-10T23:23:58.319Z",
                      "text":"Prawda",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72535,
                      "answer_id":30330,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:58.315Z",
                      "updated_at":"2022-01-10T23:23:58.315Z",
                      "text":"맞음",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72534,
                      "answer_id":30330,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:58.310Z",
                      "updated_at":"2022-01-10T23:23:58.310Z",
                      "text":"〇",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72533,
                      "answer_id":30330,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:58.305Z",
                      "updated_at":"2022-01-10T23:23:58.305Z",
                      "text":"Vero",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72532,
                      "answer_id":30330,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:58.300Z",
                      "updated_at":"2022-01-10T23:23:58.300Z",
                      "text":"Richtig",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72531,
                      "answer_id":30330,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:58.296Z",
                      "updated_at":"2022-01-10T23:23:58.296Z",
                      "text":"Vrai",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72530,
                      "answer_id":30330,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:58.291Z",
                      "updated_at":"2022-01-10T23:23:58.291Z",
                      "text":"Verdadeira",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72529,
                      "answer_id":30330,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:58.286Z",
                      "updated_at":"2022-01-10T23:23:58.286Z",
                      "text":"Vrai",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72528,
                      "answer_id":30330,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:58.281Z",
                      "updated_at":"2022-01-10T23:23:58.281Z",
                      "text":"Verdadero",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72527,
                      "answer_id":30330,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:58.277Z",
                      "updated_at":"2022-01-10T23:23:58.277Z",
                      "text":"Tama",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72526,
                      "answer_id":30330,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:58.272Z",
                      "updated_at":"2022-01-10T23:23:58.272Z",
                      "text":"对",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72525,
                      "answer_id":30330,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:58.267Z",
                      "updated_at":"2022-01-10T23:23:58.267Z",
                      "text":"是",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30331,
                "position":2,
                "active":true,
                "question_id":12057,
                "created_at":"2022-01-10T23:23:58.339Z",
                "updated_at":"2022-04-21T21:57:32.369Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Go to Kyle directly. He’ll probably respond better to this than a report to human resources.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72540,
                      "answer_id":30331,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:58.354Z",
                      "updated_at":"2022-04-21T21:57:32.373Z",
                      "text":"Go to Kyle directly. He’ll probably respond better to this than a report to human resources.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72555,
                      "answer_id":30331,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:58.430Z",
                      "updated_at":"2022-01-10T23:23:58.430Z",
                      "text":"Yanlış",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72554,
                      "answer_id":30331,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:58.425Z",
                      "updated_at":"2022-01-10T23:23:58.425Z",
                      "text":"Falsa",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72553,
                      "answer_id":30331,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:58.416Z",
                      "updated_at":"2022-01-10T23:23:58.416Z",
                      "text":"Ложь",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72552,
                      "answer_id":30331,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:58.412Z",
                      "updated_at":"2022-01-10T23:23:58.412Z",
                      "text":"Fałsz",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72551,
                      "answer_id":30331,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:58.407Z",
                      "updated_at":"2022-01-10T23:23:58.407Z",
                      "text":"틀림",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72550,
                      "answer_id":30331,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:58.402Z",
                      "updated_at":"2022-01-10T23:23:58.402Z",
                      "text":"×",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72549,
                      "answer_id":30331,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:58.398Z",
                      "updated_at":"2022-01-10T23:23:58.398Z",
                      "text":"Falso",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72548,
                      "answer_id":30331,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:58.393Z",
                      "updated_at":"2022-01-10T23:23:58.393Z",
                      "text":"Falsch",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72547,
                      "answer_id":30331,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:58.388Z",
                      "updated_at":"2022-01-10T23:23:58.388Z",
                      "text":"Faux",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72546,
                      "answer_id":30331,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:58.383Z",
                      "updated_at":"2022-01-10T23:23:58.383Z",
                      "text":"Fausse",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72545,
                      "answer_id":30331,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:58.379Z",
                      "updated_at":"2022-01-10T23:23:58.379Z",
                      "text":"Falsa",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72544,
                      "answer_id":30331,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:58.374Z",
                      "updated_at":"2022-01-10T23:23:58.374Z",
                      "text":"Falso",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72543,
                      "answer_id":30331,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:58.369Z",
                      "updated_at":"2022-01-10T23:23:58.369Z",
                      "text":"Mali",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72542,
                      "answer_id":30331,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:58.364Z",
                      "updated_at":"2022-01-10T23:23:58.364Z",
                      "text":"错",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72541,
                      "answer_id":30331,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:58.359Z",
                      "updated_at":"2022-01-10T23:23:58.359Z",
                      "text":"否",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31705,
                "position":3,
                "active":true,
                "question_id":12057,
                "created_at":"2022-04-21T21:57:55.400Z",
                "updated_at":"2022-04-21T21:57:55.400Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Report the incident directly to human resources or another appropriate channel.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77375,
                      "answer_id":31705,
                      "locale":"en",
                      "created_at":"2022-04-21T21:57:55.408Z",
                      "updated_at":"2022-04-21T21:57:55.408Z",
                      "text":"Report the incident directly to human resources or another appropriate channel.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12058,
          "shuffle":false,
          "position":33,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30334"
          ],
          "created_at":"2022-01-10T23:23:58.447Z",
          "updated_at":"2022-01-10T23:23:58.899Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":33,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"How often do you think people make false accusations?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30152,
                "question_id":12058,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:58.621Z",
                "updated_at":"2022-01-10T23:23:58.621Z",
                "text":"İnsanların ne sıklıkla yanlış suçlamalarda bulunduğunu düşünüyorsunuz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30151,
                "question_id":12058,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:58.617Z",
                "updated_at":"2022-01-10T23:23:58.617Z",
                "text":"¿Con qué frecuencia cree que la gente hace acusaciones falsas?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30150,
                "question_id":12058,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:58.611Z",
                "updated_at":"2022-01-10T23:23:58.611Z",
                "text":"Как часто, по вашему мнению, люди выдвигают ложные обвинения?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30149,
                "question_id":12058,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:58.606Z",
                "updated_at":"2022-01-10T23:23:58.606Z",
                "text":"Jak często, według Ciebie, ludzie rzucają fałszywe oskarżenia?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30148,
                "question_id":12058,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:58.602Z",
                "updated_at":"2022-01-10T23:23:58.602Z",
                "text":"사람들이 얼마나 자주 거짓 비난을 한다고 생각하나요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30147,
                "question_id":12058,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:58.597Z",
                "updated_at":"2022-01-10T23:23:58.597Z",
                "text":"人々はどのくらいの頻度で、虚偽の告発をすると思いますか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30146,
                "question_id":12058,
                "locale":"it",
                "created_at":"2022-01-10T23:23:58.592Z",
                "updated_at":"2022-01-10T23:23:58.592Z",
                "text":"Con quale frequenza pensi che le persone formulino false accuse?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30145,
                "question_id":12058,
                "locale":"de",
                "created_at":"2022-01-10T23:23:58.586Z",
                "updated_at":"2022-01-10T23:23:58.586Z",
                "text":"Wie häufig kommt es Ihrer Meinung nach zu falschen Anschuldigungen?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30144,
                "question_id":12058,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:58.581Z",
                "updated_at":"2022-01-10T23:23:58.581Z",
                "text":"À votre avis, à quelle fréquence les gens font-ils de fausses accusations?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30143,
                "question_id":12058,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:58.576Z",
                "updated_at":"2022-01-10T23:23:58.576Z",
                "text":"À votre avis, à quelle fréquence les gens font-ils de fausses accusations ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30142,
                "question_id":12058,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:58.571Z",
                "updated_at":"2022-01-10T23:23:58.571Z",
                "text":"Com que frequência você acha que as pessoas fazem acusações falsas?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30141,
                "question_id":12058,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:58.565Z",
                "updated_at":"2022-01-10T23:23:58.565Z",
                "text":"你認為人們多常做不實的指控？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30140,
                "question_id":12058,
                "locale":"es",
                "created_at":"2022-01-10T23:23:58.560Z",
                "updated_at":"2022-01-10T23:23:58.560Z",
                "text":"¿Con qué frecuencia crees que las personas presentan acusaciones falsas?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30139,
                "question_id":12058,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:58.555Z",
                "updated_at":"2022-01-10T23:23:58.555Z",
                "text":"Gaano kadalas sa palagay mo gumawa ang mga tao ng mga maling akusasyon?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30138,
                "question_id":12058,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:58.549Z",
                "updated_at":"2022-01-10T23:23:58.549Z",
                "text":"你认为人们每隔多久会实施虚假指控？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30137,
                "question_id":12058,
                "locale":"en",
                "created_at":"2022-01-10T23:23:58.466Z",
                "updated_at":"2022-01-10T23:23:58.466Z",
                "text":"How often do you think people make false accusations?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30332,
                "position":1,
                "active":true,
                "question_id":12058,
                "created_at":"2022-01-10T23:23:58.628Z",
                "updated_at":"2022-01-10T23:23:58.628Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"All the time.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72571,
                      "answer_id":30332,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:58.713Z",
                      "updated_at":"2022-01-10T23:23:58.713Z",
                      "text":"Her zaman.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72570,
                      "answer_id":30332,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:58.708Z",
                      "updated_at":"2022-01-10T23:23:58.708Z",
                      "text":"Siempre.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72569,
                      "answer_id":30332,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:58.703Z",
                      "updated_at":"2022-01-10T23:23:58.703Z",
                      "text":"Постоянно.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72568,
                      "answer_id":30332,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:58.699Z",
                      "updated_at":"2022-01-10T23:23:58.699Z",
                      "text":"Ciągle.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72567,
                      "answer_id":30332,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:58.694Z",
                      "updated_at":"2022-01-10T23:23:58.694Z",
                      "text":"항상",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72566,
                      "answer_id":30332,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:58.689Z",
                      "updated_at":"2022-01-10T23:23:58.689Z",
                      "text":"常に行っている。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72565,
                      "answer_id":30332,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:58.684Z",
                      "updated_at":"2022-01-10T23:23:58.684Z",
                      "text":"Sempre.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72564,
                      "answer_id":30332,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:58.680Z",
                      "updated_at":"2022-01-10T23:23:58.680Z",
                      "text":"Dauernd.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72563,
                      "answer_id":30332,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:58.675Z",
                      "updated_at":"2022-01-10T23:23:58.675Z",
                      "text":"Tout le temps.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72562,
                      "answer_id":30332,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:58.670Z",
                      "updated_at":"2022-01-10T23:23:58.670Z",
                      "text":"En permanence",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72561,
                      "answer_id":30332,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:58.665Z",
                      "updated_at":"2022-01-10T23:23:58.665Z",
                      "text":"O tempo todo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72560,
                      "answer_id":30332,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:58.661Z",
                      "updated_at":"2022-01-10T23:23:58.661Z",
                      "text":"Todo el tiempo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72559,
                      "answer_id":30332,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:58.656Z",
                      "updated_at":"2022-01-10T23:23:58.656Z",
                      "text":"Sa lahat ng oras.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72558,
                      "answer_id":30332,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:58.651Z",
                      "updated_at":"2022-01-10T23:23:58.651Z",
                      "text":"一直如此。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72557,
                      "answer_id":30332,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:58.646Z",
                      "updated_at":"2022-01-10T23:23:58.646Z",
                      "text":"常常。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72556,
                      "answer_id":30332,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:58.642Z",
                      "updated_at":"2022-01-10T23:23:58.642Z",
                      "text":"All the time.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30333,
                "position":2,
                "active":true,
                "question_id":12058,
                "created_at":"2022-01-10T23:23:58.719Z",
                "updated_at":"2022-01-10T23:23:58.719Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Sometimes.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72587,
                      "answer_id":30333,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:58.803Z",
                      "updated_at":"2022-01-10T23:23:58.803Z",
                      "text":"Bazen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72586,
                      "answer_id":30333,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:58.798Z",
                      "updated_at":"2022-01-10T23:23:58.798Z",
                      "text":"A veces.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72585,
                      "answer_id":30333,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:58.793Z",
                      "updated_at":"2022-01-10T23:23:58.793Z",
                      "text":"Иногда.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72584,
                      "answer_id":30333,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:58.789Z",
                      "updated_at":"2022-01-10T23:23:58.789Z",
                      "text":"Czasami.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72583,
                      "answer_id":30333,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:58.784Z",
                      "updated_at":"2022-01-10T23:23:58.784Z",
                      "text":"때때로",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72582,
                      "answer_id":30333,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:58.780Z",
                      "updated_at":"2022-01-10T23:23:58.780Z",
                      "text":"時々行っている。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72581,
                      "answer_id":30333,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:58.775Z",
                      "updated_at":"2022-01-10T23:23:58.775Z",
                      "text":"A volte.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72580,
                      "answer_id":30333,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:58.770Z",
                      "updated_at":"2022-01-10T23:23:58.770Z",
                      "text":"Manchmal.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72579,
                      "answer_id":30333,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:58.766Z",
                      "updated_at":"2022-01-10T23:23:58.766Z",
                      "text":"Parfois.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72578,
                      "answer_id":30333,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:58.761Z",
                      "updated_at":"2022-01-10T23:23:58.761Z",
                      "text":"Algumas vezes.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72577,
                      "answer_id":30333,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:58.757Z",
                      "updated_at":"2022-01-10T23:23:58.757Z",
                      "text":"Parfois.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72576,
                      "answer_id":30333,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:58.752Z",
                      "updated_at":"2022-01-10T23:23:58.752Z",
                      "text":"En ocasiones.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72575,
                      "answer_id":30333,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:58.747Z",
                      "updated_at":"2022-01-10T23:23:58.747Z",
                      "text":"Minsan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72574,
                      "answer_id":30333,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:58.742Z",
                      "updated_at":"2022-01-10T23:23:58.742Z",
                      "text":"有时候。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72573,
                      "answer_id":30333,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:58.738Z",
                      "updated_at":"2022-01-10T23:23:58.738Z",
                      "text":"有時候。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72572,
                      "answer_id":30333,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:58.733Z",
                      "updated_at":"2022-01-10T23:23:58.733Z",
                      "text":"Sometimes.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30334,
                "position":3,
                "active":true,
                "question_id":12058,
                "created_at":"2022-01-10T23:23:58.810Z",
                "updated_at":"2022-01-10T23:23:58.810Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Rarely.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72603,
                      "answer_id":30334,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:58.894Z",
                      "updated_at":"2022-01-10T23:23:58.894Z",
                      "text":"Nadiren.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72602,
                      "answer_id":30334,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:58.889Z",
                      "updated_at":"2022-01-10T23:23:58.889Z",
                      "text":"Casi nunca.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72601,
                      "answer_id":30334,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:58.885Z",
                      "updated_at":"2022-01-10T23:23:58.885Z",
                      "text":"Редко.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72600,
                      "answer_id":30334,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:58.880Z",
                      "updated_at":"2022-01-10T23:23:58.880Z",
                      "text":"Rzadko.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72599,
                      "answer_id":30334,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:58.875Z",
                      "updated_at":"2022-01-10T23:23:58.875Z",
                      "text":"드물게",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72598,
                      "answer_id":30334,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:58.871Z",
                      "updated_at":"2022-01-10T23:23:58.871Z",
                      "text":"めったに行わない。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72597,
                      "answer_id":30334,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:58.866Z",
                      "updated_at":"2022-01-10T23:23:58.866Z",
                      "text":"Raramente.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72596,
                      "answer_id":30334,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:58.861Z",
                      "updated_at":"2022-01-10T23:23:58.861Z",
                      "text":"Selten.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72595,
                      "answer_id":30334,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:58.856Z",
                      "updated_at":"2022-01-10T23:23:58.856Z",
                      "text":"Rarement.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72594,
                      "answer_id":30334,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:58.851Z",
                      "updated_at":"2022-01-10T23:23:58.851Z",
                      "text":"Raramente.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72593,
                      "answer_id":30334,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:58.847Z",
                      "updated_at":"2022-01-10T23:23:58.847Z",
                      "text":"Rarement.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72592,
                      "answer_id":30334,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:58.842Z",
                      "updated_at":"2022-01-10T23:23:58.842Z",
                      "text":"很少。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72591,
                      "answer_id":30334,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:58.837Z",
                      "updated_at":"2022-01-10T23:23:58.837Z",
                      "text":"很少。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72590,
                      "answer_id":30334,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:58.832Z",
                      "updated_at":"2022-01-10T23:23:58.832Z",
                      "text":"Raramente.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72589,
                      "answer_id":30334,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:58.828Z",
                      "updated_at":"2022-01-10T23:23:58.828Z",
                      "text":"Bihira",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72588,
                      "answer_id":30334,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:58.824Z",
                      "updated_at":"2022-01-10T23:23:58.824Z",
                      "text":"Rarely.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12059,
          "shuffle":false,
          "position":34,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30336"
          ],
          "created_at":"2022-01-10T23:23:58.912Z",
          "updated_at":"2022-04-21T22:38:44.185Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":34,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Is Mia experiencing illegal retaliation?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30168,
                "question_id":12059,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:59.084Z",
                "updated_at":"2022-01-10T23:23:59.084Z",
                "text":"Louise yasa dışı bir misillemeye mi maruz kalıyor?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30167,
                "question_id":12059,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:59.079Z",
                "updated_at":"2022-01-10T23:23:59.079Z",
                "text":"¿Louise está sufriendo represalias ilegales?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30166,
                "question_id":12059,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:59.074Z",
                "updated_at":"2022-01-10T23:23:59.074Z",
                "text":"Луиза столкнулась с противозаконным преследованием за критику?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30165,
                "question_id":12059,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:59.069Z",
                "updated_at":"2022-01-10T23:23:59.069Z",
                "text":"Czy Louise doświadcza bezprawnych działań odwetowych?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30164,
                "question_id":12059,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:59.065Z",
                "updated_at":"2022-01-10T23:23:59.065Z",
                "text":"Louise가 지금 불법적인 보복을 당하고 있습니까?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30163,
                "question_id":12059,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:59.060Z",
                "updated_at":"2022-01-10T23:23:59.060Z",
                "text":"Louiseさんは、違法な報復を経験していますか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30162,
                "question_id":12059,
                "locale":"it",
                "created_at":"2022-01-10T23:23:59.055Z",
                "updated_at":"2022-01-10T23:23:59.055Z",
                "text":"Louise sta subendo ritorsioni illegali?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30161,
                "question_id":12059,
                "locale":"de",
                "created_at":"2022-01-10T23:23:59.051Z",
                "updated_at":"2022-01-10T23:23:59.051Z",
                "text":"Widerfährt Louise illegale Vergeltung?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30160,
                "question_id":12059,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:59.046Z",
                "updated_at":"2022-01-10T23:23:59.046Z",
                "text":"Louise subit-elle des représailles illégales?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30159,
                "question_id":12059,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:59.041Z",
                "updated_at":"2022-01-10T23:23:59.041Z",
                "text":"Louise est-elle victime de représailles illégales ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30158,
                "question_id":12059,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:59.036Z",
                "updated_at":"2022-01-10T23:23:59.036Z",
                "text":"Louise 是否受到非法報復對待？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30157,
                "question_id":12059,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:59.031Z",
                "updated_at":"2022-01-10T23:23:59.031Z",
                "text":"Louise está sofrendo retaliação ilegal?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30156,
                "question_id":12059,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:59.026Z",
                "updated_at":"2022-01-10T23:23:59.026Z",
                "text":"Nakakaranas ba si Louise ng iligal na paghihiganti?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30155,
                "question_id":12059,
                "locale":"es",
                "created_at":"2022-01-10T23:23:59.021Z",
                "updated_at":"2022-01-10T23:23:59.021Z",
                "text":"¿Louise está experimentando represalias ilegales?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30154,
                "question_id":12059,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:59.016Z",
                "updated_at":"2022-01-10T23:23:59.016Z",
                "text":"Louise 是否遭到了非法报复？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30153,
                "question_id":12059,
                "locale":"en",
                "created_at":"2022-01-10T23:23:58.930Z",
                "updated_at":"2022-04-21T22:38:44.187Z",
                "text":"Is Mia experiencing illegal retaliation?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30335,
                "position":1,
                "active":true,
                "question_id":12059,
                "created_at":"2022-01-10T23:23:59.091Z",
                "updated_at":"2022-04-21T22:38:52.141Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Yes. Darryl allowed Mia to work flexible hours until she complained about sexual harassment.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72604,
                      "answer_id":30335,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:59.104Z",
                      "updated_at":"2022-04-21T22:38:52.144Z",
                      "text":"Yes. Darryl allowed Mia to work flexible hours until she complained about sexual harassment.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72619,
                      "answer_id":30335,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:59.176Z",
                      "updated_at":"2022-01-10T23:23:59.176Z",
                      "text":"Evet. Rose şikâyetinden önce Louise'ye sıcak davranıyordu. Ardından her şey bozulmaya başladı. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72618,
                      "answer_id":30335,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:59.171Z",
                      "updated_at":"2022-01-10T23:23:59.171Z",
                      "text":"Sí. Rose trató muy bien a Louise hasta que Rose se quejó. A partir de ahí, todo fue cuesta abajo. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72617,
                      "answer_id":30335,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:59.165Z",
                      "updated_at":"2022-01-10T23:23:59.165Z",
                      "text":"Да. Роуз хорошо относилась к Луизе, пока та не пожаловалась. Потом все пошло по наклонной. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72616,
                      "answer_id":30335,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:59.161Z",
                      "updated_at":"2022-01-10T23:23:59.161Z",
                      "text":"Tak. Rose traktowała Louise ciepło, dopóki Rose się nie poskarżyła. Potem wszystko zaczęło się psuć. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72615,
                      "answer_id":30335,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:59.156Z",
                      "updated_at":"2022-01-10T23:23:59.156Z",
                      "text":"그렇다. Rose는 Louise가 불평을 말하기 전까지는 그를 따뜻하게 대했다. 그러다 상황이 달라진 것이다. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72614,
                      "answer_id":30335,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:59.151Z",
                      "updated_at":"2022-01-10T23:23:59.151Z",
                      "text":"はい。Roseさんは、Roseさんが苦情を入れるまでは、Louiseさんに対して温かく接していました。そこから状況が悪化しました。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72613,
                      "answer_id":30335,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:59.146Z",
                      "updated_at":"2022-01-10T23:23:59.146Z",
                      "text":"Sì. Rose trattava Louise in modo caloroso fino a quando Rose non ha presentato un reclamo. Poi la situazione è peggiorata. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72612,
                      "answer_id":30335,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:59.142Z",
                      "updated_at":"2022-01-10T23:23:59.142Z",
                      "text":"Ja. Rose war Louise gegenüber herzlich, bis sich Rose beschwerte. Dann ging es bergab. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72611,
                      "answer_id":30335,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:59.137Z",
                      "updated_at":"2022-01-10T23:23:59.137Z",
                      "text":"Oui. Rose traita Louise chaleureusement jusqu'à ce que Rose s'en plaigne. Puis les choses se sont détériorées. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72610,
                      "answer_id":30335,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:59.132Z",
                      "updated_at":"2022-01-10T23:23:59.132Z",
                      "text":"Oui. Rose traitait Louise chaleureusement jusqu’à ce que Rose se plaigne. C’est ensuite que la situation a dégénéré. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72609,
                      "answer_id":30335,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:59.127Z",
                      "updated_at":"2022-01-10T23:23:59.127Z",
                      "text":"Sim. Rose tratou Louise calorosamente até que Rose reclamou. Então as coisas pioraram. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72608,
                      "answer_id":30335,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:59.123Z",
                      "updated_at":"2022-01-10T23:23:59.123Z",
                      "text":"Opo. Masama ang trato ni Rose kay Louise hanggang magreklamo si Rose. Pagkatapos ay lumala ang sitwasyon. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72607,
                      "answer_id":30335,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:59.118Z",
                      "updated_at":"2022-01-10T23:23:59.118Z",
                      "text":"Sí. Rose trató a Louise con calidez hasta que Rose se quejó. Luego las cosas empeoraron. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72606,
                      "answer_id":30335,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:59.113Z",
                      "updated_at":"2022-01-10T23:23:59.113Z",
                      "text":"是。Rose 本来对 Louise 很热强，但 Rose 举报以后就不了。之后事情急转直下。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72605,
                      "answer_id":30335,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:59.108Z",
                      "updated_at":"2022-01-10T23:23:59.108Z",
                      "text":"是。Rose 對待 Louise 一直很熱絡，直到 Rose 被申訴。接下來情況就每況愈下。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30336,
                "position":2,
                "active":true,
                "question_id":12059,
                "created_at":"2022-01-10T23:23:59.181Z",
                "updated_at":"2022-04-21T22:39:00.784Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Maybe, but only if Mia strongly prefers flexible work hours.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72635,
                      "answer_id":30336,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:59.266Z",
                      "updated_at":"2022-01-10T23:23:59.266Z",
                      "text":"Hayır. Rose'un davranışının yasa dışı misilleme olduğunu düşünmüyorum. Yine de bunun yerine başka bir yaklaşım benimsemeliydi. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72634,
                      "answer_id":30336,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:59.261Z",
                      "updated_at":"2022-01-10T23:23:59.261Z",
                      "text":"No, es probable que el comportamiento de Rose no sea una represalia ilegal, pero debería haber adoptado otro enfoque. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72633,
                      "answer_id":30336,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:59.257Z",
                      "updated_at":"2022-01-10T23:23:59.257Z",
                      "text":"Нет. Поведение Роуз, скорее всего, не является противозаконным преследованием за критику, но ей следовало повести себя по-другому. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72632,
                      "answer_id":30336,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:59.252Z",
                      "updated_at":"2022-01-10T23:23:59.252Z",
                      "text":"Nie. Zachowanie Rose prawdopodobnie nie jest bezprawnym odwetem, ale powinna była zastosować inne podejście. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72631,
                      "answer_id":30336,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:59.247Z",
                      "updated_at":"2022-01-10T23:23:59.247Z",
                      "text":"그렇지 않다. Rose의 행동이 불법적인 보복은 아니지만 그녀는 다른 접근 방식을 취했어야 했다. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72630,
                      "answer_id":30336,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:59.243Z",
                      "updated_at":"2022-01-10T23:23:59.243Z",
                      "text":"いいえ、Roseさんの行動は違法な報復ではないが、他のアプローチを取るべきであった。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72629,
                      "answer_id":30336,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:59.238Z",
                      "updated_at":"2022-01-10T23:23:59.238Z",
                      "text":"No, probabilmente il comportamento di Rose non è una ritorsione illegale, ma avrebbe dovuto adottare un altro approccio. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72628,
                      "answer_id":30336,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:59.233Z",
                      "updated_at":"2022-01-10T23:23:59.233Z",
                      "text":"Nein. Roses Verhalten kommt nicht einer illegalen Vergeltung gleich. Dennoch hätte sie anders reagieren sollen. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72627,
                      "answer_id":30336,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:59.229Z",
                      "updated_at":"2022-01-10T23:23:59.229Z",
                      "text":"Non. Le comportement de Rose n'est probablement pas des représailles illégales - mais elle aurait dû adopter une autre approche. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72626,
                      "answer_id":30336,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:59.224Z",
                      "updated_at":"2022-01-10T23:23:59.224Z",
                      "text":"Non, le comportement de Rose n’est probablement pas celui de représailles illégales, mais elle aurait dû adopter une autre approche. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72625,
                      "answer_id":30336,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:59.219Z",
                      "updated_at":"2022-01-10T23:23:59.219Z",
                      "text":"否。Rose 的行為並不像非法報復，但她應該採取其他方法。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72624,
                      "answer_id":30336,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:59.214Z",
                      "updated_at":"2022-01-10T23:23:59.214Z",
                      "text":"否。Rose 的行为可能不是非法报复，但她应该采取另一种方式。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72623,
                      "answer_id":30336,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:59.209Z",
                      "updated_at":"2022-01-10T23:23:59.209Z",
                      "text":"Não. O comportamento de Rose provavelmente não é retaliação ilegal, mas ela deveria ter adotado outra abordagem. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72622,
                      "answer_id":30336,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:59.205Z",
                      "updated_at":"2022-01-10T23:23:59.205Z",
                      "text":"Hindi. Ang asal ni Rose ay posibleng hindi iligal na paghihiganti--pero hindi siya dapat nagsagawa ng isa pang hakbang. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72621,
                      "answer_id":30336,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:59.200Z",
                      "updated_at":"2022-01-10T23:23:59.200Z",
                      "text":"No. Es probable que el comportamiento de Rose no sea una represalia ilegal, pero debería haber actuado de otra manera. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72620,
                      "answer_id":30336,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:59.195Z",
                      "updated_at":"2022-04-21T22:39:00.786Z",
                      "text":"Maybe, but only if Mia strongly prefers flexible work hours.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30337,
                "position":3,
                "active":true,
                "question_id":12059,
                "created_at":"2022-01-10T23:23:59.272Z",
                "updated_at":"2022-04-21T22:39:16.974Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"No. Darryl’s behavior likely isn’t illegal retaliation, although not the best approach.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72651,
                      "answer_id":30337,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:59.360Z",
                      "updated_at":"2022-01-10T23:23:59.360Z",
                      "text":"Belki de Rose, soruşturma sonucunda Louise'ye farklı davranmamasıyla ilgili bir talimat almış olabilir.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72650,
                      "answer_id":30337,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:59.355Z",
                      "updated_at":"2022-01-10T23:23:59.355Z",
                      "text":"Tal vez, pero solo si Rose recibió instrucciones específicas de no tratar a Louise de manera diferente como resultado de la investigación.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72649,
                      "answer_id":30337,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:59.351Z",
                      "updated_at":"2022-01-10T23:23:59.351Z",
                      "text":"Возможно, но только если Роуз прямо попросили не относиться к Луизе по-другому из-за расследования.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72648,
                      "answer_id":30337,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:59.346Z",
                      "updated_at":"2022-01-10T23:23:59.346Z",
                      "text":"Być może, ale tylko wtedy, gdy Rose otrzymała wyraźne polecenie, aby nie traktować Louise inaczej w wyniku dochodzenia.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72647,
                      "answer_id":30337,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:59.341Z",
                      "updated_at":"2022-01-10T23:23:59.341Z",
                      "text":"Rose가 조사의 결과 때문에 Louise를 다르게 대하지 말라고 구체적으로 지시받은 경우에만 그것을 보복이라고 할 수 있다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72646,
                      "answer_id":30337,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:59.337Z",
                      "updated_at":"2022-01-10T23:23:59.337Z",
                      "text":"可能性はあるが、RoseさんがLouiseさんを、調査の結果として違う扱いをするように指示されていた場合のみ違法である。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72645,
                      "answer_id":30337,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:59.332Z",
                      "updated_at":"2022-01-10T23:23:59.332Z",
                      "text":"Forse, ma solo se a Rose fosse stata specificatamente ordinato di non trattare Louise in modo diverso in seguito all’indagine.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72644,
                      "answer_id":30337,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:59.327Z",
                      "updated_at":"2022-01-10T23:23:59.327Z",
                      "text":"Möglicherweise. Jedoch nur, falls Rose explizit dazu angewiesen wurde, Louise nach der Untersuchung des Falls nicht anders zu behandeln.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72643,
                      "answer_id":30337,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:59.322Z",
                      "updated_at":"2022-01-10T23:23:59.322Z",
                      "text":"Peut-être, mais seulement si Rose avait reçu l'ordre de ne pas traiter Louise différemment à la suite de l'enquête.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72642,
                      "answer_id":30337,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:59.314Z",
                      "updated_at":"2022-01-10T23:23:59.314Z",
                      "text":"Peut-être, mais seulement si Rose a reçu l’instruction expresse de ne pas traiter Louise différemment à la suite de l’enquête.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72641,
                      "answer_id":30337,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:59.310Z",
                      "updated_at":"2022-01-10T23:23:59.310Z",
                      "text":"或許，但只有在 Rose 因調查之後，特別受指示不要對 Louise 有差別待遇的情況下。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72640,
                      "answer_id":30337,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:59.305Z",
                      "updated_at":"2022-01-10T23:23:59.305Z",
                      "text":"也许，但前提是 Rose 被明确指示不能因为调查而对 Louise 区别对待。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72639,
                      "answer_id":30337,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:59.300Z",
                      "updated_at":"2022-01-10T23:23:59.300Z",
                      "text":"Talvez, mas apenas se Rose fosse especificamente instruída a não tratar Louise de maneira diferente como resultado da investigação.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72638,
                      "answer_id":30337,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:59.296Z",
                      "updated_at":"2022-01-10T23:23:59.296Z",
                      "text":"Marahil, pero kung inutos lang sana kay Rose na huwag itrato nang kakaiba si Louise bilang resulta ng imbestigasyon",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72637,
                      "answer_id":30337,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:59.291Z",
                      "updated_at":"2022-01-10T23:23:59.291Z",
                      "text":"Tal vez, pero solo si Rose recibió instrucciones específicas de no tratar a Louise de manera diferente como resultado de la investigación.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72636,
                      "answer_id":30337,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:59.287Z",
                      "updated_at":"2022-04-21T22:39:16.976Z",
                      "text":"No. Darryl’s behavior likely isn’t illegal retaliation, although not the best approach.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12060,
          "shuffle":false,
          "position":35,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30338"
          ],
          "created_at":"2022-01-10T23:23:59.377Z",
          "updated_at":"2022-04-21T22:11:13.914Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":35,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What is the best action for Noel to take?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30184,
                "question_id":12060,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:23:59.552Z",
                "updated_at":"2022-01-10T23:23:59.552Z",
                "text":"Sofia aşağıdaki eylemleri gözden geçiriyor. Bu eylemlerden hangisi en az etkili olurdu?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30183,
                "question_id":12060,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:23:59.547Z",
                "updated_at":"2022-01-10T23:23:59.547Z",
                "text":"Sofia está considerando las siguientes acciones. ¿Cuál sería la menos efectiva?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30182,
                "question_id":12060,
                "locale":"ru",
                "created_at":"2022-01-10T23:23:59.541Z",
                "updated_at":"2022-01-10T23:23:59.541Z",
                "text":"София рассматривает следующие варианты действий. Какой из них будет неэффективен?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30181,
                "question_id":12060,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:23:59.536Z",
                "updated_at":"2022-01-10T23:23:59.536Z",
                "text":"Sofia rozważa podjęcie następujących działań. Które z nich byłoby najmniej skuteczne?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30180,
                "question_id":12060,
                "locale":"ko",
                "created_at":"2022-01-10T23:23:59.531Z",
                "updated_at":"2022-01-10T23:23:59.531Z",
                "text":"Sofia는 다음과 같은 조치를 고려하고 있습니다. 어느 것이 가장 비효과적일까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30179,
                "question_id":12060,
                "locale":"ja",
                "created_at":"2022-01-10T23:23:59.526Z",
                "updated_at":"2022-01-10T23:23:59.526Z",
                "text":"Sofiaさんは以下の行動を検討しています。どの行動が最も効果的でないでしょうか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30178,
                "question_id":12060,
                "locale":"it",
                "created_at":"2022-01-10T23:23:59.522Z",
                "updated_at":"2022-01-10T23:23:59.522Z",
                "text":"Sofia sta prendendo in considerazione le seguenti azioni. Quale sarebbe l’azione meno efficace?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30177,
                "question_id":12060,
                "locale":"de",
                "created_at":"2022-01-10T23:23:59.517Z",
                "updated_at":"2022-01-10T23:23:59.517Z",
                "text":"Sofia zieht folgende Maßnahmen in Erwägung. Welche davon wäre die am wenigsten wirksame?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30176,
                "question_id":12060,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:23:59.512Z",
                "updated_at":"2022-01-10T23:23:59.512Z",
                "text":"Laquelle des actions suivantes n'est pas une bonne étape à franchir pour Sofia?\n\nChoisissez la meilleure réponse:",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30175,
                "question_id":12060,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:23:59.508Z",
                "updated_at":"2022-01-10T23:23:59.508Z",
                "text":"Parmi les propositions suivantes, laquelle ne constitue pas une bonne conduite à adopter pour Sofia ?\n\nSélectionnez la meilleure réponse :",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30174,
                "question_id":12060,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:23:59.503Z",
                "updated_at":"2022-01-10T23:23:59.503Z",
                "text":"Qual das ações a seguir não é um bom passo para Sofia?\n\nEscolha a melhor resposta:",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30173,
                "question_id":12060,
                "locale":"es",
                "created_at":"2022-01-10T23:23:59.498Z",
                "updated_at":"2022-01-10T23:23:59.498Z",
                "text":"¿Cuál de las acciones siguientes no es un buen paso para que tome Sofia?\n\nElija la mejor respuesta:",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30172,
                "question_id":12060,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:59.493Z",
                "updated_at":"2022-01-10T23:23:59.493Z",
                "text":"Alin sa mga sumusunod na aksyon ang hindi magandang hakbang para gawin ni Sofia?\n\nPumili ng pinakaangkop na sagot:",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30171,
                "question_id":12060,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:59.489Z",
                "updated_at":"2022-01-10T23:23:59.489Z",
                "text":"Sofia 不应该采取以下哪一种行动？\n\n请选择最佳答案：",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30170,
                "question_id":12060,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:23:59.483Z",
                "updated_at":"2022-01-10T23:23:59.483Z",
                "text":"Sofia 不應採取下列哪些動作？\n\n選擇最佳答案：",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30169,
                "question_id":12060,
                "locale":"en",
                "created_at":"2022-01-10T23:23:59.397Z",
                "updated_at":"2022-04-21T22:11:13.916Z",
                "text":"What is the best action for Noel to take?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30338,
                "position":1,
                "active":true,
                "question_id":12060,
                "created_at":"2022-01-10T23:23:59.559Z",
                "updated_at":"2022-04-21T22:11:26.095Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Report the situation to human resources or another appropriate channel.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72652,
                      "answer_id":30338,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:59.573Z",
                      "updated_at":"2022-04-21T22:11:26.097Z",
                      "text":"Report the situation to human resources or another appropriate channel.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72667,
                      "answer_id":30338,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:59.646Z",
                      "updated_at":"2022-01-10T23:23:59.646Z",
                      "text":"İnsan kaynakları uzmanlarına bildirmek",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72666,
                      "answer_id":30338,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:59.641Z",
                      "updated_at":"2022-01-10T23:23:59.641Z",
                      "text":"Denunciar los hechos ante los profesionales de recursos humanos",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72665,
                      "answer_id":30338,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:59.636Z",
                      "updated_at":"2022-01-10T23:23:59.636Z",
                      "text":"Сообщить специалистам из отдела кадров.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72664,
                      "answer_id":30338,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:59.631Z",
                      "updated_at":"2022-01-10T23:23:59.631Z",
                      "text":"Zgłoszenie do specjalistów z działu kadr",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72663,
                      "answer_id":30338,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:59.626Z",
                      "updated_at":"2022-01-10T23:23:59.626Z",
                      "text":"인사 담당자에게 보고한다",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72662,
                      "answer_id":30338,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:59.620Z",
                      "updated_at":"2022-01-10T23:23:59.620Z",
                      "text":"人事の専門家に報告する",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72661,
                      "answer_id":30338,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:59.616Z",
                      "updated_at":"2022-01-10T23:23:59.616Z",
                      "text":"Effettuare una segnalazione ai professionisti delle Risorse umane",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72660,
                      "answer_id":30338,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:59.611Z",
                      "updated_at":"2022-01-10T23:23:59.611Z",
                      "text":"Bei Personalverantwortlichen beschweren",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72659,
                      "answer_id":30338,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:59.606Z",
                      "updated_at":"2022-01-10T23:23:59.606Z",
                      "text":"S'en plaindre auprès des professionnels des ressources humaines",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72658,
                      "answer_id":30338,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:59.601Z",
                      "updated_at":"2022-01-10T23:23:59.601Z",
                      "text":"En parler aux ressources humaines",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72657,
                      "answer_id":30338,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:59.596Z",
                      "updated_at":"2022-01-10T23:23:59.596Z",
                      "text":"Fazer uma denúncia a profissionais de recursos humanos",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72656,
                      "answer_id":30338,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:59.592Z",
                      "updated_at":"2022-01-10T23:23:59.592Z",
                      "text":"向人力資源專業人士通報",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72655,
                      "answer_id":30338,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:59.587Z",
                      "updated_at":"2022-01-10T23:23:59.587Z",
                      "text":"向人力资源专员举",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72654,
                      "answer_id":30338,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:59.582Z",
                      "updated_at":"2022-01-10T23:23:59.582Z",
                      "text":"Denunciarlo a los profesionales de Recursos Humanos",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72653,
                      "answer_id":30338,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:59.577Z",
                      "updated_at":"2022-01-10T23:23:59.577Z",
                      "text":"Ireport sa mga propesyunal ng human resource",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30339,
                "position":2,
                "active":true,
                "question_id":12060,
                "created_at":"2022-01-10T23:23:59.652Z",
                "updated_at":"2022-04-21T22:14:12.438Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Do nothing. Raj is within his rights as a supervisor to transfer Noel.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72668,
                      "answer_id":30339,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:59.666Z",
                      "updated_at":"2022-04-21T22:14:12.440Z",
                      "text":"Do nothing. Raj is within his rights as a supervisor to transfer Noel.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72683,
                      "answer_id":30339,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:59.773Z",
                      "updated_at":"2022-01-10T23:23:59.773Z",
                      "text":"James'in yöneticisine bildirmek",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72682,
                      "answer_id":30339,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:59.768Z",
                      "updated_at":"2022-01-10T23:23:59.768Z",
                      "text":"Denunciar los hechos ante el supervisor de James",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72681,
                      "answer_id":30339,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:59.763Z",
                      "updated_at":"2022-01-10T23:23:59.763Z",
                      "text":"Сообщить руководителю Джеймса.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72680,
                      "answer_id":30339,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:59.758Z",
                      "updated_at":"2022-01-10T23:23:59.758Z",
                      "text":"Zgłoszenie do przełożonego Jamesa",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72679,
                      "answer_id":30339,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:59.753Z",
                      "updated_at":"2022-01-10T23:23:59.753Z",
                      "text":"James의 상사에게 보고한다",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72678,
                      "answer_id":30339,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:59.748Z",
                      "updated_at":"2022-01-10T23:23:59.748Z",
                      "text":"Jamesさんの監督者に報告する",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72677,
                      "answer_id":30339,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:59.743Z",
                      "updated_at":"2022-01-10T23:23:59.743Z",
                      "text":"Effettuare una segnalazione al supervisore di James",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72676,
                      "answer_id":30339,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:59.738Z",
                      "updated_at":"2022-01-10T23:23:59.738Z",
                      "text":"Bei James' Vorgesetztem beschweren",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72675,
                      "answer_id":30339,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:59.732Z",
                      "updated_at":"2022-01-10T23:23:59.732Z",
                      "text":"S'en plaindre auprès du superviseur de James",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72674,
                      "answer_id":30339,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:59.724Z",
                      "updated_at":"2022-01-10T23:23:59.724Z",
                      "text":"En parler au responsable hiérarchique de James",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72673,
                      "answer_id":30339,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:59.689Z",
                      "updated_at":"2022-01-10T23:23:59.689Z",
                      "text":"Fazer a denúncia ao supervisor de James",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72672,
                      "answer_id":30339,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:59.685Z",
                      "updated_at":"2022-01-10T23:23:59.685Z",
                      "text":"向 James 的上司通報",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72671,
                      "answer_id":30339,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:59.680Z",
                      "updated_at":"2022-01-10T23:23:59.680Z",
                      "text":"Denunciarlo al supervisor de Jame",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72670,
                      "answer_id":30339,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:59.675Z",
                      "updated_at":"2022-01-10T23:23:59.675Z",
                      "text":"Ireport sa superbisor ni James",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72669,
                      "answer_id":30339,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:59.670Z",
                      "updated_at":"2022-01-10T23:23:59.670Z",
                      "text":"向 James 的主管举报",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30340,
                "position":3,
                "active":true,
                "question_id":12060,
                "created_at":"2022-01-10T23:23:59.779Z",
                "updated_at":"2022-04-21T22:14:32.914Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Confront Raj about the transfer.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72699,
                      "answer_id":30340,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:23:59.865Z",
                      "updated_at":"2022-01-10T23:23:59.865Z",
                      "text":"Transferle ilgili olarak James ile yüzleşmek.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72698,
                      "answer_id":30340,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:23:59.860Z",
                      "updated_at":"2022-01-10T23:23:59.860Z",
                      "text":"Enfrentarse a James sobre la transferencia.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72697,
                      "answer_id":30340,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:23:59.855Z",
                      "updated_at":"2022-01-10T23:23:59.855Z",
                      "text":"Напрямую поговорить с Джеймсом о переводе.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72696,
                      "answer_id":30340,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:23:59.851Z",
                      "updated_at":"2022-01-10T23:23:59.851Z",
                      "text":"Konfrontacja z Jamesem w sprawie przeniesienia.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72695,
                      "answer_id":30340,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:23:59.846Z",
                      "updated_at":"2022-01-10T23:23:59.846Z",
                      "text":"그 조치에 대해 James와 직접 얘기한다",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72694,
                      "answer_id":30340,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:23:59.841Z",
                      "updated_at":"2022-01-10T23:23:59.841Z",
                      "text":"Jamesさんに異動について問いただす",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72693,
                      "answer_id":30340,
                      "locale":"it",
                      "created_at":"2022-01-10T23:23:59.836Z",
                      "updated_at":"2022-01-10T23:23:59.836Z",
                      "text":"Affronta James in merito al trasferimento.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72692,
                      "answer_id":30340,
                      "locale":"de",
                      "created_at":"2022-01-10T23:23:59.831Z",
                      "updated_at":"2022-01-10T23:23:59.831Z",
                      "text":"James direkt auf die Versetzung ansprechen",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72691,
                      "answer_id":30340,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:23:59.826Z",
                      "updated_at":"2022-01-10T23:23:59.826Z",
                      "text":"Affrontez James à propos du transfert.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72690,
                      "answer_id":30340,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:23:59.821Z",
                      "updated_at":"2022-01-10T23:23:59.821Z",
                      "text":"Confronter James à propos du transfert.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72689,
                      "answer_id":30340,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:23:59.816Z",
                      "updated_at":"2022-01-10T23:23:59.816Z",
                      "text":"Enfrentar James sobre a transferência.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72688,
                      "answer_id":30340,
                      "locale":"es",
                      "created_at":"2022-01-10T23:23:59.811Z",
                      "updated_at":"2022-01-10T23:23:59.811Z",
                      "text":"Confrontar a Jame por la transferencia.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72687,
                      "answer_id":30340,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:23:59.807Z",
                      "updated_at":"2022-01-10T23:23:59.807Z",
                      "text":"Harapin si James tungkol sa paglilipat.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72686,
                      "answer_id":30340,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:23:59.802Z",
                      "updated_at":"2022-01-10T23:23:59.802Z",
                      "text":"质问 James 调离工作岗位的事情。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72685,
                      "answer_id":30340,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:23:59.797Z",
                      "updated_at":"2022-01-10T23:23:59.797Z",
                      "text":"與 James 就調職一事當面對質。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72684,
                      "answer_id":30340,
                      "locale":"en",
                      "created_at":"2022-01-10T23:23:59.793Z",
                      "updated_at":"2022-04-21T22:14:32.916Z",
                      "text":"Confront Raj about the transfer.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12061,
          "shuffle":false,
          "position":36,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30343"
          ],
          "created_at":"2022-01-10T23:23:59.882Z",
          "updated_at":"2022-01-10T23:24:00.625Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":36,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What should you do?\n",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30200,
                "question_id":12061,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:00.142Z",
                "updated_at":"2022-01-10T23:24:00.142Z",
                "text":"Ne yapmalısınız?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30199,
                "question_id":12061,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:00.136Z",
                "updated_at":"2022-01-10T23:24:00.136Z",
                "text":"¿Qué debería hacer?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30198,
                "question_id":12061,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:00.131Z",
                "updated_at":"2022-01-10T23:24:00.131Z",
                "text":"Что вам следует сделать?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30197,
                "question_id":12061,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:00.126Z",
                "updated_at":"2022-01-10T23:24:00.126Z",
                "text":"Co należy zrobić?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30196,
                "question_id":12061,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:00.121Z",
                "updated_at":"2022-01-10T23:24:00.121Z",
                "text":"어떻게 하시겠습니까?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30195,
                "question_id":12061,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:00.116Z",
                "updated_at":"2022-01-10T23:24:00.116Z",
                "text":"あなたは何をすべきでしょうか？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30194,
                "question_id":12061,
                "locale":"it",
                "created_at":"2022-01-10T23:24:00.106Z",
                "updated_at":"2022-01-10T23:24:00.106Z",
                "text":"Che cosa dovresti fare?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30193,
                "question_id":12061,
                "locale":"de",
                "created_at":"2022-01-10T23:24:00.100Z",
                "updated_at":"2022-01-10T23:24:00.100Z",
                "text":"Was sollten Sie tun?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30192,
                "question_id":12061,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:00.087Z",
                "updated_at":"2022-01-10T23:24:00.087Z",
                "text":"Que devriez-vous faire?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30191,
                "question_id":12061,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:00.076Z",
                "updated_at":"2022-01-10T23:24:00.076Z",
                "text":"Que devriez-vous faire ?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30190,
                "question_id":12061,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:00.053Z",
                "updated_at":"2022-01-10T23:24:00.053Z",
                "text":"O que você deve fazer?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30189,
                "question_id":12061,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:00.007Z",
                "updated_at":"2022-01-10T23:24:00.007Z",
                "text":"你應該怎麼做？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30188,
                "question_id":12061,
                "locale":"es",
                "created_at":"2022-01-10T23:23:59.996Z",
                "updated_at":"2022-01-10T23:23:59.996Z",
                "text":"¿Qué debes hacer?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30187,
                "question_id":12061,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:23:59.991Z",
                "updated_at":"2022-01-10T23:23:59.991Z",
                "text":"Ano ang dapat mong gawin?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30186,
                "question_id":12061,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:23:59.986Z",
                "updated_at":"2022-01-10T23:23:59.986Z",
                "text":"我们应怎么做？\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30185,
                "question_id":12061,
                "locale":"en",
                "created_at":"2022-01-10T23:23:59.900Z",
                "updated_at":"2022-01-10T23:23:59.900Z",
                "text":"What should you do?\n",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30341,
                "position":1,
                "active":true,
                "question_id":12061,
                "created_at":"2022-01-10T23:24:00.149Z",
                "updated_at":"2022-04-21T22:24:05.185Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Nothing. If Darryl’s behavior was unwelcome and made Michele uncomfortable, she would have told him to leave her alone.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72715,
                      "answer_id":30341,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:00.240Z",
                      "updated_at":"2022-01-10T23:24:00.240Z",
                      "text":"Hiçbir şey. David'in Heidi'nin sırtını ovduğunu gördüğünüzden emin değilsiniz.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72714,
                      "answer_id":30341,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:00.235Z",
                      "updated_at":"2022-01-10T23:24:00.235Z",
                      "text":"Nada. Usted no está seguro de haber visto a David rozando la espalda de Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72713,
                      "answer_id":30341,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:00.230Z",
                      "updated_at":"2022-01-10T23:24:00.230Z",
                      "text":"Ничего. Вы не уверены, что видели, как Дэвид гладит Хайди по спине.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72712,
                      "answer_id":30341,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:00.225Z",
                      "updated_at":"2022-01-10T23:24:00.225Z",
                      "text":"Nie podejmować żadnych działań. Nie jesteś pewien/pewna, czy widziałeś(-aś), jak David pocierał plecy Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72711,
                      "answer_id":30341,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:00.220Z",
                      "updated_at":"2022-01-10T23:24:00.220Z",
                      "text":"아무 행동도 취하지 않는다. David가 Heidi의 등을 만지는 것을 확실히 보지 못했다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72710,
                      "answer_id":30341,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:00.215Z",
                      "updated_at":"2022-01-10T23:24:00.215Z",
                      "text":"何もしない。DavidさんがHeidiさんの背中をさすっているのを見たと確信することができません。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72709,
                      "answer_id":30341,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:00.210Z",
                      "updated_at":"2022-01-10T23:24:00.210Z",
                      "text":"Nulla. Non sei sicuro di aver visto David massaggiare la schiena di Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72708,
                      "answer_id":30341,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:00.205Z",
                      "updated_at":"2022-01-10T23:24:00.205Z",
                      "text":"Nichts. Sie fanden es nicht gut, dass David Heidis Rücken rieb.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72707,
                      "answer_id":30341,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:00.200Z",
                      "updated_at":"2022-01-10T23:24:00.200Z",
                      "text":"Rien. Vous n'êtes pas sûr d'avoir vu David frotter le dos de Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72706,
                      "answer_id":30341,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:00.195Z",
                      "updated_at":"2022-01-10T23:24:00.195Z",
                      "text":"Rien. Vous n’êtes pas certain d’avoir vu David caresser le dos de Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72705,
                      "answer_id":30341,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:00.189Z",
                      "updated_at":"2022-01-10T23:24:00.189Z",
                      "text":"甚麼都不做。你並不確定是否看到 David 磨擦 Heidi 的背。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72704,
                      "answer_id":30341,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:00.184Z",
                      "updated_at":"2022-01-10T23:24:00.184Z",
                      "text":"无你不确定你看到 David 抚摸 Heidi 的背。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72703,
                      "answer_id":30341,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:00.179Z",
                      "updated_at":"2022-01-10T23:24:00.179Z",
                      "text":"Nada. Você não tem certeza se viu David esfregando as costas de Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72702,
                      "answer_id":30341,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:00.174Z",
                      "updated_at":"2022-01-10T23:24:00.174Z",
                      "text":"Wala. Hindi ka positibo nang makita mo si David na hinahaplos ang likod ni Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72701,
                      "answer_id":30341,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:00.169Z",
                      "updated_at":"2022-01-10T23:24:00.169Z",
                      "text":"Nada. No estás seguro de haber visto a David frotando la espalda de Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72700,
                      "answer_id":30341,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:00.164Z",
                      "updated_at":"2022-04-21T22:24:05.189Z",
                      "text":"Nothing. If Darryl’s behavior was unwelcome and made Michele uncomfortable, she would have told him to leave her alone.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30342,
                "position":2,
                "active":true,
                "question_id":12061,
                "created_at":"2022-01-10T23:24:00.246Z",
                "updated_at":"2022-04-21T22:24:14.062Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell Darryl to stop harassing Michele.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72716,
                      "answer_id":30342,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:00.260Z",
                      "updated_at":"2022-04-21T22:24:14.065Z",
                      "text":"Tell Darryl to stop harassing Michele.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72731,
                      "answer_id":30342,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:00.349Z",
                      "updated_at":"2022-01-10T23:24:00.349Z",
                      "text":"David'e Heidi'ye cinsel olarak taciz etmeyi bırakmasını söyleyin.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72730,
                      "answer_id":30342,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:00.336Z",
                      "updated_at":"2022-01-10T23:24:00.336Z",
                      "text":"Decirle a David que deje de acosar sexualmente a Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72729,
                      "answer_id":30342,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:00.324Z",
                      "updated_at":"2022-01-10T23:24:00.324Z",
                      "text":"Потребовать у Дэвида прекратить сексуальные домогательства в адрес Хайди.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72728,
                      "answer_id":30342,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:00.316Z",
                      "updated_at":"2022-01-10T23:24:00.316Z",
                      "text":"Powiedzieć Davidowi, żeby przestał molestować seksualnie Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72727,
                      "answer_id":30342,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:00.312Z",
                      "updated_at":"2022-01-10T23:24:00.312Z",
                      "text":"David에게 Heidi를 성희롱 하지 말라고 말한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72726,
                      "answer_id":30342,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:00.307Z",
                      "updated_at":"2022-01-10T23:24:00.307Z",
                      "text":"Davidさんに、Heidiさんに対するセクシャルハラスメントを止めるよう伝える。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72725,
                      "answer_id":30342,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:00.302Z",
                      "updated_at":"2022-01-10T23:24:00.302Z",
                      "text":"Dire a David di smetterla di molestare sessualmente Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72724,
                      "answer_id":30342,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:00.298Z",
                      "updated_at":"2022-01-10T23:24:00.298Z",
                      "text":"David auffordern, er möge es unterlassen, Heidi sexuell zu belästigen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72723,
                      "answer_id":30342,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:00.293Z",
                      "updated_at":"2022-01-10T23:24:00.293Z",
                      "text":"Dites à David d'arrêter de harceler sexuellement Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72722,
                      "answer_id":30342,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:00.288Z",
                      "updated_at":"2022-01-10T23:24:00.288Z",
                      "text":"Demander à David de cesser de harceler Heidi sexuellement.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72721,
                      "answer_id":30342,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:00.283Z",
                      "updated_at":"2022-01-10T23:24:00.283Z",
                      "text":"告訴 David 停止性騷擾 Heidi。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72720,
                      "answer_id":30342,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:00.278Z",
                      "updated_at":"2022-01-10T23:24:00.278Z",
                      "text":"告诉 David 别再性骚扰 Heidi 了。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72719,
                      "answer_id":30342,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:00.274Z",
                      "updated_at":"2022-01-10T23:24:00.274Z",
                      "text":"Dizer a David para parar de assediar sexualmente Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72718,
                      "answer_id":30342,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:00.269Z",
                      "updated_at":"2022-01-10T23:24:00.269Z",
                      "text":"Sabihin kay David na tigilan ang seksuwal na panliligalig kay Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72717,
                      "answer_id":30342,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:00.264Z",
                      "updated_at":"2022-01-10T23:24:00.264Z",
                      "text":"Decirle a David que deje de acosar sexualmente a Heidi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30343,
                "position":3,
                "active":true,
                "question_id":12061,
                "created_at":"2022-01-10T23:24:00.362Z",
                "updated_at":"2022-04-21T22:24:23.556Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Ask Michele privately whether she feels uncomfortable about Darryl’s behavior.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72732,
                      "answer_id":30343,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:00.404Z",
                      "updated_at":"2022-04-21T22:24:23.558Z",
                      "text":"Ask Michele privately whether she feels uncomfortable about Darryl’s behavior.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72747,
                      "answer_id":30343,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:00.613Z",
                      "updated_at":"2022-01-10T23:24:00.613Z",
                      "text":"David'in olmadığı bir ortamda Heidi ile özel olarak konuşun ve David'in bu davranışından rahatsız olup olmadığını sorun.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72746,
                      "answer_id":30343,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:00.601Z",
                      "updated_at":"2022-01-10T23:24:00.601Z",
                      "text":"Hablar con Heidi en privado cuando David no esté cerca y preguntarle si se siente incómoda con el comportamiento de David.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72745,
                      "answer_id":30343,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:00.587Z",
                      "updated_at":"2022-01-10T23:24:00.587Z",
                      "text":"Отвести Хайди в сторону, когда Дэвида нет рядом, и спросить, не доставляет ли ей дискомфорт поведение Дэвида.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72744,
                      "answer_id":30343,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:00.576Z",
                      "updated_at":"2022-01-10T23:24:00.576Z",
                      "text":"Poprosić Heidi o rozmowę na osobności, kiedy Davida nie będzie w pobliżu i zapytać, czy nie czuje się skrępowana zachowaniem Davida.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72743,
                      "answer_id":30343,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:00.530Z",
                      "updated_at":"2022-01-10T23:24:00.530Z",
                      "text":"David가 주변에 없을 때 Heidi를 따로 불러 그의 행동에 불편함을 느끼는지 물어본다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72742,
                      "answer_id":30343,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:00.521Z",
                      "updated_at":"2022-01-10T23:24:00.521Z",
                      "text":"Davidさんがいない時にHeidiさんを呼び出し、Davidさんの行動に不快感を覚えるかどうか聞く。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72741,
                      "answer_id":30343,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:00.512Z",
                      "updated_at":"2022-01-10T23:24:00.512Z",
                      "text":"Prendere Heidi da parte quando David non è nei paraggi e chiederle se si sente a disagio con il comportamento di David.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72740,
                      "answer_id":30343,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:00.500Z",
                      "updated_at":"2022-01-10T23:24:00.500Z",
                      "text":"Heide zur Seite nehmen, wenn David nicht in der Nähe ist, und sie fragen, ob ihr Davids Verhalten unangenehm ist.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72739,
                      "answer_id":30343,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:00.487Z",
                      "updated_at":"2022-01-10T23:24:00.487Z",
                      "text":"Prenez Heidi à part quand David n'est pas là et demandez-lui si elle se sent mal à l'aise avec le comportement de David.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72738,
                      "answer_id":30343,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:00.477Z",
                      "updated_at":"2022-01-10T23:24:00.477Z",
                      "text":"Prendre Heidi à part quand David n’est pas là et lui demander si le comportement de David la met mal à l’aise.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72737,
                      "answer_id":30343,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:00.465Z",
                      "updated_at":"2022-01-10T23:24:00.465Z",
                      "text":"Chamar Heidi no canto quando David não estiver por perto e perguntar se ela se sente desconfortável com o comportamento de David.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72736,
                      "answer_id":30343,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:00.452Z",
                      "updated_at":"2022-01-10T23:24:00.452Z",
                      "text":"Llevar a Heidi a un lado cuando David no esté cerca, y preguntar si se siente incómoda con el comportamiento de David.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72735,
                      "answer_id":30343,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:00.441Z",
                      "updated_at":"2022-01-10T23:24:00.441Z",
                      "text":"Kausapin si Heidi kung wala si David, at tanungin kung hindi siya komportable sa inaasal ni David.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72734,
                      "answer_id":30343,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:00.429Z",
                      "updated_at":"2022-01-10T23:24:00.429Z",
                      "text":"当 David 不在场时将 Heidi 拉到一边，询问她是否对于 David 的行为感到不自在。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72733,
                      "answer_id":30343,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:00.413Z",
                      "updated_at":"2022-01-10T23:24:00.413Z",
                      "text":"在 David 不在的時候把 Heidi 找來，問她是否對於 David 的行為感到不舒服。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12062,
          "shuffle":false,
          "position":37,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30344"
          ],
          "created_at":"2022-01-10T23:24:00.652Z",
          "updated_at":"2022-01-10T23:24:01.227Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":37,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Which type of intervention would work best in this situation?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30216,
                "question_id":12062,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:00.942Z",
                "updated_at":"2022-01-10T23:24:00.942Z",
                "text":"Bu durumda yapılabilecek en iyi müdahale nedir?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30215,
                "question_id":12062,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:00.937Z",
                "updated_at":"2022-01-10T23:24:00.937Z",
                "text":"¿Qué tipo de intervención funcionaría mejor en esta situación?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30214,
                "question_id":12062,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:00.932Z",
                "updated_at":"2022-01-10T23:24:00.932Z",
                "text":"Какой способ вмешаться оптимален в этой ситуации?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30213,
                "question_id":12062,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:00.928Z",
                "updated_at":"2022-01-10T23:24:00.928Z",
                "text":"Jaki rodzaj interwencji sprawdziłby się najlepiej w tej sytuacji?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30212,
                "question_id":12062,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:00.923Z",
                "updated_at":"2022-01-10T23:24:00.923Z",
                "text":"이 상황에서 어떤 유형의 개입이 가장 효과적일까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30211,
                "question_id":12062,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:00.917Z",
                "updated_at":"2022-01-10T23:24:00.917Z",
                "text":"この状況では、どちらの種類の介入が最も効果的でしょうか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30210,
                "question_id":12062,
                "locale":"it",
                "created_at":"2022-01-10T23:24:00.912Z",
                "updated_at":"2022-01-10T23:24:00.912Z",
                "text":"Quale tipo di intervento funzionerebbe meglio in questa situazione?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30209,
                "question_id":12062,
                "locale":"de",
                "created_at":"2022-01-10T23:24:00.907Z",
                "updated_at":"2022-01-10T23:24:00.907Z",
                "text":"Welche Art von Intervention wäre in dieser Situation am geeignetsten?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30208,
                "question_id":12062,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:00.902Z",
                "updated_at":"2022-01-10T23:24:00.902Z",
                "text":"Quel type d'intervention fonctionnerait le mieux dans cette situation?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30207,
                "question_id":12062,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:00.897Z",
                "updated_at":"2022-01-10T23:24:00.897Z",
                "text":"Quelle est l’intervention la plus appropriée dans ce type de situation ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30206,
                "question_id":12062,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:00.892Z",
                "updated_at":"2022-01-10T23:24:00.892Z",
                "text":"Que tipo de intervenção funcionaria melhor nessa situação?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30205,
                "question_id":12062,
                "locale":"es",
                "created_at":"2022-01-10T23:24:00.887Z",
                "updated_at":"2022-01-10T23:24:00.887Z",
                "text":"¿Qué tipo de intervención funcionará mejor en esta situación?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30204,
                "question_id":12062,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:00.882Z",
                "updated_at":"2022-01-10T23:24:00.882Z",
                "text":"Aling uri ng interbensyon ang pinakamahusay na gagana sa sitwasyong ito?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30203,
                "question_id":12062,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:00.878Z",
                "updated_at":"2022-01-10T23:24:00.878Z",
                "text":"这种情况下采用何种干预最好？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30202,
                "question_id":12062,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:00.872Z",
                "updated_at":"2022-01-10T23:24:00.872Z",
                "text":"哪種類型的介入對於這種情況的效果最好？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30201,
                "question_id":12062,
                "locale":"en",
                "created_at":"2022-01-10T23:24:00.708Z",
                "updated_at":"2022-01-10T23:24:00.708Z",
                "text":"Which type of intervention would work best in this situation?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30344,
                "position":1,
                "active":true,
                "question_id":12062,
                "created_at":"2022-01-10T23:24:00.949Z",
                "updated_at":"2022-01-10T23:24:00.949Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Politely say you don’t like that kind of joke and pass the phone back to Anna.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72763,
                      "answer_id":30344,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:01.036Z",
                      "updated_at":"2022-01-10T23:24:01.036Z",
                      "text":"Kibarca bu tarz şakaları sevmediğinizi söyleyin ve telefonu Anna'ya geri verin.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72762,
                      "answer_id":30344,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:01.031Z",
                      "updated_at":"2022-01-10T23:24:01.031Z",
                      "text":"Decirle con educación que no te gusta ese tipo de bromas y devolverle el teléfono a Anna.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72761,
                      "answer_id":30344,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:01.026Z",
                      "updated_at":"2022-01-10T23:24:01.026Z",
                      "text":"Вежливо ответить, что такие шутки вам неприятны, и передать телефон Анне.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72760,
                      "answer_id":30344,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:01.021Z",
                      "updated_at":"2022-01-10T23:24:01.021Z",
                      "text":"Grzecznie powiedzieć, że nie lubisz tego typu żartów i przekazać z powrotem telefon Annie.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72759,
                      "answer_id":30344,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:01.016Z",
                      "updated_at":"2022-01-10T23:24:01.016Z",
                      "text":"그런 농담이 불편하다고 정중하게 말하고 전화를 Anna에게 돌려준다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72758,
                      "answer_id":30344,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:01.011Z",
                      "updated_at":"2022-01-10T23:24:01.011Z",
                      "text":"礼儀正しく、そのような冗談は好きではないことを伝え、Annaさんに電話を返す。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72757,
                      "answer_id":30344,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:01.006Z",
                      "updated_at":"2022-01-10T23:24:01.006Z",
                      "text":"Dire educatamente che non ti piace quel tipo di battuta e restituire il telefono ad Anna.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72756,
                      "answer_id":30344,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:01.002Z",
                      "updated_at":"2022-01-10T23:24:01.002Z",
                      "text":"Höflich sagen, dass Sie diese Art von Witz nicht mögen, und Anna das Handy zurückgeben.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72755,
                      "answer_id":30344,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:00.997Z",
                      "updated_at":"2022-01-10T23:24:00.997Z",
                      "text":"Dites poliment que vous n'aimez pas ce genre de blague et rendez le téléphone à Anna.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72754,
                      "answer_id":30344,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:00.992Z",
                      "updated_at":"2022-01-10T23:24:00.992Z",
                      "text":"Dire poliment que vous n’appréciez pas ce genre de blague et rendre le téléphone à Anna.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72753,
                      "answer_id":30344,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:00.987Z",
                      "updated_at":"2022-01-10T23:24:00.987Z",
                      "text":"Dizer educadamente que você não gosta desse tipo de piada e passar o telefone de volta para Anna.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72752,
                      "answer_id":30344,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:00.982Z",
                      "updated_at":"2022-01-10T23:24:00.982Z",
                      "text":"Decir educadamente que no te agrada ese tipo de broma y devolver el teléfono a Anna.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72751,
                      "answer_id":30344,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:00.977Z",
                      "updated_at":"2022-01-10T23:24:00.977Z",
                      "text":"Magalang na sabihin na hindi mo gusto ang ganoong klaseng biro at ibalik ang telepono kay Anna.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72750,
                      "answer_id":30344,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:00.972Z",
                      "updated_at":"2022-01-10T23:24:00.972Z",
                      "text":"礼貌地说你不喜欢这种玩笑，然后将电话还给 Anna。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72749,
                      "answer_id":30344,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:00.967Z",
                      "updated_at":"2022-01-10T23:24:00.967Z",
                      "text":"禮貌地說你不喜歡那種笑話，然後將電話還給 Anna。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72748,
                      "answer_id":30344,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:00.963Z",
                      "updated_at":"2022-01-10T23:24:00.963Z",
                      "text":"Politely say you don’t like that kind of joke and pass the phone back to Anna.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30345,
                "position":2,
                "active":true,
                "question_id":12062,
                "created_at":"2022-01-10T23:24:01.044Z",
                "updated_at":"2022-01-10T23:24:01.044Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Take Anna’s cell phone to human resource professionals to report the biased meme.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72779,
                      "answer_id":30345,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:01.130Z",
                      "updated_at":"2022-01-10T23:24:01.130Z",
                      "text":"Ön yargılı paylaşımını bildirmek için Anna'nın cep telefonunu insan kaynakları uzmanlarına götürün.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72778,
                      "answer_id":30345,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:01.126Z",
                      "updated_at":"2022-01-10T23:24:01.126Z",
                      "text":"Llevar el teléfono de Anna a los profesionales de recursos humanos para denunciar el meme sesgado.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72777,
                      "answer_id":30345,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:01.121Z",
                      "updated_at":"2022-01-10T23:24:01.121Z",
                      "text":"Отнести телефон Анны в отдел кадров, чтобы сообщить о дискриминирующем меме.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72776,
                      "answer_id":30345,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:01.116Z",
                      "updated_at":"2022-01-10T23:24:01.116Z",
                      "text":"Zabrać telefon komórkowy Anny do specjalistów z działu kadr, aby zgłosić tendencyjnego mema.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72775,
                      "answer_id":30345,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:01.111Z",
                      "updated_at":"2022-01-10T23:24:01.111Z",
                      "text":"Anna의 휴대 전화를 인사 담당자에게 가져가 편향된 밈(meme)을 신고한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72774,
                      "answer_id":30345,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:01.106Z",
                      "updated_at":"2022-01-10T23:24:01.106Z",
                      "text":"Annaさんの携帯電話を人事の専門家まで持っていき、偏見のあるミームを報告する。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72773,
                      "answer_id":30345,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:01.101Z",
                      "updated_at":"2022-01-10T23:24:01.101Z",
                      "text":"Portare il cellulare di Anna ai professionisti delle Risorse umane per segnalare il meme non oggettivo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72772,
                      "answer_id":30345,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:01.096Z",
                      "updated_at":"2022-01-10T23:24:01.096Z",
                      "text":"Annas Handy zur Personalabteilung bringen und dort von dem Vorfall berichten.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72771,
                      "answer_id":30345,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:01.091Z",
                      "updated_at":"2022-01-10T23:24:01.091Z",
                      "text":"Apportez le téléphone portable d'Anna aux professionnels des ressources humaines pour signaler /*le mème biaisé.*/",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72770,
                      "answer_id":30345,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:01.087Z",
                      "updated_at":"2022-01-10T23:24:01.087Z",
                      "text":"Apporter le portable d’Anna aux ressources humaines pour leur montrer le mème tendancieux.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72769,
                      "answer_id":30345,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:01.082Z",
                      "updated_at":"2022-01-10T23:24:01.082Z",
                      "text":"Leve o celular da Anna para os profissionais de recursos humanos para relatar o meme tendencioso.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72768,
                      "answer_id":30345,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:01.077Z",
                      "updated_at":"2022-01-10T23:24:01.077Z",
                      "text":"把 Anna 的手機交給人力資源專業人士，通報帶有偏見的迷因圖。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72767,
                      "answer_id":30345,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:01.072Z",
                      "updated_at":"2022-01-10T23:24:01.072Z",
                      "text":"Llevar el teléfono de Anna a los profesionales de Recursos Humanos para denunciar el meme sesgado.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72766,
                      "answer_id":30345,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:01.067Z",
                      "updated_at":"2022-01-10T23:24:01.067Z",
                      "text":"Dalhin ang cell phone ni Anna sa mga propesyunal ng human resource upang maiulat ang bias na meme.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72765,
                      "answer_id":30345,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:01.062Z",
                      "updated_at":"2022-01-10T23:24:01.062Z",
                      "text":"将 Anna 的手机交给人力资源专员举报该有偏见的 meme。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72764,
                      "answer_id":30345,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:01.058Z",
                      "updated_at":"2022-01-10T23:24:01.058Z",
                      "text":"Take Anna’s cell phone to human resource professionals to report the biased meme.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30346,
                "position":3,
                "active":true,
                "question_id":12062,
                "created_at":"2022-01-10T23:24:01.136Z",
                "updated_at":"2022-01-10T23:24:01.136Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Pretend to think the joke is funny just to be polite, but later check in with Don to make sure he wasn’t offended.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72795,
                      "answer_id":30346,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:01.222Z",
                      "updated_at":"2022-01-10T23:24:01.222Z",
                      "text":"Sadece kibar olmak için şakanın komik olduğunu düşünüyormuş gibi davranın ve ardından gücenmediğinden emin olmak için Don'la görüşün.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72794,
                      "answer_id":30346,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:01.217Z",
                      "updated_at":"2022-01-10T23:24:01.217Z",
                      "text":"Fingir que la broma es divertida solo para ser educado, pero luego consultar a Don para asegurarse de que no se haya ofendido.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72793,
                      "answer_id":30346,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:01.212Z",
                      "updated_at":"2022-01-10T23:24:01.212Z",
                      "text":"Только из вежливости притвориться, что шутка смешная, но позже выяснить у Дона, не оскорбила ли она его.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72792,
                      "answer_id":30346,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:01.207Z",
                      "updated_at":"2022-01-10T23:24:01.207Z",
                      "text":"Udawać, że myślisz, że żart jest śmieszny tylko z uprzejmości, ale później sprawdzić, czy Don nie poczuł się urażony.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72791,
                      "answer_id":30346,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:01.202Z",
                      "updated_at":"2022-01-10T23:24:01.202Z",
                      "text":"단지 예의를 차리기 위해 농담이 재미있는 척하고, 나중에 Don에게 기분이 상하지 않았는지 물어본다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72790,
                      "answer_id":30346,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:01.198Z",
                      "updated_at":"2022-01-10T23:24:01.198Z",
                      "text":"失礼にならないよう、その冗談が面白いふりをし、後でDonさんに、気を悪くしなかったかどうか確認する。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72789,
                      "answer_id":30346,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:01.193Z",
                      "updated_at":"2022-01-10T23:24:01.193Z",
                      "text":"Far finta di pensare che la battuta sia divertente solo per essere educato, ma in seguito parlare con Don per assicurarti che non si sia offeso.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72788,
                      "answer_id":30346,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:01.188Z",
                      "updated_at":"2022-01-10T23:24:01.188Z",
                      "text":"Aus Höflichkeit so tun, als ob es witzig wäre, aber später mit Don sprechen und sicherstellen, dass ihn der Witz nicht verletzt hat.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72787,
                      "answer_id":30346,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:01.183Z",
                      "updated_at":"2022-01-10T23:24:01.183Z",
                      "text":"Faites semblant de penser que la blague est drôle juste pour être poli, mais s'assurer plus tard que Don n'en a pas été offensé.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72786,
                      "answer_id":30346,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:01.178Z",
                      "updated_at":"2022-01-10T23:24:01.178Z",
                      "text":"Faire semblant de penser que la blague est drôle par politesse, mais vérifier ensuite auprès de Don s’il ne s’est pas senti offensé.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72785,
                      "answer_id":30346,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:01.174Z",
                      "updated_at":"2022-01-10T23:24:01.174Z",
                      "text":"Fingir que acha a piada engraçada apenas por uma questão de educação, mas depois conversar com Don para ter certeza de que ele não ficou ofendido.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72784,
                      "answer_id":30346,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:01.169Z",
                      "updated_at":"2022-01-10T23:24:01.169Z",
                      "text":"Pretender pensar que la broma es divertida solo para ser educado, pero más tarde consultar con Don para asegurarse de que no se haya sentido ofendido.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72783,
                      "answer_id":30346,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:01.163Z",
                      "updated_at":"2022-01-10T23:24:01.163Z",
                      "text":"Isipin na lang na ang biro ay nakakatawa para lang maging magalang, ngunit pagkalipas ay tanungin si Don upang matiyak na hindi siya nasasaktan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72782,
                      "answer_id":30346,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:01.159Z",
                      "updated_at":"2022-01-10T23:24:01.159Z",
                      "text":"出于礼貌假装认为该笑话很有趣，但随后询问 Don 以确保他没有被冒犯。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72781,
                      "answer_id":30346,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:01.154Z",
                      "updated_at":"2022-01-10T23:24:01.154Z",
                      "text":"禮貌性假裝覺得笑話很好笑，但事後關心 Don 是否覺得受到冒犯。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72780,
                      "answer_id":30346,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:01.150Z",
                      "updated_at":"2022-01-10T23:24:01.150Z",
                      "text":"Pretend to think the joke is funny just to be polite, but later check in with Don to make sure he wasn’t offended.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12063,
          "shuffle":false,
          "position":38,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30349"
          ],
          "created_at":"2022-01-10T23:24:01.240Z",
          "updated_at":"2022-04-21T22:26:06.129Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":38,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"How should Ida respond?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30217,
                "question_id":12063,
                "locale":"en",
                "created_at":"2022-01-10T23:24:01.259Z",
                "updated_at":"2022-04-21T22:26:06.132Z",
                "text":"How should Ida respond?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30232,
                "question_id":12063,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:01.419Z",
                "updated_at":"2022-01-10T23:24:01.419Z",
                "text":"Brad nasıl karşılık vermelidir?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30231,
                "question_id":12063,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:01.414Z",
                "updated_at":"2022-01-10T23:24:01.414Z",
                "text":"¿Cómo debería responder Brad?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30230,
                "question_id":12063,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:01.409Z",
                "updated_at":"2022-01-10T23:24:01.409Z",
                "text":"Как следует ответить Брэду?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30229,
                "question_id":12063,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:01.404Z",
                "updated_at":"2022-01-10T23:24:01.404Z",
                "text":"Jak powinien odpowiedzieć Brad?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30228,
                "question_id":12063,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:01.399Z",
                "updated_at":"2022-01-10T23:24:01.399Z",
                "text":"Brad는 어떻게 대응해야 할까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30227,
                "question_id":12063,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:01.394Z",
                "updated_at":"2022-01-10T23:24:01.394Z",
                "text":"Bradさんはどのように返答すべきですか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30226,
                "question_id":12063,
                "locale":"it",
                "created_at":"2022-01-10T23:24:01.389Z",
                "updated_at":"2022-01-10T23:24:01.389Z",
                "text":"Come dovrebbe rispondere Brad?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30225,
                "question_id":12063,
                "locale":"de",
                "created_at":"2022-01-10T23:24:01.384Z",
                "updated_at":"2022-01-10T23:24:01.384Z",
                "text":"Wie sollte Brad reagieren?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30224,
                "question_id":12063,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:01.379Z",
                "updated_at":"2022-01-10T23:24:01.379Z",
                "text":"Comment Brad devrait-il répondre?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30223,
                "question_id":12063,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:01.374Z",
                "updated_at":"2022-01-10T23:24:01.374Z",
                "text":"Comment Brad devrait-il réagir ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30222,
                "question_id":12063,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:01.369Z",
                "updated_at":"2022-01-10T23:24:01.369Z",
                "text":"Como Brad deve responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30221,
                "question_id":12063,
                "locale":"es",
                "created_at":"2022-01-10T23:24:01.364Z",
                "updated_at":"2022-01-10T23:24:01.364Z",
                "text":"¿Cómo debería responder Brad?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30220,
                "question_id":12063,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:01.359Z",
                "updated_at":"2022-01-10T23:24:01.359Z",
                "text":"Paano sasagot si Brad?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30219,
                "question_id":12063,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:01.354Z",
                "updated_at":"2022-01-10T23:24:01.354Z",
                "text":"Brad 应如何回应？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30218,
                "question_id":12063,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:01.349Z",
                "updated_at":"2022-01-10T23:24:01.349Z",
                "text":"Brad 該如何回應？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30347,
                "position":1,
                "active":true,
                "question_id":12063,
                "created_at":"2022-01-10T23:24:01.426Z",
                "updated_at":"2022-04-21T22:26:16.056Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Let the move proceed. Moving someone’s work location isn’t a big enough change to be retaliation.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72796,
                      "answer_id":30347,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:01.440Z",
                      "updated_at":"2022-04-21T22:26:16.058Z",
                      "text":"Let the move proceed. Moving someone’s work location isn’t a big enough change to be retaliation.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72811,
                      "answer_id":30347,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:01.514Z",
                      "updated_at":"2022-01-10T23:24:01.514Z",
                      "text":"\"Elbette, ancak şu anda zamanım gerçekten kısıtlı. Toplantıma giderken bana hızlıca anlatır mısın?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72810,
                      "answer_id":30347,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:01.509Z",
                      "updated_at":"2022-01-10T23:24:01.509Z",
                      "text":"\"Claro, pero ahora estoy en un momento importante. ¿Puedes hacerme un resumen rápido de camino a la reunión?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72809,
                      "answer_id":30347,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:01.504Z",
                      "updated_at":"2022-01-10T23:24:01.504Z",
                      "text":"«Конечно, но сейчас у меня вообще нет времени. Вы могли бы вкратце мне все рассказать по дороге на встречу?»",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72808,
                      "answer_id":30347,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:01.499Z",
                      "updated_at":"2022-01-10T23:24:01.499Z",
                      "text":"„Jasne, ale mam teraz naprawdę mało czasu. Czy możesz mi to szybko opowiedzieć w drodze na moje spotkanie?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72807,
                      "answer_id":30347,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:01.494Z",
                      "updated_at":"2022-01-10T23:24:01.494Z",
                      "text":"“그래요. 하지만 지금은 정말 시간이 없어서요. 회의 가는 길에 빨리 말씀해 주실래요?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72806,
                      "answer_id":30347,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:01.489Z",
                      "updated_at":"2022-01-10T23:24:01.489Z",
                      "text":"「いいですよ、でも今時間に追われています。ミーティングへの移動中に簡単に話していただけますか？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72805,
                      "answer_id":30347,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:01.484Z",
                      "updated_at":"2022-01-10T23:24:01.484Z",
                      "text":"“Certo, ma adesso sono davvero stretto con i tempi. Puoi dirmelo rapidamente mentre andiamo alla mia riunione?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72804,
                      "answer_id":30347,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:01.479Z",
                      "updated_at":"2022-01-10T23:24:01.479Z",
                      "text":"„Gerne, nur habe ich es gerade wirklich eilig. Kannst du es mir auf dem Weg zum Meeting kurz erklären?“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72803,
                      "answer_id":30347,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:01.474Z",
                      "updated_at":"2022-01-10T23:24:01.474Z",
                      "text":"« Bien sûr, mais je suis vraiment à court de temps maintenant. Pouvez-vous m'en parler rapidement sur le chemin vers ma réunion? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72802,
                      "answer_id":30347,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:01.469Z",
                      "updated_at":"2022-01-10T23:24:01.469Z",
                      "text":"« Bien sûr, mais je suis vraiment à court de temps pour l’instant. Est-ce que tu peux m’en toucher un mot en vitesse sur le chemin de la réunion ? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72801,
                      "answer_id":30347,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:01.464Z",
                      "updated_at":"2022-01-10T23:24:01.464Z",
                      "text":"“Claro, mas estou realmente sem tempo agora. Você pode me contar rapidamente durante o caminho para a minha reunião?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72800,
                      "answer_id":30347,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:01.459Z",
                      "updated_at":"2022-01-10T23:24:01.459Z",
                      "text":"“Seguro, pero en este momento tengo muy poco tiempo. Me puedes decir rápidamente mientras voy hacia mi reunión?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72799,
                      "answer_id":30347,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:01.455Z",
                      "updated_at":"2022-01-10T23:24:01.455Z",
                      "text":"“Oo naman, pero naghahabol ako sa oras ngayon. Maaari mo bang sabihin sa akin agad habang papunta sa aking pulong?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72798,
                      "answer_id":30347,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:01.449Z",
                      "updated_at":"2022-01-10T23:24:01.449Z",
                      "text":"“没问题，但我现在确实没有时间。你能趁我在去开会的路上抓紧时间告诉我吗？”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72797,
                      "answer_id":30347,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:01.444Z",
                      "updated_at":"2022-01-10T23:24:01.444Z",
                      "text":"「當然，但我現在真的時間很緊迫。我現在正要去開會，你可以邊走邊快速地跟我說嗎？",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30348,
                "position":2,
                "active":true,
                "question_id":12063,
                "created_at":"2022-01-10T23:24:01.520Z",
                "updated_at":"2022-04-21T22:26:29.599Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Wait and see if the move actually happens. If it does and Logan gets upset about it, Ida can tell human resources.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72812,
                      "answer_id":30348,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:01.534Z",
                      "updated_at":"2022-04-21T22:26:29.601Z",
                      "text":"Wait and see if the move actually happens. If it does and Logan gets upset about it, Ida can tell human resources.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72827,
                      "answer_id":30348,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:01.612Z",
                      "updated_at":"2022-01-10T23:24:01.612Z",
                      "text":"\"Elbette, ancak şu anda zamanım gerçekten kısıtlı. Bunun yerine durumu açıklayan bir e-posta atabilir misin?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72826,
                      "answer_id":30348,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:01.607Z",
                      "updated_at":"2022-01-10T23:24:01.607Z",
                      "text":"\"Claro, pero ahora estoy en un momento importante. ¿Puedes enviarme un correo electrónico sobre el tema?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72825,
                      "answer_id":30348,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:01.602Z",
                      "updated_at":"2022-01-10T23:24:01.602Z",
                      "text":"«Конечно, но сейчас у меня вообще нет времени. Вы могли бы написать о проблеме на электронную почту?»",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72824,
                      "answer_id":30348,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:01.596Z",
                      "updated_at":"2022-01-10T23:24:01.596Z",
                      "text":"„Jasne, ale mam teraz naprawdę mało czasu. Czy możesz zamiast tego wysłać do mnie maila w tej sprawie?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72823,
                      "answer_id":30348,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:01.591Z",
                      "updated_at":"2022-01-10T23:24:01.591Z",
                      "text":"“그래요. 하지만 지금은 정말 시간이 없어서요. 그 문제를 이메일로 보내 주시겠어요?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72822,
                      "answer_id":30348,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:01.586Z",
                      "updated_at":"2022-01-10T23:24:01.586Z",
                      "text":"「いいですよ、でも今時間に追われています。代わりに、その問題に関するメールを送っていただけますか？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72821,
                      "answer_id":30348,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:01.581Z",
                      "updated_at":"2022-01-10T23:24:01.581Z",
                      "text":"“Certo, ma adesso sono davvero stretto con i tempi. Puoi inviarmi un’e-mail che descriva il problema?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72820,
                      "answer_id":30348,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:01.576Z",
                      "updated_at":"2022-01-10T23:24:01.576Z",
                      "text":"„Gerne, nur habe ich es gerade wirklich eilig. Kannst du mir stattdessen eine E-Mail zu dem Problem senden?“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72819,
                      "answer_id":30348,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:01.571Z",
                      "updated_at":"2022-01-10T23:24:01.571Z",
                      "text":"« Bien sûr, mais je suis vraiment à court de temps maintenant. Pouvez-vous plutôt m'envoyer un e-mail à propos du problème? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72818,
                      "answer_id":30348,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:01.566Z",
                      "updated_at":"2022-01-10T23:24:01.566Z",
                      "text":"« Bien sûr, mais je suis vraiment à court de temps pour l’instant. Tu ne pourrais pas plutôt m’envoyer un mail pour m’expliquer de quoi il s’agit ? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72817,
                      "answer_id":30348,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:01.561Z",
                      "updated_at":"2022-01-10T23:24:01.561Z",
                      "text":"“Claro, mas estou realmente sem tempo agora. Você pode então me enviar um e-mail sobre o problema?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72816,
                      "answer_id":30348,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:01.556Z",
                      "updated_at":"2022-01-10T23:24:01.556Z",
                      "text":"“Seguro, pero en este momento tengo muy poco tiempo. ¿Me puedes enviar un correo electrónico sobre el problema?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72815,
                      "answer_id":30348,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:01.549Z",
                      "updated_at":"2022-01-10T23:24:01.549Z",
                      "text":"“Oo naman, pero naghahabol ako sa oras ngayon. Pwede mo ba akong padalhan na lang ng email tungkol sa isyu?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72814,
                      "answer_id":30348,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:01.545Z",
                      "updated_at":"2022-01-10T23:24:01.545Z",
                      "text":"“没问题，但我现在确实没有时间。你能发邮件告诉我此事吗？”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72813,
                      "answer_id":30348,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:01.539Z",
                      "updated_at":"2022-01-10T23:24:01.539Z",
                      "text":"「當然，但我現在真的時間很緊迫。你可以改寄電子郵件給我嗎？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30349,
                "position":3,
                "active":true,
                "question_id":12063,
                "created_at":"2022-01-10T23:24:01.618Z",
                "updated_at":"2022-04-21T22:26:41.986Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Immediately contact the person in human resources conducting the harassment investigation.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72843,
                      "answer_id":30349,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:01.707Z",
                      "updated_at":"2022-01-10T23:24:01.707Z",
                      "text":"\"Elbette, ancak şu anda zamanım gerçekten kısıtlı. Bir saat sonra tüm dikkatimle dinleyebileceğim; o zaman buluşabilir miyiz?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72842,
                      "answer_id":30349,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:01.702Z",
                      "updated_at":"2022-01-10T23:24:01.702Z",
                      "text":"\"Claro, pero ahora estoy en un momento importante. ¿Podemos vernos en una hora? Así, podré dedicarte toda mi atención.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72841,
                      "answer_id":30349,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:01.697Z",
                      "updated_at":"2022-01-10T23:24:01.697Z",
                      "text":"«Конечно, но сейчас у меня вообще нет времени. Мы могли бы встретиться через час, когда я смогу уделить вам должное внимание?»",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72840,
                      "answer_id":30349,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:01.692Z",
                      "updated_at":"2022-01-10T23:24:01.692Z",
                      "text":"„Jasne, ale mam teraz naprawdę mało czasu. Czy możemy spotkać się za godzinę, kiedy będę mógł poświęcić Ci całą swoją uwagę?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72839,
                      "answer_id":30349,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:01.687Z",
                      "updated_at":"2022-01-10T23:24:01.687Z",
                      "text":"“그래요. 하지만 지금은 정말 시간이 없어서요. 한 시간 후에 제가 온전히 집중해서 들을 수 있을 때 만날까요?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72838,
                      "answer_id":30349,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:01.682Z",
                      "updated_at":"2022-01-10T23:24:01.682Z",
                      "text":"「いいですよ、でも今時間に追われています。あなたに全神経を集中させることができるように、1時間後にお会いできますか？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72837,
                      "answer_id":30349,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:01.676Z",
                      "updated_at":"2022-01-10T23:24:01.676Z",
                      "text":"“Certo, ma adesso sono davvero stretto con i tempi. Possiamo incontrarci tra un’ora, quando posso dedicarti tutta la mia attenzione?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72836,
                      "answer_id":30349,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:01.672Z",
                      "updated_at":"2022-01-10T23:24:01.672Z",
                      "text":"„Gerne, nur habe ich es gerade wirklich eilig. Können wir uns in einer Stunde treffen, damit ich dir auch wirklich aufmerksam zuhören kann?“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72835,
                      "answer_id":30349,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:01.667Z",
                      "updated_at":"2022-01-10T23:24:01.667Z",
                      "text":"« Bien sûr, mais je suis vraiment à court de temps maintenant. Pouvons-nous nous rencontrer dans une heure, quand je pourrai vous consacrer toute mon attention? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72834,
                      "answer_id":30349,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:01.662Z",
                      "updated_at":"2022-01-10T23:24:01.662Z",
                      "text":"« Bien sûr, mais je suis vraiment à court de temps pour l’instant. Est-ce qu’on peut se voir dans une heure ? Je pourrai alors te consacrer toute mon attention. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72833,
                      "answer_id":30349,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:01.657Z",
                      "updated_at":"2022-01-10T23:24:01.657Z",
                      "text":"“Claro, mas estou realmente sem tempo agora. Podemos nos encontrar daqui a uma hora, quando poderei dar minha atenção total a você?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72832,
                      "answer_id":30349,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:01.652Z",
                      "updated_at":"2022-01-10T23:24:01.652Z",
                      "text":"“Seguro, pero en este momento tengo muy poco tiempo. ¿Podemos reunirnos dentro de una hora, cuando pueda dedicarte toda mi atención?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72831,
                      "answer_id":30349,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:01.647Z",
                      "updated_at":"2022-01-10T23:24:01.647Z",
                      "text":"“Oo naman, pero naghahabol ako sa oras ngayon. Maaari ba tayong magkita sa isang oras, kung kailan maibibigay ko ang aking buong pansin sa iyo?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72830,
                      "answer_id":30349,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:01.642Z",
                      "updated_at":"2022-01-10T23:24:01.642Z",
                      "text":"“没问题，但我现在确实没有时间。我们一小时后见怎样，那样我可以集中精力处理你的事情？”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72829,
                      "answer_id":30349,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:01.637Z",
                      "updated_at":"2022-01-10T23:24:01.637Z",
                      "text":"「當然，但我現在真的時間很緊迫。我們可以一個小時後見面聊嗎？到時候我可以全神貫注聽你說？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72828,
                      "answer_id":30349,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:01.632Z",
                      "updated_at":"2022-04-21T22:26:41.988Z",
                      "text":"Immediately contact the person in human resources conducting the harassment investigation.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12064,
          "shuffle":false,
          "position":39,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30352"
          ],
          "created_at":"2022-01-10T23:24:01.725Z",
          "updated_at":"2022-04-21T22:27:12.366Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":39,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What should you say to Mia?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30248,
                "question_id":12064,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:01.908Z",
                "updated_at":"2022-01-10T23:24:01.908Z",
                "text":"Henry'ye ne söylemelisiniz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30247,
                "question_id":12064,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:01.903Z",
                "updated_at":"2022-01-10T23:24:01.903Z",
                "text":"¿Qué debería decirle a Henry?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30246,
                "question_id":12064,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:01.898Z",
                "updated_at":"2022-01-10T23:24:01.898Z",
                "text":"Что вам следует ответить Генри?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30245,
                "question_id":12064,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:01.893Z",
                "updated_at":"2022-01-10T23:24:01.893Z",
                "text":"Co należy powiedzieć Henry'emu?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30244,
                "question_id":12064,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:01.888Z",
                "updated_at":"2022-01-10T23:24:01.888Z",
                "text":"Henry에게 뭐라고 말해야 할까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30243,
                "question_id":12064,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:01.883Z",
                "updated_at":"2022-01-10T23:24:01.883Z",
                "text":"Henryさんに何と伝えるべきですか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30242,
                "question_id":12064,
                "locale":"it",
                "created_at":"2022-01-10T23:24:01.878Z",
                "updated_at":"2022-01-10T23:24:01.878Z",
                "text":"Che cosa dovresti dire a Henry?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30241,
                "question_id":12064,
                "locale":"de",
                "created_at":"2022-01-10T23:24:01.873Z",
                "updated_at":"2022-01-10T23:24:01.873Z",
                "text":"Was sollten Sie zu Henry sagen?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30240,
                "question_id":12064,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:01.868Z",
                "updated_at":"2022-01-10T23:24:01.868Z",
                "text":"Que devriez-vous dire à Henry?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30239,
                "question_id":12064,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:01.863Z",
                "updated_at":"2022-01-10T23:24:01.863Z",
                "text":"Que devriez-vous dire à Henry ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30238,
                "question_id":12064,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:01.858Z",
                "updated_at":"2022-01-10T23:24:01.858Z",
                "text":"O que você deve dizer a Henry?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30237,
                "question_id":12064,
                "locale":"es",
                "created_at":"2022-01-10T23:24:01.852Z",
                "updated_at":"2022-01-10T23:24:01.852Z",
                "text":"¿Qué deberías decirle a Henry?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30236,
                "question_id":12064,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:01.847Z",
                "updated_at":"2022-01-10T23:24:01.847Z",
                "text":"Ano ang dapat mong sabihin kay Henry?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30235,
                "question_id":12064,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:01.842Z",
                "updated_at":"2022-01-10T23:24:01.842Z",
                "text":"你應該跟 Henry 說甚麼？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30234,
                "question_id":12064,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:01.837Z",
                "updated_at":"2022-01-10T23:24:01.837Z",
                "text":"你应该对 Henry 说什么？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30233,
                "question_id":12064,
                "locale":"en",
                "created_at":"2022-01-10T23:24:01.744Z",
                "updated_at":"2022-04-21T22:27:12.369Z",
                "text":"What should you say to Mia?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30350,
                "position":1,
                "active":true,
                "question_id":12064,
                "created_at":"2022-01-10T23:24:01.915Z",
                "updated_at":"2022-04-21T22:27:20.933Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“That’s age harassment! Come with me; I have to report this now.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72844,
                      "answer_id":30350,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:01.928Z",
                      "updated_at":"2022-04-21T22:27:20.935Z",
                      "text":"“That’s age harassment! Come with me; I have to report this now.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72859,
                      "answer_id":30350,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:02.003Z",
                      "updated_at":"2022-01-10T23:24:02.003Z",
                      "text":"\"Bu yaptığın yaş ayrımcılığı! Benimle gel, bunu bildirmem gerekiyor.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72858,
                      "answer_id":30350,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:01.998Z",
                      "updated_at":"2022-01-10T23:24:01.998Z",
                      "text":"\"Es una discriminación por edad. Acompáñame, tengo que denunciar esto ya\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72857,
                      "answer_id":30350,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:01.993Z",
                      "updated_at":"2022-01-10T23:24:01.993Z",
                      "text":"«Это дискриминация по возрастному признаку! Пойдемте, я должен сообщить об этом».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72856,
                      "answer_id":30350,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:01.988Z",
                      "updated_at":"2022-01-10T23:24:01.988Z",
                      "text":"„To jest dyskryminacja ze względu na wiek! Chodź ze mną, muszę to teraz zgłosić”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72855,
                      "answer_id":30350,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:01.983Z",
                      "updated_at":"2022-01-10T23:24:01.983Z",
                      "text":"“그것은 연령 차별이에요! 저와 함께 가요, 지금 바로 신고해야 돼요.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72854,
                      "answer_id":30350,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:01.977Z",
                      "updated_at":"2022-01-10T23:24:01.977Z",
                      "text":"「それは年齢差別です！付いてきてください、すぐに報告する必要があります。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72853,
                      "answer_id":30350,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:01.973Z",
                      "updated_at":"2022-01-10T23:24:01.973Z",
                      "text":"“Questa è discriminazione basata sull’età! Vieni con me, devo segnalare questa situazione adesso”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72852,
                      "answer_id":30350,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:01.968Z",
                      "updated_at":"2022-01-10T23:24:01.968Z",
                      "text":"„Das ist Altersdiskriminierung! Begleite mich, das muss ich sofort melden.“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72851,
                      "answer_id":30350,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:01.963Z",
                      "updated_at":"2022-01-10T23:24:01.963Z",
                      "text":"« C'est une discrimination fondée sur l'âge! Venez avec moi, je dois le signaler maintenant.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72850,
                      "answer_id":30350,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:01.957Z",
                      "updated_at":"2022-01-10T23:24:01.957Z",
                      "text":"« C’est de la discrimination fondée sur l’âge ! Suis-moi, je dois le signaler sans tarder. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72849,
                      "answer_id":30350,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:01.952Z",
                      "updated_at":"2022-01-10T23:24:01.952Z",
                      "text":"“Isso é discriminação por idade! Venha comigo, eu tenho que relatar isso agora.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72848,
                      "answer_id":30350,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:01.947Z",
                      "updated_at":"2022-01-10T23:24:01.947Z",
                      "text":"「那是年齡歧視！我帶你去，我現在必須通報這件事情。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72847,
                      "answer_id":30350,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:01.943Z",
                      "updated_at":"2022-01-10T23:24:01.943Z",
                      "text":"“¡Se trata de discriminación por edad! Ven conmigo, debo denunciarlo ahora”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72846,
                      "answer_id":30350,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:01.938Z",
                      "updated_at":"2022-01-10T23:24:01.938Z",
                      "text":"“Diskriminasyon yan ng edad! Lumapit ka sa akin, kailangan ko itong ireport ngayon.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72845,
                      "answer_id":30350,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:01.933Z",
                      "updated_at":"2022-01-10T23:24:01.933Z",
                      "text":"“这是年龄歧视！随我来，我必须立即举报此事。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30351,
                "position":2,
                "active":true,
                "question_id":12064,
                "created_at":"2022-01-10T23:24:02.012Z",
                "updated_at":"2022-04-21T22:27:30.816Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Nothing. Mia is probably just trying to show concern and means no harm.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72875,
                      "answer_id":30351,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:02.111Z",
                      "updated_at":"2022-01-10T23:24:02.111Z",
                      "text":"Hiçbir şey. Henry muhtemelen sunum yapma konusunda gergindir ve kimseyi incitmek istemez.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72874,
                      "answer_id":30351,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:02.105Z",
                      "updated_at":"2022-01-10T23:24:02.105Z",
                      "text":"Nada. Es probable que Henry solo esté nervioso por la presentación y no pretendiera hacer daño.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72873,
                      "answer_id":30351,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:02.100Z",
                      "updated_at":"2022-01-10T23:24:02.100Z",
                      "text":"Ничего. Генри, вероятно, просто нервничает из-за выступления и не имел ввиду ничего плохого.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72872,
                      "answer_id":30351,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:02.094Z",
                      "updated_at":"2022-01-10T23:24:02.094Z",
                      "text":"Nie podejmować żadnych działań. Henry prawdopodobnie denerwuje się prezentacją i nie miał na myśli nic złego.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72871,
                      "answer_id":30351,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:02.088Z",
                      "updated_at":"2022-01-10T23:24:02.088Z",
                      "text":"아무 행동도 취하지 않는다. Henry는 발표에 대해 긴장하고 있었던 것일 뿐 악의는 없었을 것이다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72870,
                      "answer_id":30351,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:02.083Z",
                      "updated_at":"2022-01-10T23:24:02.083Z",
                      "text":"何もしない。Henryさんは発表することに対して緊張していただけで、悪意はなかったでしょう。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72869,
                      "answer_id":30351,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:02.078Z",
                      "updated_at":"2022-01-10T23:24:02.078Z",
                      "text":"Nulla. Henry probabilmente è solo nervoso per la presentazione e non intendeva arrecare danno a nessuno.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72868,
                      "answer_id":30351,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:02.072Z",
                      "updated_at":"2022-01-10T23:24:02.072Z",
                      "text":"Nichts. Henry ist wahrscheinlich nur nervös aufgrund seiner Präsentation und hat es nicht böse gemeint.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72867,
                      "answer_id":30351,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:02.066Z",
                      "updated_at":"2022-01-10T23:24:02.066Z",
                      "text":"Rien. Henry est probablement juste nerveux à l'idée de se présenter et sont but n'était pas de faire du mal.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72866,
                      "answer_id":30351,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:02.061Z",
                      "updated_at":"2022-01-10T23:24:02.061Z",
                      "text":"Rien. Henry est sans doute juste nerveux à l’idée de donner une présentation et ne pensait pas à mal.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72865,
                      "answer_id":30351,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:02.056Z",
                      "updated_at":"2022-01-10T23:24:02.056Z",
                      "text":"Nada. Henry provavelmente está apenas nervoso com a apresentação e não teve a intenção de ofender.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72864,
                      "answer_id":30351,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:02.051Z",
                      "updated_at":"2022-01-10T23:24:02.051Z",
                      "text":"Nada. Henry probablemente solo esté nervioso con la presentación, y no tenga malas intenciones.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72863,
                      "answer_id":30351,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:02.046Z",
                      "updated_at":"2022-01-10T23:24:02.046Z",
                      "text":"Wala. Marahil ay kinakabahan lang si Henry sa pagpe-present at hindi sinasadyang makasakit.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72862,
                      "answer_id":30351,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:02.040Z",
                      "updated_at":"2022-01-10T23:24:02.040Z",
                      "text":"无Henry 可能只是演讲时感到紧张，无意伤害你。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72861,
                      "answer_id":30351,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:02.033Z",
                      "updated_at":"2022-01-10T23:24:02.033Z",
                      "text":"甚麼都不做。Henry 可能只是對於簡報感到緊張，沒有惡意。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72860,
                      "answer_id":30351,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:02.028Z",
                      "updated_at":"2022-04-21T22:27:30.819Z",
                      "text":"Nothing. Mia is probably just trying to show concern and means no harm.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30352,
                "position":3,
                "active":true,
                "question_id":12064,
                "created_at":"2022-01-10T23:24:02.119Z",
                "updated_at":"2022-04-21T22:27:38.617Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"\"Mia, that was not OK. Let’s talk privately for a moment.\"",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72891,
                      "answer_id":30352,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:02.220Z",
                      "updated_at":"2022-01-10T23:24:02.220Z",
                      "text":"\"Henry, bu hoş değil. Toplantıdan sonra konuşalım.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72890,
                      "answer_id":30352,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:02.214Z",
                      "updated_at":"2022-01-10T23:24:02.214Z",
                      "text":"\"Henry, eso no estuvo bien. Hablemos después de la reunión\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72889,
                      "answer_id":30352,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:02.209Z",
                      "updated_at":"2022-01-10T23:24:02.209Z",
                      "text":"«Генри, это было неприемлемо. Давайте поговорим после собрания».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72888,
                      "answer_id":30352,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:02.204Z",
                      "updated_at":"2022-01-10T23:24:02.204Z",
                      "text":"„Henry, to nie było w porządku. Porozmawiajmy po tym spotkaniu”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72887,
                      "answer_id":30352,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:02.199Z",
                      "updated_at":"2022-01-10T23:24:02.199Z",
                      "text":"\"Henry, 그건 부적절했어요. 회의 후에 이야기 하죠.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72886,
                      "answer_id":30352,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:02.193Z",
                      "updated_at":"2022-01-10T23:24:02.193Z",
                      "text":"「Henryさん、さっきの言動はよくありませんでした。ミーティング後に話し合いましょう。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72885,
                      "answer_id":30352,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:02.188Z",
                      "updated_at":"2022-01-10T23:24:02.188Z",
                      "text":"“Henry, questa situazione non andava bene. Parliamo dopo questa riunione”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72884,
                      "answer_id":30352,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:02.182Z",
                      "updated_at":"2022-01-10T23:24:02.182Z",
                      "text":"„Henry, das war nicht in Ordnung. Nach dem Meeting sprechen wir darüber.“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72883,
                      "answer_id":30352,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:02.177Z",
                      "updated_at":"2022-01-10T23:24:02.177Z",
                      "text":"« Henry, ce n'était pas suffisant. Parlons-en après cette réunion. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72882,
                      "answer_id":30352,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:02.171Z",
                      "updated_at":"2022-01-10T23:24:02.171Z",
                      "text":"« Henry, ça ne peut pas se passer comme ça. Il faut qu’on en parle après la réunion. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72881,
                      "answer_id":30352,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:02.166Z",
                      "updated_at":"2022-01-10T23:24:02.166Z",
                      "text":"\"Henry, isso não foi legal. Vamos conversar depois desta reunião.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72880,
                      "answer_id":30352,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:02.160Z",
                      "updated_at":"2022-01-10T23:24:02.160Z",
                      "text":"\"Henry, eso no estuvo bien. Hablemos después de esta reunión\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72879,
                      "answer_id":30352,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:02.155Z",
                      "updated_at":"2022-01-10T23:24:02.155Z",
                      "text":"\"Henry, hindi iyon OK. Mag-usap tayo pagkatapos ng pulong.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72878,
                      "answer_id":30352,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:02.149Z",
                      "updated_at":"2022-01-10T23:24:02.149Z",
                      "text":"“Henry，不能就这样算了。我们会后再谈这个事情。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72877,
                      "answer_id":30352,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:02.142Z",
                      "updated_at":"2022-01-10T23:24:02.142Z",
                      "text":"「Henry，你那麼做是不應該的。我們在會議後需要談談。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72876,
                      "answer_id":30352,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:02.137Z",
                      "updated_at":"2022-04-21T22:27:38.619Z",
                      "text":"\"Mia, that was not OK. Let’s talk privately for a moment.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12065,
          "shuffle":false,
          "position":40,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30353"
          ],
          "created_at":"2022-01-10T23:24:02.242Z",
          "updated_at":"2022-01-10T23:24:02.692Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":40,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"How should you respond?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30264,
                "question_id":12065,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:02.461Z",
                "updated_at":"2022-01-10T23:24:02.461Z",
                "text":"Nasıl karşılık vermelisiniz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30263,
                "question_id":12065,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:02.454Z",
                "updated_at":"2022-01-10T23:24:02.454Z",
                "text":"¿Cómo debería responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30262,
                "question_id":12065,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:02.448Z",
                "updated_at":"2022-01-10T23:24:02.448Z",
                "text":"Как вам следует ответить?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30261,
                "question_id":12065,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:02.442Z",
                "updated_at":"2022-01-10T23:24:02.442Z",
                "text":"Jak należy zareagować?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30260,
                "question_id":12065,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:02.436Z",
                "updated_at":"2022-01-10T23:24:02.436Z",
                "text":"귀하는 어떻게 대처해야 합니까?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30259,
                "question_id":12065,
                "locale":"it",
                "created_at":"2022-01-10T23:24:02.429Z",
                "updated_at":"2022-01-10T23:24:02.429Z",
                "text":"Come dovresti rispondere?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30258,
                "question_id":12065,
                "locale":"de",
                "created_at":"2022-01-10T23:24:02.422Z",
                "updated_at":"2022-01-10T23:24:02.422Z",
                "text":"Wie sollten Sie reagieren?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30257,
                "question_id":12065,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:02.416Z",
                "updated_at":"2022-01-10T23:24:02.416Z",
                "text":"Comment réagiriez-vous ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30256,
                "question_id":12065,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:02.411Z",
                "updated_at":"2022-01-10T23:24:02.411Z",
                "text":"Comment devriez-vous réagir ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30255,
                "question_id":12065,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:02.406Z",
                "updated_at":"2022-01-10T23:24:02.406Z",
                "text":"Como você deve responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30254,
                "question_id":12065,
                "locale":"es",
                "created_at":"2022-01-10T23:24:02.400Z",
                "updated_at":"2022-01-10T23:24:02.400Z",
                "text":"¿Cómo debes responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30253,
                "question_id":12065,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:02.395Z",
                "updated_at":"2022-01-10T23:24:02.395Z",
                "text":"Paano ka sasagot?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30252,
                "question_id":12065,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:02.389Z",
                "updated_at":"2022-01-10T23:24:02.389Z",
                "text":"你該如何回應？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30251,
                "question_id":12065,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:02.383Z",
                "updated_at":"2022-01-10T23:24:02.383Z",
                "text":"你应如何回应？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30250,
                "question_id":12065,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:02.377Z",
                "updated_at":"2022-01-10T23:24:02.377Z",
                "text":"どのように返答すべきですか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30249,
                "question_id":12065,
                "locale":"en",
                "created_at":"2022-01-10T23:24:02.263Z",
                "updated_at":"2022-01-10T23:24:02.263Z",
                "text":"How should you respond?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30353,
                "position":1,
                "active":true,
                "question_id":12065,
                "created_at":"2022-01-10T23:24:02.469Z",
                "updated_at":"2022-04-21T22:30:00.759Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“I’m sorry, but the meetings are mandatory. You’ll just have to learn how to handle Mustafa.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72892,
                      "answer_id":30353,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:02.483Z",
                      "updated_at":"2022-04-21T22:30:00.762Z",
                      "text":"“I’m sorry, but the meetings are mandatory. You’ll just have to learn how to handle Mustafa.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72907,
                      "answer_id":30353,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:02.573Z",
                      "updated_at":"2022-01-10T23:24:02.573Z",
                      "text":"Konsantre olma konusunda yardımcı olmak için yapabileceğiniz bir şey olup olmadığını sorun. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72906,
                      "answer_id":30353,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:02.566Z",
                      "updated_at":"2022-01-10T23:24:02.566Z",
                      "text":"Preguntar si hay algo que usted pueda hacer para ayudarle a concentrarse. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72905,
                      "answer_id":30353,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:02.560Z",
                      "updated_at":"2022-01-10T23:24:02.560Z",
                      "text":"Спросить, что вы можете сделать, чтобы помочь ей сосредоточиться. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72904,
                      "answer_id":30353,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:02.554Z",
                      "updated_at":"2022-01-10T23:24:02.554Z",
                      "text":"Zapytać, czy jest coś, co możesz zrobić, aby ją wesprzeć i pomóc jej się skoncentrować. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72903,
                      "answer_id":30353,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:02.548Z",
                      "updated_at":"2022-01-10T23:24:02.548Z",
                      "text":"그녀가 집중할 수 있도록 돕기 위해 해줄 수 있는 일이 있는지 물어본다. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72902,
                      "answer_id":30353,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:02.542Z",
                      "updated_at":"2022-01-10T23:24:02.542Z",
                      "text":"彼女が集中できるように何かできることはないか聞く。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72901,
                      "answer_id":30353,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:02.537Z",
                      "updated_at":"2022-01-10T23:24:02.537Z",
                      "text":"Chiederle se c’è qualche azione che puoi compiere per supportarla e aiutarla a concentrarsi. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72900,
                      "answer_id":30353,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:02.531Z",
                      "updated_at":"2022-01-10T23:24:02.531Z",
                      "text":"Fragen, ob Sie ihr irgendwie helfen können, damit sie sich besser konzentrieren kann. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72899,
                      "answer_id":30353,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:02.526Z",
                      "updated_at":"2022-01-10T23:24:02.526Z",
                      "text":"Demandez-lui si vous pouvez faire quelque chose pour l'aider à se concentrer. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72898,
                      "answer_id":30353,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:02.520Z",
                      "updated_at":"2022-01-10T23:24:02.520Z",
                      "text":"Lui demander si vous pouvez faire quelque chose pour l’aider à se concentrer. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72897,
                      "answer_id":30353,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:02.513Z",
                      "updated_at":"2022-01-10T23:24:02.513Z",
                      "text":"Perguntar se há algo que você possa fazer para apoiá-la e ajudá-la a se concentrar. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72896,
                      "answer_id":30353,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:02.508Z",
                      "updated_at":"2022-01-10T23:24:02.508Z",
                      "text":"Preguntar si puedes hacer algo para apoyarla y ayudarla a concentrarse. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72895,
                      "answer_id":30353,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:02.503Z",
                      "updated_at":"2022-01-10T23:24:02.503Z",
                      "text":"Tanungin kung mayroong anumang maaari mong gawin upang matulungan siya para makapag-concentrate. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72894,
                      "answer_id":30353,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:02.494Z",
                      "updated_at":"2022-01-10T23:24:02.494Z",
                      "text":"询问你可以做什么来帮助给她支持，以帮助她集中精力。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72893,
                      "answer_id":30353,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:02.489Z",
                      "updated_at":"2022-01-10T23:24:02.489Z",
                      "text":"問問她是否你如何可以幫助她專注。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30354,
                "position":2,
                "active":true,
                "question_id":12065,
                "created_at":"2022-01-10T23:24:02.581Z",
                "updated_at":"2022-04-21T22:30:11.377Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“Let's have you not join the team meetings anymore.\"",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72923,
                      "answer_id":30354,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:02.685Z",
                      "updated_at":"2022-01-10T23:24:02.685Z",
                      "text":"Sabina'yı daha az stres yaşaması için yarı zamanlı bir çalışma programına dahil etmeyi teklif edin.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72922,
                      "answer_id":30354,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:02.679Z",
                      "updated_at":"2022-01-10T23:24:02.679Z",
                      "text":"Ofrecer poner a Sabina en un trabajo a tiempo parcial para que no sufra tanto estrés.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72921,
                      "answer_id":30354,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:02.673Z",
                      "updated_at":"2022-01-10T23:24:02.673Z",
                      "text":"Предложить Сабине перейти на график с частичной занятостью, чтобы в ее жизни было меньше стресса.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72920,
                      "answer_id":30354,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:02.668Z",
                      "updated_at":"2022-01-10T23:24:02.668Z",
                      "text":"Zaoferować Sabinie pracę w niepełnym wymiarze godzin, aby doświadczała mniej stresu w swoim życiu.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72919,
                      "answer_id":30354,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:02.661Z",
                      "updated_at":"2022-01-10T23:24:02.661Z",
                      "text":"Sabina에게 시간제 근무 일정을 제안하여 스트레스를 덜어 준다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72918,
                      "answer_id":30354,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:02.655Z",
                      "updated_at":"2022-01-10T23:24:02.655Z",
                      "text":"Sabinaさんの生活にかかるストレスを軽減するために、勤務スケジュールをパートタイムに変更することを提案する。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72917,
                      "answer_id":30354,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:02.649Z",
                      "updated_at":"2022-01-10T23:24:02.649Z",
                      "text":"Offrire Sabina un orario di lavoro part-time in modo che la sua vita sia meno stressata.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72916,
                      "answer_id":30354,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:02.642Z",
                      "updated_at":"2022-01-10T23:24:02.642Z",
                      "text":"Sabina anbieten, nur halbtags zu arbeiten, damit sie weniger gestresst ist.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72915,
                      "answer_id":30354,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:02.636Z",
                      "updated_at":"2022-01-10T23:24:02.636Z",
                      "text":"Offrez de mettre Sabina sur un horaire de travail à temps partiel afin qu'elle ait moins de stress dans sa vie.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72914,
                      "answer_id":30354,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:02.629Z",
                      "updated_at":"2022-01-10T23:24:02.629Z",
                      "text":"Proposer à Sabina de lui donner un horaire à temps partiel pour diminuer le stress qu’elle ressent dans sa vie.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72913,
                      "answer_id":30354,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:02.624Z",
                      "updated_at":"2022-01-10T23:24:02.624Z",
                      "text":"Oferecer para colocar Sabina em um horário de trabalho de meio expediente para que ela tenha menos estresse em sua vida.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72912,
                      "answer_id":30354,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:02.618Z",
                      "updated_at":"2022-01-10T23:24:02.618Z",
                      "text":"Ofrecer a Sabina un horario laboral de medio tiempo para que tenga menos estrés en su vida.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72911,
                      "answer_id":30354,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:02.613Z",
                      "updated_at":"2022-01-10T23:24:02.613Z",
                      "text":"Mag-alok na ilagay si Sabina sa isang part-time na iskedyul ng trabaho upang mabawasan ang stress sa kanyang buhay.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72910,
                      "answer_id":30354,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:02.608Z",
                      "updated_at":"2022-01-10T23:24:02.608Z",
                      "text":"主动提出给 Sabina 安排非全职工作，以便减少她的生活压力。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72909,
                      "answer_id":30354,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:02.602Z",
                      "updated_at":"2022-01-10T23:24:02.602Z",
                      "text":"向 Sabina 提議兼職的工作時間，減輕她的生活壓力。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72908,
                      "answer_id":30354,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:02.597Z",
                      "updated_at":"2022-04-21T22:30:11.379Z",
                      "text":"“Let's have you not join the team meetings anymore.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31706,
                "position":3,
                "active":true,
                "question_id":12065,
                "created_at":"2022-04-21T22:30:22.145Z",
                "updated_at":"2022-04-21T22:30:22.145Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“I’d like to learn more. What’s happening in these meetings?”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77376,
                      "answer_id":31706,
                      "locale":"en",
                      "created_at":"2022-04-21T22:30:22.153Z",
                      "updated_at":"2022-04-21T22:30:22.153Z",
                      "text":"“I’d like to learn more. What’s happening in these meetings?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12066,
          "shuffle":false,
          "position":41,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30356"
          ],
          "created_at":"2022-01-10T23:24:02.709Z",
          "updated_at":"2022-01-10T23:24:03.139Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":41,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"How should you respond?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30280,
                "question_id":12066,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:02.914Z",
                "updated_at":"2022-01-10T23:24:02.914Z",
                "text":"Nasıl karşılık vermelisiniz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30279,
                "question_id":12066,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:02.909Z",
                "updated_at":"2022-01-10T23:24:02.909Z",
                "text":"¿Cómo debería responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30278,
                "question_id":12066,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:02.904Z",
                "updated_at":"2022-01-10T23:24:02.904Z",
                "text":"Как вам следует ответить?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30277,
                "question_id":12066,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:02.898Z",
                "updated_at":"2022-01-10T23:24:02.898Z",
                "text":"Jak należy zareagować?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30276,
                "question_id":12066,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:02.893Z",
                "updated_at":"2022-01-10T23:24:02.893Z",
                "text":"귀하는 어떻게 대처해야 합니까?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30275,
                "question_id":12066,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:02.887Z",
                "updated_at":"2022-01-10T23:24:02.887Z",
                "text":"どのように返答すべきですか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30274,
                "question_id":12066,
                "locale":"it",
                "created_at":"2022-01-10T23:24:02.882Z",
                "updated_at":"2022-01-10T23:24:02.882Z",
                "text":"Come dovresti rispondere?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30273,
                "question_id":12066,
                "locale":"de",
                "created_at":"2022-01-10T23:24:02.877Z",
                "updated_at":"2022-01-10T23:24:02.877Z",
                "text":"Wie sollten Sie reagieren?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30272,
                "question_id":12066,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:02.871Z",
                "updated_at":"2022-01-10T23:24:02.871Z",
                "text":"Comment réagiriez-vous ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30271,
                "question_id":12066,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:02.865Z",
                "updated_at":"2022-01-10T23:24:02.865Z",
                "text":"Comment devriez-vous réagir ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30270,
                "question_id":12066,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:02.860Z",
                "updated_at":"2022-01-10T23:24:02.860Z",
                "text":"Como você deve responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30269,
                "question_id":12066,
                "locale":"es",
                "created_at":"2022-01-10T23:24:02.855Z",
                "updated_at":"2022-01-10T23:24:02.855Z",
                "text":"¿Cómo debes responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30268,
                "question_id":12066,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:02.848Z",
                "updated_at":"2022-01-10T23:24:02.848Z",
                "text":"Paano ka sasagot?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30267,
                "question_id":12066,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:02.843Z",
                "updated_at":"2022-01-10T23:24:02.843Z",
                "text":"你該如何回應？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30266,
                "question_id":12066,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:02.837Z",
                "updated_at":"2022-01-10T23:24:02.837Z",
                "text":"你应如何回应？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30265,
                "question_id":12066,
                "locale":"en",
                "created_at":"2022-01-10T23:24:02.730Z",
                "updated_at":"2022-01-10T23:24:02.730Z",
                "text":"How should you respond?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30355,
                "position":1,
                "active":true,
                "question_id":12066,
                "created_at":"2022-01-10T23:24:02.922Z",
                "updated_at":"2022-01-10T23:24:02.922Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“I’m sorry, but the meetings are mandatory. You’ll just have to learn how to handle Jules.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72939,
                      "answer_id":30355,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:03.017Z",
                      "updated_at":"2022-01-10T23:24:03.017Z",
                      "text":"\"Üzgünüm fakat toplantılara katılmak zorunlu. Jules ile nasıl başa çıkılacağını öğrenmen gerekecek.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72938,
                      "answer_id":30355,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:03.011Z",
                      "updated_at":"2022-01-10T23:24:03.011Z",
                      "text":"\"Lo siento, pero las reuniones son obligatorias. Tendrás que aprender a tratar con Jules\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72937,
                      "answer_id":30355,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:03.006Z",
                      "updated_at":"2022-01-10T23:24:03.006Z",
                      "text":"«Мне жаль, но совещания посещать обязательно. Вам придется научиться сосуществовать с Жюлем».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72936,
                      "answer_id":30355,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:03.001Z",
                      "updated_at":"2022-01-10T23:24:03.001Z",
                      "text":"„Przykro mi, ale spotkania są obowiązkowe. Musisz się tylko nauczyć, jak postępować z Julesem”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72935,
                      "answer_id":30355,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:02.995Z",
                      "updated_at":"2022-01-10T23:24:02.995Z",
                      "text":"“미안하지만 회의는 필수예요. Jules를 대하는 법에 익숙해지면 될 거예요.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72934,
                      "answer_id":30355,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:02.990Z",
                      "updated_at":"2022-01-10T23:24:02.990Z",
                      "text":"「すみませんが、ミーティングは全員参加です。Julesさんに対する対応方法を学ぶしかありません。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72933,
                      "answer_id":30355,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:02.984Z",
                      "updated_at":"2022-01-10T23:24:02.984Z",
                      "text":"“Mi dispiace, ma le riunioni sono obbligatorie. Dovrai solo imparare a gestire Jules”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72932,
                      "answer_id":30355,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:02.979Z",
                      "updated_at":"2022-01-10T23:24:02.979Z",
                      "text":"„Es tut mir leid, aber die Meetings sind verpflichtend. Du musst nur lernen, mit Jules umzugehen.“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72931,
                      "answer_id":30355,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:02.974Z",
                      "updated_at":"2022-01-10T23:24:02.974Z",
                      "text":"« Je suis désolé, mais les réunions sont obligatoires. Vous devrez juste apprendre à gérer Jules. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72930,
                      "answer_id":30355,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:02.969Z",
                      "updated_at":"2022-01-10T23:24:02.969Z",
                      "text":"« Désolé, mais ces réunions sont obligatoires. Il faudra que tu apprennes à composer avec Jules. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72929,
                      "answer_id":30355,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:02.963Z",
                      "updated_at":"2022-01-10T23:24:02.963Z",
                      "text":"“Sinto muito, mas as reuniões são obrigatórias. Você apenas terá que aprender a lidar com Jules.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72928,
                      "answer_id":30355,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:02.958Z",
                      "updated_at":"2022-01-10T23:24:02.958Z",
                      "text":"“Lo siento, pero las reuniones son obligatorias. Simplemente deberás aprender a manejar a Jules”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72927,
                      "answer_id":30355,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:02.953Z",
                      "updated_at":"2022-01-10T23:24:02.953Z",
                      "text":"“Paumanhin, pero ipinag-uutos ang pulong. Kailangan mong alamin kung paano haharapin si Jules.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72926,
                      "answer_id":30355,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:02.948Z",
                      "updated_at":"2022-01-10T23:24:02.948Z",
                      "text":"“抱歉，不过必须参加会议。你只需要学会如何对付 Jules 就可以了。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72925,
                      "answer_id":30355,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:02.943Z",
                      "updated_at":"2022-01-10T23:24:02.943Z",
                      "text":"「很抱歉，這個會議你必須要參加。你必須學會如何應付 Jules。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72924,
                      "answer_id":30355,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:02.938Z",
                      "updated_at":"2022-01-10T23:24:02.938Z",
                      "text":"“I’m sorry, but the meetings are mandatory. You’ll just have to learn how to handle Jules.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30356,
                "position":2,
                "active":true,
                "question_id":12066,
                "created_at":"2022-01-10T23:24:03.024Z",
                "updated_at":"2022-01-10T23:24:03.024Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“I’d like to learn more. What’s happening in these meetings?”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72955,
                      "answer_id":30356,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:03.134Z",
                      "updated_at":"2022-01-10T23:24:03.134Z",
                      "text":"\"Daha fazla bilgi almak isterim. Bu toplantılarda ne oluyor?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72954,
                      "answer_id":30356,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:03.129Z",
                      "updated_at":"2022-01-10T23:24:03.129Z",
                      "text":"\"Me gustaría tener más información. ¿Qué ocurre en estas reuniones?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72953,
                      "answer_id":30356,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:03.123Z",
                      "updated_at":"2022-01-10T23:24:03.123Z",
                      "text":"«Можно поподробнее? Что происходит на этих совещаниях?»",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72952,
                      "answer_id":30356,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:03.118Z",
                      "updated_at":"2022-01-10T23:24:03.118Z",
                      "text":"„Chciał(a)bym dowiedzieć się więcej. Co się dzieje na tych spotkaniach?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72951,
                      "answer_id":30356,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:03.107Z",
                      "updated_at":"2022-01-10T23:24:03.107Z",
                      "text":"“더 자세히 알고 싶어요. 이 회의에서 무슨 일이 일어나고 있나요?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72950,
                      "answer_id":30356,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:03.102Z",
                      "updated_at":"2022-01-10T23:24:03.102Z",
                      "text":"「もっと詳しく知りたいです。これらのミーティングで何が起こっているのですか？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72949,
                      "answer_id":30356,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:03.097Z",
                      "updated_at":"2022-01-10T23:24:03.097Z",
                      "text":"“Mi piacerebbe saperne di più. Che cosa sta succedendo durante queste riunioni?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72948,
                      "answer_id":30356,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:03.090Z",
                      "updated_at":"2022-01-10T23:24:03.090Z",
                      "text":"„Erzähl mir mehr. Was passiert in diesen Meetings?“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72947,
                      "answer_id":30356,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:03.085Z",
                      "updated_at":"2022-01-10T23:24:03.085Z",
                      "text":"« J'aimerais en savoir plus. Que se passe-t-il lors de ces réunions? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72946,
                      "answer_id":30356,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:03.080Z",
                      "updated_at":"2022-01-10T23:24:03.080Z",
                      "text":"« J’aimerais en savoir plus. Qu’est-ce qui se passe au cours de ces réunions ? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72945,
                      "answer_id":30356,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:03.074Z",
                      "updated_at":"2022-01-10T23:24:03.074Z",
                      "text":"“Eu gostaria de saber mais. O que está acontecendo nessas reuniões? ”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72944,
                      "answer_id":30356,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:03.067Z",
                      "updated_at":"2022-01-10T23:24:03.067Z",
                      "text":"“Me gustaría obtener más información. Qué sucede en estas reuniones?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72943,
                      "answer_id":30356,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:03.061Z",
                      "updated_at":"2022-01-10T23:24:03.061Z",
                      "text":"“Gusto kong matuto pa. Ano ang nangyayari sa mga pulong na ito?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72942,
                      "answer_id":30356,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:03.055Z",
                      "updated_at":"2022-01-10T23:24:03.055Z",
                      "text":"“我想多了解一些情况。会上发生了什么？”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72941,
                      "answer_id":30356,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:03.050Z",
                      "updated_at":"2022-01-10T23:24:03.050Z",
                      "text":"「我想要進一步瞭解。這些會議裡發生甚麼事了？",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72940,
                      "answer_id":30356,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:03.045Z",
                      "updated_at":"2022-01-10T23:24:03.045Z",
                      "text":"“I’d like to learn more. What’s happening in these meetings?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12067,
          "shuffle":false,
          "position":42,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30358"
          ],
          "created_at":"2022-01-10T23:24:03.160Z",
          "updated_at":"2022-01-10T23:24:03.585Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":42,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"How should you respond?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30296,
                "question_id":12067,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:03.371Z",
                "updated_at":"2022-01-10T23:24:03.371Z",
                "text":"Nasıl karşılık vermelisiniz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30295,
                "question_id":12067,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:03.365Z",
                "updated_at":"2022-01-10T23:24:03.365Z",
                "text":"¿Cómo debería responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30294,
                "question_id":12067,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:03.360Z",
                "updated_at":"2022-01-10T23:24:03.360Z",
                "text":"Как вам следует ответить?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30293,
                "question_id":12067,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:03.355Z",
                "updated_at":"2022-01-10T23:24:03.355Z",
                "text":"Jak należy zareagować?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30292,
                "question_id":12067,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:03.349Z",
                "updated_at":"2022-01-10T23:24:03.349Z",
                "text":"귀하는 어떻게 대처해야 합니까?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30291,
                "question_id":12067,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:03.344Z",
                "updated_at":"2022-01-10T23:24:03.344Z",
                "text":"どのように返答すべきですか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30290,
                "question_id":12067,
                "locale":"it",
                "created_at":"2022-01-10T23:24:03.339Z",
                "updated_at":"2022-01-10T23:24:03.339Z",
                "text":"Come dovresti rispondere?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30289,
                "question_id":12067,
                "locale":"de",
                "created_at":"2022-01-10T23:24:03.334Z",
                "updated_at":"2022-01-10T23:24:03.334Z",
                "text":"Wie sollten Sie reagieren?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30288,
                "question_id":12067,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:03.328Z",
                "updated_at":"2022-01-10T23:24:03.328Z",
                "text":"Comment réagiriez-vous ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30287,
                "question_id":12067,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:03.323Z",
                "updated_at":"2022-01-10T23:24:03.323Z",
                "text":"Comment devriez-vous réagir ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30286,
                "question_id":12067,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:03.318Z",
                "updated_at":"2022-01-10T23:24:03.318Z",
                "text":"Como você deve responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30285,
                "question_id":12067,
                "locale":"es",
                "created_at":"2022-01-10T23:24:03.313Z",
                "updated_at":"2022-01-10T23:24:03.313Z",
                "text":"¿Cómo debes responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30284,
                "question_id":12067,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:03.307Z",
                "updated_at":"2022-01-10T23:24:03.307Z",
                "text":"Paano ka sasagot?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30283,
                "question_id":12067,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:03.301Z",
                "updated_at":"2022-01-10T23:24:03.301Z",
                "text":"你該如何回應？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30282,
                "question_id":12067,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:03.295Z",
                "updated_at":"2022-01-10T23:24:03.295Z",
                "text":"你应如何回应？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30281,
                "question_id":12067,
                "locale":"en",
                "created_at":"2022-01-10T23:24:03.185Z",
                "updated_at":"2022-01-10T23:24:03.185Z",
                "text":"How should you respond?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30357,
                "position":1,
                "active":true,
                "question_id":12067,
                "created_at":"2022-01-10T23:24:03.378Z",
                "updated_at":"2022-01-10T23:24:03.378Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“If that’s your preference, then that’s what we have to do.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72971,
                      "answer_id":30357,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:03.472Z",
                      "updated_at":"2022-01-10T23:24:03.472Z",
                      "text":"\"Tercihin buysa, yapmamız gereken de bu.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72970,
                      "answer_id":30357,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:03.466Z",
                      "updated_at":"2022-01-10T23:24:03.466Z",
                      "text":"\"Si esa es su preferencia, entonces es lo que hay que hacer\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72969,
                      "answer_id":30357,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:03.461Z",
                      "updated_at":"2022-01-10T23:24:03.461Z",
                      "text":"«Если вы предпочитаете такой вариант, то именно так мы и поступим».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72968,
                      "answer_id":30357,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:03.455Z",
                      "updated_at":"2022-01-10T23:24:03.455Z",
                      "text":"„Jeśli takie są Twoje preferencje, to tak właśnie musimy zrobić”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72967,
                      "answer_id":30357,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:03.449Z",
                      "updated_at":"2022-01-10T23:24:03.449Z",
                      "text":"“그것을 선호한다면 우리가 고려해야죠.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72966,
                      "answer_id":30357,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:03.444Z",
                      "updated_at":"2022-01-10T23:24:03.444Z",
                      "text":"「それがあなたの好みであれば、そのようにするしかありません。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72965,
                      "answer_id":30357,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:03.438Z",
                      "updated_at":"2022-01-10T23:24:03.438Z",
                      "text":"“Se questa è la tua preferenza, allora questa è l’azione che dobbiamo intraprendere”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72964,
                      "answer_id":30357,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:03.433Z",
                      "updated_at":"2022-01-10T23:24:03.433Z",
                      "text":"„Wenn es das ist, was du willst, wird es so gemacht.“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72963,
                      "answer_id":30357,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:03.428Z",
                      "updated_at":"2022-01-10T23:24:03.428Z",
                      "text":"« Si c'est votre préférence, c'est ce que nous devons faire. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72962,
                      "answer_id":30357,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:03.423Z",
                      "updated_at":"2022-01-10T23:24:03.423Z",
                      "text":"« Si c’est ce que tu préfères, c’est comme ça qu’il faut faire. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72961,
                      "answer_id":30357,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:03.418Z",
                      "updated_at":"2022-01-10T23:24:03.418Z",
                      "text":"“Se você prefere assim, então é isso que temos que fazer.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72960,
                      "answer_id":30357,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:03.413Z",
                      "updated_at":"2022-01-10T23:24:03.413Z",
                      "text":"“Si eso prefieres, es lo que debemos hacer”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72959,
                      "answer_id":30357,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:03.407Z",
                      "updated_at":"2022-01-10T23:24:03.407Z",
                      "text":"“Kung iyan ang gusto mo, anong magagawa namin.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72958,
                      "answer_id":30357,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:03.402Z",
                      "updated_at":"2022-01-10T23:24:03.402Z",
                      "text":"“如果这是你的偏好，那么我们就不得不这样做。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72957,
                      "answer_id":30357,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:03.397Z",
                      "updated_at":"2022-01-10T23:24:03.397Z",
                      "text":"「如果你偏好如此，我們就必須這麼做。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72956,
                      "answer_id":30357,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:03.392Z",
                      "updated_at":"2022-01-10T23:24:03.392Z",
                      "text":"“If that’s your preference, then that’s what we have to do.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30358,
                "position":2,
                "active":true,
                "question_id":12067,
                "created_at":"2022-01-10T23:24:03.480Z",
                "updated_at":"2022-04-21T22:31:19.105Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“I’m sorry, but skipping the meetings is not up for discussion.\"",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72972,
                      "answer_id":30358,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:03.495Z",
                      "updated_at":"2022-04-21T22:31:19.107Z",
                      "text":"“I’m sorry, but skipping the meetings is not up for discussion.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72987,
                      "answer_id":30358,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:03.579Z",
                      "updated_at":"2022-01-10T23:24:03.579Z",
                      "text":"\"Bu durumu insan kaynakları bölümüyle görüşecek ve kararımızı bildireceğim.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72986,
                      "answer_id":30358,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:03.574Z",
                      "updated_at":"2022-01-10T23:24:03.574Z",
                      "text":"\"Voy a hablarlo con nuestro departamento de recursos humanos y te informaremos sobre la decisión que tomemos\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72985,
                      "answer_id":30358,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:03.569Z",
                      "updated_at":"2022-01-10T23:24:03.569Z",
                      "text":"«Позвольте мне согласовать это с отделом кадров. Я сообщу вам о нашем решении».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72984,
                      "answer_id":30358,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:03.564Z",
                      "updated_at":"2022-01-10T23:24:03.564Z",
                      "text":"„Pozwól, że sprawdzę to w naszym dziale kadr i dam ci znać, co postanowimy”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72983,
                      "answer_id":30358,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:03.557Z",
                      "updated_at":"2022-01-10T23:24:03.557Z",
                      "text":"\"인사 부서에 알리고 결정 사항을 알려 드리겠습니다.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72982,
                      "answer_id":30358,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:03.552Z",
                      "updated_at":"2022-01-10T23:24:03.552Z",
                      "text":"「人事部と相談させてください。対応が決まりましたらお知らせします。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72981,
                      "answer_id":30358,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:03.546Z",
                      "updated_at":"2022-01-10T23:24:03.546Z",
                      "text":"“Lascia che gestisca questa situazione dal nostro reparto delle Risorse umane e ti faccio sapere le nostre decisioni”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72980,
                      "answer_id":30358,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:03.540Z",
                      "updated_at":"2022-01-10T23:24:03.540Z",
                      "text":"„Lass mich die Sache an die Personalabteilung weitergeben. Ich sage dir dann, was entschieden wurde.“",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72979,
                      "answer_id":30358,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:03.534Z",
                      "updated_at":"2022-01-10T23:24:03.534Z",
                      "text":"« Laissez-moi diriger cela par notre service des ressources humaines et vous mettre au courant de notre décision. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72978,
                      "answer_id":30358,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:03.529Z",
                      "updated_at":"2022-01-10T23:24:03.529Z",
                      "text":"« Laisse-moi demander aux ressources humaines de s’en occuper. Je te communiquerai notre décision. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72977,
                      "answer_id":30358,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:03.523Z",
                      "updated_at":"2022-01-10T23:24:03.523Z",
                      "text":"“Deixe-me passar isso para o nosso departamento de recursos humanos e informaremos sobre o que decidirmos.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72976,
                      "answer_id":30358,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:03.517Z",
                      "updated_at":"2022-01-10T23:24:03.517Z",
                      "text":"“Déjame consultar con nuestro Departamento de Recursos Humanos y te diré qué decidimos”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72975,
                      "answer_id":30358,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:03.512Z",
                      "updated_at":"2022-01-10T23:24:03.512Z",
                      "text":"\"Hayaan mong ako ang magsabi nito sa human resources department at ipaalam sa iyo kung ano ang aming pagpapasya.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72974,
                      "answer_id":30358,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:03.506Z",
                      "updated_at":"2022-01-10T23:24:03.506Z",
                      "text":"“让我把这事交给我们的人力资源部处理吧，然后告诉你我们的决定。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72973,
                      "answer_id":30358,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:03.500Z",
                      "updated_at":"2022-01-10T23:24:03.500Z",
                      "text":"「讓我問問人力資源部門的意思，然後再讓你知道我們的決定。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":31707,
                "position":3,
                "active":true,
                "question_id":12067,
                "created_at":"2022-04-21T22:31:29.167Z",
                "updated_at":"2022-04-21T22:31:29.167Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“Let me run this by our human resources department and let you know what they say.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":77377,
                      "answer_id":31707,
                      "locale":"en",
                      "created_at":"2022-04-21T22:31:29.174Z",
                      "updated_at":"2022-04-21T22:31:29.174Z",
                      "text":"“Let me run this by our human resources department and let you know what they say.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12068,
          "shuffle":false,
          "position":43,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30361"
          ],
          "created_at":"2022-01-10T23:24:03.599Z",
          "updated_at":"2022-01-10T23:24:04.123Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":43,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What should you do?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30312,
                "question_id":12068,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:03.811Z",
                "updated_at":"2022-01-10T23:24:03.811Z",
                "text":"Ne yapmalısınız?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30311,
                "question_id":12068,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:03.806Z",
                "updated_at":"2022-01-10T23:24:03.806Z",
                "text":"¿Qué debería hacer?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30310,
                "question_id":12068,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:03.801Z",
                "updated_at":"2022-01-10T23:24:03.801Z",
                "text":"Что вам следует сделать?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30309,
                "question_id":12068,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:03.796Z",
                "updated_at":"2022-01-10T23:24:03.796Z",
                "text":"Co należy zrobić?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30308,
                "question_id":12068,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:03.790Z",
                "updated_at":"2022-01-10T23:24:03.790Z",
                "text":"어떻게 하시겠습니까?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30307,
                "question_id":12068,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:03.785Z",
                "updated_at":"2022-01-10T23:24:03.785Z",
                "text":"あなたは何をすべきでしょうか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30306,
                "question_id":12068,
                "locale":"it",
                "created_at":"2022-01-10T23:24:03.780Z",
                "updated_at":"2022-01-10T23:24:03.780Z",
                "text":"Che cosa dovresti fare?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30305,
                "question_id":12068,
                "locale":"de",
                "created_at":"2022-01-10T23:24:03.775Z",
                "updated_at":"2022-01-10T23:24:03.775Z",
                "text":"Was sollten Sie tun?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30304,
                "question_id":12068,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:03.769Z",
                "updated_at":"2022-01-10T23:24:03.769Z",
                "text":"Que devriez-vous faire?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30303,
                "question_id":12068,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:03.764Z",
                "updated_at":"2022-01-10T23:24:03.764Z",
                "text":"Que devriez-vous faire ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30302,
                "question_id":12068,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:03.759Z",
                "updated_at":"2022-01-10T23:24:03.759Z",
                "text":"O que você deve fazer?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30301,
                "question_id":12068,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:03.753Z",
                "updated_at":"2022-01-10T23:24:03.753Z",
                "text":"你應該怎麼做？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30300,
                "question_id":12068,
                "locale":"es",
                "created_at":"2022-01-10T23:24:03.747Z",
                "updated_at":"2022-01-10T23:24:03.747Z",
                "text":"¿Qué debes hacer?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30299,
                "question_id":12068,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:03.741Z",
                "updated_at":"2022-01-10T23:24:03.741Z",
                "text":"Ano ang dapat mong gawin?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30298,
                "question_id":12068,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:03.735Z",
                "updated_at":"2022-01-10T23:24:03.735Z",
                "text":"我们应怎么做？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30297,
                "question_id":12068,
                "locale":"en",
                "created_at":"2022-01-10T23:24:03.621Z",
                "updated_at":"2022-01-10T23:24:03.621Z",
                "text":"What should you do?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30359,
                "position":1,
                "active":true,
                "question_id":12068,
                "created_at":"2022-01-10T23:24:03.819Z",
                "updated_at":"2022-04-21T22:32:09.021Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Since you don’t know for sure whether the incidents occurred, you don’t have to report it. But, you should still try to convince Raj to let you report.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":72988,
                      "answer_id":30359,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:03.834Z",
                      "updated_at":"2022-04-21T22:32:09.024Z",
                      "text":"Since you don’t know for sure whether the incidents occurred, you don’t have to report it. But, you should still try to convince Raj to let you report.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73003,
                      "answer_id":30359,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:03.912Z",
                      "updated_at":"2022-01-10T23:24:03.912Z",
                      "text":"Olayın meydana gelip gelmediğinden tam olarak emin olmadığınız için, henüz bildirmeniz gerekmiyor. Ancak yine de sizin bildirmeniz konusunda Rohawna'yı ikna etmelisiniz.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73002,
                      "answer_id":30359,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:03.907Z",
                      "updated_at":"2022-01-10T23:24:03.907Z",
                      "text":"Como no sabe con certeza si ocurrió el incidente, usted no tiene que denunciarlo. Pero debería intentar convencer a Rohawna para que le deje denunciarlo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73001,
                      "answer_id":30359,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:03.902Z",
                      "updated_at":"2022-01-10T23:24:03.902Z",
                      "text":"Так как вы точно не знаете, произошло ли это на самом деле, вы не обязаны сообщать о проблеме. Но вам следует попытаться убедить Роану, что вы должны сообщить о ее жалобе.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73000,
                      "answer_id":30359,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:03.897Z",
                      "updated_at":"2022-01-10T23:24:03.897Z",
                      "text":"Ponieważ nie wiesz na pewno, czy incydent miał miejsce, nie musisz go zgłaszać. Powinieneś/Powinnaś jednak spróbować przekonać Rohawnę, żeby pozwoliła Ci zgłosić incydent.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72999,
                      "answer_id":30359,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:03.891Z",
                      "updated_at":"2022-01-10T23:24:03.891Z",
                      "text":"사건이 발생했는지 확실치 않기 때문에 신고할 필요는 없다. 하지만 신고하기 위해 Rohawna를 설득해야 한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72998,
                      "answer_id":30359,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:03.886Z",
                      "updated_at":"2022-01-10T23:24:03.886Z",
                      "text":"その出来事が実際に起こったかどうかの確信が持てないため、報告する必要はない。しかし、報告することを許可してもらえるようRohawna酸を説得すべきです。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72997,
                      "answer_id":30359,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:03.881Z",
                      "updated_at":"2022-01-10T23:24:03.881Z",
                      "text":"Dal momento che non si sa con certezza se l’incidente si è verificato, non è necessario segnalarlo. Ma sarebbe necessario comunque provare a convincere Rohawna a lasciar effettuare la segnalazione.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72996,
                      "answer_id":30359,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:03.876Z",
                      "updated_at":"2022-01-10T23:24:03.876Z",
                      "text":"Da Sie nicht sicher sind, ob der Vorfall geschehen ist, müssen Sie nichts melden. Sie sollten dennoch versuchen, Rohawna zu überreden, dass Sie es melden dürfen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72995,
                      "answer_id":30359,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:03.870Z",
                      "updated_at":"2022-01-10T23:24:03.870Z",
                      "text":"Puisque vous ne savez pas avec certitude si l'incident s'est produit, vous n'avez pas à le signaler. Mais vous devriez toujours essayer de convaincre Rohawna de vous laisser signaler.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72994,
                      "answer_id":30359,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:03.865Z",
                      "updated_at":"2022-01-10T23:24:03.865Z",
                      "text":"Comme vous n’êtes pas certain que l’incident s’est produit, vous ne devez pas le signaler. Mais vous devez quand même tenter de convaincre Rohawna de vous laisser le signaler.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72993,
                      "answer_id":30359,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:03.860Z",
                      "updated_at":"2022-01-10T23:24:03.860Z",
                      "text":"Como você não sabe ao certo se o incidente ocorreu, você não precisa denunciar. Mas você ainda deve tentar convencer Rohawna a deixá-lo fazer a denúncia.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72992,
                      "answer_id":30359,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:03.855Z",
                      "updated_at":"2022-01-10T23:24:03.855Z",
                      "text":"既然你不確定事件是否真的發生，就不用通報。但你仍應說服 Rohawna 讓你通報。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72991,
                      "answer_id":30359,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:03.850Z",
                      "updated_at":"2022-01-10T23:24:03.850Z",
                      "text":"Como no estás seguro de si ocurrió el incidente, no tienes la obligación de denunciarlo. Pero aún debes intentar convencer a Rohawna que te permita denunciarlo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72990,
                      "answer_id":30359,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:03.845Z",
                      "updated_at":"2022-01-10T23:24:03.845Z",
                      "text":"Dahil siguradong hindi mo alam kung nangyari ang insidente, hindi mo kailangang iulat. Ngunit dapat mo pa ring subukang kumbinsihin si Rohawna na hayaan kang mag-ulat.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":72989,
                      "answer_id":30359,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:03.839Z",
                      "updated_at":"2022-01-10T23:24:03.839Z",
                      "text":"由于你并不确定该事件是否发生，因此你不必举报。但你仍要试着说服 Rohawna 让你举报。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30360,
                "position":2,
                "active":true,
                "question_id":12068,
                "created_at":"2022-01-10T23:24:03.920Z",
                "updated_at":"2022-04-21T22:32:23.705Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Agree to Raj's wishes and keep the matter confidential. It's enough that his concerns were heard and validated.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73019,
                      "answer_id":30360,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:04.017Z",
                      "updated_at":"2022-01-10T23:24:04.017Z",
                      "text":"Rohawna'nın isteklerine uyun ve konuyu gizli tutun. Endişelerinin öğrenilmesi ve doğrulanması yeterli olacaktır.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73018,
                      "answer_id":30360,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:04.012Z",
                      "updated_at":"2022-01-10T23:24:04.012Z",
                      "text":"Respete la voluntad de Rohawna y mantenga la confidencialidad. Bastaría con que sus preocupaciones fueran escuchadas y aprobadas.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73017,
                      "answer_id":30360,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:04.006Z",
                      "updated_at":"2022-01-10T23:24:04.006Z",
                      "text":"Согласиться с пожеланиями Роаны и сохранить проблему с тайне. Достаточно того, что ее опасения услышали и признали.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73016,
                      "answer_id":30360,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:04.001Z",
                      "updated_at":"2022-01-10T23:24:04.001Z",
                      "text":"Zgódź się na prośbę Rohawny i zachowaj tę sprawę w tajemnicy. Wystarczy, że jej obawy zostały wysłuchane i potwierdzone.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73015,
                      "answer_id":30360,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:03.995Z",
                      "updated_at":"2022-01-10T23:24:03.995Z",
                      "text":"Rohawna가 원하는 것에 동의하고 문제를 기밀로 유지한다. 그녀의 염려를 들어주고 인정하는 것으로 충분하다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73014,
                      "answer_id":30360,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:03.990Z",
                      "updated_at":"2022-01-10T23:24:03.990Z",
                      "text":"Rohawnaさんの希望に同意し、この件を機密とする。彼女の懸念に対して耳が傾けられ、それが立証されたということだけで十分である。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73013,
                      "answer_id":30360,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:03.985Z",
                      "updated_at":"2022-01-10T23:24:03.985Z",
                      "text":"Assecondare il desiderio di Rohawna e mantenere la questione riservata. È sufficiente che i suoi dubbi siano stati ascoltati e convalidati.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73012,
                      "answer_id":30360,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:03.976Z",
                      "updated_at":"2022-01-10T23:24:03.976Z",
                      "text":"Rohawnas Wünsche respektieren und die Angelegenheit vertraulich behandeln. Es ist genug, dass ihre Bedenken gehört und bestätigt wurden.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73011,
                      "answer_id":30360,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:03.971Z",
                      "updated_at":"2022-01-10T23:24:03.971Z",
                      "text":"Acceptez les souhaits de Rohawna et gardez la question confidentielle. Il suffit que ses préoccupations soient entendues et validées.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73010,
                      "answer_id":30360,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:03.966Z",
                      "updated_at":"2022-01-10T23:24:03.966Z",
                      "text":"Consentir au souhait de Rohawna et garder la chose confidentielle. Il suffit que ses préoccupations soient entendues et validées.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73009,
                      "answer_id":30360,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:03.960Z",
                      "updated_at":"2022-01-10T23:24:03.960Z",
                      "text":"Concordar com o que Rohawna deseja e manter o assunto em sigilo. É suficiente que as preocupações dela tenham sido ouvidas e validadas.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73008,
                      "answer_id":30360,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:03.954Z",
                      "updated_at":"2022-01-10T23:24:03.954Z",
                      "text":"Sumangayon sa kahilingan ni Rohawna at panatilihing lihim ang usapin. Sapat nang narinig at napatunayan ang kanyangg mga alalahanin.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73007,
                      "answer_id":30360,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:03.949Z",
                      "updated_at":"2022-01-10T23:24:03.949Z",
                      "text":"Aceptar los deseos de Rohawna y mantener el asunto confidencial. Es suficiente que sus inquietudes sean escuchadas y validadas.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73006,
                      "answer_id":30360,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:03.944Z",
                      "updated_at":"2022-01-10T23:24:03.944Z",
                      "text":"同意 Rohawna 的意愿，并保守秘密。聆听和确认她的担忧就足够了。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73005,
                      "answer_id":30360,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:03.939Z",
                      "updated_at":"2022-01-10T23:24:03.939Z",
                      "text":"尊重 Rohawna 的意願，將這件事情保密。她的疑慮被聽到也被驗證就足夠了。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73004,
                      "answer_id":30360,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:03.934Z",
                      "updated_at":"2022-04-21T22:32:23.707Z",
                      "text":"Agree to Raj's wishes and keep the matter confidential. It's enough that his concerns were heard and validated.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30361,
                "position":3,
                "active":true,
                "question_id":12068,
                "created_at":"2022-01-10T23:24:04.025Z",
                "updated_at":"2022-04-21T22:32:38.505Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Tell Raj that while our policy requires you to report possible harassment, discrimination, and retaliation, you won’t share the information with anyone who doesn’t need to know.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73020,
                      "answer_id":30361,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:04.040Z",
                      "updated_at":"2022-04-21T22:32:38.508Z",
                      "text":"Tell Raj that while our policy requires you to report possible harassment, discrimination, and retaliation, you won’t share the information with anyone who doesn’t need to know.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73035,
                      "answer_id":30361,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:04.117Z",
                      "updated_at":"2022-01-10T23:24:04.117Z",
                      "text":"Rohawna'ya şöyle söyleyin: Politikamız doğrultusunda şikâyetinle adil bir şekilde ilgilenmemiz gerekiyor; ancak, bu bilgileri bilmesi gerekmeyen hiç kimseyle paylaşamazsın. Bu sırada Jack ile olan etkileşiminde nasıl bir yaklaşım benimseyeceğiyle ilgili yardımcı olabilirsiniz.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73034,
                      "answer_id":30361,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:04.113Z",
                      "updated_at":"2022-01-10T23:24:04.113Z",
                      "text":"Dígale a Rohawna que, si bien nuestra política requiere que gestionemos su denuncia de manera justa, no compartirá la información con nadie si no es necesario. Mientras tanto, puede ayudarle a decidir cómo gestionar las interacciones con Jack.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73033,
                      "answer_id":30361,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:04.108Z",
                      "updated_at":"2022-01-10T23:24:04.108Z",
                      "text":"Сказать Роане, что, хотя наша политика требует добросовестно обработать ее жалобу, вы не будете раскрывать информацию тем, кого она не касается. В то же время вы можете помочь ей определиться, как в дальнейшем взаимодействовать с Джеком.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73032,
                      "answer_id":30361,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:04.103Z",
                      "updated_at":"2022-01-10T23:24:04.103Z",
                      "text":"Powiedz Rohawnie, że chociaż nasza polityka wymaga, abyśmy sprawiedliwie rozpatrzyli jej skargę, nie podzielisz się tą informacją z nikim, kto nie musi jej znać. W międzyczasie możesz pomóc jej zdecydować, jak radzić sobie w interakcjach z Jackiem.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73031,
                      "answer_id":30361,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:04.097Z",
                      "updated_at":"2022-01-10T23:24:04.097Z",
                      "text":"Rohawna에게 회사의 정책에 따라 불만을 공정하게 처리해야 하며, 관련이 없는 사람과는 정보를 공유하지 않을 것이라고 말한다. 한편, Jack과 마주칠 때 그녀가 어떻게 행동할지 결정하는 데 도움을 준다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73030,
                      "answer_id":30361,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:04.092Z",
                      "updated_at":"2022-01-10T23:24:04.092Z",
                      "text":"Rohawnaさんに、彼女からの苦情を平等に対処することはポリシーの要件ではあるが、知る必要のない人には情報が共有されないことを伝える。その間、Jackさんとの交流をどのように行うべきかを決定する手助けをすることができます。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73029,
                      "answer_id":30361,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:04.087Z",
                      "updated_at":"2022-01-10T23:24:04.087Z",
                      "text":"Dire a Rohawna che, sebbene la nostra politica ci imponga di gestire il suo reclamo in modo equo, le informazioni non saranno condivise con nessuno che non abbia necessità di conoscerle. Nel frattempo, è possibile aiutarla a decidere il modo di affrontare le interazioni con Jack.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73028,
                      "answer_id":30361,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:04.082Z",
                      "updated_at":"2022-01-10T23:24:04.082Z",
                      "text":"Rohawna erklären, dass unsere Richtlinie zwar verlangt, die Beschwerde fair zu beurteilen, dass Sie jedoch nur diejenigen einweihen werden, die unbedingt davon wissen müssen. In der Zwischenzeit können Sie ihr helfen, zu entscheiden, wie sie mit Jack umgehen soll.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73027,
                      "answer_id":30361,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:04.077Z",
                      "updated_at":"2022-01-10T23:24:04.077Z",
                      "text":"Dites à Rohawna que, bien que notre politique nous oblige à traiter sa plainte équitablement, vous ne partagerez pas les informations avec toute quiconque, si ce n'est ceux qui sont en droit de savoir. En attendant, vous pouvez l'aider à décider comment aborder les interactions avec Jack.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73026,
                      "answer_id":30361,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:04.071Z",
                      "updated_at":"2022-01-10T23:24:04.071Z",
                      "text":"Dire à Rohawna que, bien que la procédure vous oblige à traiter sa plainte équitablement, vous ne divulguerez pas les informations à quiconque n’a pas besoin de savoir. En attendant, vous pouvez l’aider à décider comment se conduire en présence de Jack.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73025,
                      "answer_id":30361,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:04.065Z",
                      "updated_at":"2022-01-10T23:24:04.065Z",
                      "text":"Dizer a Rohawna que, embora nossa política exija que tratemos sua reclamação de forma justa, você não compartilhará as informações com ninguém que não precise saber. Enquanto isso, você pode ajudá-la a decidir como abordar as interações com Jack.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73024,
                      "answer_id":30361,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:04.060Z",
                      "updated_at":"2022-01-10T23:24:04.060Z",
                      "text":"Decir a Rohawna que, si bien nuestra política requiere que manejemos su reclamo de manera justa, no compartirás la información con ninguna persona que no necesite conocerla. Mientras tanto, puedes ayudarla a decidir cómo enfocar las interacciones con Jack.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73023,
                      "answer_id":30361,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:04.055Z",
                      "updated_at":"2022-01-10T23:24:04.055Z",
                      "text":"Sabihin kay Rohawna na, habang hinihiling sa amin ng aming patakaran na pangasiwaan nang patas ang kanyang reklamo, hindi mo ibabahagi ang impormasyon sa sinumang hindi kailangang malaman. Pansamantala, matutulungan mo siyang magpasya kung paano makikipag-usap kay Jack.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73022,
                      "answer_id":30361,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:04.050Z",
                      "updated_at":"2022-01-10T23:24:04.050Z",
                      "text":"告诉 Rohawna，尽管我们的政策要求我们公正地处理她的投诉，但你不会与任何不需要知道此事的人分享这些信息。与此同时，你可以帮助她决定如何与 Jack 打交道。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73021,
                      "answer_id":30361,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:04.045Z",
                      "updated_at":"2022-01-10T23:24:04.045Z",
                      "text":"告訴 Rohawna，雖然我們的政策要求我們公平處理她的申訴，你不會把資訊透露給任何不需要知道的人。同時，你可以幫助她決定與 Jack 互動的方式。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12069,
          "shuffle":false,
          "position":44,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30364"
          ],
          "created_at":"2022-01-10T23:24:04.136Z",
          "updated_at":"2022-01-10T23:24:04.641Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":44,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"How should you respond?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30328,
                "question_id":12069,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:04.358Z",
                "updated_at":"2022-01-10T23:24:04.358Z",
                "text":"Nasıl karşılık vermelisiniz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30327,
                "question_id":12069,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:04.353Z",
                "updated_at":"2022-01-10T23:24:04.353Z",
                "text":"¿Cómo debería responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30326,
                "question_id":12069,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:04.348Z",
                "updated_at":"2022-01-10T23:24:04.348Z",
                "text":"Как вам следует ответить?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30325,
                "question_id":12069,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:04.343Z",
                "updated_at":"2022-01-10T23:24:04.343Z",
                "text":"Jak należy zareagować?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30324,
                "question_id":12069,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:04.338Z",
                "updated_at":"2022-01-10T23:24:04.338Z",
                "text":"귀하는 어떻게 대처해야 합니까?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30323,
                "question_id":12069,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:04.333Z",
                "updated_at":"2022-01-10T23:24:04.333Z",
                "text":"どのように返答すべきですか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30322,
                "question_id":12069,
                "locale":"it",
                "created_at":"2022-01-10T23:24:04.328Z",
                "updated_at":"2022-01-10T23:24:04.328Z",
                "text":"Come dovresti rispondere?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30321,
                "question_id":12069,
                "locale":"de",
                "created_at":"2022-01-10T23:24:04.323Z",
                "updated_at":"2022-01-10T23:24:04.323Z",
                "text":"Wie sollten Sie reagieren?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30320,
                "question_id":12069,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:04.318Z",
                "updated_at":"2022-01-10T23:24:04.318Z",
                "text":"Comment réagiriez-vous ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30319,
                "question_id":12069,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:04.312Z",
                "updated_at":"2022-01-10T23:24:04.312Z",
                "text":"Comment devriez-vous réagir ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30318,
                "question_id":12069,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:04.307Z",
                "updated_at":"2022-01-10T23:24:04.307Z",
                "text":"Como você deve responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30317,
                "question_id":12069,
                "locale":"es",
                "created_at":"2022-01-10T23:24:04.303Z",
                "updated_at":"2022-01-10T23:24:04.303Z",
                "text":"¿Cómo debes responder?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30316,
                "question_id":12069,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:04.298Z",
                "updated_at":"2022-01-10T23:24:04.298Z",
                "text":"Paano ka sasagot?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30315,
                "question_id":12069,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:04.293Z",
                "updated_at":"2022-01-10T23:24:04.293Z",
                "text":"你該如何回應？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30314,
                "question_id":12069,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:04.288Z",
                "updated_at":"2022-01-10T23:24:04.288Z",
                "text":"你应如何回应？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30313,
                "question_id":12069,
                "locale":"en",
                "created_at":"2022-01-10T23:24:04.155Z",
                "updated_at":"2022-01-10T23:24:04.155Z",
                "text":"How should you respond?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30362,
                "position":1,
                "active":true,
                "question_id":12069,
                "created_at":"2022-01-10T23:24:04.366Z",
                "updated_at":"2022-04-21T22:33:30.137Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Assure Raj that you will talk to Heidi and handle the situation.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73051,
                      "answer_id":30362,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:04.452Z",
                      "updated_at":"2022-01-10T23:24:04.452Z",
                      "text":"Rohawna'ya Jack ile konuşup bu durumu çözeceğinize dair garanti verin.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73050,
                      "answer_id":30362,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:04.447Z",
                      "updated_at":"2022-01-10T23:24:04.447Z",
                      "text":"Asegurarle a Rohawna que hablará con Jack y gestionará la situación.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73049,
                      "answer_id":30362,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:04.443Z",
                      "updated_at":"2022-01-10T23:24:04.443Z",
                      "text":"Заверить Роану, что вы поговорите с Джеком и разрешите эту ситуацию.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73048,
                      "answer_id":30362,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:04.437Z",
                      "updated_at":"2022-01-10T23:24:04.437Z",
                      "text":"Zapewnić Rohawnę, że porozmawiasz z Jackiem i zajmiesz się tą sytuacją.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73047,
                      "answer_id":30362,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:04.433Z",
                      "updated_at":"2022-01-10T23:24:04.433Z",
                      "text":"Rohawna에게 Jack과 이야기하여 상황을 처리할 것이라고 안심시켜 준다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73046,
                      "answer_id":30362,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:04.428Z",
                      "updated_at":"2022-01-10T23:24:04.428Z",
                      "text":"Rohawnaさんに、あなたがJackさんと話をし、状況の対処をすると約束する。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73045,
                      "answer_id":30362,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:04.423Z",
                      "updated_at":"2022-01-10T23:24:04.423Z",
                      "text":"Garantire a Rohawna che parlerai con Jack e gestirai la situazione.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73044,
                      "answer_id":30362,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:04.418Z",
                      "updated_at":"2022-01-10T23:24:04.418Z",
                      "text":"Rohawna zusichern, dass Sie mit Jack sprechen werden und sich um die Situation kümmern.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73043,
                      "answer_id":30362,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:04.413Z",
                      "updated_at":"2022-01-10T23:24:04.413Z",
                      "text":"Assurez Rohawna que vous allez parler à Jack et gérer la situation.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73042,
                      "answer_id":30362,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:04.408Z",
                      "updated_at":"2022-01-10T23:24:04.408Z",
                      "text":"Assurer Rohawna que vous allez en parler à Jack et prendre la situation en main.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73041,
                      "answer_id":30362,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:04.403Z",
                      "updated_at":"2022-01-10T23:24:04.403Z",
                      "text":"Garantir a Rohawna que você falará com Jack e tratará a situação.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73040,
                      "answer_id":30362,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:04.399Z",
                      "updated_at":"2022-01-10T23:24:04.399Z",
                      "text":"Asegurar a Rohawna que hablarás con Jack y manejarás la situación.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73039,
                      "answer_id":30362,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:04.393Z",
                      "updated_at":"2022-01-10T23:24:04.393Z",
                      "text":"Tiyakin kay Rohawna na makikipag-usap ka kay Jack at pangangasiwaan ang sitwasyon.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73038,
                      "answer_id":30362,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:04.389Z",
                      "updated_at":"2022-01-10T23:24:04.389Z",
                      "text":"向 Rohawna 保证你会与 Jack 谈话并处理此情况。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73037,
                      "answer_id":30362,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:04.384Z",
                      "updated_at":"2022-01-10T23:24:04.384Z",
                      "text":"請 Rohawna 安心，讓她知道你會與 Jack 談，並且處理這個情況。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73036,
                      "answer_id":30362,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:04.380Z",
                      "updated_at":"2022-04-21T22:33:30.144Z",
                      "text":"Assure Raj that you will talk to Heidi and handle the situation.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30363,
                "position":2,
                "active":true,
                "question_id":12069,
                "created_at":"2022-01-10T23:24:04.458Z",
                "updated_at":"2022-04-21T22:33:42.003Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Sympathize with his fears of retaliation and harassment. Let Raj know that he’s doing everyone a service by coming forward.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73052,
                      "answer_id":30363,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:04.472Z",
                      "updated_at":"2022-04-21T22:33:42.007Z",
                      "text":"Sympathize with his fears of retaliation and harassment. Let Raj know that he’s doing everyone a service by coming forward.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73067,
                      "answer_id":30363,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:04.545Z",
                      "updated_at":"2022-01-10T23:24:04.545Z",
                      "text":"Rohawna'ya yaşadığı misilleme korkusunu anladığınızı ve bunu bildirmesinin herkesin iyiliğine olduğunu belirtin.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73066,
                      "answer_id":30363,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:04.540Z",
                      "updated_at":"2022-01-10T23:24:04.540Z",
                      "text":"Comprender sus temores de represalias y hacerle saber que está dando un servicio a todos al comparecer.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73065,
                      "answer_id":30363,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:04.535Z",
                      "updated_at":"2022-01-10T23:24:04.535Z",
                      "text":"Посочувствовать ее страху последствий и дать Роане понять, что, не промолчав, она оказала услугу всему коллективу.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73064,
                      "answer_id":30363,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:04.530Z",
                      "updated_at":"2022-01-10T23:24:04.530Z",
                      "text":"Wyrazić współczucie z powodu jej obaw przed odwetem i dać Rohawnie do zrozumienia, że ujawniając incydent, wyświadcza wszystkim przysługę.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73063,
                      "answer_id":30363,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:04.525Z",
                      "updated_at":"2022-01-10T23:24:04.525Z",
                      "text":"보복에 대한 두려움에 공감하면서 Rohawna의 용기 있는 행동이 모두에게 유익을 주는 것임을 확신시켜 준다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73062,
                      "answer_id":30363,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:04.520Z",
                      "updated_at":"2022-01-10T23:24:04.520Z",
                      "text":"報復への恐怖に共感し、Rohawnaに、名乗りを上げたことは皆のためでもあることを知らせる。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73061,
                      "answer_id":30363,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:04.515Z",
                      "updated_at":"2022-01-10T23:24:04.515Z",
                      "text":"Comprendere le sue paure di ritorsioni e far sapere a Rohawna che sta rendendo un servizio a tutti facendosi avanti.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73060,
                      "answer_id":30363,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:04.510Z",
                      "updated_at":"2022-01-10T23:24:04.510Z",
                      "text":"Verständnis für ihre Angst vor Vergeltung zeigen und Rohawna sagen, dass sie allen einen Gefallen tut, wenn sie den Vorfall meldet.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73059,
                      "answer_id":30363,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:04.506Z",
                      "updated_at":"2022-01-10T23:24:04.506Z",
                      "text":"Montrez de l'empathie pour ses craintes de représailles et faites savoir à Rohawna qu'elle rend service à tout le monde en se manifestant.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73058,
                      "answer_id":30363,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:04.500Z",
                      "updated_at":"2022-01-10T23:24:04.500Z",
                      "text":"Comprendre sa crainte des représailles et faire savoir à Rohawna qu’en se manifestant, elle rend service à tout le monde.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73057,
                      "answer_id":30363,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:04.496Z",
                      "updated_at":"2022-01-10T23:24:04.496Z",
                      "text":"Solidarizar-se com os temores de retaliação dela e dizer a Rohawna que ela está prestando um serviço a todos ao se apresentar.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73056,
                      "answer_id":30363,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:04.491Z",
                      "updated_at":"2022-01-10T23:24:04.491Z",
                      "text":"Makisimpatya sa kanilang mga takot ng paghihiganti at ipaalam kay Rohawna na ginagawa niya ang paglilingkod sa lahat sa pamamagitan ng paglapit.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73055,
                      "answer_id":30363,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:04.486Z",
                      "updated_at":"2022-01-10T23:24:04.486Z",
                      "text":"Simpatizar con sus temores de represalias e informar a Rohawna que beneficia a todos al presentar su denuncia.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73054,
                      "answer_id":30363,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:04.481Z",
                      "updated_at":"2022-01-10T23:24:04.481Z",
                      "text":"同情她害怕受到報復對待，讓 Rohawna 知道，挺身而出就是幫助身邊的每個人。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73053,
                      "answer_id":30363,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:04.476Z",
                      "updated_at":"2022-01-10T23:24:04.476Z",
                      "text":"同情她对于报复的恐惧，并让 Rohawna 知道她前来举报对于所有人都好。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30364,
                "position":3,
                "active":true,
                "question_id":12069,
                "created_at":"2022-01-10T23:24:04.550Z",
                "updated_at":"2022-04-21T22:33:54.675Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Assure Raj that all reports are reviewed and that retaliation is prohibited. He should come forward if anyone tries to retaliate against him in any form, and our organization will monitor the situation.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73068,
                      "answer_id":30364,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:04.564Z",
                      "updated_at":"2022-04-21T22:33:54.678Z",
                      "text":"Assure Raj that all reports are reviewed and that retaliation is prohibited. He should come forward if anyone tries to retaliate against him in any form, and our organization will monitor the situation.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73083,
                      "answer_id":30364,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:04.636Z",
                      "updated_at":"2022-01-10T23:24:04.636Z",
                      "text":"Rohawana'ya tüm bildirilerin gözden geçirildiğinin ve misillemenin yasaklandığının garantisini verin. Biri kendisine karşı herhangi bir şekilde misilleme yapmaya çalışırsa bunu bildirmesi gerektiğini ve sizin durumu izleyeceğinizi söyleyin. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73082,
                      "answer_id":30364,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:04.631Z",
                      "updated_at":"2022-01-10T23:24:04.631Z",
                      "text":"Asegurarle a Rohawna que se revisan todas las denuncias y que se prohíben las represalias. Ella debe comparecer si alguien intenta tomar represalias contra ella de cualquier forma, y usted estará controlando la situación. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73081,
                      "answer_id":30364,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:04.626Z",
                      "updated_at":"2022-01-10T23:24:04.626Z",
                      "text":"Заверить Роану, что рассматриваются все жалобы, и преследования за критику запрещены. Ей следует сообщать о любых попытках преследования за критику в любой форме, и вы будете отслеживать происходящее. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73080,
                      "answer_id":30364,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:04.622Z",
                      "updated_at":"2022-01-10T23:24:04.622Z",
                      "text":"Zapewnić Rohawnę, że wszystkie zgłoszenia są rozpatrywane, a działania odwetowe są zabronione. Powinna zgłosić się, jeśli ktokolwiek będzie próbował dokonać odwetu w jakiejkolwiek formie, a Ty będziesz monitorować sytuację. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73079,
                      "answer_id":30364,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:04.617Z",
                      "updated_at":"2022-01-10T23:24:04.617Z",
                      "text":"모든 신고는 검토되어야 하며 보복이 금지된다는 사실을 Rohawna에게 알려준다. 누군가가 어떤 형태로든 그녀에게 보복을 시도하면 그것을 알려야 하며 상황은 모니터링될 것임을 알린다. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73078,
                      "answer_id":30364,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:04.612Z",
                      "updated_at":"2022-01-10T23:24:04.612Z",
                      "text":"Rohawanaさんにすべての報告は確実に確認され、報復は禁止されていることを伝える。誰かが、いかなる形でも報復しようとした場合、彼女はそれを報告するべきであり、あなたは状況を監視します。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73077,
                      "answer_id":30364,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:04.607Z",
                      "updated_at":"2022-01-10T23:24:04.607Z",
                      "text":"Garantire a Rohawana che tutte le segnalazioni vengono esaminate e che le ritorsioni sono vietate. Dovrebbe farsi avanti se qualcuno cerca di reagire con ritorsioni contro di lei in qualsiasi forma, e tu monitorerai la situazione. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73076,
                      "answer_id":30364,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:04.602Z",
                      "updated_at":"2022-01-10T23:24:04.602Z",
                      "text":"Rohawna versichern, dass alle Beschwerden geprüft werden, und dass Vergeltung verboten ist. Sie solle sich melden, wenn jemand versucht, Vergeltungsmaßnahmen gegen sie zu ergreifen, und Sie würden die Situation weiter beobachten. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73075,
                      "answer_id":30364,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:04.597Z",
                      "updated_at":"2022-01-10T23:24:04.597Z",
                      "text":"Assurez Rohawana que tous les rapports sont examinés et que les représailles sont interdites. Elle devrait se manifester si quelqu'un tente de se venger d'elle sous quelque forme que ce soit, et que vous avez l'œil sur la situation. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73074,
                      "answer_id":30364,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:04.593Z",
                      "updated_at":"2022-01-10T23:24:04.593Z",
                      "text":"Assurer Rohawana que tous les signalements sont pris en compte et que les représailles sont interdites. Si quelqu’un essaie de se venger d’elle sous quelque forme que ce soit, elle doit le faire savoir. Vous allez surveiller la situation. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73073,
                      "answer_id":30364,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:04.587Z",
                      "updated_at":"2022-01-10T23:24:04.587Z",
                      "text":"Garantir a Rohawana que todas as denúncias são avaliadas e que a retaliação é proibida. Ela deverá denunciar se alguém tentar alguma retaliação contra ela de qualquer forma, e você estará monitorando a situação. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73072,
                      "answer_id":30364,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:04.583Z",
                      "updated_at":"2022-01-10T23:24:04.583Z",
                      "text":"請 Rohawana 放心，所有通報都會被審核，且嚴禁報復行為。如有任何人對她採取任何形式的報復行為，她應該站出來讓你知道，你會監督整個情況。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73071,
                      "answer_id":30364,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:04.577Z",
                      "updated_at":"2022-01-10T23:24:04.577Z",
                      "text":"Asegurar a Rohawana que se revisan todas las denuncias, y las represalias están prohibidas. Debe presentar una denuncia si una persona intenta tomar represalias en su contra de cualquier forma, y que controlarás la situación. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73070,
                      "answer_id":30364,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:04.572Z",
                      "updated_at":"2022-01-10T23:24:04.572Z",
                      "text":"Tiyaking kay Rohawana na ang lahat ng mga ulat ay nasuri, at ang paghihiganti ay ipinagbabawal. Dapat siyang magsalita kung may sinumang sumusubok na gumanti laban sa kanya sa anumang anyo, at susubaybayan mo ang sitwasyon. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73069,
                      "answer_id":30364,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:04.568Z",
                      "updated_at":"2022-01-10T23:24:04.568Z",
                      "text":"向 Rohawna 保证会审查所有举报，报复会得到禁止。如果任何人试着以任何形式对她报复，她都要进行举报，并且你会对该情况进行监督。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12070,
          "shuffle":false,
          "position":45,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30365"
          ],
          "created_at":"2022-01-10T23:24:04.656Z",
          "updated_at":"2022-01-10T23:24:05.141Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":45,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Is Iqra’s concern for Niamh warranted?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30344,
                "question_id":12070,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:04.852Z",
                "updated_at":"2022-01-10T23:24:04.852Z",
                "text":"Iqra, Niamh konusunda endişelenmekte haklı mı?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30343,
                "question_id":12070,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:04.847Z",
                "updated_at":"2022-01-10T23:24:04.847Z",
                "text":"¿Está justificada la preocupación de Iqra por Niamh?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30342,
                "question_id":12070,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:04.842Z",
                "updated_at":"2022-01-10T23:24:04.842Z",
                "text":"Опасения Икры по поводу Нив обоснованы?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30341,
                "question_id":12070,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:04.838Z",
                "updated_at":"2022-01-10T23:24:04.838Z",
                "text":"Czy troska Iqry o Niamh jest uzasadniona?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30340,
                "question_id":12070,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:04.833Z",
                "updated_at":"2022-01-10T23:24:04.833Z",
                "text":"Niamh에 대한 Iqra의 염려가 정당할까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30339,
                "question_id":12070,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:04.828Z",
                "updated_at":"2022-01-10T23:24:04.828Z",
                "text":"IqraさんのNiamhさんに対する懸念は正当ですか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30338,
                "question_id":12070,
                "locale":"it",
                "created_at":"2022-01-10T23:24:04.823Z",
                "updated_at":"2022-01-10T23:24:04.823Z",
                "text":"La preoccupazione di Iqra per Niamh è giustificata?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30337,
                "question_id":12070,
                "locale":"de",
                "created_at":"2022-01-10T23:24:04.817Z",
                "updated_at":"2022-01-10T23:24:04.817Z",
                "text":"Ist Iqras Sorge gegenüber Niamh berechtigt?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30336,
                "question_id":12070,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:04.809Z",
                "updated_at":"2022-01-10T23:24:04.809Z",
                "text":"La préoccupation d'Iqra pour Niamh est-elle justifiée?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30335,
                "question_id":12070,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:04.805Z",
                "updated_at":"2022-01-10T23:24:04.805Z",
                "text":"Iqra a-t-il raison de se faire du souci pour Niamh ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30334,
                "question_id":12070,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:04.800Z",
                "updated_at":"2022-01-10T23:24:04.800Z",
                "text":"A preocupação de Iqra com Niamh é justificada?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30333,
                "question_id":12070,
                "locale":"es",
                "created_at":"2022-01-10T23:24:04.795Z",
                "updated_at":"2022-01-10T23:24:04.795Z",
                "text":"¿La inquietud de Iqra por Niamh es justificada?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30332,
                "question_id":12070,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:04.790Z",
                "updated_at":"2022-01-10T23:24:04.790Z",
                "text":"Nag-aalala ba Iqra sa gusto ni Niamh?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30331,
                "question_id":12070,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:04.785Z",
                "updated_at":"2022-01-10T23:24:04.785Z",
                "text":"Iqra 對於 Niamh 的疑慮是否有正當理由？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30330,
                "question_id":12070,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:04.780Z",
                "updated_at":"2022-01-10T23:24:04.780Z",
                "text":"Iqra 对 Niamh 担心有必要吗？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30329,
                "question_id":12070,
                "locale":"en",
                "created_at":"2022-01-10T23:24:04.675Z",
                "updated_at":"2022-01-10T23:24:04.675Z",
                "text":"Is Iqra’s concern for Niamh warranted?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30365,
                "position":1,
                "active":true,
                "question_id":12070,
                "created_at":"2022-01-10T23:24:04.858Z",
                "updated_at":"2022-01-10T23:24:04.858Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Yes, Iqra is right to be concerned.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73099,
                      "answer_id":30365,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:04.943Z",
                      "updated_at":"2022-01-10T23:24:04.943Z",
                      "text":"Evet, Iqra endişelenmekte haklı.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73098,
                      "answer_id":30365,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:04.938Z",
                      "updated_at":"2022-01-10T23:24:04.938Z",
                      "text":"Sí, está bien que Iqra esté preocupado.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73097,
                      "answer_id":30365,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:04.933Z",
                      "updated_at":"2022-01-10T23:24:04.933Z",
                      "text":"Да, у Икры есть все основания тревожиться.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73096,
                      "answer_id":30365,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:04.929Z",
                      "updated_at":"2022-01-10T23:24:04.929Z",
                      "text":"Tak, Iqra ma rację, że się niepokoi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73095,
                      "answer_id":30365,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:04.924Z",
                      "updated_at":"2022-01-10T23:24:04.924Z",
                      "text":"그렇다. Iqra가 염려할 만 하다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73094,
                      "answer_id":30365,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:04.919Z",
                      "updated_at":"2022-01-10T23:24:04.919Z",
                      "text":"はい、Iqraが懸念を抱いたのは正しい反応である。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73093,
                      "answer_id":30365,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:04.914Z",
                      "updated_at":"2022-01-10T23:24:04.914Z",
                      "text":"Sì, Iqra ha ragione a essere preoccupata.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73092,
                      "answer_id":30365,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:04.910Z",
                      "updated_at":"2022-01-10T23:24:04.910Z",
                      "text":"Ja, Iqra ist zurecht besorgt.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73091,
                      "answer_id":30365,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:04.905Z",
                      "updated_at":"2022-01-10T23:24:04.905Z",
                      "text":"Oui, Iqra a raison de s'inquiéter.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73090,
                      "answer_id":30365,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:04.900Z",
                      "updated_at":"2022-01-10T23:24:04.900Z",
                      "text":"Oui, Iqra a raison de se faire du souci.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73089,
                      "answer_id":30365,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:04.895Z",
                      "updated_at":"2022-01-10T23:24:04.895Z",
                      "text":"是的，Iqra 有權對他有疑慮。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73088,
                      "answer_id":30365,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:04.890Z",
                      "updated_at":"2022-01-10T23:24:04.890Z",
                      "text":"Sim, Iqra está certa em se preocupar.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73087,
                      "answer_id":30365,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:04.886Z",
                      "updated_at":"2022-01-10T23:24:04.886Z",
                      "text":"Sí, Iqra tiene razón en estar preocupado.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73086,
                      "answer_id":30365,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:04.881Z",
                      "updated_at":"2022-01-10T23:24:04.881Z",
                      "text":"Oo, tamang mag-alala si Iqra.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73085,
                      "answer_id":30365,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:04.876Z",
                      "updated_at":"2022-01-10T23:24:04.876Z",
                      "text":"有，Iqra 的担心是正确的。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73084,
                      "answer_id":30365,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:04.872Z",
                      "updated_at":"2022-01-10T23:24:04.872Z",
                      "text":"Yes, Iqra is right to be concerned.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30366,
                "position":2,
                "active":true,
                "question_id":12070,
                "created_at":"2022-01-10T23:24:04.949Z",
                "updated_at":"2022-01-10T23:24:04.949Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"No, Iqra is assuming too much and should not interfere.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73115,
                      "answer_id":30366,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:05.042Z",
                      "updated_at":"2022-01-10T23:24:05.042Z",
                      "text":"Hayır, Iqra çok fazla varsayımda bulunuyor; bu nedenle, müdahale etmemeli.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73114,
                      "answer_id":30366,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:05.030Z",
                      "updated_at":"2022-01-10T23:24:05.030Z",
                      "text":"No, Iqra está asumiendo demasiado y no debería interferir.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73113,
                      "answer_id":30366,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:05.024Z",
                      "updated_at":"2022-01-10T23:24:05.024Z",
                      "text":"Нет, Икра слишком многое додумывает и не должна вмешиваться.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73112,
                      "answer_id":30366,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:05.019Z",
                      "updated_at":"2022-01-10T23:24:05.019Z",
                      "text":"Nie, Iqra za dużo zakłada i nie powinna się wtrącać.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73111,
                      "answer_id":30366,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:05.014Z",
                      "updated_at":"2022-01-10T23:24:05.014Z",
                      "text":"그렇지 않다. Iqra는 과도한 걱정을 하고 있으며, 이 일에 개입해서도 안 된다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73110,
                      "answer_id":30366,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:05.009Z",
                      "updated_at":"2022-01-10T23:24:05.009Z",
                      "text":"いいえ、Iqraさんは憶測しすぎであり、介入すべきではない。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73109,
                      "answer_id":30366,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:05.004Z",
                      "updated_at":"2022-01-10T23:24:05.004Z",
                      "text":"No, Iqra sta supponendo troppe informazioni e non dovrebbe interferire.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73108,
                      "answer_id":30366,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:04.999Z",
                      "updated_at":"2022-01-10T23:24:04.999Z",
                      "text":"Nein, Iqras Sorge ist nicht ausreichend begründet und sie sollte sich nicht einmischen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73107,
                      "answer_id":30366,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:04.994Z",
                      "updated_at":"2022-01-10T23:24:04.994Z",
                      "text":"Non, Iqra en fait trop et ne devrait pas interférer.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73106,
                      "answer_id":30366,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:04.989Z",
                      "updated_at":"2022-01-10T23:24:04.989Z",
                      "text":"Non, Iqra se fait des idées et ne doit pas intervenir.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73105,
                      "answer_id":30366,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:04.985Z",
                      "updated_at":"2022-01-10T23:24:04.985Z",
                      "text":"Não, Iqra está presumindo demais e não deve interferir.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73104,
                      "answer_id":30366,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:04.980Z",
                      "updated_at":"2022-01-10T23:24:04.980Z",
                      "text":"No, Iqra supone demasiado y no debe interferir.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73103,
                      "answer_id":30366,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:04.975Z",
                      "updated_at":"2022-01-10T23:24:04.975Z",
                      "text":"Hindi, masyadong nag-iisip si Iqra at hindi dapat makialam.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73102,
                      "answer_id":30366,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:04.970Z",
                      "updated_at":"2022-01-10T23:24:04.970Z",
                      "text":"否，Iqra 的猜测过多，不应干预。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73101,
                      "answer_id":30366,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:04.966Z",
                      "updated_at":"2022-01-10T23:24:04.966Z",
                      "text":"否，Iqra 有太多預設立場，而且不應該介入。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73100,
                      "answer_id":30366,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:04.962Z",
                      "updated_at":"2022-01-10T23:24:04.962Z",
                      "text":"No, Iqra is assuming too much and should not interfere.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30367,
                "position":3,
                "active":true,
                "question_id":12070,
                "created_at":"2022-01-10T23:24:05.048Z",
                "updated_at":"2022-01-10T23:24:05.048Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"I’m not sure.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73131,
                      "answer_id":30367,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:05.136Z",
                      "updated_at":"2022-01-10T23:24:05.136Z",
                      "text":"Emin değilim.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73130,
                      "answer_id":30367,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:05.131Z",
                      "updated_at":"2022-01-10T23:24:05.131Z",
                      "text":"No estoy seguro.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73129,
                      "answer_id":30367,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:05.127Z",
                      "updated_at":"2022-01-10T23:24:05.127Z",
                      "text":"Затрудняюсь ответить.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73128,
                      "answer_id":30367,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:05.122Z",
                      "updated_at":"2022-01-10T23:24:05.122Z",
                      "text":"Nie mam pewności.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73127,
                      "answer_id":30367,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:05.117Z",
                      "updated_at":"2022-01-10T23:24:05.117Z",
                      "text":"잘 모르겠다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73126,
                      "answer_id":30367,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:05.112Z",
                      "updated_at":"2022-01-10T23:24:05.112Z",
                      "text":"わからない。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73125,
                      "answer_id":30367,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:05.108Z",
                      "updated_at":"2022-01-10T23:24:05.108Z",
                      "text":"Non ne sono sicuro/a.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73124,
                      "answer_id":30367,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:05.103Z",
                      "updated_at":"2022-01-10T23:24:05.103Z",
                      "text":"Ich bin mir nicht sicher.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73123,
                      "answer_id":30367,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:05.098Z",
                      "updated_at":"2022-01-10T23:24:05.098Z",
                      "text":"Je ne suis pas sûr.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73122,
                      "answer_id":30367,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:05.093Z",
                      "updated_at":"2022-01-10T23:24:05.093Z",
                      "text":"Je ne sais pas très bien.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73121,
                      "answer_id":30367,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:05.088Z",
                      "updated_at":"2022-01-10T23:24:05.088Z",
                      "text":"Não tenho certeza.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73120,
                      "answer_id":30367,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:05.084Z",
                      "updated_at":"2022-01-10T23:24:05.084Z",
                      "text":"No estoy seguro.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73119,
                      "answer_id":30367,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:05.079Z",
                      "updated_at":"2022-01-10T23:24:05.079Z",
                      "text":"Hindi ako sigurado.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73118,
                      "answer_id":30367,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:05.074Z",
                      "updated_at":"2022-01-10T23:24:05.074Z",
                      "text":"我不确定。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73117,
                      "answer_id":30367,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:05.069Z",
                      "updated_at":"2022-01-10T23:24:05.069Z",
                      "text":"我不確定。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73116,
                      "answer_id":30367,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:05.065Z",
                      "updated_at":"2022-01-10T23:24:05.065Z",
                      "text":"I’m not sure.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12071,
          "shuffle":false,
          "position":46,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30368"
          ],
          "created_at":"2022-01-10T23:24:05.153Z",
          "updated_at":"2022-01-10T23:24:05.636Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":46,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Which of the following would be Iqra’s best response?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30360,
                "question_id":12071,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:05.347Z",
                "updated_at":"2022-01-10T23:24:05.347Z",
                "text":"Iqra'nın verebileceği en iyi yanıt aşağıdakilerden hangisidir?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30359,
                "question_id":12071,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:05.342Z",
                "updated_at":"2022-01-10T23:24:05.342Z",
                "text":"¿Cuál de las siguientes opciones sería la mejor respuesta de Iqra?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30358,
                "question_id":12071,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:05.337Z",
                "updated_at":"2022-01-10T23:24:05.337Z",
                "text":"Какой из ответов Икры будет оптимальным?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30357,
                "question_id":12071,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:05.333Z",
                "updated_at":"2022-01-10T23:24:05.333Z",
                "text":"Która z poniższych odpowiedzi byłaby najlepsza dla Iqry?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30356,
                "question_id":12071,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:05.327Z",
                "updated_at":"2022-01-10T23:24:05.327Z",
                "text":"다음 중 Iqra가 할 수 있는 최선의 대응은 무엇일까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30355,
                "question_id":12071,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:05.322Z",
                "updated_at":"2022-01-10T23:24:05.322Z",
                "text":"次のうち、Iqraさんが取るべき最善の対応はどれですか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30354,
                "question_id":12071,
                "locale":"it",
                "created_at":"2022-01-10T23:24:05.317Z",
                "updated_at":"2022-01-10T23:24:05.317Z",
                "text":"Quale delle seguenti sarebbe la risposta migliore di Iqra?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30353,
                "question_id":12071,
                "locale":"de",
                "created_at":"2022-01-10T23:24:05.312Z",
                "updated_at":"2022-01-10T23:24:05.312Z",
                "text":"Welche dieser Antworten sollte Iqra wählen?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30352,
                "question_id":12071,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:05.307Z",
                "updated_at":"2022-01-10T23:24:05.307Z",
                "text":"Laquelle des propositions suivantes serait la meilleure réponse d'Iqra?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30351,
                "question_id":12071,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:05.302Z",
                "updated_at":"2022-01-10T23:24:05.302Z",
                "text":"Quelle est la meilleure manière de réagir pour Iqra ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30350,
                "question_id":12071,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:05.297Z",
                "updated_at":"2022-01-10T23:24:05.297Z",
                "text":"Qual das alternativas a seguir seria a melhor resposta de Iqra?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30349,
                "question_id":12071,
                "locale":"es",
                "created_at":"2022-01-10T23:24:05.292Z",
                "updated_at":"2022-01-10T23:24:05.292Z",
                "text":"¿Cuál de las opciones siguientes debería ser la mejor respuesta de Iqra?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30348,
                "question_id":12071,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:05.287Z",
                "updated_at":"2022-01-10T23:24:05.287Z",
                "text":"Alin sa sumusunod ang pinakamagandang tugon ni Iqra?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30347,
                "question_id":12071,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:05.282Z",
                "updated_at":"2022-01-10T23:24:05.282Z",
                "text":"下列何項是 Iqra 最好的回應方式？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30346,
                "question_id":12071,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:05.276Z",
                "updated_at":"2022-01-10T23:24:05.276Z",
                "text":"以下哪一种反应是 Iqra 的最佳反应？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30345,
                "question_id":12071,
                "locale":"en",
                "created_at":"2022-01-10T23:24:05.172Z",
                "updated_at":"2022-01-10T23:24:05.172Z",
                "text":"Which of the following would be Iqra’s best response?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30368,
                "position":1,
                "active":true,
                "question_id":12071,
                "created_at":"2022-01-10T23:24:05.354Z",
                "updated_at":"2022-01-10T23:24:05.354Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“I noticed the cut on your lip last week, and that you’ve been off work more often than usual. You looked upset and worried after the conference call today. Is there anything I can do to help?”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73147,
                      "answer_id":30368,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:05.439Z",
                      "updated_at":"2022-01-10T23:24:05.439Z",
                      "text":"\"Geçen hafta dudağında kesik olduğunu ve her zamankinden daha sık işten ayrıldığını fark ettim. Bugünkü konferans görüşmesinden sonra üzgün ve endişeli görünüyordun. Yardımcı olabileceğim bir şey var mı?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73146,
                      "answer_id":30368,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:05.434Z",
                      "updated_at":"2022-01-10T23:24:05.434Z",
                      "text":"\"Me di cuenta del corte en tu labio la semana pasada y de que has estado fuera del trabajo más de lo habitual. Parecías triste y preocupado después de la llamada de hoy. ¿Hay algo que pueda hacer para ayudar?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73145,
                      "answer_id":30368,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:05.430Z",
                      "updated_at":"2022-01-10T23:24:05.430Z",
                      "text":"«На прошлой неделе я заметила ссадину у тебя на губе, и что ты чаще обычного не выходила на работу. После конференц-вызова ты выглядела расстроенной и обеспокоенной. Я могу чем-то помочь?»",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73144,
                      "answer_id":30368,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:05.425Z",
                      "updated_at":"2022-01-10T23:24:05.425Z",
                      "text":"„Zauważyłem(-am) w zeszłym tygodniu skaleczenie na twojej wardze i to, że częściej niż zwykle nie jesteś w pracy. Po dzisiejszej telekonferencji wyglądałeś(-aś) na zdenerwowanego(-ną) i zmartwionego(-ną). Czy mogę Ci jakoś pomóc?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73143,
                      "answer_id":30368,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:05.420Z",
                      "updated_at":"2022-01-10T23:24:05.420Z",
                      "text":"“지난주에 보니까 입술에 상처가 생겼고, 요즘 평소보다 더 자주 결근을 하셨어요. 오늘 화상 회의 후 표정이 안 좋으시던데요. 제가 뭔가 도울 일이 있을까요?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73142,
                      "answer_id":30368,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:05.413Z",
                      "updated_at":"2022-01-10T23:24:05.413Z",
                      "text":"「先週唇が切れていたこと、そして通常よりも頻繁に休まれていたことに気づきました。今日の電話会議の後、動揺しており、なにか心配事があるように見えました。何か私にできることはありますか？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73141,
                      "answer_id":30368,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:05.409Z",
                      "updated_at":"2022-01-10T23:24:05.409Z",
                      "text":"“Ho notato il taglio sul labbro la scorsa settimana e che sei stata assente dal lavoro più spesso del solito. Sembravi turbata e preoccupata dopo l’audioconferenza di oggi. C’è qualcosa che posso fare per aiutarti?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73140,
                      "answer_id":30368,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:05.404Z",
                      "updated_at":"2022-01-10T23:24:05.404Z",
                      "text":"„Ich habe deine Verletzung an der Lippe letzte Woche gesehen und bemerkt, dass du öfter gefehlt hast als sonst. Du hast nach der Konferenz heute verzweifelt und besorgt ausgesehen. Kann ich etwas tun, um dir zu helfen?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73139,
                      "answer_id":30368,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:05.399Z",
                      "updated_at":"2022-01-10T23:24:05.399Z",
                      "text":"« J'ai remarqué la coupure sur votre lèvre la semaine dernière et que vous vous êtes absenté plus souvent que d'habitude. Vous aviez l'air bouleversé et inquiet après la conférence téléphonique d'aujourd'hui. Qu'est-ce que je peux faire pour aider?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73138,
                      "answer_id":30368,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:05.395Z",
                      "updated_at":"2022-01-10T23:24:05.395Z",
                      "text":"« J’ai remarqué la coupure sur ta lèvre la semaine dernière et tu es absente plus souvent que d’habitude. Tu avais l’air contrariée et inquiète après la téléconférence d’aujourd’hui. Est-ce que je peux faire quelque chose pour aider ? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73137,
                      "answer_id":30368,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:05.390Z",
                      "updated_at":"2022-01-10T23:24:05.390Z",
                      "text":"“Eu percebi o corte em seu lábio na semana passada e que você esteve fora do trabalho mais do que o normal. Você parecia chateado e preocupado após a teleconferência de hoje. Há algo que eu possa fazer para ajudar?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73136,
                      "answer_id":30368,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:05.385Z",
                      "updated_at":"2022-01-10T23:24:05.385Z",
                      "text":"“Observé el corte en tu labio la semana pasada, y que te has ausentado al trabajo con más frecuencia de lo habitual. Te ves molesto y preocupado después de la llamada en conferencia de hoy. ¿Hay algo que pueda hacer para ayudar?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73135,
                      "answer_id":30368,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:05.380Z",
                      "updated_at":"2022-01-10T23:24:05.380Z",
                      "text":"“Napansin ko na may putok ang labi mo noong nakaraang linggo, at madalas kang lumiliban sa trabaho kaysa sa dati. Mukha kang balisa at nag-aalala pagkatapos ng conference call ngayong araw. May maitutulong ba ako?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73134,
                      "answer_id":30368,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:05.375Z",
                      "updated_at":"2022-01-10T23:24:05.375Z",
                      "text":"“我上周就注意到你嘴唇上的伤口了，而且你缺勤的次数比平常多了。你在今天的会议电话结束后看起来很伤心和焦虑。有什么我可以帮忙的吗？”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73133,
                      "answer_id":30368,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:05.371Z",
                      "updated_at":"2022-01-10T23:24:05.371Z",
                      "text":"「我注意到上星期你嘴唇上的傷口，而且你請假的次數也比平常頻繁。今天電話會議後，你看起來情緒不佳且憂心重重。有甚麼我可以幫上忙的？",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73132,
                      "answer_id":30368,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:05.367Z",
                      "updated_at":"2022-01-10T23:24:05.367Z",
                      "text":"“I noticed the cut on your lip last week, and that you’ve been off work more often than usual. You looked upset and worried after the conference call today. Is there anything I can do to help?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30369,
                "position":2,
                "active":true,
                "question_id":12071,
                "created_at":"2022-01-10T23:24:05.445Z",
                "updated_at":"2022-01-10T23:24:05.445Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“I’ve noticed that you’ve had trouble meeting your deadlines lately. Can we talk about how to manage your workload?”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73163,
                      "answer_id":30369,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:05.535Z",
                      "updated_at":"2022-01-10T23:24:05.535Z",
                      "text":"\"Son zamanlarda teslim tarihlerine uymakta sıkıntı yaşadığını fark ettim. İş yükünü nasıl düzeltebileceğimiz konusunda konuşabilir miyiz?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73162,
                      "answer_id":30369,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:05.530Z",
                      "updated_at":"2022-01-10T23:24:05.530Z",
                      "text":"\"Me he dado cuenta de que últimamente has tenido problemas para cumplir con tus plazos. ¿Podemos hablar sobre cómo gestionar tu carga de trabajo?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73161,
                      "answer_id":30369,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:05.524Z",
                      "updated_at":"2022-01-10T23:24:05.524Z",
                      "text":"«Я заметила, что в последнее время ты с трудом соблюдаешь сроки. Мы могли бы поговорить о том, как тебе распределять рабочую нагрузку?»",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73160,
                      "answer_id":30369,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:05.519Z",
                      "updated_at":"2022-01-10T23:24:05.519Z",
                      "text":"„Zauważyłem(-am), że ostatnio masz problemy z dotrzymywaniem terminów. Czy możemy porozmawiać o tym, jak zarządzać swoim obciążeniem pracą?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73159,
                      "answer_id":30369,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:05.514Z",
                      "updated_at":"2022-01-10T23:24:05.514Z",
                      "text":"“요즘 마감일을 맞추는 데 어려움이 있으신 것 같아요. 업무량 관리에 대해 이야기를 나눌 수 있을까요?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73158,
                      "answer_id":30369,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:05.510Z",
                      "updated_at":"2022-01-10T23:24:05.510Z",
                      "text":"「最近、期限に間に合わせることが困難なようですね。ご自身の仕事量を管理する方法についてお話しできますか？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73157,
                      "answer_id":30369,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:05.505Z",
                      "updated_at":"2022-01-10T23:24:05.505Z",
                      "text":"“Ho notato che ultimamente hai avuto problemi a rispettare le scadenze. Possiamo parlare di come gestire il tuo carico di lavoro?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73156,
                      "answer_id":30369,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:05.499Z",
                      "updated_at":"2022-01-10T23:24:05.499Z",
                      "text":"„Ich habe bemerkt, dass du in letzter Zeit Schwierigkeiten damit hattest, Fristen einzuhalten. Könnten wir besprechen, wie du dir deine Arbeit einteilst?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73155,
                      "answer_id":30369,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:05.494Z",
                      "updated_at":"2022-01-10T23:24:05.494Z",
                      "text":"« J'ai remarqué que vous avez eu du mal à respecter vos délais ces derniers temps. Pouvons-nous vous expliquer comment gérer votre charge de travail? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73154,
                      "answer_id":30369,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:05.490Z",
                      "updated_at":"2022-01-10T23:24:05.490Z",
                      "text":"« J’ai remarqué que tu avais du mal à respecter les délais ces derniers temps. Tu veux qu’on discute de la façon de gérer ta charge de travail ? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73153,
                      "answer_id":30369,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:05.485Z",
                      "updated_at":"2022-01-10T23:24:05.485Z",
                      "text":"“Percebi que você teve problemas para cumprir seus prazos ultimamente. Podemos conversar sobre como gerenciar sua carga de trabalho?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73152,
                      "answer_id":30369,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:05.480Z",
                      "updated_at":"2022-01-10T23:24:05.480Z",
                      "text":"“He observado que has tenido problemas para cumplir con tus plazos últimamente. ¿Podemos hablar sobre cómo manejar tu carga de trabajo?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73151,
                      "answer_id":30369,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:05.474Z",
                      "updated_at":"2022-01-10T23:24:05.474Z",
                      "text":"“Napansin ko na nahihirapan kang abutin ang mga deadline mo kamakailan. Maaari ba tayong mag-usap kung paano pangangasiwaan ang trabaho mo?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73150,
                      "answer_id":30369,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:05.469Z",
                      "updated_at":"2022-01-10T23:24:05.469Z",
                      "text":"“我注意到你近来无法按时完成工作。我们可以谈一下如何管理你的工作量吗？”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73149,
                      "answer_id":30369,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:05.464Z",
                      "updated_at":"2022-01-10T23:24:05.464Z",
                      "text":"「我注意到你最近常常錯過期限。我們是否可以談談如何管理你的工作量？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73148,
                      "answer_id":30369,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:05.459Z",
                      "updated_at":"2022-01-10T23:24:05.459Z",
                      "text":"“I’ve noticed that you’ve had trouble meeting your deadlines lately. Can we talk about how to manage your workload?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30370,
                "position":3,
                "active":true,
                "question_id":12071,
                "created_at":"2022-01-10T23:24:05.541Z",
                "updated_at":"2022-01-10T23:24:05.541Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“I am concerned about you. You seem isolated and afraid. Are you OK? Did Karl do that to your lip? Can I help?\"",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73179,
                      "answer_id":30370,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:05.631Z",
                      "updated_at":"2022-01-10T23:24:05.631Z",
                      "text":"\"Senin için endişeleniyorum. Yalnız ve korkmuş görünüyorsun. İyi misin? Dudağının böyle olmasının sebebi Karl mı? Yardımcı olabilir miyim?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73178,
                      "answer_id":30370,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:05.626Z",
                      "updated_at":"2022-01-10T23:24:05.626Z",
                      "text":"\"Estoy preocupado por ti. Pareces aislado y preocupado. ¿Estás bien? ¿Karl te hizo eso en el labio? ¿Puedo ayudar?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73177,
                      "answer_id":30370,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:05.622Z",
                      "updated_at":"2022-01-10T23:24:05.622Z",
                      "text":"«Я о тебе волнуюсь. Ты выглядишь одинокой и напуганной. У тебя все в порядке? Это Карл разбил тебе губу? Я могу чем-то помочь?»",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73176,
                      "answer_id":30370,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:05.617Z",
                      "updated_at":"2022-01-10T23:24:05.617Z",
                      "text":"„Martwię się o Ciebie. Wygląda na to, że jesteś zamknięty(-a) w sobie i boisz się. Wszystko w porządku? Czy skaleczenie na Twojej wardze to wina Karla? Czy mogę Ci pomóc?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73175,
                      "answer_id":30370,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:05.612Z",
                      "updated_at":"2022-01-10T23:24:05.612Z",
                      "text":"“걱정이 되어서요. 혼자 계실 때가 많고 걱정이 있으신 것 같아요. 괜찮으신 건가요? 그 상처는 Karl 때문에 생긴 건가요? 제가 도와드릴까요?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73174,
                      "answer_id":30370,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:05.608Z",
                      "updated_at":"2022-01-10T23:24:05.608Z",
                      "text":"「あなたのことが心配です。孤立していて、怯えているように見えます。大丈夫ですか？唇のその傷は、Karlさんによるものですか？私にできることはありますか？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73173,
                      "answer_id":30370,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:05.603Z",
                      "updated_at":"2022-01-10T23:24:05.603Z",
                      "text":"“Sono preoccupata per te. Sembri isolata e impaurita. Stai bene? Karl ti ha fatto questo al labbro? Posso aiutare?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73172,
                      "answer_id":30370,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:05.598Z",
                      "updated_at":"2022-01-10T23:24:05.598Z",
                      "text":"„Ich mache mir Sorgen um dich. Du wirkst isoliert und ängstlich. Geht es dir gut? Hat Karl dich an der Lippe verletzt? Kann ich dir irgendwie helfen?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73171,
                      "answer_id":30370,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:05.593Z",
                      "updated_at":"2022-01-10T23:24:05.593Z",
                      "text":"« Je m'inquiète pour vous. Vous semblez isolé et effrayé. Est-ce que ça va ? C'est Karl qui a fait ça à votre lèvre? Puis-je vous aider ? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73170,
                      "answer_id":30370,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:05.588Z",
                      "updated_at":"2022-01-10T23:24:05.588Z",
                      "text":"« Je me fais du souci pour toi. Tu sembles isolée et effrayée. Tout va bien ? C’est Karl qui a fait ça à ta lèvre ? Je peux t’aider ? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73169,
                      "answer_id":30370,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:05.583Z",
                      "updated_at":"2022-01-10T23:24:05.583Z",
                      "text":"“Estou preocupado com você. Você parece isolado e com medo. Você está bem? Karl fez isso em seu lábio? Posso ajudar?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73168,
                      "answer_id":30370,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:05.578Z",
                      "updated_at":"2022-01-10T23:24:05.578Z",
                      "text":"“Estoy preocupado por ti. Pareces aislado y temeroso. ¿Te sientes bien? ¿Karl hizo eso en tu labio? ¿Puedo ayudar?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73167,
                      "answer_id":30370,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:05.573Z",
                      "updated_at":"2022-01-10T23:24:05.573Z",
                      "text":"“Nag-aalala ako tungkol sa iyo. Mukha kang malayo at natatakot. AYOS ka lang ba? Si Karl ba ang may gawa niyan sa labi mo? Maaari ba akong tumulong?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73166,
                      "answer_id":30370,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:05.568Z",
                      "updated_at":"2022-01-10T23:24:05.568Z",
                      "text":"“我很担心你。你似乎很孤立和害怕。你没事吧？你嘴唇的伤口是 Karl 弄得吧？需要我帮忙吗？”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73165,
                      "answer_id":30370,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:05.564Z",
                      "updated_at":"2022-01-10T23:24:05.564Z",
                      "text":"「我很擔心你。你似乎很孤立而且很害怕。你還好嗎？你的嘴唇受傷是因為 Karl 嗎？我可以幫上忙嗎？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73164,
                      "answer_id":30370,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:05.559Z",
                      "updated_at":"2022-01-10T23:24:05.559Z",
                      "text":"“I am concerned about you. You seem isolated and afraid. Are you OK? Did Karl do that to your lip? Can I help?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12072,
          "shuffle":false,
          "position":47,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30373"
          ],
          "created_at":"2022-01-10T23:24:05.648Z",
          "updated_at":"2022-01-10T23:24:06.133Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":47,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What should be Iqra’s first response to Niamh’s disclosure?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30376,
                "question_id":12072,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:05.847Z",
                "updated_at":"2022-01-10T23:24:05.847Z",
                "text":"Iqra'nın Niamh'ın açıklamasına ilk tepkisi ne olmalıdır?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30375,
                "question_id":12072,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:05.842Z",
                "updated_at":"2022-01-10T23:24:05.842Z",
                "text":"¿Cuál debería ser la primera respuesta de Iqra ante la declaración de Niamh?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30374,
                "question_id":12072,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:05.837Z",
                "updated_at":"2022-01-10T23:24:05.837Z",
                "text":"Как Икре следует прежде всего отреагировать на признание Нив?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30373,
                "question_id":12072,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:05.832Z",
                "updated_at":"2022-01-10T23:24:05.832Z",
                "text":"Jaka powinna być pierwsza reakcja Iqry na ujawnienie informacji przez Niamh?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30372,
                "question_id":12072,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:05.826Z",
                "updated_at":"2022-01-10T23:24:05.826Z",
                "text":"Niamh가 그 사실을 밝혔을 때 Iqra의 적절한 첫 반응은 무엇일까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30371,
                "question_id":12072,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:05.822Z",
                "updated_at":"2022-01-10T23:24:05.822Z",
                "text":"Niamhさんの開示に対するIqraさんの最初の反応はどのようなものであるべきでしょうか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30370,
                "question_id":12072,
                "locale":"it",
                "created_at":"2022-01-10T23:24:05.817Z",
                "updated_at":"2022-01-10T23:24:05.817Z",
                "text":"Quale dovrebbe essere la prima risposta di Iqra alla rivelazione di Niamh?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30369,
                "question_id":12072,
                "locale":"de",
                "created_at":"2022-01-10T23:24:05.812Z",
                "updated_at":"2022-01-10T23:24:05.812Z",
                "text":"Wie sollte Iqra zuerst auf Niamhs Offenbarung reagieren?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30368,
                "question_id":12072,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:05.807Z",
                "updated_at":"2022-01-10T23:24:05.807Z",
                "text":"Quelle devrait être la première réponse d'Iqra à la révélation de Niamh?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30367,
                "question_id":12072,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:05.802Z",
                "updated_at":"2022-01-10T23:24:05.802Z",
                "text":"Comment Iqra devrait-il réagir face aux révélations de Niamh ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30366,
                "question_id":12072,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:05.798Z",
                "updated_at":"2022-01-10T23:24:05.798Z",
                "text":"Qual deve ser a primeira resposta de Iqra sobre a revelação de Niamh?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30365,
                "question_id":12072,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:05.793Z",
                "updated_at":"2022-01-10T23:24:05.793Z",
                "text":"Iqra 對於 Niamh 向他揭露的事情第一個反應應該是甚麼？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30364,
                "question_id":12072,
                "locale":"es",
                "created_at":"2022-01-10T23:24:05.788Z",
                "updated_at":"2022-01-10T23:24:05.788Z",
                "text":"¿Cuál debería ser la primera respuesta de Iqra a la divulgación de Niamh?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30363,
                "question_id":12072,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:05.783Z",
                "updated_at":"2022-01-10T23:24:05.783Z",
                "text":"Ano ang dapat unang sagot ni Iqra sa pagbubunyag ni Niamh?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30362,
                "question_id":12072,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:05.778Z",
                "updated_at":"2022-01-10T23:24:05.778Z",
                "text":"Iqra 对于 Niamh 披露的事情第一反应应该是什么？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30361,
                "question_id":12072,
                "locale":"en",
                "created_at":"2022-01-10T23:24:05.667Z",
                "updated_at":"2022-01-10T23:24:05.667Z",
                "text":"What should be Iqra’s first response to Niamh’s disclosure?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30371,
                "position":1,
                "active":true,
                "question_id":12072,
                "created_at":"2022-01-10T23:24:05.855Z",
                "updated_at":"2022-01-10T23:24:05.855Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“What about your daughter, are you worried about her? Are you sure that she is safe?”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73195,
                      "answer_id":30371,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:05.939Z",
                      "updated_at":"2022-01-10T23:24:05.939Z",
                      "text":"\"Kızın için endişeleniyor musun? Güvende olduğundan emin misin?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73194,
                      "answer_id":30371,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:05.935Z",
                      "updated_at":"2022-01-10T23:24:05.935Z",
                      "text":"\"¿Y tu hija? ¿Te preocupa? ¿Estás segura de que está a salvo?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73193,
                      "answer_id":30371,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:05.930Z",
                      "updated_at":"2022-01-10T23:24:05.930Z",
                      "text":"«А что насчет твоей дочери, ты беспокоишься о ней? Ты уверена, что она в безопасности?»",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73192,
                      "answer_id":30371,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:05.925Z",
                      "updated_at":"2022-01-10T23:24:05.925Z",
                      "text":"„A co z Twoją córką, martwisz się o nią? Czy jesteś pewien/pewna, że jest bezpieczna?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73191,
                      "answer_id":30371,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:05.921Z",
                      "updated_at":"2022-01-10T23:24:05.921Z",
                      "text":"“따님은 괜찮나요? 걱정이 되나요? 따님이 지금 안전한가요?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73190,
                      "answer_id":30371,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:05.916Z",
                      "updated_at":"2022-01-10T23:24:05.916Z",
                      "text":"「娘さんに関してはどうですか、彼女の心配をされていますか？彼女が安全であると確証できますか？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73189,
                      "answer_id":30371,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:05.911Z",
                      "updated_at":"2022-01-10T23:24:05.911Z",
                      "text":"“Sei preoccupata per tua figlia? Sei convinta che sia al sicuro?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73188,
                      "answer_id":30371,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:05.907Z",
                      "updated_at":"2022-01-10T23:24:05.907Z",
                      "text":"„Was ist mit deiner Tochter. Hast du Angst um sie? Bist du sicher, dass ihr nichts passiert?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73187,
                      "answer_id":30371,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:05.902Z",
                      "updated_at":"2022-01-10T23:24:05.902Z",
                      "text":"« Et votre fille, vous inquiétez-vous pour elle? Êtes-vous sûr qu'elle est en sécurité? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73186,
                      "answer_id":30371,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:05.897Z",
                      "updated_at":"2022-01-10T23:24:05.897Z",
                      "text":"« Est-ce que tu t’inquiètes pour ta fille ? Tu es sûre qu’elle est en sécurité ? »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73185,
                      "answer_id":30371,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:05.892Z",
                      "updated_at":"2022-01-10T23:24:05.892Z",
                      "text":"“E quanto à sua filha, você está preocupado com ela? Tem certeza de que ela está segura?\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73184,
                      "answer_id":30371,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:05.887Z",
                      "updated_at":"2022-01-10T23:24:05.887Z",
                      "text":"“¿Y mi hija, estás preocupado por ella? ¿Estás seguro de que está a salvo?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73183,
                      "answer_id":30371,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:05.883Z",
                      "updated_at":"2022-01-10T23:24:05.883Z",
                      "text":"“Kumusta ang anak mo, nag-aalala ka ba sa kanya? Sigurado ka bang ligtas siya?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73182,
                      "answer_id":30371,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:05.878Z",
                      "updated_at":"2022-01-10T23:24:05.878Z",
                      "text":"“你女儿怎样，你担心她吗？你确定她是安全的吗？”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73181,
                      "answer_id":30371,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:05.873Z",
                      "updated_at":"2022-01-10T23:24:05.873Z",
                      "text":"「你的女兒呢？你擔心她嗎？」你確定她是安全的嗎？」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73180,
                      "answer_id":30371,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:05.869Z",
                      "updated_at":"2022-01-10T23:24:05.869Z",
                      "text":"“What about your daughter, are you worried about her? Are you sure that she is safe?”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30372,
                "position":2,
                "active":true,
                "question_id":12072,
                "created_at":"2022-01-10T23:24:05.945Z",
                "updated_at":"2022-01-10T23:24:05.945Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“No one deserves to be harassed by their partner. We can put you in touch with people who can help if you need that.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73211,
                      "answer_id":30372,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:06.032Z",
                      "updated_at":"2022-01-10T23:24:06.032Z",
                      "text":"\"Kimse eşi tarafından tacize uğramayı hak etmiyor. İhtiyacın olduğunda yardımcı olabilecek kişilerle iletişime geçmeni sağlayabiliriz.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73210,
                      "answer_id":30372,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:06.027Z",
                      "updated_at":"2022-01-10T23:24:06.027Z",
                      "text":"\"Nadie merece sufrir acoso por parte de su pareja. Podemos ponerte en contacto con personas que pueden ayudarte si lo necesitas\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73209,
                      "answer_id":30372,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:06.022Z",
                      "updated_at":"2022-01-10T23:24:06.022Z",
                      "text":"«Никто не заслуживает унижений со стороны партнера. Мы можем дать тебе контакты людей, которые при необходимости тебе помогут».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73208,
                      "answer_id":30372,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:06.018Z",
                      "updated_at":"2022-01-10T23:24:06.018Z",
                      "text":"„Nikt nie zasługuje na to, aby być nękanym przez swojego partnera. Jeśli tego potrzebujesz, możemy skontaktować cię z osobami, które mogą ci pomóc”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73207,
                      "answer_id":30372,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:06.013Z",
                      "updated_at":"2022-01-10T23:24:06.013Z",
                      "text":"“그 누구도 파트너에게 괴롭힘을 당해서는 안 돼요. 필요하다면 도움을 줄 수 있는 사람들과 연락할 수 있어요.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73206,
                      "answer_id":30372,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:06.008Z",
                      "updated_at":"2022-01-10T23:24:06.008Z",
                      "text":"「誰もパートナーからハラスメントを受けるべきではありません。必要であれば、手助けをしてくれる人々をご紹介します。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73205,
                      "answer_id":30372,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:06.001Z",
                      "updated_at":"2022-01-10T23:24:06.001Z",
                      "text":"“Nessuno merita di essere molestato dal proprio partner. Possiamo metterti in contatto con persone che possono aiutarti se ne hai bisogno”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73204,
                      "answer_id":30372,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:05.996Z",
                      "updated_at":"2022-01-10T23:24:05.996Z",
                      "text":"„Niemand verdient es, von seinem Partner belästigt zu werden. Wir können dir helfen, Personen zu finden, die dir weiterhelfen können, falls du Bedarf danach hast.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73203,
                      "answer_id":30372,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:05.991Z",
                      "updated_at":"2022-01-10T23:24:05.991Z",
                      "text":"« Personne ne mérite d'être harcelé par son partenaire. Nous pouvons vous mettre en contact avec des personnes qui peuvent vous aider si vous en avez besoin. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73202,
                      "answer_id":30372,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:05.987Z",
                      "updated_at":"2022-01-10T23:24:05.987Z",
                      "text":"« Personne n’a le droit d’être harcelé par son partenaire. Nous pouvons te mettre en contact avec des personnes qui peuvent t’aider si tu en as besoin. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73201,
                      "answer_id":30372,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:05.982Z",
                      "updated_at":"2022-01-10T23:24:05.982Z",
                      "text":"“Ninguém merece ser assediado por seu parceiro. Podemos colocá-la em contato com pessoas que podem ajudar se você precisar.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73200,
                      "answer_id":30372,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:05.977Z",
                      "updated_at":"2022-01-10T23:24:05.977Z",
                      "text":"“Nadie merece ser acosado por su pareja. Podemos contactarte con personas que pueden ayudar, si lo necesitas”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73199,
                      "answer_id":30372,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:05.972Z",
                      "updated_at":"2022-01-10T23:24:05.972Z",
                      "text":"“Walang sinuman ang dapat makaranas ng pananakit ng kanyang kapareha. Maaari ka naming ipakipag-usap sa mga taong makatutulong sa iyo kung kailangan mo.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73198,
                      "answer_id":30372,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:05.967Z",
                      "updated_at":"2022-01-10T23:24:05.967Z",
                      "text":"“没有人应该承受他们的伴侣的骚扰。如果你需要，我们会为你联系可以帮助你的人。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73197,
                      "answer_id":30372,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:05.963Z",
                      "updated_at":"2022-01-10T23:24:05.963Z",
                      "text":"「沒有人應該被自己的伴侶騷擾。如果妳需要，我可以幫妳聯繫一些人。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73196,
                      "answer_id":30372,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:05.959Z",
                      "updated_at":"2022-01-10T23:24:05.959Z",
                      "text":"“No one deserves to be harassed by their partner. We can put you in touch with people who can help if you need that.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30373,
                "position":3,
                "active":true,
                "question_id":12072,
                "created_at":"2022-01-10T23:24:06.037Z",
                "updated_at":"2022-01-10T23:24:06.037Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“What you’re sharing is really concerning to me, Niamh. Because of my role on campus, I do have reporting responsibilities, but I’m also here to help. If you would prefer to talk about your options with someone who can keep your experience confidential, I can connect you to them as well.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73227,
                      "answer_id":30373,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:06.129Z",
                      "updated_at":"2022-01-10T23:24:06.129Z",
                      "text":"\"Niamh, paylaştıkların beni gerçekten endişelendiriyor. Kampüsteki rolüm gereği durumu bildirmem gerekiyor; ancak, burada olmamın bir diğer sebebi de yardım etmek. Yaşadıklarını gizli tutabileceğin biriyle seçeneklerinin neler olduğunu konuşmak istersen, seni o kişilerle iletişime geçirebilirim.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73226,
                      "answer_id":30373,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:06.124Z",
                      "updated_at":"2022-01-10T23:24:06.124Z",
                      "text":"\"Lo que estás compartiendo me preocupa mucho, Niamh. Debido a mi función en el campus, tengo la responsabilidad de denunciarlo, pero también estoy aquí para ayudar. Si prefieres hablar con alguien que pueda mantener la confidencialidad de tu experiencia, también puedo ponerte en contacto con alguien\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73225,
                      "answer_id":30373,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:06.119Z",
                      "updated_at":"2022-01-10T23:24:06.119Z",
                      "text":"«То, что ты мне рассказываешь, меня очень беспокоит, Нив. Моя должность в кампусе означает, что я обязана сообщать о подобном, но я здесь для того, чтобы помочь. Если ты хочешь обсудить свои дальнейшие действия со специалистом, который сохранит твою конфиденциальность, я помогу тебе с ним связаться».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73224,
                      "answer_id":30373,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:06.113Z",
                      "updated_at":"2022-01-10T23:24:06.113Z",
                      "text":"„Niamh, to, o czym mówisz, jest dla mnie naprawdę niepokojące. Ze względu na moją rolę w kampusie, mam obowiązek zgłoszenia incydentu, ale jestem tu także po to, aby pomagać. Jeśli wolisz porozmawiać o swoich możliwościach z kimś, kto zachowa Twoje doświadczenia w tajemnicy, mogę Cię również skontaktować z tą osobą”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73223,
                      "answer_id":30373,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:06.108Z",
                      "updated_at":"2022-01-10T23:24:06.108Z",
                      "text":"“지금 말한 것은 정말 걱정이 되는 일이에요, Niamh. 저는 여기 캠퍼스에서 신고할 책임을 담당하고 있고, 또 직접 도움을 줄 수도 있어요. 당신의 상황을 기밀로 유지한 채 가능한 조치들에 대해 알아보고 싶다면, 그런 도움을 줄 수 있는 사람들과도 연결해 줄 수 있어요.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73222,
                      "answer_id":30373,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:06.103Z",
                      "updated_at":"2022-01-10T23:24:06.103Z",
                      "text":"「Niamhさん、今お話しいただいた内容は非常に心配です。キャンパスでの私の役割として、報告をするという責任がありますが、お手伝いもさせてください。ご自身の体験を機密にできる人と今後の選択肢をお話したい場合は、そのような人をご紹介することもできます。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73221,
                      "answer_id":30373,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:06.098Z",
                      "updated_at":"2022-01-10T23:24:06.098Z",
                      "text":"“Mi preoccupa davvero ciò che stai condividendo, Niamh. A causa del mio ruolo nel campus, ho la responsabilità di segnalare, ma sono anche qui per aiutare. Se preferisci parlare delle tue opzioni con qualcuno che possa mantenere riservata la tua esperienza, posso metterti in contatto anche con queste persone”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73220,
                      "answer_id":30373,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:06.093Z",
                      "updated_at":"2022-01-10T23:24:06.093Z",
                      "text":"„Was du sagst, beunruhigt mich wirklich, Niamh. Aufgrund meiner Rolle hier auf dem Campus habe ich Meldepflichten, bin aber auch hier, um zu helfen. Ich würde gerne mit jemandem Vertrauenswürdigen über die Optionen sprechen, die du hast, oder dich direkt mit einer solchen Person in Verbindung bringen.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73219,
                      "answer_id":30373,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:06.088Z",
                      "updated_at":"2022-01-10T23:24:06.088Z",
                      "text":"« Ce que vous dites me préoccupe vraiment, Niamh. En raison de mon rôle sur le campus, j'ai des responsabilités en matière de rapports, mais je suis également là pour vous aider. Si vous préférez parler de vos options avec quelqu'un qui peut garder votre expérience confidentielle, je peux également vous mettre en contact avec eux. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73218,
                      "answer_id":30373,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:06.082Z",
                      "updated_at":"2022-01-10T23:24:06.082Z",
                      "text":"« Ce que tu me dis m’inquiète vraiment, Niamh. De par ma fonction sur le campus, je suis soumis à une obligation de signalement, mais je suis là aussi pour t’aider. Si tu préfères, je peux également te mettre en contact avec quelqu’un qui pourra te dire ce que tu peux faire en toute confidentialité. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73217,
                      "answer_id":30373,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:06.076Z",
                      "updated_at":"2022-01-10T23:24:06.076Z",
                      "text":"“O que você está compartilhando é realmente preocupante para mim, Niamh. Devido à minha função no campus, tenho responsabilidades de denunciar, mas também estou aqui para ajudar. Se você preferir falar sobre suas opções com alguém que possa manter sua experiência confidencial, posso conectá-la a eles também. ”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73216,
                      "answer_id":30373,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:06.072Z",
                      "updated_at":"2022-01-10T23:24:06.072Z",
                      "text":"「妳今天跟我說的事情讓我非常擔心，Niamh。因為我在校園的角色，我必須通報，但我一定會幫助妳。如果妳希望談論這件事的對象可以保密，我也可以幫妳跟他們聯繫。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73215,
                      "answer_id":30373,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:06.067Z",
                      "updated_at":"2022-01-10T23:24:06.067Z",
                      "text":"“Lo que me dices realmente me preocupa, Niamh. Debido a mi función en el campus, tengo responsabilidades de informe, pero también estoy aquí para ayudar. Si prefieres hablar sobre tus opciones con una persona que pueda mantener tu experiencia confidencial, también puedo contactarte”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73214,
                      "answer_id":30373,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:06.062Z",
                      "updated_at":"2022-01-10T23:24:06.062Z",
                      "text":"“Ang ibinabahagi mo ay talagang nakakapag-alala sa akin, Niamh. Dahil sa tungkulin ko sa campus, mayroon akong pananagutan sa pagrereport, pero narito rin ako para tumulong. Kung gusto mong pag-usapan ang mga opsyon mo sa isang tao na mapananatiling lihim ang karanasan mo, maaari kitang iugnay din sa kanila.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73213,
                      "answer_id":30373,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:06.056Z",
                      "updated_at":"2022-01-10T23:24:06.056Z",
                      "text":"“你告诉我的事情确实令我感到担心，Niamh。由于我在校内的角色的关系，我确实有举报责任，但我也会为你提供帮助。如果你想与能为你保密的人谈论你的打算，我也可以联系他们。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73212,
                      "answer_id":30373,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:06.051Z",
                      "updated_at":"2022-01-10T23:24:06.051Z",
                      "text":"“What you’re sharing is really concerning to me, Niamh. Because of my role on campus, I do have reporting responsibilities, but I’m also here to help. If you would prefer to talk about your options with someone who can keep your experience confidential, I can connect you to them as well.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12073,
          "shuffle":false,
          "position":48,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30374"
          ],
          "created_at":"2022-01-10T23:24:06.146Z",
          "updated_at":"2022-01-10T23:24:06.631Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":48,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What advice would you give Dr. Lutz?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30392,
                "question_id":12073,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:06.341Z",
                "updated_at":"2022-01-10T23:24:06.341Z",
                "text":"Doktor Lutz'a ne tavsiye edersiniz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30391,
                "question_id":12073,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:06.337Z",
                "updated_at":"2022-01-10T23:24:06.337Z",
                "text":"¿Qué consejo le daría al Dr. Lutz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30390,
                "question_id":12073,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:06.332Z",
                "updated_at":"2022-01-10T23:24:06.332Z",
                "text":"Что бы вы посоветовали доктору Лутцу?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30389,
                "question_id":12073,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:06.327Z",
                "updated_at":"2022-01-10T23:24:06.327Z",
                "text":"Jakiej rady udzielił(a)byś dr Lutzowi?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30388,
                "question_id":12073,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:06.322Z",
                "updated_at":"2022-01-10T23:24:06.322Z",
                "text":"Lutz 박사에게 어떤 조언을 하는 것이 좋을까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30387,
                "question_id":12073,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:06.317Z",
                "updated_at":"2022-01-10T23:24:06.317Z",
                "text":"Dr. Lutzにどのような助言をしますか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30386,
                "question_id":12073,
                "locale":"it",
                "created_at":"2022-01-10T23:24:06.312Z",
                "updated_at":"2022-01-10T23:24:06.312Z",
                "text":"Quale consiglio daresti al dott. Lutz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30385,
                "question_id":12073,
                "locale":"de",
                "created_at":"2022-01-10T23:24:06.307Z",
                "updated_at":"2022-01-10T23:24:06.307Z",
                "text":"Welchen Rat würden Sie Dr. Lutz geben?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30384,
                "question_id":12073,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:06.303Z",
                "updated_at":"2022-01-10T23:24:06.303Z",
                "text":"Quels conseils donneriez-vous au Dr Lutz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30383,
                "question_id":12073,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:06.298Z",
                "updated_at":"2022-01-10T23:24:06.298Z",
                "text":"Que conseilleriez-vous au Dr Lutz ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30382,
                "question_id":12073,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:06.292Z",
                "updated_at":"2022-01-10T23:24:06.292Z",
                "text":"Que conselho você daria ao Dr. Lutz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30381,
                "question_id":12073,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:06.287Z",
                "updated_at":"2022-01-10T23:24:06.287Z",
                "text":"你會給 Lutz 教授甚麼建議？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30380,
                "question_id":12073,
                "locale":"es",
                "created_at":"2022-01-10T23:24:06.282Z",
                "updated_at":"2022-01-10T23:24:06.282Z",
                "text":"¿Qué consejo darías al Dr. Lutz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30379,
                "question_id":12073,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:06.276Z",
                "updated_at":"2022-01-10T23:24:06.276Z",
                "text":"Anong payo ang maibibigay mo kay Dr. Lutz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30378,
                "question_id":12073,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:06.271Z",
                "updated_at":"2022-01-10T23:24:06.271Z",
                "text":"你会给予 Lutz 博士什么建议？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30377,
                "question_id":12073,
                "locale":"en",
                "created_at":"2022-01-10T23:24:06.164Z",
                "updated_at":"2022-01-10T23:24:06.164Z",
                "text":"What advice would you give Dr. Lutz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30374,
                "position":1,
                "active":true,
                "question_id":12073,
                "created_at":"2022-01-10T23:24:06.349Z",
                "updated_at":"2022-01-10T23:24:06.349Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"He should first address the incident by thanking Mei for sharing this, telling her that he wants to help, and offering to connect her with support and and confidential resources that are available on-campus or in the community.  Dr. Lutz should also follow any other reporting or response procedures set forth by his institution.\n",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73243,
                      "answer_id":30374,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:06.435Z",
                      "updated_at":"2022-01-10T23:24:06.435Z",
                      "text":"Öncelikle bu durumu paylaştığı için Mei'ye teşekkür etmelidir. Yardım etmek istediğini söylemeli ve kampüste veya toplulukta mevcut olan destek ve gizli kaynaklarla bağlantı kurmasını teklif etmelidir.  Ayrıca Dr. Lutz, kurumu tarafından belirlenen diğer bildiride bulunma veya yanıt prosedürlerini takip etmelidir.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73242,
                      "answer_id":30374,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:06.430Z",
                      "updated_at":"2022-01-10T23:24:06.430Z",
                      "text":"Primero debe abordar el incidente y agradecerle a Mei que haya compartido esto, diciéndole que quiere ayudar y que puede ponerle en contacto con recursos de apoyo y confidenciales que están disponibles en el campus o en la comunidad.  El Dr. Lutz también debe seguir cualquier otro procedimiento de denuncia o respuesta establecido por el centro.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73241,
                      "answer_id":30374,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:06.425Z",
                      "updated_at":"2022-01-10T23:24:06.425Z",
                      "text":"Сначала ему следует поблагодарить Мэй за то, что она сообщила об этом происшествии, сказать ей, что готов помочь и объяснить, как получить доступ к ресурсам обеспечения поддержки и конфиденциальности, доступными в кампусе или в сообществе.  Доктору Лутцу также следует выполнить все процедуры уведомления о происшествиях или принятия ответных мер, установленные в его учреждении.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73240,
                      "answer_id":30374,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:06.420Z",
                      "updated_at":"2022-01-10T23:24:06.420Z",
                      "text":"W pierwszej kolejności powinien odnieść się do incydentu, dziękując Mei za podzielenie się tym, mówiąc jej, że chce pomóc i oferując skontaktowanie jej ze wsparciem i poufnymi osobami kontaktowymi, które są dostępne w kampusie lub w społeczności.  Dr Lutz powinien również postępować zgodnie z innymi wszelkimi procedurami zgłaszania i reagowania określonymi przez jego instytucję.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73239,
                      "answer_id":30374,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:06.415Z",
                      "updated_at":"2022-01-10T23:24:06.415Z",
                      "text":"그는 먼저 그 사실을 말해 준 Mei에게 감사하고, 돕고 싶다고 말하고, 캠퍼스 또는 커뮤니티를 통해 받을 수 있는 지원이나 기밀 리소스 제공을 제안해야 한다.  Lutz 박사는 또한 자신의 기관이 정한 기타 신고 또는 대응 절차를 따라야 한다.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73238,
                      "answer_id":30374,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:06.410Z",
                      "updated_at":"2022-01-10T23:24:06.410Z",
                      "text":"まずMeiさんに、この出来事について共有してもらったことに感謝し、手助けをしたい旨を伝え、キャンパス内や地域で利用可能なサポートや機密リソースを紹介することを申し出ることで、この件に対処する。  Dr. Lutzは、彼の機関で示されているその他のあらゆる報告・対応手順にも従うべきである。\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73237,
                      "answer_id":30374,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:06.405Z",
                      "updated_at":"2022-01-10T23:24:06.405Z",
                      "text":"Dovrebbe prima affrontare l’incidente ringraziando Mei per aver condiviso questa situazione, dicendole che desidera aiutare e offrendosi di metterla in contatto con le persone dedite al supporto e alle risorse riservate disponibili nel campus o nella comunità.  Il dott. Lutz dovrebbe anche seguire qualsiasi altra procedura di segnalazione o risposta stabilita dal suo istituto.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73236,
                      "answer_id":30374,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:06.400Z",
                      "updated_at":"2022-01-10T23:24:06.400Z",
                      "text":"Er sollte zuerst Mei für ihr Vertrauen danken und ihr zusichern, dass er ihr helfen möchte. Er sollte anbieten, für sie den Kontakt zu vertrauenswürdigen Personen und Ressourcen herzustellen, die auf dem Campus oder in der Community verfügbar sind und sie unterstützen können.  Dr. Lutz sollte auch alle anderen Meldeprozeduren befolgen, die sein Institut vorschreibt.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73235,
                      "answer_id":30374,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:06.395Z",
                      "updated_at":"2022-01-10T23:24:06.395Z",
                      "text":"Il devrait d'abord aborder l'incident en remerciant Mei d'avoir partagé cela, en lui disant qu'il voulait l'aider et en lui proposant de relier ses informations à un soutien et à des ressources confidentielles disponibles sur le campus ou dans la communauté.  Le Dr. Lutz devrait également suivre toute autre procédure de rapport ou de réponse établie par son institution.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73234,
                      "answer_id":30374,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:06.390Z",
                      "updated_at":"2022-01-10T23:24:06.390Z",
                      "text":"Il devrait d’abord remercier Mei d’avoir partagé ces informations avec lui, l’assurer de son aide et lui proposer de communiquer ses informations aux ressources d’assistance confidentielles qui sont disponibles sur le campus ou dans la communauté.  Le Dr Lutz devrait également suivre toute autre procédure de signalement ou de réponse mise en place par son établissement.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73233,
                      "answer_id":30374,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:06.385Z",
                      "updated_at":"2022-01-10T23:24:06.385Z",
                      "text":"他首先應該感謝 Mei 分享此訊息以做對該事件的初步處理，告訴她他想要幫助她，並幫助她取得校園內或社群中提供的扶助和機密資源。  Lutz 教授也應遵循學校設置的任何其他通報或回應流程。\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73232,
                      "answer_id":30374,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:06.380Z",
                      "updated_at":"2022-01-10T23:24:06.380Z",
                      "text":"他应该首先处理该事件，即感谢 Mei 告诉他此事，告诉她他希望提供帮助，并为她提供支持资源和校园内外的机密资源的联系信息。  然后 Lutz 博士还应该执行其机构设定的任何其他举报或响应程序。\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73231,
                      "answer_id":30374,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:06.376Z",
                      "updated_at":"2022-01-10T23:24:06.376Z",
                      "text":"Ele deve primeiro abordar o incidente agradecendo a Mei por compartilhar isso, dizendo a ela que deseja ajudar e oferecendo-se para buscar suporte em relação às informações dela e recursos confidenciais que estão disponíveis no campus ou na comunidade.  Dr. Lutz também deve seguir quaisquer outros procedimentos de denúncias ou respostas estabelecidos por sua instituição.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73230,
                      "answer_id":30374,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:06.371Z",
                      "updated_at":"2022-01-10T23:24:06.371Z",
                      "text":"Dapat muna niyang lutasin ang insidente sa pamamagitan ng pagpapasalamat kay Mei sa pagbabahagi nito, na sabihin niya na gusto niyang tumulong, at mag-alok na iugnay ang kanyang impormasyon sa suporta at kumpidensyal na mga resource na magagamit sa campus o sa komunidad.  Dapat sinunod din ni Dr. Lutz ang alinman sa iba pang pagrereport o mga pamamaraan ng pagtugon na itinakda ng kanyang institusyon.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73229,
                      "answer_id":30374,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:06.366Z",
                      "updated_at":"2022-01-10T23:24:06.366Z",
                      "text":"Primero debe abordar el incidente agradeciendo a Mei por compartirlo, y decirle que quiere ayudar y ofrecerle información con apoyo y recursos confidenciales que están disponibles en el campus o en la comunidad.  El Dr. Lutz también debe seguir cualquier otro procedimiento de notificación o respuesta establecido por su institución.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73228,
                      "answer_id":30374,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:06.362Z",
                      "updated_at":"2022-01-10T23:24:06.362Z",
                      "text":"He should first address the incident by thanking Mei for sharing this, telling her that he wants to help, and offering to connect her with support and and confidential resources that are available on-campus or in the community.  Dr. Lutz should also follow any other reporting or response procedures set forth by his institution.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30375,
                "position":2,
                "active":true,
                "question_id":12073,
                "created_at":"2022-01-10T23:24:06.441Z",
                "updated_at":"2022-01-10T23:24:06.441Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"He should not respond to Mei, but address the incident she mentions with the institution, since he has to fulfill his duty to report.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73259,
                      "answer_id":30375,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:06.524Z",
                      "updated_at":"2022-01-10T23:24:06.524Z",
                      "text":"Mei'ye cevap vermemelidir, ancak bildiride bulunma görevini yerine getirmek zorunda olduğundan Mei'nin bahsettiği olayı bildirmelidir.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73258,
                      "answer_id":30375,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:06.519Z",
                      "updated_at":"2022-01-10T23:24:06.519Z",
                      "text":"No debe responder a Mei, sino abordar con el centro el incidente que menciona, ya que él tiene que cumplir con su deber de denunciar.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73257,
                      "answer_id":30375,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:06.514Z",
                      "updated_at":"2022-01-10T23:24:06.514Z",
                      "text":"Ему не следует отвечать Мэй, но следует сообщить о происшествии, о котором она сообщила, в учреждение для рассмотрения, так как на него возложена обязанность по уведомлению о происшествиях.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73256,
                      "answer_id":30375,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:06.509Z",
                      "updated_at":"2022-01-10T23:24:06.509Z",
                      "text":"Nie powinien odpowiadać Mei, ale zwrócić się do odpowiedniej instytucji w sprawie incydentu, o którym wspomina, ponieważ musi wypełnić swój obowiązek zgłoszenia incydentu.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73255,
                      "answer_id":30375,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:06.504Z",
                      "updated_at":"2022-01-10T23:24:06.504Z",
                      "text":"그는 Mei에게 대답해서는 안 되며, 그녀가 언급한 사건을 기관에 보고하여 자신의 신고 의무를 다해야 한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73254,
                      "answer_id":30375,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:06.500Z",
                      "updated_at":"2022-01-10T23:24:06.500Z",
                      "text":"Meiさんには返答すべきではないが、報告という義務を果たす必要があるため、彼女が話す出来事を機関に言及する。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73253,
                      "answer_id":30375,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:06.495Z",
                      "updated_at":"2022-01-10T23:24:06.495Z",
                      "text":"Non dovrebbe rispondere a Mei, ma affrontare l’incidente menzionato da lei con l’istituto, poiché deve adempiere al suo obbligo di segnalazione.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73252,
                      "answer_id":30375,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:06.490Z",
                      "updated_at":"2022-01-10T23:24:06.490Z",
                      "text":"Er sollte Mei nicht antworten, aber den Vorfall, von dem sie berichtet hat, mit dem Institut besprechen, da er schließlich seine Meldepflicht erfüllen muss.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73251,
                      "answer_id":30375,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:06.486Z",
                      "updated_at":"2022-01-10T23:24:06.486Z",
                      "text":"Il ne doit pas répondre à Mei, mais signaler l'incident qu'elle mentionne à l'institution, car il doit remplir son devoir de dénonciation.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73250,
                      "answer_id":30375,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:06.481Z",
                      "updated_at":"2022-01-10T23:24:06.481Z",
                      "text":"Il ne devrait pas répondre à Mei, mais signaler l’incident dont elle a fait état à l’établissement, afin de respecter son obligation de signalement.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73249,
                      "answer_id":30375,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:06.477Z",
                      "updated_at":"2022-01-10T23:24:06.477Z",
                      "text":"Ele não deve responder a Mei, mas sim abordar o incidente que ela menciona com a instituição, já que ele tem que cumprir seu dever de denunciar.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73248,
                      "answer_id":30375,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:06.472Z",
                      "updated_at":"2022-01-10T23:24:06.472Z",
                      "text":"他不應回應 Mei，但需與學校共同處理這個事件，因為他必須履行通報的義務。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73247,
                      "answer_id":30375,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:06.467Z",
                      "updated_at":"2022-01-10T23:24:06.467Z",
                      "text":"No debe responder a Mei, pero abordar el incidente que menciona con la institución, ya que debe cumplir con su deber de informe.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73246,
                      "answer_id":30375,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:06.463Z",
                      "updated_at":"2022-01-10T23:24:06.463Z",
                      "text":"Hindi siya dapat sumagot kay Mei, kundi tugunan ang insidente na binanggit niya sa institusyon, dahil kailangan niyang isakatuparan ang kanyang tungkuling magreport.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73245,
                      "answer_id":30375,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:06.458Z",
                      "updated_at":"2022-01-10T23:24:06.458Z",
                      "text":"他不应响应 Mei 的请求，而是将她提到的事件交给机构处理，因为他必须履行自己的举报责任。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73244,
                      "answer_id":30375,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:06.454Z",
                      "updated_at":"2022-01-10T23:24:06.454Z",
                      "text":"He should not respond to Mei, but address the incident she mentions with the institution, since he has to fulfill his duty to report.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30376,
                "position":3,
                "active":true,
                "question_id":12073,
                "created_at":"2022-01-10T23:24:06.530Z",
                "updated_at":"2022-01-10T23:24:06.530Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"He should respond to the student but only address her academic question. Afterwards, he should report the incident to the institution's Title IX coordinator but not inform Mei of that decision.\n",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73275,
                      "answer_id":30376,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:06.626Z",
                      "updated_at":"2022-01-10T23:24:06.626Z",
                      "text":"Yalnızca akademik sorusuyla ilgilenecek şekilde öğrenciye yanıt vermelidir. Daha sonra, olayı kurumun Başlık IX koordinatörüne bildirmeli ancak bu Mei'yi bu kararla ilgili bilgilendirmemelidir.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73274,
                      "answer_id":30376,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:06.621Z",
                      "updated_at":"2022-01-10T23:24:06.621Z",
                      "text":"Debe responder a la estudiante, pero solo abordar su pregunta académica. Posteriormente, debe denunciar el incidente ante el coordinador del Título IX del centro, pero no informar a Mei de esa decisión.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73273,
                      "answer_id":30376,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:06.617Z",
                      "updated_at":"2022-01-10T23:24:06.617Z",
                      "text":"Ему следует ответить студентке, но коснуться только вопроса, связанного с обучением. После этого ему следует сообщить о происшествии ответственному за исполнение Раздела IX в учебном заведении, но не уведомлять Мэй об этом решении.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73272,
                      "answer_id":30376,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:06.612Z",
                      "updated_at":"2022-01-10T23:24:06.612Z",
                      "text":"Powinien on odpowiedzieć studentce, ale tylko na jej pytanie dotyczące zajęć. Następnie powinien zgłosić ten incydent koordynatorowi ds. tytułu IX w danej instytucji, ale nie informować Mei o tej decyzji.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73271,
                      "answer_id":30376,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:06.607Z",
                      "updated_at":"2022-01-10T23:24:06.607Z",
                      "text":"그는 학생에게 답해야 하지만 학문적 질문에만 답해야 한다. 나중에 그는 해당 사건을 기관의 제9편 관련 법률 담당자에게 보고해야 하며, Mei에게는 그러한 결정을 알리지 않아야 한다.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73270,
                      "answer_id":30376,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:06.602Z",
                      "updated_at":"2022-01-10T23:24:06.602Z",
                      "text":"学生に返答すべきであるが、学術的な質問にのみ返答する。後から、機関の第九編コーディネーターにその出来事を報告するが、その決定についてはMeiさんに伝えない。\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73269,
                      "answer_id":30376,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:06.598Z",
                      "updated_at":"2022-01-10T23:24:06.598Z",
                      "text":"Dovrebbe rispondere allo studente, ma affrontare solo la sua domanda di natura accademica. Successivamente, dovrebbe segnalare l’incidente al coordinatore del Titolo IX dell’istituto ma non informare Mei di tale decisione.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73268,
                      "answer_id":30376,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:06.593Z",
                      "updated_at":"2022-01-10T23:24:06.593Z",
                      "text":"Er sollte der Studentin antworten, aber nur auf ihre akademischen Fragen eingehen. Danach sollte er den Vorfall dem Titel IX-Verantwortlichen des Instituts melden, Mei aber nichts von dieser Entscheidung sagen.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73267,
                      "answer_id":30376,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:06.588Z",
                      "updated_at":"2022-01-10T23:24:06.588Z",
                      "text":"Il doit répondre à l'étudiant mais uniquement sur ce qui se rapporte à sa question académique. Par la suite, il doit signaler l'incident au coordinateur du Titre IX de l'institution mais ne pas informer Mei de cette décision.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73266,
                      "answer_id":30376,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:06.583Z",
                      "updated_at":"2022-01-10T23:24:06.583Z",
                      "text":"Il devrait répondre à l’étudiante, mais uniquement en ce qui concerne les cours. Il devrait ensuite signaler l’incident au coordinateur du Titre IX de son établissement, mais ne pas informer Mei de cette décision.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73265,
                      "answer_id":30376,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:06.578Z",
                      "updated_at":"2022-01-10T23:24:06.578Z",
                      "text":"他應回應該名學生，但只處理她的教育問題。之後，他應向學校的第九編協調員通報該事件，但不讓 Mei 得知這個決定。\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73264,
                      "answer_id":30376,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:06.574Z",
                      "updated_at":"2022-01-10T23:24:06.574Z",
                      "text":"他应对该学生做出回应，但只能处理她的学业问题。之后，他应该向机构的第九修正案协调员举报该事件，但不应通知 Mei 该决定。\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73263,
                      "answer_id":30376,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:06.569Z",
                      "updated_at":"2022-01-10T23:24:06.569Z",
                      "text":"Ele deve responder à aluna, mas apenas abordar sua questão acadêmica. Depois, ele deverá relatar o incidente ao coordenador da Título IX da instituição, mas não informar a Mei sobre essa decisão.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73262,
                      "answer_id":30376,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:06.564Z",
                      "updated_at":"2022-01-10T23:24:06.564Z",
                      "text":"Dapat siyang tumugon sa mag-aaral ngunit tugunan lang ang kanyang pang-akademikong tanong. Pagkatapos nito, dapat niyang ireport ang insidente sa Title IX coordinator ng institusyon subalit huwag ipaalam kay Mei ang desisyong iyon.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73261,
                      "answer_id":30376,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:06.558Z",
                      "updated_at":"2022-01-10T23:24:06.558Z",
                      "text":"Debe responder a la estudiante pero solo abordar la pregunta académica. Luego, debe informar el incidente al coordinador del título IX de la institución, pero no informar a Mei sobre esa decisión.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73260,
                      "answer_id":30376,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:06.543Z",
                      "updated_at":"2022-01-10T23:24:06.543Z",
                      "text":"He should respond to the student but only address her academic question. Afterwards, he should report the incident to the institution's Title IX coordinator but not inform Mei of that decision.\n",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12074,
          "shuffle":false,
          "position":49,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30378"
          ],
          "created_at":"2022-01-10T23:24:06.644Z",
          "updated_at":"2022-01-10T23:24:07.130Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":49,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Which of the following is the best reply? ",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30408,
                "question_id":12074,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:06.843Z",
                "updated_at":"2022-01-10T23:24:06.843Z",
                "text":"En iyi yanıt aşağıdakilerden hangisidir? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30407,
                "question_id":12074,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:06.838Z",
                "updated_at":"2022-01-10T23:24:06.838Z",
                "text":"¿Cuál de las siguientes opciones es la mejor respuesta? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30406,
                "question_id":12074,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:06.834Z",
                "updated_at":"2022-01-10T23:24:06.834Z",
                "text":"Какой ответ оптимален? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30405,
                "question_id":12074,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:06.829Z",
                "updated_at":"2022-01-10T23:24:06.829Z",
                "text":"Która z poniższych odpowiedzi jest najlepsza? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30404,
                "question_id":12074,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:06.824Z",
                "updated_at":"2022-01-10T23:24:06.824Z",
                "text":"다음 중 가장 좋은 답변은 무엇일까요? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30403,
                "question_id":12074,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:06.819Z",
                "updated_at":"2022-01-10T23:24:06.819Z",
                "text":"次のうち、最善の対応はどれでしょうか？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30402,
                "question_id":12074,
                "locale":"it",
                "created_at":"2022-01-10T23:24:06.814Z",
                "updated_at":"2022-01-10T23:24:06.814Z",
                "text":"Quale delle seguenti è la migliore risposta? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30401,
                "question_id":12074,
                "locale":"de",
                "created_at":"2022-01-10T23:24:06.809Z",
                "updated_at":"2022-01-10T23:24:06.809Z",
                "text":"Welche der folgenden Antworten eignet sich am besten? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30400,
                "question_id":12074,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:06.804Z",
                "updated_at":"2022-01-10T23:24:06.804Z",
                "text":"Laquelle des réponses suivantes est la meilleure réponse? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30399,
                "question_id":12074,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:06.799Z",
                "updated_at":"2022-01-10T23:24:06.799Z",
                "text":"Parmi les réponses suivantes, quelle est la meilleure ? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30398,
                "question_id":12074,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:06.795Z",
                "updated_at":"2022-01-10T23:24:06.795Z",
                "text":"Qual das alternativas a seguir é a melhor resposta? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30397,
                "question_id":12074,
                "locale":"es",
                "created_at":"2022-01-10T23:24:06.790Z",
                "updated_at":"2022-01-10T23:24:06.790Z",
                "text":"¿Cuál de las siguientes es la mejor respuesta? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30396,
                "question_id":12074,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:06.785Z",
                "updated_at":"2022-01-10T23:24:06.785Z",
                "text":"Alin sa sumusunod ang pinakamahusay na tugon? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30395,
                "question_id":12074,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:06.780Z",
                "updated_at":"2022-01-10T23:24:06.780Z",
                "text":"下列何者是最好的回應？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30394,
                "question_id":12074,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:06.775Z",
                "updated_at":"2022-01-10T23:24:06.775Z",
                "text":"以下哪一项是最佳答案？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30393,
                "question_id":12074,
                "locale":"en",
                "created_at":"2022-01-10T23:24:06.663Z",
                "updated_at":"2022-01-10T23:24:06.663Z",
                "text":"Which of the following is the best reply? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30377,
                "position":1,
                "active":true,
                "question_id":12074,
                "created_at":"2022-01-10T23:24:06.850Z",
                "updated_at":"2022-01-10T23:24:06.850Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“In order to respond to this situation appropriately, I would have to know more about what happened.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73291,
                      "answer_id":30377,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:06.940Z",
                      "updated_at":"2022-01-10T23:24:06.940Z",
                      "text":"\"Bu duruma uygun şekilde yanıt verebilmek için, ne olduğu hakkında daha fazla bilgi sahibi olmam gerekiyor.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73290,
                      "answer_id":30377,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:06.935Z",
                      "updated_at":"2022-01-10T23:24:06.935Z",
                      "text":"\"Para responder a esta situación de manera adecuada, necesitaría más información sobre lo que sucedió\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73289,
                      "answer_id":30377,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:06.930Z",
                      "updated_at":"2022-01-10T23:24:06.930Z",
                      "text":"«Для того, чтобы принять в отношении этой ситуации адекватные меры, я бы хотел подробнее узнать о том, что произошло».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73288,
                      "answer_id":30377,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:06.925Z",
                      "updated_at":"2022-01-10T23:24:06.925Z",
                      "text":"„Aby odpowiednio zareagować na tę sytuację, musiałbym dowiedzieć więcej o tym, co się stało”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73287,
                      "answer_id":30377,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:06.920Z",
                      "updated_at":"2022-01-10T23:24:06.920Z",
                      "text":"\"이 상황에 적절하게 대응하려면 무슨 일이 있었는지 더 자세히 알아야 해요.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73286,
                      "answer_id":30377,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:06.916Z",
                      "updated_at":"2022-01-10T23:24:06.916Z",
                      "text":"「この状況に適切に対応するために、何が起こったのかをより詳細に知る必要があります。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73285,
                      "answer_id":30377,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:06.911Z",
                      "updated_at":"2022-01-10T23:24:06.911Z",
                      "text":"“Per rispondere a questa situazione in modo appropriato, dovrei conoscere maggiori dettagli di quanto è accaduto”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73284,
                      "answer_id":30377,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:06.906Z",
                      "updated_at":"2022-01-10T23:24:06.906Z",
                      "text":"„Um angemessen auf die Situation reagieren zu können, müsste ich mehr dazu erfahren, was passiert ist.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73283,
                      "answer_id":30377,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:06.901Z",
                      "updated_at":"2022-01-10T23:24:06.901Z",
                      "text":"« Afin de réagir de manière appropriée à cette situation, je devrais en savoir plus sur ce qui s'est passé. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73282,
                      "answer_id":30377,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:06.893Z",
                      "updated_at":"2022-01-10T23:24:06.893Z",
                      "text":"« Pour pouvoir apporter une réponse appropriée à cette situation, je dois en savoir plus sur ce qui s’est passé. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73281,
                      "answer_id":30377,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:06.888Z",
                      "updated_at":"2022-01-10T23:24:06.888Z",
                      "text":"“Para responder a essa situação de forma adequada, eu teria que saber mais sobre o que aconteceu.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73280,
                      "answer_id":30377,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:06.883Z",
                      "updated_at":"2022-01-10T23:24:06.883Z",
                      "text":"“我了妥善处理该情况，我需要详细知道发生了什么事情。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73279,
                      "answer_id":30377,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:06.878Z",
                      "updated_at":"2022-01-10T23:24:06.878Z",
                      "text":"“A fin de responder a esta situación correctamente, necesito más información sobre lo sucedido”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73278,
                      "answer_id":30377,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:06.874Z",
                      "updated_at":"2022-01-10T23:24:06.874Z",
                      "text":"“Upang naaangkop na tugunan ang sitwasyong ito, kakailanganin kong alamin ang tungkol sa nangyari.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73277,
                      "answer_id":30377,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:06.869Z",
                      "updated_at":"2022-01-10T23:24:06.869Z",
                      "text":"「為了能適當地回應這個情況，我必須瞭解更多關於這件事情的始末。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73276,
                      "answer_id":30377,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:06.865Z",
                      "updated_at":"2022-01-10T23:24:06.865Z",
                      "text":"“In order to respond to this situation appropriately, I would have to know more about what happened.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30378,
                "position":2,
                "active":true,
                "question_id":12074,
                "created_at":"2022-01-10T23:24:06.946Z",
                "updated_at":"2022-01-10T23:24:06.946Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"\"Confidential resources are available to explain your options, and if you decide to report the incident, the school’s Title IX Coordinator can provide supportive measures to you.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73307,
                      "answer_id":30378,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:07.034Z",
                      "updated_at":"2022-01-10T23:24:07.034Z",
                      "text":"\"Seçeneklerini anlatan gizli kaynaklar mevcut ve bu olayı bildirmek istemen halinde, okulun Başlık IX Koordinatörü bu konuda destekleyici önlemler sağlayabilir.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73306,
                      "answer_id":30378,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:07.029Z",
                      "updated_at":"2022-01-10T23:24:07.029Z",
                      "text":"\"Hay recursos confidenciales disponibles para que expliques tus opciones. Si decides denunciar el incidente, el coordinador del Título IX del centro puede ofrecerte medidas de apoyo\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73305,
                      "answer_id":30378,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:07.024Z",
                      "updated_at":"2022-01-10T23:24:07.024Z",
                      "text":"«Чтобы узнать о возможных дальнейших шагах, вы можете использовать конфиденциальные ресурсы, и если вы решите подать жалобу о происшествии, то ответственный за исполнение Раздела IX в школе предоставит вам необходимую поддержку».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73304,
                      "answer_id":30378,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:07.019Z",
                      "updated_at":"2022-01-10T23:24:07.019Z",
                      "text":"„Dostępne są poufne osoby kontaktowe, które przedstawią Pani możliwe rozwiązania, a jeśli zdecyduje się Pani zgłosić incydent, szkolny koordynator ds. tytułu IX może zapewnić Pani środki wsparcia”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73303,
                      "answer_id":30378,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:07.014Z",
                      "updated_at":"2022-01-10T23:24:07.014Z",
                      "text":"\"기밀 리소스를 통해 선택 가능한 옵션을 알려드릴 수 있고, 사건을 신고하기로 결정한다면, 학교의 제9편 관련 법률 담당자가 지원 조치를 제공할 수 있어요.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73302,
                      "answer_id":30378,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:07.009Z",
                      "updated_at":"2022-01-10T23:24:07.009Z",
                      "text":"「ご自身の今後の選択肢を説明する機密リソースが利用可能です。この出来事を報告することを決めた場合、学校の第九編コーディネーターが、あなたのための支援策を提供してくれます。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73301,
                      "answer_id":30378,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:07.004Z",
                      "updated_at":"2022-01-10T23:24:07.004Z",
                      "text":"“Sono disponibili risorse riservate per spiegare le tue opzioni e, se decidi di segnalare l’incidente, il coordinatore del Titolo IX della scuola può fornirti misure di supporto”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73300,
                      "answer_id":30378,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:06.999Z",
                      "updated_at":"2022-01-10T23:24:06.999Z",
                      "text":"„Es gibt vertrauenswürdige Ressourcen, die dir deine Optionen erklären können. Wenn du dann entscheidest, den Vorfall zu melden, unterstützt dich der Titel IX-Verantwortliche dabei.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73299,
                      "answer_id":30378,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:06.994Z",
                      "updated_at":"2022-01-10T23:24:06.994Z",
                      "text":"« Des ressources confidentielles sont disponibles pour expliquer vos options, et si vous décidez de signaler l'incident, le coordonnateur du titre IX de l'école peut vous fournir des mesures de soutien. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73298,
                      "answer_id":30378,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:06.989Z",
                      "updated_at":"2022-01-10T23:24:06.989Z",
                      "text":"« Des ressources confidentielles sont disponibles pour vous expliquer vos options, et si vous décidez de signaler l’incident, le coordinateur du Titre IX de l’école peut vous proposer des mesures de soutien. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73297,
                      "answer_id":30378,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:06.984Z",
                      "updated_at":"2022-01-10T23:24:06.984Z",
                      "text":"「機密資源能跟你解釋你的選項，如果你決定通報事件，學校的第九編協調員能提供扶助措施給你。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73296,
                      "answer_id":30378,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:06.979Z",
                      "updated_at":"2022-01-10T23:24:06.979Z",
                      "text":"“一些机密资源可以解释你拥有的选择，如果你决定举报该事件，学校的第九修正案协调员可以为你提供支持性措施。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73295,
                      "answer_id":30378,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:06.974Z",
                      "updated_at":"2022-01-10T23:24:06.974Z",
                      "text":"\"Recursos confidenciais estão disponíveis para explicar suas opções. Se você optar por denunciar o incidente, o Coordenador da Título IX da escola poderá fornecer medidas de apoio para você.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73294,
                      "answer_id":30378,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:06.970Z",
                      "updated_at":"2022-01-10T23:24:06.970Z",
                      "text":"\"Ang mga kumpidensyal na mapagkukunan ay available upang ipaliwanag ang mga opsyon mo, at kung nagpasya kang ireport ang insidente, ang Title IX Coordinator ay maaaring maglaan ng pansuportang mga pamamaraan sa iyo.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73293,
                      "answer_id":30378,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:06.965Z",
                      "updated_at":"2022-01-10T23:24:06.965Z",
                      "text":"“Hay recursos confidenciales disponibles para explicar tus opciones y, si decides denunciar el incidente, el coordinador del título IX de la escuela puede brindarte medidas de apoyo”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73292,
                      "answer_id":30378,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:06.960Z",
                      "updated_at":"2022-01-10T23:24:06.960Z",
                      "text":"\"Confidential resources are available to explain your options, and if you decide to report the incident, the school’s Title IX Coordinator can provide supportive measures to you.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30379,
                "position":3,
                "active":true,
                "question_id":12074,
                "created_at":"2022-01-10T23:24:07.040Z",
                "updated_at":"2022-01-10T23:24:07.040Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"“As you clearly did not intend to report this, I will forget we ever had this conversation.”",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73323,
                      "answer_id":30379,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:07.125Z",
                      "updated_at":"2022-01-10T23:24:07.125Z",
                      "text":"\"Açıkça bu olayı bildirmek istemediğin için bu konuşmayı yapmadık varsayacağım.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73322,
                      "answer_id":30379,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:07.120Z",
                      "updated_at":"2022-01-10T23:24:07.120Z",
                      "text":"\"Como está claro que no tenías intención de denunciar esto, olvidaré que tuvimos esta conversación\".",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73321,
                      "answer_id":30379,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:07.115Z",
                      "updated_at":"2022-01-10T23:24:07.115Z",
                      "text":"«Так как вы явно не собирались подавать жалобу об этом, будем считать, что этого разговора не было».",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73320,
                      "answer_id":30379,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:07.110Z",
                      "updated_at":"2022-01-10T23:24:07.110Z",
                      "text":"„Ponieważ najwyraźniej nie zamierzała Pani tego zgłosić, zapomnę, że kiedykolwiek odbyliśmy tę rozmowę”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73319,
                      "answer_id":30379,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:07.105Z",
                      "updated_at":"2022-01-10T23:24:07.105Z",
                      "text":"\"신고하려는 분명한 의도를 알리지 않으셨기 때문에, 지금 나눈 대화는 없었던 것으로 하겠습니다.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73318,
                      "answer_id":30379,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:07.100Z",
                      "updated_at":"2022-01-10T23:24:07.100Z",
                      "text":"「明らかに報告される意思はないようですので、ここでの会話はなかったものとさせていただきます。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73317,
                      "answer_id":30379,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:07.096Z",
                      "updated_at":"2022-01-10T23:24:07.096Z",
                      "text":"“Poiché chiaramente non intendevi segnalare questa situazione, dimenticherò di aver avuto questa conversazione”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73316,
                      "answer_id":30379,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:07.091Z",
                      "updated_at":"2022-01-10T23:24:07.091Z",
                      "text":"„Da du klar gemacht hast, dass du den Vorfall nicht melden willst, hat es dieses Gespräch für mich nie gegeben.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73315,
                      "answer_id":30379,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:07.086Z",
                      "updated_at":"2022-01-10T23:24:07.086Z",
                      "text":"« Comme vous n'aviez clairement pas l'intention de signaler cela, j'oublierai que nous avons déjà eu cette conversation. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73314,
                      "answer_id":30379,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:07.081Z",
                      "updated_at":"2022-01-10T23:24:07.081Z",
                      "text":"« Comme vous n’aviez clairement pas l’intention de le signaler, j’oublierai que nous avons eu cette conversation. »",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73313,
                      "answer_id":30379,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:07.077Z",
                      "updated_at":"2022-01-10T23:24:07.077Z",
                      "text":"「顯見你沒有通報這件事的意圖，我會忘記我們有過這個對話。」",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73312,
                      "answer_id":30379,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:07.072Z",
                      "updated_at":"2022-01-10T23:24:07.072Z",
                      "text":"“由于很明显你不打算对这件事情进行举报，我不记得我们曾经有过此次交谈。”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73311,
                      "answer_id":30379,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:07.067Z",
                      "updated_at":"2022-01-10T23:24:07.067Z",
                      "text":"\"Como você claramente não pretendia relatar isso, vou esquecer que já tivemos essa conversa.\"",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73310,
                      "answer_id":30379,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:07.062Z",
                      "updated_at":"2022-01-10T23:24:07.062Z",
                      "text":"“Dahil malinaw mong hindi layunin na ito ay ireport, kakalimutan ko na nagkaroon tayo ng ganitong usapan.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73309,
                      "answer_id":30379,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:07.057Z",
                      "updated_at":"2022-01-10T23:24:07.057Z",
                      "text":"“Como claramente no tenías la intención de denunciarlo, olvidaré que alguna vez tuvimos esta conversación”.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73308,
                      "answer_id":30379,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:07.053Z",
                      "updated_at":"2022-01-10T23:24:07.053Z",
                      "text":"“As you clearly did not intend to report this, I will forget we ever had this conversation.”",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12075,
          "shuffle":false,
          "position":50,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30382"
          ],
          "created_at":"2022-01-10T23:24:07.143Z",
          "updated_at":"2022-01-10T23:24:07.646Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":50,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"What else, if anything, should he add to his email?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30424,
                "question_id":12075,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:07.355Z",
                "updated_at":"2022-01-10T23:24:07.355Z",
                "text":"Bu e-postaya başka ne eklemeli?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30423,
                "question_id":12075,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:07.350Z",
                "updated_at":"2022-01-10T23:24:07.350Z",
                "text":"¿Qué más debería añadir el Dr. Lutz a su correo electrónico (si corresponde)?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30422,
                "question_id":12075,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:07.345Z",
                "updated_at":"2022-01-10T23:24:07.345Z",
                "text":"Что еще ему следует добавить к своему письму?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30421,
                "question_id":12075,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:07.340Z",
                "updated_at":"2022-01-10T23:24:07.340Z",
                "text":"Co jeszcze ewentualnie powinien dodać do swojego maila?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30420,
                "question_id":12075,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:07.335Z",
                "updated_at":"2022-01-10T23:24:07.335Z",
                "text":"그는 그 밖에 무엇을 이메일에 추가해야 할까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30419,
                "question_id":12075,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:07.331Z",
                "updated_at":"2022-01-10T23:24:07.331Z",
                "text":"このメールに、他に何を追加すべきでしょうか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30418,
                "question_id":12075,
                "locale":"it",
                "created_at":"2022-01-10T23:24:07.326Z",
                "updated_at":"2022-01-10T23:24:07.326Z",
                "text":"Quali altri elementi, se presenti, dovrebbe aggiungere alla sua e-mail?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30417,
                "question_id":12075,
                "locale":"de",
                "created_at":"2022-01-10T23:24:07.321Z",
                "updated_at":"2022-01-10T23:24:07.321Z",
                "text":"Was, wenn überhaupt etwas, könnte er der E-Mail hinzufügen?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30416,
                "question_id":12075,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:07.316Z",
                "updated_at":"2022-01-10T23:24:07.316Z",
                "text":"Que devrait-il ajouter d'autre, le cas échéant, à son e-mail?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30415,
                "question_id":12075,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:07.310Z",
                "updated_at":"2022-01-10T23:24:07.310Z",
                "text":"Que devrait-il, le cas échéant, ajouter à son e-mail ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30414,
                "question_id":12075,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:07.305Z",
                "updated_at":"2022-01-10T23:24:07.305Z",
                "text":"O que mais, se houver alguma coisa, ele deve adicionar ao e-mail?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30413,
                "question_id":12075,
                "locale":"es",
                "created_at":"2022-01-10T23:24:07.295Z",
                "updated_at":"2022-01-10T23:24:07.295Z",
                "text":"¿Qué otra cosa, si corresponde, debería agregar a su correo electrónico?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30412,
                "question_id":12075,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:07.290Z",
                "updated_at":"2022-01-10T23:24:07.290Z",
                "text":"Ano pa, kung mayroon man ang dapat niyang idagdag sa kanyang email?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30411,
                "question_id":12075,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:07.285Z",
                "updated_at":"2022-01-10T23:24:07.285Z",
                "text":"還有甚麼他可以加入這封電子郵件的？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30410,
                "question_id":12075,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:07.278Z",
                "updated_at":"2022-01-10T23:24:07.278Z",
                "text":"他的电子邮件中还应增加什么内容（如有）？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30409,
                "question_id":12075,
                "locale":"en",
                "created_at":"2022-01-10T23:24:07.161Z",
                "updated_at":"2022-01-10T23:24:07.161Z",
                "text":"What else, if anything, should he add to his email?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30380,
                "position":1,
                "active":true,
                "question_id":12075,
                "created_at":"2022-01-10T23:24:07.361Z",
                "updated_at":"2022-01-10T23:24:07.361Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Dr. Lutz should tell the Title IX coordinator both what happened and his impressions of the situation: Dear Hilo, This is Alan Lutz from the Anthropology Department. One of my students inadvertently told me about an unreported incident. Knowing this student, I think that she…",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73339,
                      "answer_id":30380,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:07.449Z",
                      "updated_at":"2022-01-10T23:24:07.449Z",
                      "text":"Dr. Lutz, Başlık IX koordinatörüne hem olanları hem de durumla ilgili izlenimlerini anlatmalıdır: Sevgili Hilo, Ben Antropoloji Bölümünden Alan Lutz. Öğrencilerimden biri istemeden bana bildirilmemiş bir olaydan bahsetti. Bu öğrenciyi tanıdığım için, sanırım o…",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73338,
                      "answer_id":30380,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:07.444Z",
                      "updated_at":"2022-01-10T23:24:07.444Z",
                      "text":"El Dr. Lutz debe contarle al coordinador del Título IX lo que sucedió y sus impresiones de la situación: Estimado Hilo, soy Alan Lutz del Departamento de Antropología. Una de mis estudiantes me contó inadvertidamente un incidente no denunciado. Teniendo en cuenta cómo es esta estudiante, creo que...",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73337,
                      "answer_id":30380,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:07.439Z",
                      "updated_at":"2022-01-10T23:24:07.439Z",
                      "text":"Доктор Лутц должен сообщить ответственному за исполнение Раздела IX о том, что произошло, и о своих впечатлениях от этой ситуации. «Уважаемый Хайло, это Алан Лутц с кафедры антропологии. Одна из моих студенток случайно рассказала мне о ранее неизвестном происшествии. Зная эту студентку, я думаю, что она...»",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73336,
                      "answer_id":30380,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:07.434Z",
                      "updated_at":"2022-01-10T23:24:07.434Z",
                      "text":"Dr Lutz powinien powiedzieć koordynatorowi ds. tytułu IX zarówno o tym, co się stało, jak i o swoich wrażeniach z tej sytuacji: Szanowny Panie Hilo, tu Alan Lutz z Wydziału Antropologii. Jedna z moich studentek niechcący opowiedziała mi o niezgłoszonym incydencie. Znając tę studentkę, myślę, że ona...",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73335,
                      "answer_id":30380,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:07.429Z",
                      "updated_at":"2022-01-10T23:24:07.429Z",
                      "text":"Lutz 박사는 발생한 상황과 그 상황에 대한 자신의 생각을 제9편 관련 법률 담당자에게 알려야 한다. 친애하는 Hilo씨에게, 저는 인류학 부서의 Alan Lutz입니다. 저는 학생 중 한 명으로부터 아직 신고되지 않은 사건에 대해 우연히 알게 되었습니다. 저는 이 학생을 잘 알고 있고, 제 생각에는 그녀가...",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73334,
                      "answer_id":30380,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:07.424Z",
                      "updated_at":"2022-01-10T23:24:07.424Z",
                      "text":"Dr. Lutzは、第九編コーディネーターに、実際に何が起こったのかと、その状況に対する自身の見解を伝えるべきである。Hiloさん、人類学科のAlan Lutzです。ある学生がうっかり、報告されていない出来事について話してきました。この学生について知っているのですが、彼女は…だと考えます。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73333,
                      "answer_id":30380,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:07.420Z",
                      "updated_at":"2022-01-10T23:24:07.420Z",
                      "text":"Il dott. Lutz dovrebbe descrivere al coordinatore del Titolo IX sia la situazione che si è verificata sia le sue impressioni: Caro Hilo, sono Alan Lutz del dipartimento di antropologia. Una delle mie studentesse mi ha involontariamente raccontato di un incidente non segnalato. Conoscendo questa studentessa, penso che...",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73332,
                      "answer_id":30380,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:07.413Z",
                      "updated_at":"2022-01-10T23:24:07.413Z",
                      "text":"Dr. Lutz sollte der Titel IX-Verantwortlichen schildern, was passiert ist, und ihr seinen Eindruck von der Situation vermitteln: Liebe Hilo, ich bin Alan Lutz vom Fachbereich Anthropologie. Eine meiner Studentinnen hat mir unbeabsichtigt von einem Vorfall erzählt, der nicht gemeldet wurde. So wie ich die Studentin kenne, hat sie....",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73331,
                      "answer_id":30380,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:07.408Z",
                      "updated_at":"2022-01-10T23:24:07.408Z",
                      "text":"Le Dr Lutz devrait dire au coordinateur du Title IX ce qui s'est passé et ses impressions sur la situation: Cher Hilo, Voici Alan Lutz du département d'anthropologie. Une de mes élèves m'a parlé par inadvertance d'un incident non signalé. Connaissant cette élève, je pense qu'elle…",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73330,
                      "answer_id":30380,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:07.403Z",
                      "updated_at":"2022-01-10T23:24:07.403Z",
                      "text":"Le Dr Lutz devrait expliquer au coordinateur du Titre IX ce qui s’est passé et ce qu’il pense de la situation : « Cher Hilo, je suis Alan Lutz, du département d’anthropologie. L’une de mes étudiantes m’a parlé par inadvertance d’un incident non signalé. Connaissant cette étudiante, je pense qu’elle...",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73329,
                      "answer_id":30380,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:07.398Z",
                      "updated_at":"2022-01-10T23:24:07.398Z",
                      "text":"O Dr. Lutz deve contar ao coordenador da Título IX o que aconteceu e suas impressões sobre a situação: Caro Hilo, aqui é Alan Lutz, do Departamento de Antropologia. Uma das minhas alunas inadvertidamente me contou sobre um incidente não relatado. Conhecendo essa aluna, acho que ela...",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73328,
                      "answer_id":30380,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:07.394Z",
                      "updated_at":"2022-01-10T23:24:07.394Z",
                      "text":"Lutz 教授應該告訴第九編協調員事情發生的始末，以及他對該情況的印象：親愛的 Hilo，我是人類學系的 Alan Lutz。我的一名學生無意中告訴我一起未通報事件。基於我對這位學生的瞭解，我認為她…",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73327,
                      "answer_id":30380,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:07.388Z",
                      "updated_at":"2022-01-10T23:24:07.388Z",
                      "text":"El Dr. Lutz debe informar al coordinador del Título IX lo que sucedió y sus impresiones de la situación: Estimado Hilo: Soy Alan Lutz del Departamento de Antropología. Una de mis estudiantes inadvertidamente mencionó un incidente no denunciado. Conociendo a esta estudiante, creo que ella…",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73326,
                      "answer_id":30380,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:07.384Z",
                      "updated_at":"2022-01-10T23:24:07.384Z",
                      "text":"Dapat sabihin ni Dr. Lutz sa Title IX coordinator ang nangyari at ang kanyang pananaw sa sitwasyon: Mahal na Hilo, Ako si Alan Lutz mula sa Anthropology Department. Ang isa sa aking mga mag-aaral sa na hindi sinasadya ay nagsabi sa akin tungkol sa isang hindi nareport na insidente. Dahil kilala ko ang estudyanten ito, sa tingin ko siya ay...",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73325,
                      "answer_id":30380,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:07.379Z",
                      "updated_at":"2022-01-10T23:24:07.379Z",
                      "text":"Lutz 博士应将发生的事情及他自己对该情况的印象都告诉第九修正案协调员：尊敬的 Hilo，我是人类学系的 Alan Lutz。我的一名学生无意中告诉我一起发生的未举报的事件。我了解这名学生，我认为她…",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73324,
                      "answer_id":30380,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:07.375Z",
                      "updated_at":"2022-01-10T23:24:07.375Z",
                      "text":"Dr. Lutz should tell the Title IX coordinator both what happened and his impressions of the situation: Dear Hilo, This is Alan Lutz from the Anthropology Department. One of my students inadvertently told me about an unreported incident. Knowing this student, I think that she…",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30381,
                "position":2,
                "active":true,
                "question_id":12075,
                "created_at":"2022-01-10T23:24:07.455Z",
                "updated_at":"2022-01-10T23:24:07.455Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Dr. Lutz should tell the Title IX coordinator that an incident occurred, but protect Mei’s identity to the greatest extent possible: Dear Hilo, This is Alan Lutz from the Anthropology Department. One of my students inadvertently told me about an unreported incident. That is all I can disclose without violating the student’s trust… ",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73355,
                      "answer_id":30381,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:07.539Z",
                      "updated_at":"2022-01-10T23:24:07.539Z",
                      "text":"Dr. Lutz, Başlık IX koordinatörüne bir olayın meydana geldiğini söylemeli, ancak olabildiğince Mei'nin kimliğini gizli tutmalıdır: Sevgili Hilo, Ben Antropoloji Bölümünden Alan Lutz. Öğrencilerimden biri istemeden bana bildirilmemiş bir olaydan bahsetti. Öğrencinin güvenini ihlal etmek istemediğim için söyleyebileceğim tek şey bu… ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73354,
                      "answer_id":30381,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:07.534Z",
                      "updated_at":"2022-01-10T23:24:07.534Z",
                      "text":"El Dr. Lutz debe indicarle al coordinador del Título IX que ocurrió un incidente, pero proteger la identidad de Mei en la mayor medida posible: Estimado Hilo, soy Alan Lutz del Departamento de Antropología. Una de mis estudiantes me contó inadvertidamente un incidente no denunciado. Eso es todo lo que puedo contar sin traicionar la confianza de la estudiante... ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73353,
                      "answer_id":30381,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:07.529Z",
                      "updated_at":"2022-01-10T23:24:07.529Z",
                      "text":"Доктор Лутц должен сообщить ответственному за исполнение Раздела IX о происшествии, но обеспечить максимальную анонимность Мэй: «Уважаемый Хайло, это Алан Лутц с кафедры антропологии. Одна из моих студенток случайно рассказала мне о ранее неизвестном происшествии. Это все, что я могу вам сообщить, не нарушая оказанное мне доверие...» ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73352,
                      "answer_id":30381,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:07.525Z",
                      "updated_at":"2022-01-10T23:24:07.525Z",
                      "text":"Dr Lutz powinien poinformować koordynatora ds. tytułu IX, że doszło do incydentu, ale powinien w jak największym stopniu chronić tożsamość Mei: Szanowny Panie Hilo, tu Alan Lutz z Wydziału Antropologii. Jedna z moich studentek niechcący opowiedziała mi o niezgłoszonym incydencie. To wszystko, co mogę ujawnić, nie naruszając zaufania studentki. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73351,
                      "answer_id":30381,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:07.520Z",
                      "updated_at":"2022-01-10T23:24:07.520Z",
                      "text":"Lutz 박사는 제9편 관련 법률 담당자에게 발생한 사건을 알려야 하지만 Mei의 신원을 최대한 보호해야 한다. 친애하는 Hilo씨에게, 저는 인류학 부서의 Alan Lutz입니다. 저는 학생 중 한 명으로부터 아직 신고되지 않은 사건에 대해 우연히 알게 되었습니다. 학생의 신원을 보호하면서 제가 알릴 수 있는 내용은 이것이 전부입니다... ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73350,
                      "answer_id":30381,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:07.515Z",
                      "updated_at":"2022-01-10T23:24:07.515Z",
                      "text":"Dr. Lutzは、第九編コーディネーターにある出来事が起こったことを伝えるが、Meiさんの身元を最大限保護出来る方法を取る。Hiloさん、人類学科のAlan Lutzです。ある学生がうっかり、報告されていない出来事について話してきました。学生の信用を侵害せずに開示できる情報は以上です。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73349,
                      "answer_id":30381,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:07.510Z",
                      "updated_at":"2022-01-10T23:24:07.510Z",
                      "text":"Il dott. Lutz dovrebbe informare il coordinatore del Titolo IX che si è verificato un incidente, ma proteggere l’identità di Mei nella massima misura possibile: Caro Hilo, sono Alan Lutz del dipartimento di antropologia. Una delle mie studentesse mi ha involontariamente raccontato di un incidente non segnalato. Questo è tutto quello che posso rivelare senza violare la fiducia della studentessa... ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73348,
                      "answer_id":30381,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:07.505Z",
                      "updated_at":"2022-01-10T23:24:07.505Z",
                      "text":"Dr. Lutz sollte der Titel IX-Verantwortlichen schildern, dass sich ein Vorfall ereignet hat, Meis Identität aber so weit es geht schützen: Liebe Hilo, ich bin Alan Lutz vom Fachbereich Anthropologie. Eine meiner Studentinnen hat mir unbeabsichtigt von einem Vorfall erzählt, der nicht gemeldet wurde. Mehr kann ich nicht preisgeben, um das Vertrauen der Studentin nicht zu missbrauchen... ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73347,
                      "answer_id":30381,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:07.501Z",
                      "updated_at":"2022-01-10T23:24:07.501Z",
                      "text":"Le Dr Lutz devrait informer le coordinateur du Title IX qu'un incident s'est produit, mais protéger l'identité de Mei dans la mesure du possible: Cher Hilo, Voici Alan Lutz du département d'anthropologie. Une de mes élèves m'a parlé par inadvertance d'un incident non signalé. C'est tout ce que je peux divulguer sans rompre la confiance de l'élève… ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73346,
                      "answer_id":30381,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:07.496Z",
                      "updated_at":"2022-01-10T23:24:07.496Z",
                      "text":"Le Dr Lutz doit informer le coordinateur du Titre IX qu’un incident s’est produit, mais protéger autant que possible l’identité de Mei : « Cher Hilo, je suis Alan Lutz, du département d’anthropologie. L’une de mes étudiantes m’a parlé par inadvertance d’un incident non signalé. Voilà tout ce que je peux divulguer sans trahir la confiance de l’élève… ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73345,
                      "answer_id":30381,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:07.491Z",
                      "updated_at":"2022-01-10T23:24:07.491Z",
                      "text":"O Dr. Lutz deve informar ao coordenador da Título IX que ocorreu um incidente, mas proteger a identidade da Mei o máximo possível: Caro Hilo, aqui é Alan Lutz, do Departamento de Antropologia. Uma das minhas alunas inadvertidamente me contou sobre um incidente não relatado. Isso é tudo que posso divulgar sem violar a confiança da aluna... ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73344,
                      "answer_id":30381,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:07.486Z",
                      "updated_at":"2022-01-10T23:24:07.486Z",
                      "text":"Lutz 教授應該告訴第九編協調員發生一起事件，並竭盡可能保護 Mei 的身分：親愛的 Hilo，我是人類學系的 Alan Lutz。我的一名學生無意中告訴我一起未通報事件。以下是我在不違反學生信任的前提下可以揭露的資訊… ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73343,
                      "answer_id":30381,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:07.481Z",
                      "updated_at":"2022-01-10T23:24:07.481Z",
                      "text":"Lutz 博士应当告诉第九修正案协调员发生的事件，但应尽最大可能保护 Mei 的身份：尊敬的 Hilo，我是人类学系的 Alan Lutz。我的一名学生无意中告诉我一起发生的未举报的事件。为了不辜负该学生的信任，我只能披露这些…… ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73342,
                      "answer_id":30381,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:07.476Z",
                      "updated_at":"2022-01-10T23:24:07.476Z",
                      "text":"Dapat sabihin ni Dr. Lutz Title IX coordinator ang insidenteng nangyari, pero dapat protektahan ang pagkakakilanlan ni Mei hangga't maari: Mahal na Hilo, Ako si Alan Lutz mula sa Anthropology Department. Ang isa sa aking mga mag-aaral sa na hindi sinasadya ay nagsabi sa akin tungkol sa isang hindi nareport na insidente. Iyon lang ang maaari kong ibunyag nang hindi lumalabag sa tiwala ng mag-aaral ... ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73341,
                      "answer_id":30381,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:07.472Z",
                      "updated_at":"2022-01-10T23:24:07.472Z",
                      "text":"El Dr. Lutz debe informar al coordinador del Título IX que ocurrió un incidente, pero proteger la identidad de Mei en la mayor medida posible: Estimado Hilo: Soy Alan Lutz del Departamento de Antropología. Una de mis estudiantes inadvertidamente mencionó un incidente no denunciado. Es todo lo que puedo divulgar sin infringir la confianza de la estudiante… ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73340,
                      "answer_id":30381,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:07.468Z",
                      "updated_at":"2022-01-10T23:24:07.468Z",
                      "text":"Dr. Lutz should tell the Title IX coordinator that an incident occurred, but protect Mei’s identity to the greatest extent possible: Dear Hilo, This is Alan Lutz from the Anthropology Department. One of my students inadvertently told me about an unreported incident. That is all I can disclose without violating the student’s trust… ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30382,
                "position":3,
                "active":true,
                "question_id":12075,
                "created_at":"2022-01-10T23:24:07.545Z",
                "updated_at":"2022-01-10T23:24:07.545Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Dr. Lutz doesn’t need to add anything unless required to do so under the school's policies.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73371,
                      "answer_id":30382,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:07.642Z",
                      "updated_at":"2022-01-10T23:24:07.642Z",
                      "text":"Dr. Lutz'un, okul politikaları uyarınca zorunlu olmadığı sürece başka bir şey söylemesine gerek yoktur.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73370,
                      "answer_id":30382,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:07.637Z",
                      "updated_at":"2022-01-10T23:24:07.637Z",
                      "text":"El Dr. Lutz no necesita añadir nada a menos que lo requieran las políticas del centro.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73369,
                      "answer_id":30382,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:07.632Z",
                      "updated_at":"2022-01-10T23:24:07.632Z",
                      "text":"Доктору Лутцу не нужно ничего добавлять, если иное не сказано в школьной политике.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73368,
                      "answer_id":30382,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:07.627Z",
                      "updated_at":"2022-01-10T23:24:07.627Z",
                      "text":"Dr Lutz nie musi nic dodawać, chyba że wymaga tego polityka uczelni.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73367,
                      "answer_id":30382,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:07.619Z",
                      "updated_at":"2022-01-10T23:24:07.619Z",
                      "text":"Lutz 박사는 학교 정책에 따라 필요한 경우가 아니면 아무것도 추가할 필요가 없다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73366,
                      "answer_id":30382,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:07.614Z",
                      "updated_at":"2022-01-10T23:24:07.614Z",
                      "text":"Dr. Lutzは、学校のポリシーにより必要とされていない限り、これ以上何かを追加する必要はない。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73365,
                      "answer_id":30382,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:07.609Z",
                      "updated_at":"2022-01-10T23:24:07.609Z",
                      "text":"Il dott. Lutz non ha bisogno di aggiungere nessun’altra informazione a meno che non sia richiesto dalle politiche della scuola.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73364,
                      "answer_id":30382,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:07.604Z",
                      "updated_at":"2022-01-10T23:24:07.604Z",
                      "text":"Dr. Lutz braucht nichts zu unternehmen, solange er laut den Richtlinien der Hochschule nicht dazu verpflichtet ist.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73363,
                      "answer_id":30382,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:07.599Z",
                      "updated_at":"2022-01-10T23:24:07.599Z",
                      "text":"Le Dr. Lutz n'a pas besoin d'ajouter quoi que ce soit, sauf si les politiques de l'école l'exigent.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73362,
                      "answer_id":30382,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:07.595Z",
                      "updated_at":"2022-01-10T23:24:07.595Z",
                      "text":"Le Dr Lutz n’a pas besoin d’ajouter quoi que ce soit, sauf s’il est tenu de le faire en vertu des politiques de l’école.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73361,
                      "answer_id":30382,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:07.590Z",
                      "updated_at":"2022-01-10T23:24:07.590Z",
                      "text":"Lutz 教授除非因學校政策要求，否則不需要再補充任何事情。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73360,
                      "answer_id":30382,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:07.585Z",
                      "updated_at":"2022-01-10T23:24:07.585Z",
                      "text":"Lutz 博士不需要增加任何东西，除非根据学校的政策需要这么做。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73359,
                      "answer_id":30382,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:07.580Z",
                      "updated_at":"2022-01-10T23:24:07.580Z",
                      "text":"Dr. Lutz não precisa acrescentar nada, a menos que seja exigido pelas políticas da escola.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73358,
                      "answer_id":30382,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:07.575Z",
                      "updated_at":"2022-01-10T23:24:07.575Z",
                      "text":"Hindi kailangang magdagdag ng anumang bagay si Dr. Lutz maliban kung kinakailangang gawin iyon sa ilalim ng mga patakaran ng paaralan.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73357,
                      "answer_id":30382,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:07.570Z",
                      "updated_at":"2022-01-10T23:24:07.570Z",
                      "text":"El Dr. Lutz no necesita agregar nada a menos que sea requerido por las políticas de la escuela.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73356,
                      "answer_id":30382,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:07.566Z",
                      "updated_at":"2022-01-10T23:24:07.566Z",
                      "text":"Dr. Lutz doesn’t need to add anything unless required to do so under the school's policies.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12076,
          "shuffle":false,
          "position":51,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30384"
          ],
          "created_at":"2022-01-10T23:24:07.659Z",
          "updated_at":"2022-01-10T23:24:08.165Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":51,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Which of the following would be the most appropriate response?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30440,
                "question_id":12076,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:07.866Z",
                "updated_at":"2022-01-10T23:24:07.866Z",
                "text":"Verilebilecek en uygun yanıt aşağıdakilerden hangisidir?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30439,
                "question_id":12076,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:07.861Z",
                "updated_at":"2022-01-10T23:24:07.861Z",
                "text":"¿Cuál de las siguientes opciones sería la respuesta más adecuada?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30438,
                "question_id":12076,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:07.856Z",
                "updated_at":"2022-01-10T23:24:07.856Z",
                "text":"Какой из ответов будет оптимальным?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30437,
                "question_id":12076,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:07.850Z",
                "updated_at":"2022-01-10T23:24:07.850Z",
                "text":"Które z poniższych stwierdzeń byłoby najwłaściwsze?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30436,
                "question_id":12076,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:07.844Z",
                "updated_at":"2022-01-10T23:24:07.844Z",
                "text":"다음 중 가장 적절한 대응은 무엇일까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30435,
                "question_id":12076,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:07.839Z",
                "updated_at":"2022-01-10T23:24:07.839Z",
                "text":"次のうち、取るべき最も適切な対応はどれですか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30434,
                "question_id":12076,
                "locale":"it",
                "created_at":"2022-01-10T23:24:07.835Z",
                "updated_at":"2022-01-10T23:24:07.835Z",
                "text":"Quale delle seguenti sarebbe la risposta più adeguata?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30433,
                "question_id":12076,
                "locale":"de",
                "created_at":"2022-01-10T23:24:07.829Z",
                "updated_at":"2022-01-10T23:24:07.829Z",
                "text":"Welche dieser Antworten wäre die angemessenste?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30432,
                "question_id":12076,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:07.825Z",
                "updated_at":"2022-01-10T23:24:07.825Z",
                "text":"Laquelle des propositions suivantes serait la réponse la plus appropriée?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30431,
                "question_id":12076,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:07.820Z",
                "updated_at":"2022-01-10T23:24:07.820Z",
                "text":"Parmi les réponses suivantes, laquelle est la plus appropriée ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30430,
                "question_id":12076,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:07.815Z",
                "updated_at":"2022-01-10T23:24:07.815Z",
                "text":"Qual das alternativas a seguir seria a melhor resposta?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30429,
                "question_id":12076,
                "locale":"es",
                "created_at":"2022-01-10T23:24:07.810Z",
                "updated_at":"2022-01-10T23:24:07.810Z",
                "text":"¿Cuál de las opciones siguientes será la respuesta más apropiada?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30428,
                "question_id":12076,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:07.806Z",
                "updated_at":"2022-01-10T23:24:07.806Z",
                "text":"Alin sa sumusunod ang pinakamagandang tugon?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30427,
                "question_id":12076,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:07.801Z",
                "updated_at":"2022-01-10T23:24:07.801Z",
                "text":"下列何項是最適合的回應方式？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30426,
                "question_id":12076,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:07.796Z",
                "updated_at":"2022-01-10T23:24:07.796Z",
                "text":"以下哪一种反应最为适当？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30425,
                "question_id":12076,
                "locale":"en",
                "created_at":"2022-01-10T23:24:07.678Z",
                "updated_at":"2022-01-10T23:24:07.678Z",
                "text":"Which of the following would be the most appropriate response?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30383,
                "position":1,
                "active":true,
                "question_id":12076,
                "created_at":"2022-01-10T23:24:07.873Z",
                "updated_at":"2022-01-10T23:24:07.873Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Jeh is my colleague, and I don’t want to cross any lines into his personal life.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73387,
                      "answer_id":30383,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:07.959Z",
                      "updated_at":"2022-01-10T23:24:07.959Z",
                      "text":"Jeh benim iş arkadaşım ve kişisel hayatını sınırlandırmak istemiyorum.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73386,
                      "answer_id":30383,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:07.954Z",
                      "updated_at":"2022-01-10T23:24:07.954Z",
                      "text":"Jeh es mi compañero y no quiero cruzar ninguna línea en su vida personal.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73385,
                      "answer_id":30383,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:07.950Z",
                      "updated_at":"2022-01-10T23:24:07.950Z",
                      "text":"Дже — мой коллега, и я не хочу влезать в его личную жизнь.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73384,
                      "answer_id":30383,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:07.945Z",
                      "updated_at":"2022-01-10T23:24:07.945Z",
                      "text":"Jeh jest moim współpracownikiem i nie chcę wkraczać w jego życie osobiste.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73383,
                      "answer_id":30383,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:07.940Z",
                      "updated_at":"2022-01-10T23:24:07.940Z",
                      "text":"Jeh는 내 동료이며 그의 사생활을 침해할 생각은 전혀 없다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73382,
                      "answer_id":30383,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:07.935Z",
                      "updated_at":"2022-01-10T23:24:07.935Z",
                      "text":"Jehさんは同僚であるため、彼の私生活に対して一線を越えたくありません。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73381,
                      "answer_id":30383,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:07.930Z",
                      "updated_at":"2022-01-10T23:24:07.930Z",
                      "text":"Jeh è un mio collega e non desidero oltrepassare alcun confine della sua vita personale.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73380,
                      "answer_id":30383,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:07.926Z",
                      "updated_at":"2022-01-10T23:24:07.926Z",
                      "text":"Jeh ist mein Kollege und ich möchte mich nicht in sein Privatleben einmischen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73379,
                      "answer_id":30383,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:07.921Z",
                      "updated_at":"2022-01-10T23:24:07.921Z",
                      "text":"Jeh est mon collègue, et je ne veux pas franchir aucune limite dans sa vie personnelle.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73378,
                      "answer_id":30383,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:07.916Z",
                      "updated_at":"2022-01-10T23:24:07.916Z",
                      "text":"Jeh est mon collègue, et je ne veux pas m’immiscer dans sa vie privée.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73377,
                      "answer_id":30383,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:07.911Z",
                      "updated_at":"2022-01-10T23:24:07.911Z",
                      "text":"Jeh é meu colega, e não quero invadir sua vida pessoal.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73376,
                      "answer_id":30383,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:07.906Z",
                      "updated_at":"2022-01-10T23:24:07.906Z",
                      "text":"Jeh es mi colega, y no deseo cruzar ninguna línea en su vida personal.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73375,
                      "answer_id":30383,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:07.901Z",
                      "updated_at":"2022-01-10T23:24:07.901Z",
                      "text":"Kasamahan ko si Jeh, at ayaw kong manghimasok sa kanyang personal na buhay.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73374,
                      "answer_id":30383,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:07.896Z",
                      "updated_at":"2022-01-10T23:24:07.896Z",
                      "text":"Jeh 是我的同事，我不想越线干预他的个人生活。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73373,
                      "answer_id":30383,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:07.891Z",
                      "updated_at":"2022-01-10T23:24:07.891Z",
                      "text":"Jeh 是我的同事，我不希望跨越他私生活的界線。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73372,
                      "answer_id":30383,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:07.887Z",
                      "updated_at":"2022-01-10T23:24:07.887Z",
                      "text":"Jeh is my colleague, and I don’t want to cross any lines into his personal life.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30384,
                "position":2,
                "active":true,
                "question_id":12076,
                "created_at":"2022-01-10T23:24:07.965Z",
                "updated_at":"2022-01-10T23:24:07.965Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Jeh’s public display of stress may be indicative of a much deeper problem in his personal life. I should say something.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73403,
                      "answer_id":30384,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:08.061Z",
                      "updated_at":"2022-01-10T23:24:08.061Z",
                      "text":"Jeh'nin stresli olduğunun açıkça görülüyor olması kişisel yaşamında çok daha derin bir sorunla baş ediyor olduğunu gösterebilir. Bir şey söylemeliyim.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73402,
                      "answer_id":30384,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:08.056Z",
                      "updated_at":"2022-01-10T23:24:08.056Z",
                      "text":"La muestra pública de estrés de Jeh puede indicar un problema mucho más profundo en su vida personal. Debería hacer algo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73401,
                      "answer_id":30384,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:08.051Z",
                      "updated_at":"2022-01-10T23:24:08.051Z",
                      "text":"Открытые проявления стресса со стороны Дже могут указывать на гораздо более глубокие проблемы в его личной жизни. Мне следует что-то сказать.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73400,
                      "answer_id":30384,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:08.046Z",
                      "updated_at":"2022-01-10T23:24:08.046Z",
                      "text":"Publiczne okazywanie stresu przez Jeha może świadczyć o znacznie głębszym problemie w jego życiu osobistym. Powinienem coś powiedzieć.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73399,
                      "answer_id":30384,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:08.041Z",
                      "updated_at":"2022-01-10T23:24:08.041Z",
                      "text":"Jeh가 공개적으로 드러내는 스트레스는 사생활에 심각한 문제가 있음을 나타내는 것일 수 있다. 뭔가 말을 할 필요가 있다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73398,
                      "answer_id":30384,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:08.036Z",
                      "updated_at":"2022-01-10T23:24:08.036Z",
                      "text":"Jehさんがストレスを公に示していることは、彼の私生活におけるより深い問題を示唆している可能性があります。何か言うべきである。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73397,
                      "answer_id":30384,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:08.026Z",
                      "updated_at":"2022-01-10T23:24:08.026Z",
                      "text":"La manifestazione pubblica di stress di Jeh può essere indicativa di un problema molto più profondo della sua vita personale. Dovrei dire qualcosa.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73396,
                      "answer_id":30384,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:08.020Z",
                      "updated_at":"2022-01-10T23:24:08.020Z",
                      "text":"Da Jeh offen zur Schau stellt, wie gestresst er ist, könnte er in seinem Privatleben ein viel größeres Problem haben. Ich sollte etwas sagen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73395,
                      "answer_id":30384,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:08.013Z",
                      "updated_at":"2022-01-10T23:24:08.013Z",
                      "text":"L'exposition publique du stress de Jeh peut être le signe d'un problème beaucoup plus profond dans sa vie personnelle. Je devrais dire quelque chose.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73394,
                      "answer_id":30384,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:08.008Z",
                      "updated_at":"2022-01-10T23:24:08.008Z",
                      "text":"Le stress affiché par Jeh en public trahit peut-être un problème beaucoup plus profond dans sa vie privée. Je devrais dire quelque chose.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73393,
                      "answer_id":30384,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:08.002Z",
                      "updated_at":"2022-01-10T23:24:08.002Z",
                      "text":"A exposição pública do estresse de Jeh pode ser indicativo de um problema muito mais profundo em sua vida pessoal. Eu devo dizer alguma coisa.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73392,
                      "answer_id":30384,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:07.997Z",
                      "updated_at":"2022-01-10T23:24:07.997Z",
                      "text":"La exhibición pública de estrés de Jeh puede indicar un problema mucho más profundo en su vida personal. Debo decir algo.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73391,
                      "answer_id":30384,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:07.992Z",
                      "updated_at":"2022-01-10T23:24:07.992Z",
                      "text":"Ang hayagang pagpapakita ni Jeh ng pagkabalisa ay maaaring palatandaan ng mas malalim na problema sa kanyang personal na buhay. Dapat akong magsalita.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73390,
                      "answer_id":30384,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:07.987Z",
                      "updated_at":"2022-01-10T23:24:07.987Z",
                      "text":"Jeh 公开显示压力可能说明他的个人生活遇到了非常严重的问题。我应该说些什么。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73389,
                      "answer_id":30384,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:07.983Z",
                      "updated_at":"2022-01-10T23:24:07.983Z",
                      "text":"Jeh 公開表現出的壓力可能是他私生活中有更嚴重問題的跡象。我應該說些甚麼。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73388,
                      "answer_id":30384,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:07.978Z",
                      "updated_at":"2022-01-10T23:24:07.978Z",
                      "text":"Jeh’s public display of stress may be indicative of a much deeper problem in his personal life. I should say something.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30385,
                "position":3,
                "active":true,
                "question_id":12076,
                "created_at":"2022-01-10T23:24:08.067Z",
                "updated_at":"2022-01-10T23:24:08.067Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"I’m not sure; there must be someone better equipped to talk to Jeh.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73419,
                      "answer_id":30385,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:08.160Z",
                      "updated_at":"2022-01-10T23:24:08.160Z",
                      "text":"Emin değilim; Jeh ile daha donanımlı biri konuşmalı.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73418,
                      "answer_id":30385,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:08.155Z",
                      "updated_at":"2022-01-10T23:24:08.155Z",
                      "text":"No estoy seguro. Debe haber alguien mejor preparado para hablar con Jeh.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73417,
                      "answer_id":30385,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:08.151Z",
                      "updated_at":"2022-01-10T23:24:08.151Z",
                      "text":"Я не знаю; разговор с Дже должен проводить кто-то, кто умеет это делать.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73416,
                      "answer_id":30385,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:08.146Z",
                      "updated_at":"2022-01-10T23:24:08.146Z",
                      "text":"Nie jestem pewien; musi być ktoś lepiej przygotowany do rozmowy z Jehem.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73415,
                      "answer_id":30385,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:08.141Z",
                      "updated_at":"2022-01-10T23:24:08.141Z",
                      "text":"잘 모르겠다. Jeh와 대화할 더 나은 사람이 있을 것이다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73414,
                      "answer_id":30385,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:08.136Z",
                      "updated_at":"2022-01-10T23:24:08.136Z",
                      "text":"よくわからないが、Jehさんと話をするのにより適した人がいると思う。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73413,
                      "answer_id":30385,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:08.131Z",
                      "updated_at":"2022-01-10T23:24:08.131Z",
                      "text":"Non sono sicuro, dev’esserci qualcuno preparato meglio per parlare con Jeh.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73412,
                      "answer_id":30385,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:08.127Z",
                      "updated_at":"2022-01-10T23:24:08.127Z",
                      "text":"Ich bin mir nicht sicher. Bestimmt gibt es jemanden, der besser dafür geeignet ist, mit Jeh zu sprechen.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73411,
                      "answer_id":30385,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:08.122Z",
                      "updated_at":"2022-01-10T23:24:08.122Z",
                      "text":"Je ne suis pas sûr; il doit y avoir quelqu'un de mieux équipé pour parler à Jeh.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73410,
                      "answer_id":30385,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:08.117Z",
                      "updated_at":"2022-01-10T23:24:08.117Z",
                      "text":"J’hésite. Quelqu’un d’autre est sûrement mieux placé pour parler à Jeh.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73409,
                      "answer_id":30385,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:08.112Z",
                      "updated_at":"2022-01-10T23:24:08.112Z",
                      "text":"Não tenho certeza; deve haver alguém mais capacitado para falar com Jeh.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73408,
                      "answer_id":30385,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:08.107Z",
                      "updated_at":"2022-01-10T23:24:08.107Z",
                      "text":"No estoy seguro; debe haber alguien más preparado para hablar con Jeh.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73407,
                      "answer_id":30385,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:08.101Z",
                      "updated_at":"2022-01-10T23:24:08.101Z",
                      "text":"Hindi ko tiyak; may mas dalubhasa kaysa sa akin para kausapin si Jeh.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73406,
                      "answer_id":30385,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:08.096Z",
                      "updated_at":"2022-01-10T23:24:08.096Z",
                      "text":"我不确定；一定有更专业的人可以帮助 Jeh。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73405,
                      "answer_id":30385,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:08.091Z",
                      "updated_at":"2022-01-10T23:24:08.091Z",
                      "text":"我不確定；一定有人比我更適合跟 Jeh 談。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73404,
                      "answer_id":30385,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:08.082Z",
                      "updated_at":"2022-01-10T23:24:08.082Z",
                      "text":"I’m not sure; there must be someone better equipped to talk to Jeh.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12077,
          "shuffle":false,
          "position":52,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30387"
          ],
          "created_at":"2022-01-10T23:24:08.178Z",
          "updated_at":"2022-01-10T23:24:08.681Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":52,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"Should you stop and say something?",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30456,
                "question_id":12077,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:08.394Z",
                "updated_at":"2022-01-10T23:24:08.394Z",
                "text":"Durup bir şey söylemeli misiniz?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30455,
                "question_id":12077,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:08.389Z",
                "updated_at":"2022-01-10T23:24:08.389Z",
                "text":"¿Debería detenerse y decir algo?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30454,
                "question_id":12077,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:08.384Z",
                "updated_at":"2022-01-10T23:24:08.384Z",
                "text":"Следует ли вам остановиться и что-то сказать?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30453,
                "question_id":12077,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:08.379Z",
                "updated_at":"2022-01-10T23:24:08.379Z",
                "text":"Czy należy przerwać i coś powiedzieć?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30452,
                "question_id":12077,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:08.374Z",
                "updated_at":"2022-01-10T23:24:08.374Z",
                "text":"여러분이 개입해서 뭔가 말할 필요가 있을까요?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30451,
                "question_id":12077,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:08.368Z",
                "updated_at":"2022-01-10T23:24:08.368Z",
                "text":"立ち止まり、何かを言うべきでしょうか？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30450,
                "question_id":12077,
                "locale":"it",
                "created_at":"2022-01-10T23:24:08.363Z",
                "updated_at":"2022-01-10T23:24:08.363Z",
                "text":"Dovresti fermarti e dire qualcosa?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30449,
                "question_id":12077,
                "locale":"de",
                "created_at":"2022-01-10T23:24:08.359Z",
                "updated_at":"2022-01-10T23:24:08.359Z",
                "text":"Sollten Sie anhalten und etwas sagen?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30448,
                "question_id":12077,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:08.353Z",
                "updated_at":"2022-01-10T23:24:08.353Z",
                "text":"Devriez-vous vous arrêter et dire quelque chose?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30447,
                "question_id":12077,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:08.349Z",
                "updated_at":"2022-01-10T23:24:08.349Z",
                "text":"Devriez-vous vous arrêter et dire quelque chose ?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30446,
                "question_id":12077,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:08.343Z",
                "updated_at":"2022-01-10T23:24:08.343Z",
                "text":"Você deve parar e dizer algo?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30445,
                "question_id":12077,
                "locale":"es",
                "created_at":"2022-01-10T23:24:08.339Z",
                "updated_at":"2022-01-10T23:24:08.339Z",
                "text":"¿Deberías detenerte y decir algo?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30444,
                "question_id":12077,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:08.334Z",
                "updated_at":"2022-01-10T23:24:08.334Z",
                "text":"Dapat ka bang huminto at magsalita?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30443,
                "question_id":12077,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:08.329Z",
                "updated_at":"2022-01-10T23:24:08.329Z",
                "text":"你是否應該停下來說些甚麼？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30442,
                "question_id":12077,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:08.323Z",
                "updated_at":"2022-01-10T23:24:08.323Z",
                "text":"你是否应停止并说点什么？",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30441,
                "question_id":12077,
                "locale":"en",
                "created_at":"2022-01-10T23:24:08.198Z",
                "updated_at":"2022-01-10T23:24:08.198Z",
                "text":"Should you stop and say something?",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30386,
                "position":1,
                "active":true,
                "question_id":12077,
                "created_at":"2022-01-10T23:24:08.400Z",
                "updated_at":"2022-01-10T23:24:08.400Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"I’m friends with Sonja and Slav, but we’re not that good friends.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73435,
                      "answer_id":30386,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:08.489Z",
                      "updated_at":"2022-01-10T23:24:08.489Z",
                      "text":"Sonja ve Slav ile arkadaşız ancak o kadar da yakın değiliz.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73434,
                      "answer_id":30386,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:08.485Z",
                      "updated_at":"2022-01-10T23:24:08.485Z",
                      "text":"Conozco a Sonja y Slav, pero no tenemos tanta relación.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73433,
                      "answer_id":30386,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:08.480Z",
                      "updated_at":"2022-01-10T23:24:08.480Z",
                      "text":"Мы дружим с Соней и Славом, но не настолько близко.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73432,
                      "answer_id":30386,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:08.475Z",
                      "updated_at":"2022-01-10T23:24:08.475Z",
                      "text":"Przyjaźnię się z Sonją i Slavem, ale nie jesteśmy aż tak dobrymi przyjaciółmi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73431,
                      "answer_id":30386,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:08.470Z",
                      "updated_at":"2022-01-10T23:24:08.470Z",
                      "text":"나는 Sonja와 Slav의 친구이기는 하지만 그다지 가까운 사이는 아니다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73430,
                      "answer_id":30386,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:08.465Z",
                      "updated_at":"2022-01-10T23:24:08.465Z",
                      "text":"SonjaさんとSlavさんとは友達ですが、そこまで気の知れた友達ではありません。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73429,
                      "answer_id":30386,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:08.461Z",
                      "updated_at":"2022-01-10T23:24:08.461Z",
                      "text":"Sono amico di Sonja e Slav, ma non siamo così intimi.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73428,
                      "answer_id":30386,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:08.455Z",
                      "updated_at":"2022-01-10T23:24:08.455Z",
                      "text":"Ich bin zwar mit Sonja und Slav befreundet, aber auch nicht so gut.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73427,
                      "answer_id":30386,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:08.451Z",
                      "updated_at":"2022-01-10T23:24:08.451Z",
                      "text":"Je suis ami avec Sonja et Slav, mais pas de si bons amis que ça.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73426,
                      "answer_id":30386,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:08.445Z",
                      "updated_at":"2022-01-10T23:24:08.445Z",
                      "text":"Sonja et Slav sont mes amis, mais pas vraiment proches.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73425,
                      "answer_id":30386,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:08.441Z",
                      "updated_at":"2022-01-10T23:24:08.441Z",
                      "text":"Sou amiga da Sonja e do Slav, mas não somos assim tão bons amigos.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73424,
                      "answer_id":30386,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:08.436Z",
                      "updated_at":"2022-01-10T23:24:08.436Z",
                      "text":"Soy amigo de Sonja y Slav, pero no somos tan buenos amigos.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73423,
                      "answer_id":30386,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:08.431Z",
                      "updated_at":"2022-01-10T23:24:08.431Z",
                      "text":"Kaibigan ako ni Sonja at Slav, pero hindi kami gaanong matalik na magkakaibigan/",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73422,
                      "answer_id":30386,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:08.425Z",
                      "updated_at":"2022-01-10T23:24:08.425Z",
                      "text":"我是 Sonja 和 Slav 的朋友，但我们不是那么要好的朋友。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73421,
                      "answer_id":30386,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:08.418Z",
                      "updated_at":"2022-01-10T23:24:08.418Z",
                      "text":"我跟 Sonja 和 Slav 都是朋友，但不算是好朋友。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73420,
                      "answer_id":30386,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:08.414Z",
                      "updated_at":"2022-01-10T23:24:08.414Z",
                      "text":"I’m friends with Sonja and Slav, but we’re not that good friends.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30387,
                "position":2,
                "active":true,
                "question_id":12077,
                "created_at":"2022-01-10T23:24:08.496Z",
                "updated_at":"2022-01-10T23:24:08.496Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Yes, I should check on them to make sure everything is OK.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73451,
                      "answer_id":30387,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:08.582Z",
                      "updated_at":"2022-01-10T23:24:08.582Z",
                      "text":"Evet, her şeyin yolunda olduğundan emin olmak için gidip sormalıyım.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73450,
                      "answer_id":30387,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:08.577Z",
                      "updated_at":"2022-01-10T23:24:08.577Z",
                      "text":"Sí, debería investigar para asegurarme de que no hay ningún problema.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73449,
                      "answer_id":30387,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:08.572Z",
                      "updated_at":"2022-01-10T23:24:08.572Z",
                      "text":"Да, мне следует убедиться, что у них все в порядке.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73448,
                      "answer_id":30387,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:08.567Z",
                      "updated_at":"2022-01-10T23:24:08.567Z",
                      "text":"Tak, powinienem sprawdzić, czy wszystko jest w porządku.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73447,
                      "answer_id":30387,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:08.562Z",
                      "updated_at":"2022-01-10T23:24:08.562Z",
                      "text":"그렇다. 모든 것이 괜찮은지 확인해야 한다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73446,
                      "answer_id":30387,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:08.558Z",
                      "updated_at":"2022-01-10T23:24:08.558Z",
                      "text":"はい、2人の様子を確認し、何も問題がない事を確認すべきである。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73445,
                      "answer_id":30387,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:08.553Z",
                      "updated_at":"2022-01-10T23:24:08.553Z",
                      "text":"Sì, dovrei verificare per assicurarmi che vada tutto bene.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73444,
                      "answer_id":30387,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:08.548Z",
                      "updated_at":"2022-01-10T23:24:08.548Z",
                      "text":"Ja, ich sollte mit ihnen sprechen und sicherstellen, dass alles in Ordnung ist.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73443,
                      "answer_id":30387,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:08.543Z",
                      "updated_at":"2022-01-10T23:24:08.543Z",
                      "text":"Oui, je devrais aller les voir pour m'assurer que tout va bien.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73442,
                      "answer_id":30387,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:08.538Z",
                      "updated_at":"2022-01-10T23:24:08.538Z",
                      "text":"Oui, je devrais leur demander si tout va bien.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73441,
                      "answer_id":30387,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:08.533Z",
                      "updated_at":"2022-01-10T23:24:08.533Z",
                      "text":"Sim, devo falar com eles para ter certeza de que está tudo bem.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73440,
                      "answer_id":30387,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:08.528Z",
                      "updated_at":"2022-01-10T23:24:08.528Z",
                      "text":"Sí, debería acercarme para ver si todo está bien.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73439,
                      "answer_id":30387,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:08.523Z",
                      "updated_at":"2022-01-10T23:24:08.523Z",
                      "text":"Oo, dapat ko silang kumustahin para tiyaking AYOS sila.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73438,
                      "answer_id":30387,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:08.519Z",
                      "updated_at":"2022-01-10T23:24:08.519Z",
                      "text":"是的，我应该向他们了解情况以确保一切正常。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73437,
                      "answer_id":30387,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:08.514Z",
                      "updated_at":"2022-01-10T23:24:08.514Z",
                      "text":"是，我應該關心一下他們，確認一切都沒問題。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73436,
                      "answer_id":30387,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:08.509Z",
                      "updated_at":"2022-01-10T23:24:08.509Z",
                      "text":"Yes, I should check on them to make sure everything is OK.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30388,
                "position":3,
                "active":true,
                "question_id":12077,
                "created_at":"2022-01-10T23:24:08.589Z",
                "updated_at":"2022-01-10T23:24:08.589Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"I’m not sure; isn’t it intrusive to walk up to his car and interrupt them?",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73467,
                      "answer_id":30388,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:08.675Z",
                      "updated_at":"2022-01-10T23:24:08.675Z",
                      "text":"Emin değilim, arabasına kadar gidip onları rahatsız etmek sinir bozucu değil mi?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73466,
                      "answer_id":30388,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:08.670Z",
                      "updated_at":"2022-01-10T23:24:08.670Z",
                      "text":"No estoy seguro, ¿no resultará intrusivo ir hasta su coche e interrumpirles?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73465,
                      "answer_id":30388,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:08.665Z",
                      "updated_at":"2022-01-10T23:24:08.665Z",
                      "text":"Я не знаю, разве не будет невежливо подойти к его автомобилю и прервать их разговор?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73464,
                      "answer_id":30388,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:08.660Z",
                      "updated_at":"2022-01-10T23:24:08.660Z",
                      "text":"Nie jestem pewien, czy nie jest to zbyt natrętne, aby podchodzić do jego samochodu i przerywać mu?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73463,
                      "answer_id":30388,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:08.655Z",
                      "updated_at":"2022-01-10T23:24:08.655Z",
                      "text":"잘 모르겠다. 그의 차까지 걸어 가서 끼어드는 것은 거슬리는 일이 아닐까?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73462,
                      "answer_id":30388,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:08.650Z",
                      "updated_at":"2022-01-10T23:24:08.650Z",
                      "text":"よくわからないが、車に歩み寄り、会話に割り込むのは押し付けがましいのではないかと思う。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73461,
                      "answer_id":30388,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:08.646Z",
                      "updated_at":"2022-01-10T23:24:08.646Z",
                      "text":"Non sono sicuro, non è un comportamento invadente avvicinarsi alla sua macchina e interromperli?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73460,
                      "answer_id":30388,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:08.641Z",
                      "updated_at":"2022-01-10T23:24:08.641Z",
                      "text":"Ich bin mir nicht sicher. Ist es nicht ein bisschen aufdringlich, wenn ich zu seinem Auto gehe und sie unterbreche?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73459,
                      "answer_id":30388,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:08.636Z",
                      "updated_at":"2022-01-10T23:24:08.636Z",
                      "text":"Je ne suis pas sûr; n'est-ce pas indiscret de marcher jusqu'à sa voiture et de les interrompre?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73458,
                      "answer_id":30388,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:08.631Z",
                      "updated_at":"2022-01-10T23:24:08.631Z",
                      "text":"J’hésite. N’est-il pas indiscret de s’approcher de sa voiture et de les interrompre ?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73457,
                      "answer_id":30388,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:08.626Z",
                      "updated_at":"2022-01-10T23:24:08.626Z",
                      "text":"Não tenho certeza; não é intrusivo ir até o carro dele e interrompê-los?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73456,
                      "answer_id":30388,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:08.621Z",
                      "updated_at":"2022-01-10T23:24:08.621Z",
                      "text":"Hindi ko sigurado, hindi pa mapanghimasok na sumakay sa kotse niya at gambalain sila?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73455,
                      "answer_id":30388,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:08.616Z",
                      "updated_at":"2022-01-10T23:24:08.616Z",
                      "text":"No estoy seguro; ¿no es muy invasivo acercarme a su automóvil e interrumpirlos?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73454,
                      "answer_id":30388,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:08.611Z",
                      "updated_at":"2022-01-10T23:24:08.611Z",
                      "text":"我不确定；到他的车那里打断他们是否太冒失了？",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73453,
                      "answer_id":30388,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:08.606Z",
                      "updated_at":"2022-01-10T23:24:08.606Z",
                      "text":"我不確定，走到他的車旁打斷他們會不會很唐突？",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73452,
                      "answer_id":30388,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:08.602Z",
                      "updated_at":"2022-01-10T23:24:08.602Z",
                      "text":"I’m not sure; isn’t it intrusive to walk up to his car and interrupt them?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             }
          ]
       },
       {
          "id":12078,
          "shuffle":false,
          "position":53,
          "active":true,
          "section_id":3312,
          "correct_answers":[
             "30390"
          ],
          "created_at":"2022-01-10T23:24:08.694Z",
          "updated_at":"2022-01-10T23:24:09.192Z",
          "weighted_response":false,
          "matrix_question_id":null,
          "fields":{
             
          },
          "required":false,
          "allow_prefer_not_to_answer":false,
          "deleted_at":null,
          "matrix_parent":false,
          "calendar_duration_days":null,
          "slug":null,
          "evaluation_id":1444,
          "display_position":53,
          "show_feedback":false,
          "only_positive":false,
          "labels":[
             
          ],
          "answer_format":"any",
          "text":"You know you should work with her to revise your project deadlines, but should you ask her to elaborate on the Tinder date? ",
          "media":null,
          "help_text":null,
          "detail_text":null,
          "after_text":null,
          "type":"Questions::MultipleChoice",
          "translations":[
             {
                "id":30472,
                "question_id":12078,
                "locale":"tr-TR",
                "created_at":"2022-01-10T23:24:08.902Z",
                "updated_at":"2022-01-10T23:24:08.902Z",
                "text":"Proje teslim tarihlerini birlikte gözden geçiriyor olmanız Tinder randevusunun ayrıntılarını sorabileceğiniz anlamına mı geliyor? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30471,
                "question_id":12078,
                "locale":"es-ES",
                "created_at":"2022-01-10T23:24:08.897Z",
                "updated_at":"2022-01-10T23:24:08.897Z",
                "text":"Usted sabe que debería trabajar con ella para revisar los plazos del proyecto, pero ¿debería pedirle explicaciones sobre la cita de Tinder? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30470,
                "question_id":12078,
                "locale":"ru",
                "created_at":"2022-01-10T23:24:08.892Z",
                "updated_at":"2022-01-10T23:24:08.892Z",
                "text":"Вы знаете, что должны вместе с ней проговорить все крайние сроки по проекту, но следует ли заговаривать с ней о подробностях свидания со знакомым из Tinder? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30469,
                "question_id":12078,
                "locale":"pl-PL",
                "created_at":"2022-01-10T23:24:08.888Z",
                "updated_at":"2022-01-10T23:24:08.888Z",
                "text":"Wiesz, że powinieneś z nią współpracować nad poprawą terminów realizacji projektów, ale czy powinieneś poprosić ją o rozwinięcie tematu randki na Tinderze? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30468,
                "question_id":12078,
                "locale":"ko",
                "created_at":"2022-01-10T23:24:08.882Z",
                "updated_at":"2022-01-10T23:24:08.882Z",
                "text":"당신은 그녀와 상의해서 프로젝트 마감일을 수정해야 합니다. 그러나 그녀가 사용하는 Tinder(데이팅 앱)상의 스케줄에 대해 물어봐도 될까요? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30467,
                "question_id":12078,
                "locale":"ja",
                "created_at":"2022-01-10T23:24:08.877Z",
                "updated_at":"2022-01-10T23:24:08.877Z",
                "text":"プロジェクトの締め切りを変更することについて、連携し合う必要はありますが、Tinderによるデートに関して詳しく聞く必要はありますか？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30466,
                "question_id":12078,
                "locale":"it",
                "created_at":"2022-01-10T23:24:08.872Z",
                "updated_at":"2022-01-10T23:24:08.872Z",
                "text":"Sai che dovresti lavorare con lei per riconsiderare le scadenze del tuo progetto, ma dovresti chiederle di approfondire l’appuntamento di Tinder? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30465,
                "question_id":12078,
                "locale":"de",
                "created_at":"2022-01-10T23:24:08.867Z",
                "updated_at":"2022-01-10T23:24:08.867Z",
                "text":"Sie sollten mit ihr die Projektfristen überarbeiten, aber sollten Sie sie bitten, näher auf das Tinder-Date einzugehen? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30464,
                "question_id":12078,
                "locale":"fr-CA",
                "created_at":"2022-01-10T23:24:08.862Z",
                "updated_at":"2022-01-10T23:24:08.862Z",
                "text":"Vous savez que vous devriez travailler avec elle pour réviser les délais de votre projet, mais devriez-vous lui demander de préciser la date de Tinder? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30463,
                "question_id":12078,
                "locale":"fr-FR",
                "created_at":"2022-01-10T23:24:08.857Z",
                "updated_at":"2022-01-10T23:24:08.857Z",
                "text":"Vous savez que vous devriez collaborer avec elle pour réviser les délais de votre projet, mais faut-il lui demander d’en dire plus à propos du rendez-vous sur Tinder ? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30462,
                "question_id":12078,
                "locale":"pt-BR",
                "created_at":"2022-01-10T23:24:08.852Z",
                "updated_at":"2022-01-10T23:24:08.852Z",
                "text":"Você sabe que deve trabalhar com ela para revisar os prazos de seu projeto, mas deve pedir a ela que pense sobre o encontro do Tinder? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30461,
                "question_id":12078,
                "locale":"es",
                "created_at":"2022-01-10T23:24:08.847Z",
                "updated_at":"2022-01-10T23:24:08.847Z",
                "text":"Sabes que debes trabajar con ella para revisar los plazos de tu proyecto, ¿pero debes pedirle que proporcione detalles sobre la cita de Tinder? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30460,
                "question_id":12078,
                "locale":"tl-PH",
                "created_at":"2022-01-10T23:24:08.842Z",
                "updated_at":"2022-01-10T23:24:08.842Z",
                "text":"Alam mo na dapat kang makipagtulungan sa kanya upang baguhin ang iyong mga deadline ng proyekto, ngunit dapat mo bang hilingin sa kanya na ipaliwanag ang petsa ng Tinder? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30459,
                "question_id":12078,
                "locale":"zh-TW",
                "created_at":"2022-01-10T23:24:08.837Z",
                "updated_at":"2022-01-10T23:24:08.837Z",
                "text":"你知道你應該與她一起修改專案期限，但你可以問她關於 Tinder 約會的細節嗎？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30458,
                "question_id":12078,
                "locale":"zh-CN",
                "created_at":"2022-01-10T23:24:08.831Z",
                "updated_at":"2022-01-10T23:24:08.831Z",
                "text":"你知道你应该帮助她修改你的项目交期，但你是否应该让她告知与 Tinder 约会的事情呢？ ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             },
             {
                "id":30457,
                "question_id":12078,
                "locale":"en",
                "created_at":"2022-01-10T23:24:08.712Z",
                "updated_at":"2022-01-10T23:24:08.712Z",
                "text":"You know you should work with her to revise your project deadlines, but should you ask her to elaborate on the Tinder date? ",
                "media":null,
                "help_text":null,
                "deleted_at":null,
                "detail_text":null,
                "after_text":null
             }
          ],
          "answers":[
             {
                "id":30389,
                "position":1,
                "active":true,
                "question_id":12078,
                "created_at":"2022-01-10T23:24:08.909Z",
                "updated_at":"2022-01-10T23:24:08.909Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Don’t even go there. Her relationship is her business, and if she wants to get help, she should probably seek out the Counseling Center on campus.",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73483,
                      "answer_id":30389,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:08.995Z",
                      "updated_at":"2022-01-10T23:24:08.995Z",
                      "text":"Oraya gitmeyin bile. Bu onun ilişkisi ve eğer yardım almak isterse muhtemelen kampüsteki Danışmanlık Merkezini aramalıdır.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73482,
                      "answer_id":30389,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:08.990Z",
                      "updated_at":"2022-01-10T23:24:08.990Z",
                      "text":"Ni se le ocurra. Sus relaciones son asunto suyo, y si necesita ayuda, quizás debería contactar con el Centro de Orientación del campus.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73481,
                      "answer_id":30389,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:08.985Z",
                      "updated_at":"2022-01-10T23:24:08.985Z",
                      "text":"Даже не стоит ввязываться. Ее отношения — это ее личное дело, и если ей нужна помощь, она должна обращаться за ней в Центр по предоставлению консультаций в кампусе.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73480,
                      "answer_id":30389,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:08.980Z",
                      "updated_at":"2022-01-10T23:24:08.980Z",
                      "text":"Nawet tam nie idź. Jej związek to jej sprawa, a jeśli chce uzyskać pomoc, powinna prawdopodobnie poszukać jej w centrum doradztwa w kampusie.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73479,
                      "answer_id":30389,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:08.975Z",
                      "updated_at":"2022-01-10T23:24:08.975Z",
                      "text":"그러한 시도도 해서는 안 된다. 그녀의 인간 관계는 그녀가 알아서 할 일이며, 도움이 필요하다면 캠퍼스 내 상담 센터를 찾아야 할 것이다.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73478,
                      "answer_id":30389,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:08.971Z",
                      "updated_at":"2022-01-10T23:24:08.971Z",
                      "text":"その話はやめましょう。彼女の恋愛事情は彼女自身の問題であり、助けが必要な場合はキャンパス内のカウンセリングセンターで相談するでしょう。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73477,
                      "answer_id":30389,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:08.966Z",
                      "updated_at":"2022-01-10T23:24:08.966Z",
                      "text":"Non pensarci nemmeno. La sua relazione è affar suo, e se vuole essere aiutata, probabilmente dovrebbe cercare il Centro di consulenza del campus.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73476,
                      "answer_id":30389,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:08.961Z",
                      "updated_at":"2022-01-10T23:24:08.961Z",
                      "text":"Nicht hingehen. Ihre Beziehung geht nur sie etwas an, und wenn sie Hilfe braucht, wendet sie sich vermutlich an die Beratungsstelle des Campus.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73475,
                      "answer_id":30389,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:08.956Z",
                      "updated_at":"2022-01-10T23:24:08.956Z",
                      "text":"N'empruntez même pas ce chemin. Sa relation est son affaire, et si elle veut obtenir de l'aide, elle devrait probablement chercher le bureau conseil sur le campus.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73474,
                      "answer_id":30389,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:08.951Z",
                      "updated_at":"2022-01-10T23:24:08.951Z",
                      "text":"Inutile d’y songer. Sa relation ne regarde qu’elle, et si elle veut de l’aide, elle devrait probablement s’adresser au service d’aide du campus.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73473,
                      "answer_id":30389,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:08.947Z",
                      "updated_at":"2022-01-10T23:24:08.947Z",
                      "text":"Nem vá lá. O relacionamento que ela tem é assunto dela, e se ela deseja obter ajuda, provavelmente deve procurar o Centro de Aconselhamento no campus.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73472,
                      "answer_id":30389,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:08.942Z",
                      "updated_at":"2022-01-10T23:24:08.942Z",
                      "text":"Ni siquiera acercarse. Su relación es comercial, y si desea ayuda, probablemente deba contactar al Centro de Asesoría del campus.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73471,
                      "answer_id":30389,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:08.937Z",
                      "updated_at":"2022-01-10T23:24:08.937Z",
                      "text":"Huwag ka man lamang magpunta doon. Ang kanyang relasyon ay ang kanyang negosyo, at kung nais niyang humingi ng tulong, dapat siyang humingi sa Counseling Center ng campus.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73470,
                      "answer_id":30389,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:08.932Z",
                      "updated_at":"2022-01-10T23:24:08.932Z",
                      "text":"连问也不要问。她的关系是她的事情，如果她要获得帮助，她可能应该找校内的咨询中心。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73469,
                      "answer_id":30389,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:08.927Z",
                      "updated_at":"2022-01-10T23:24:08.927Z",
                      "text":"千萬別提這件事。她的感情關係是她自己的事，如果她需要幫忙，她應該會找校園的輔導中心。",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73468,
                      "answer_id":30389,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:08.923Z",
                      "updated_at":"2022-01-10T23:24:08.923Z",
                      "text":"Don’t even go there. Her relationship is her business, and if she wants to get help, she should probably seek out the Counseling Center on campus.",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30390,
                "position":2,
                "active":true,
                "question_id":12078,
                "created_at":"2022-01-10T23:24:09.001Z",
                "updated_at":"2022-01-10T23:24:09.001Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"Yes, you should say something. It’s incredibly troubling that someone is interfering with her work life in a confrontational way. ",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73499,
                      "answer_id":30390,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:09.089Z",
                      "updated_at":"2022-01-10T23:24:09.089Z",
                      "text":"Evet, bir şey söylemelisiniz. Birinin iş hayatına böyle agresifçe müdahale edilmesi inanılmaz derecede rahatsız edici. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73498,
                      "answer_id":30390,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:09.084Z",
                      "updated_at":"2022-01-10T23:24:09.084Z",
                      "text":"Sí, debería decir algo. Es muy preocupante que alguien interfiera en su vida laboral de manera conflictiva. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73497,
                      "answer_id":30390,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:09.079Z",
                      "updated_at":"2022-01-10T23:24:09.079Z",
                      "text":"Да, вам следует что-то сделать. То, что кто-то вмешивается в ее рабочую жизнь в такой агрессивной манере, вызывает огромные опасения. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73496,
                      "answer_id":30390,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:09.074Z",
                      "updated_at":"2022-01-10T23:24:09.074Z",
                      "text":"Tak, należy coś powiedzieć. To bardzo niepokojące, że ktoś w konfrontacyjny sposób ingeruje w jej życie zawodowe. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73495,
                      "answer_id":30390,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:09.069Z",
                      "updated_at":"2022-01-10T23:24:09.069Z",
                      "text":"그렇다. 뭔가 말을 할 필요가 있다. 누군가가 그녀의 직장 생활에 공격적인 방식으로 개입한다는 것은 매우 실례되는 일이다. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73494,
                      "answer_id":30390,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:09.064Z",
                      "updated_at":"2022-01-10T23:24:09.064Z",
                      "text":"はい、何か言うべきである。彼女のワークライフに、対立的な方法で誰かが干渉していることは、非常に厄介である。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73493,
                      "answer_id":30390,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:09.059Z",
                      "updated_at":"2022-01-10T23:24:09.059Z",
                      "text":"Sì, dovresti dire qualcosa. È estremamente preoccupante che qualcuno stia interferendo con la sua vita lavorativa in modo conflittuale. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73492,
                      "answer_id":30390,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:09.054Z",
                      "updated_at":"2022-01-10T23:24:09.054Z",
                      "text":"Sie sollten etwas sagen. Es ist äußerst besorgniserregend, dass sich jemand auf so konfrontative Weise in ihr Arbeitsleben einmischt. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73491,
                      "answer_id":30390,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:09.049Z",
                      "updated_at":"2022-01-10T23:24:09.049Z",
                      "text":"Oui, tu devrais dire quelque chose. Il est incroyablement troublant que quelqu'un interfère avec sa vie professionnelle de manière conflictuelle. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73490,
                      "answer_id":30390,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:09.043Z",
                      "updated_at":"2022-01-10T23:24:09.043Z",
                      "text":"Oui, vous devriez dire quelque chose. Il est fort troublant que quelqu’un s’immisce dans sa vie professionnelle de manière conflictuelle. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73489,
                      "answer_id":30390,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:09.038Z",
                      "updated_at":"2022-01-10T23:24:09.038Z",
                      "text":"Sim, você deve dizer algo. É extremamente preocupante que alguém esteja interferindo na vida profissional dela de forma confrontadora. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73488,
                      "answer_id":30390,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:09.033Z",
                      "updated_at":"2022-01-10T23:24:09.033Z",
                      "text":"Sí, deberías decir algo. Es increíblemente problemático que una persona interfiera con su vida laboral de forma controvertida. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73487,
                      "answer_id":30390,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:09.028Z",
                      "updated_at":"2022-01-10T23:24:09.028Z",
                      "text":"Oo, dapat kang magsalita. Lubhang nakakabahala na ang isang tao ay nakikialam sa kanyang buhay trabaho sa pagkomprontang paraan. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73486,
                      "answer_id":30390,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:09.023Z",
                      "updated_at":"2022-01-10T23:24:09.023Z",
                      "text":"是的，你应该说些什么。如果有人以对抗的方式干扰她的工作生活，可想而知会造成多大的困扰。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73485,
                      "answer_id":30390,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:09.018Z",
                      "updated_at":"2022-01-10T23:24:09.018Z",
                      "text":"是，你應該說些甚麼。有人以當面質問的方式介入她的工作是非常令人懊惱的一件事。 ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73484,
                      "answer_id":30390,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:09.014Z",
                      "updated_at":"2022-01-10T23:24:09.014Z",
                      "text":"Yes, you should say something. It’s incredibly troubling that someone is interfering with her work life in a confrontational way. ",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
                ]
             },
             {
                "id":30391,
                "position":3,
                "active":true,
                "question_id":12078,
                "created_at":"2022-01-10T23:24:09.100Z",
                "updated_at":"2022-01-10T23:24:09.100Z",
                "weight":0,
                "deleted_at":null,
                "score":null,
                "slug":null,
                "evaluation_id":1444,
                "collect_user_supplied_text":false,
                "text":"I’m not sure. Didn’t she choose to go on a date with him?",
                "help_text":null,
                "feedback":null,
                "translations":[
                   {
                      "id":73515,
                      "answer_id":30391,
                      "locale":"tr-TR",
                      "created_at":"2022-01-10T23:24:09.188Z",
                      "updated_at":"2022-01-10T23:24:09.188Z",
                      "text":"Emin değilim. Onunla randevuya çıkmak kendi seçimi değil miydi?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73514,
                      "answer_id":30391,
                      "locale":"es-ES",
                      "created_at":"2022-01-10T23:24:09.183Z",
                      "updated_at":"2022-01-10T23:24:09.183Z",
                      "text":"No estoy seguro. ¿No fue ella la que eligió tener una cita con él?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73513,
                      "answer_id":30391,
                      "locale":"ru",
                      "created_at":"2022-01-10T23:24:09.178Z",
                      "updated_at":"2022-01-10T23:24:09.178Z",
                      "text":"Затрудняюсь ответить. Разве ее кто-то заставлял идти с ним на свидание?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73512,
                      "answer_id":30391,
                      "locale":"pl-PL",
                      "created_at":"2022-01-10T23:24:09.172Z",
                      "updated_at":"2022-01-10T23:24:09.172Z",
                      "text":"Nie mam pewności. Czy to nie ona zdecydowała się pójść z nim na randkę?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73511,
                      "answer_id":30391,
                      "locale":"ko",
                      "created_at":"2022-01-10T23:24:09.168Z",
                      "updated_at":"2022-01-10T23:24:09.168Z",
                      "text":"잘 모르겠다. 그녀는 데이트가 있지 않나요?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73510,
                      "answer_id":30391,
                      "locale":"ja",
                      "created_at":"2022-01-10T23:24:09.163Z",
                      "updated_at":"2022-01-10T23:24:09.163Z",
                      "text":"わからない。彼女が彼とデートに行くことを選んだのではないですか？",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73509,
                      "answer_id":30391,
                      "locale":"it",
                      "created_at":"2022-01-10T23:24:09.158Z",
                      "updated_at":"2022-01-10T23:24:09.158Z",
                      "text":"Non ne sono sicuro/a. Non ha scelto di uscire con lui?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73508,
                      "answer_id":30391,
                      "locale":"de",
                      "created_at":"2022-01-10T23:24:09.153Z",
                      "updated_at":"2022-01-10T23:24:09.153Z",
                      "text":"Ich bin mir nicht sicher. War es nicht ihre eigene Entscheidung, ihn auf ein Date zu treffen?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73507,
                      "answer_id":30391,
                      "locale":"fr-CA",
                      "created_at":"2022-01-10T23:24:09.148Z",
                      "updated_at":"2022-01-10T23:24:09.148Z",
                      "text":"Je ne suis pas sûr. N'a-t-elle pas choisi de sortir avec lui?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73506,
                      "answer_id":30391,
                      "locale":"fr-FR",
                      "created_at":"2022-01-10T23:24:09.143Z",
                      "updated_at":"2022-01-10T23:24:09.143Z",
                      "text":"Je ne sais pas très bien. N’a-t-elle pas choisi de sortir avec lui ?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73505,
                      "answer_id":30391,
                      "locale":"pt-BR",
                      "created_at":"2022-01-10T23:24:09.138Z",
                      "updated_at":"2022-01-10T23:24:09.138Z",
                      "text":"Não tenho certeza. Ela não escolheu ir a um encontro com ele?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73504,
                      "answer_id":30391,
                      "locale":"es",
                      "created_at":"2022-01-10T23:24:09.133Z",
                      "updated_at":"2022-01-10T23:24:09.133Z",
                      "text":"No estoy seguro. ¿No eligió salir en una cita con él?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73503,
                      "answer_id":30391,
                      "locale":"tl-PH",
                      "created_at":"2022-01-10T23:24:09.129Z",
                      "updated_at":"2022-01-10T23:24:09.129Z",
                      "text":"Hindi ako sigurado. Hindi ba't pinili niyang makipag-date sa kanya?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73502,
                      "answer_id":30391,
                      "locale":"zh-CN",
                      "created_at":"2022-01-10T23:24:09.124Z",
                      "updated_at":"2022-01-10T23:24:09.124Z",
                      "text":"我不确定。她不应该选择与他约会吗？",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73501,
                      "answer_id":30391,
                      "locale":"zh-TW",
                      "created_at":"2022-01-10T23:24:09.119Z",
                      "updated_at":"2022-01-10T23:24:09.119Z",
                      "text":"我不確定。不是她自己選擇跟他約會的嗎？",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   },
                   {
                      "id":73500,
                      "answer_id":30391,
                      "locale":"en",
                      "created_at":"2022-01-10T23:24:09.114Z",
                      "updated_at":"2022-01-10T23:24:09.114Z",
                      "text":"I’m not sure. Didn’t she choose to go on a date with him?",
                      "help_text":null,
                      "deleted_at":null,
                      "feedback":null
                   }
               ]
           }
       ]
   }
]
}



  
});

